export interface Municipality {
    name: string;
    istatCode?: string;
}

export const MUNICIPALITIES: Municipality[] = [
    {
        name: 'ABANO TERME',
        istatCode: '005028001'
    },
    {
        name: 'ABBADIA CERRETO',
        istatCode: '003098001'
    },
    {
        name: 'ABBADIA LARIANA',
        istatCode: '003097001'
    },
    {
        name: 'ABBADIA SAN SALVATORE',
        istatCode: '009052001'
    },
    {
        name: 'ABBASANTA',
        istatCode: '020095001'
    },
    {
        name: 'ABBATEGGIO',
        istatCode: '013068001'
    },
    {
        name: 'ABBIATEGRASSO',
        istatCode: '003015002'
    },
    {
        name: 'ABETONE',
        istatCode: '009047001'
    },
    {
        name: 'ABETONE CUTIGLIANO',
        istatCode: '009047023'
    },
    {
        name: 'ABRIOLA',
        istatCode: '017076001'
    },
    {
        name: 'ACATE',
        istatCode: '019088001'
    },
    {
        name: 'ACCADIA',
        istatCode: '016071001'
    },
    {
        name: 'ACCEGLIO',
        istatCode: '001004001'
    },
    {
        name: 'ACCETTURA',
        istatCode: '017077001'
    },
    {
        name: 'ACCIANO',
        istatCode: '013066001'
    },
    {
        name: 'ACCUMOLI',
        istatCode: '012057001'
    },
    {
        name: 'ACERENZA',
        istatCode: '017076002'
    },
    {
        name: 'ACERNO',
        istatCode: '015065001'
    },
    {
        name: 'ACERRA',
        istatCode: '015063001'
    },
    {
        name: 'ACI BONACCORSI',
        istatCode: '019087001'
    },
    {
        name: 'ACI CASTELLO',
        istatCode: '019087002'
    },
    {
        name: 'ACI CATENA',
        istatCode: '019087003'
    },
    {
        name: 'ACI SANT\'ANTONIO',
        istatCode: '019087005'
    },
    {
        name: 'ACIREALE',
        istatCode: '019087004'
    },
    {
        name: 'ACQUACANINA',
        istatCode: '011043001'
    },
    {
        name: 'ACQUAFONDATA',
        istatCode: '012060001'
    },
    {
        name: 'ACQUAFORMOSA',
        istatCode: '018078001'
    },
    {
        name: 'ACQUAFREDDA',
        istatCode: '003017001'
    },
    {
        name: 'ACQUALAGNA',
        istatCode: '011041001'
    },
    {
        name: 'ACQUANEGRA CREMONESE',
        istatCode: '003019001'
    },
    {
        name: 'ACQUANEGRA SUL CHIESE',
        istatCode: '003020001'
    },
    {
        name: 'ACQUAPENDENTE',
        istatCode: '012056001'
    },
    {
        name: 'ACQUAPPESA',
        istatCode: '018078002'
    },
    {
        name: 'ACQUARICA DEL CAPO',
        istatCode: '016075001'
    },
    {
        name: 'ACQUARO',
        istatCode: '018102001'
    },
    {
        name: 'ACQUASANTA TERME',
        istatCode: '011044001'
    },
    {
        name: 'ACQUASPARTA',
        istatCode: '010055001'
    },
    {
        name: 'ACQUAVIVA COLLECROCE',
        istatCode: '014070001'
    },
    {
        name: 'ACQUAVIVA DELLE FONTI',
        istatCode: '016072001'
    },
    {
        name: 'ACQUAVIVA D\'ISERNIA',
        istatCode: '014094001'
    },
    {
        name: 'ACQUAVIVA PICENA',
        istatCode: '011044002'
    },
    {
        name: 'ACQUAVIVA PLATANI',
        istatCode: '019085001'
    },
    {
        name: 'ACQUEDOLCI',
        istatCode: '019083107'
    },
    {
        name: 'ACQUI TERME',
        istatCode: '001006001'
    },
    {
        name: 'ACRI',
        istatCode: '018078003'
    },
    {
        name: 'ACUTO',
        istatCode: '012060002'
    },
    {
        name: 'ADELFIA',
        istatCode: '016072002'
    },
    {
        name: 'ADRANO',
        istatCode: '019087006'
    },
    {
        name: 'ADRARA SAN MARTINO',
        istatCode: '003016001'
    },
    {
        name: 'ADRARA SAN ROCCO',
        istatCode: '003016002'
    },
    {
        name: 'ADRIA',
        istatCode: '005029001'
    },
    {
        name: 'ADRO',
        istatCode: '003017002'
    },
    {
        name: 'AFFI',
        istatCode: '005023001'
    },
    {
        name: 'AFFILE',
        istatCode: '012058001'
    },
    {
        name: 'AFFORI',
        istatCode: '003015801'
    },
    {
        name: 'AFRAGOLA',
        istatCode: '015063002'
    },
    {
        name: 'AFRICO',
        istatCode: '018080001'
    },
    {
        name: 'AGAZZANO',
        istatCode: '008033001'
    },
    {
        name: 'AGEROLA',
        istatCode: '015063003'
    },
    {
        name: 'AGGIUS',
        istatCode: '020090001'
    },
    {
        name: 'AGIRA',
        istatCode: '019086001'
    },
    {
        name: 'AGLIANA',
        istatCode: '009047002'
    },
    {
        name: 'AGLIANO TERME',
        istatCode: '001005001'
    },
    {
        name: 'AGLIE\'',
        istatCode: '001001001'
    },
    {
        name: 'AGLIENTU',
        istatCode: '020090062'
    },
    {
        name: 'AGNA',
        istatCode: '005028002'
    },
    {
        name: 'AGNADELLO',
        istatCode: '003019002'
    },
    {
        name: 'AGNANA CALABRA',
        istatCode: '018080002'
    },
    {
        name: 'AGNONE',
        istatCode: '014094002'
    },
    {
        name: 'AGNOSINE',
        istatCode: '003017003'
    },
    {
        name: 'AGORDO',
        istatCode: '005025001'
    },
    {
        name: 'AGOSTA',
        istatCode: '012058002'
    },
    {
        name: 'AGRA',
        istatCode: '003012001'
    },
    {
        name: 'AGRATE BRIANZA',
        istatCode: '003108001'
    },
    {
        name: 'AGRATE CONTURBIA',
        istatCode: '001003001'
    },
    {
        name: 'AGRIGENTO',
        istatCode: '019084001'
    },
    {
        name: 'AGROPOLI',
        istatCode: '015065002'
    },
    {
        name: 'AGUGLIANO',
        istatCode: '011042001'
    },
    {
        name: 'AGUGLIARO',
        istatCode: '005024001'
    },
    {
        name: 'AICURZIO',
        istatCode: '003108002'
    },
    {
        name: 'AIDOMAGGIORE',
        istatCode: '020095002'
    },
    {
        name: 'AIDONE',
        istatCode: '019086002'
    },
    {
        name: 'AIELLI',
        istatCode: '013066002'
    },
    {
        name: 'AIELLO CALABRO',
        istatCode: '018078004'
    },
    {
        name: 'AIELLO DEL FRIULI',
        istatCode: '006030001'
    },
    {
        name: 'AIELLO DEL SABATO',
        istatCode: '015064001'
    },
    {
        name: 'AIETA',
        istatCode: '018078005'
    },
    {
        name: 'AILANO',
        istatCode: '015061001'
    },
    {
        name: 'AILOCHE',
        istatCode: '001096001'
    },
    {
        name: 'AIRASCA',
        istatCode: '001001002'
    },
    {
        name: 'AIROLA',
        istatCode: '015062001'
    },
    {
        name: 'AIROLE',
        istatCode: '007008001'
    },
    {
        name: 'AIRUNO',
        istatCode: '003097002'
    },
    {
        name: 'AISONE',
        istatCode: '001004002'
    },
    {
        name: 'ALA',
        istatCode: '004022001'
    },
    {
        name: 'ALA\' DEI SARDI',
        istatCode: '020090002'
    },
    {
        name: 'ALA DI STURA',
        istatCode: '001001003'
    },
    {
        name: 'ALAGNA',
        istatCode: '003018001'
    },
    {
        name: 'ALAGNA VALSESIA',
        istatCode: '001002002'
    },
    {
        name: 'ALANNO',
        istatCode: '013068002'
    },
    {
        name: 'ALANO DI PIAVE',
        istatCode: '005025002'
    },
    {
        name: 'ALASSIO',
        istatCode: '007009001'
    },
    {
        name: 'ALATRI',
        istatCode: '012060003'
    },
    {
        name: 'ALBA',
        istatCode: '001004003'
    },
    {
        name: 'ALBA ADRIATICA',
        istatCode: '013067001'
    },
    {
        name: 'ALBAGIARA',
        istatCode: '020095003'
    },
    {
        name: 'ALBAIRATE',
        istatCode: '003015005'
    },
    {
        name: 'ALBANELLA',
        istatCode: '015065003'
    },
    {
        name: 'ALBANO DI LUCANIA',
        istatCode: '017076003'
    },
    {
        name: 'ALBANO LAZIALE',
        istatCode: '012058003'
    },
    {
        name: 'ALBANO SANT\'ALESSANDRO',
        istatCode: '003016003'
    },
    {
        name: 'ALBANO VERCELLESE',
        istatCode: '001002003'
    },
    {
        name: 'ALBANOVA',
        istatCode: '015061801'
    },
    {
        name: 'ALBAREDO ARNABOLDI',
        istatCode: '003018002'
    },
    {
        name: 'ALBAREDO D\'ADIGE',
        istatCode: '005023002'
    },
    {
        name: 'ALBAREDO PER SAN MARCO',
        istatCode: '003014001'
    },
    {
        name: 'ALBARETO',
        istatCode: '008034001'
    },
    {
        name: 'ALBARETTO DELLA TORRE',
        istatCode: '001004004'
    },
    {
        name: 'ALBATE',
        istatCode: '003013804'
    },
    {
        name: 'ALBAVILLA',
        istatCode: '003013003'
    },
    {
        name: 'ALBENGA',
        istatCode: '007009002'
    },
    {
        name: 'ALBERA LIGURE',
        istatCode: '001006002'
    },
    {
        name: 'ALBEROBELLO',
        istatCode: '016072003'
    },
    {
        name: 'ALBERONA',
        istatCode: '016071002'
    },
    {
        name: 'ALBESE CON CASSANO',
        istatCode: '003013004'
    },
    {
        name: 'ALBETTONE',
        istatCode: '005024002'
    },
    {
        name: 'ALBI',
        istatCode: '018079002'
    },
    {
        name: 'ALBIANO',
        istatCode: '004022002'
    },
    {
        name: 'ALBIANO D\'IVREA',
        istatCode: '001001004'
    },
    {
        name: 'ALBIATE',
        istatCode: '003108003'
    },
    {
        name: 'ALBIDONA',
        istatCode: '018078006'
    },
    {
        name: 'ALBIGNASEGO',
        istatCode: '005028003'
    },
    {
        name: 'ALBINEA',
        istatCode: '008035001'
    },
    {
        name: 'ALBINO',
        istatCode: '003016004'
    },
    {
        name: 'ALBIOLO',
        istatCode: '003013005'
    },
    {
        name: 'ALBISOLA MARINA',
        istatCode: '007009003'
    },
    {
        name: 'ALBISOLA SUPERIORE',
        istatCode: '007009004'
    },
    {
        name: 'ALBIZZATE',
        istatCode: '003012002'
    },
    {
        name: 'ALBONESE',
        istatCode: '003018003'
    },
    {
        name: 'ALBOSAGGIA',
        istatCode: '003014002'
    },
    {
        name: 'ALBUGNANO',
        istatCode: '001005002'
    },
    {
        name: 'ALBUZZANO',
        istatCode: '003018004'
    },
    {
        name: 'ALCAMO',
        istatCode: '019081001'
    },
    {
        name: 'ALCARA LI FUSI',
        istatCode: '019083001'
    },
    {
        name: 'ALDENO',
        istatCode: '004022003'
    },
    {
        name: 'ALDINO - ALDEIN',
        istatCode: '004021001'
    },
    {
        name: 'ALES',
        istatCode: '020095004'
    },
    {
        name: 'ALESSANDRIA',
        istatCode: '001006003'
    },
    {
        name: 'ALESSANDRIA DEL CARRETTO',
        istatCode: '018078007'
    },
    {
        name: 'ALESSANDRIA DELLA ROCCA',
        istatCode: '019084002'
    },
    {
        name: 'ALESSANO',
        istatCode: '016075002'
    },
    {
        name: 'ALEZIO',
        istatCode: '016075003'
    },
    {
        name: 'ALFANO',
        istatCode: '015065004'
    },
    {
        name: 'ALFEDENA',
        istatCode: '013066003'
    },
    {
        name: 'ALFIANELLO',
        istatCode: '003017004'
    },
    {
        name: 'ALFIANO NATTA',
        istatCode: '001006004'
    },
    {
        name: 'ALFONSINE',
        istatCode: '008039001'
    },
    {
        name: 'ALGHERO',
        istatCode: '020090003'
    },
    {
        name: 'ALGUA',
        istatCode: '003016248'
    },
    {
        name: 'ALI\'',
        istatCode: '019083002'
    },
    {
        name: 'ALI\' TERME',
        istatCode: '019083003'
    },
    {
        name: 'ALIA',
        istatCode: '019082001'
    },
    {
        name: 'ALIANO',
        istatCode: '017077002'
    },
    {
        name: 'ALICE BEL COLLE',
        istatCode: '001006005'
    },
    {
        name: 'ALICE CASTELLO',
        istatCode: '001002004'
    },
    {
        name: 'ALICE SUPERIORE',
        istatCode: '001001005'
    },
    {
        name: 'ALIFE',
        istatCode: '015061002'
    },
    {
        name: 'ALIMENA',
        istatCode: '019082002'
    },
    {
        name: 'ALIMINUSA',
        istatCode: '019082003'
    },
    {
        name: 'ALLAI',
        istatCode: '020095005'
    },
    {
        name: 'ALLEGHE',
        istatCode: '005025003'
    },
    {
        name: 'ALLEIN',
        istatCode: '002007001'
    },
    {
        name: 'ALLERONA',
        istatCode: '010055002'
    },
    {
        name: 'ALLISTE',
        istatCode: '016075004'
    },
    {
        name: 'ALLUMIERE',
        istatCode: '012058004'
    },
    {
        name: 'ALLUVIONI CAMBIO\'',
        istatCode: '001006006'
    },
    {
        name: 'ALLUVIONI PIOVERA',
        istatCode: '001006192'
    },
    {
        name: 'ALME\'',
        istatCode: '003016005'
    },
    {
        name: 'ALME\' CON VILLA',
        istatCode: '003016551'
    },
    {
        name: 'ALMENNO SAN BARTOLOMEO',
        istatCode: '003016006'
    },
    {
        name: 'ALMENNO SAN SALVATORE',
        istatCode: '003016007'
    },
    {
        name: 'ALMESE',
        istatCode: '001001006'
    },
    {
        name: 'ALONTE',
        istatCode: '005024003'
    },
    {
        name: 'ALPAGO',
        istatCode: '005025072'
    },
    {
        name: 'ALPETTE',
        istatCode: '001001007'
    },
    {
        name: 'ALPIGNANO',
        istatCode: '001001008'
    },
    {
        name: 'ALSENO',
        istatCode: '008033002'
    },
    {
        name: 'ALSERIO',
        istatCode: '003013006'
    },
    {
        name: 'ALTA VAL TIDONE',
        istatCode: '008033049'
    },
    {
        name: 'ALTA VALLE INTELVI',
        istatCode: '003013253'
    },
    {
        name: 'ALTAMURA',
        istatCode: '016072004'
    },
    {
        name: 'ALTARE',
        istatCode: '007009005'
    },
    {
        name: 'ALTAVALLE',
        istatCode: '004022235'
    },
    {
        name: 'ALTAVILLA IRPINA',
        istatCode: '015064002'
    },
    {
        name: 'ALTAVILLA MILICIA',
        istatCode: '019082004'
    },
    {
        name: 'ALTAVILLA MONFERRATO',
        istatCode: '001006007'
    },
    {
        name: 'ALTAVILLA SILENTINA',
        istatCode: '015065005'
    },
    {
        name: 'ALTAVILLA VICENTINA',
        istatCode: '005024004'
    },
    {
        name: 'ALTIDONA',
        istatCode: '011109001'
    },
    {
        name: 'ALTILIA',
        istatCode: '018078008'
    },
    {
        name: 'ALTINO',
        istatCode: '013069001'
    },
    {
        name: 'ALTISSIMO',
        istatCode: '005024005'
    },
    {
        name: 'ALTIVOLE',
        istatCode: '005026001'
    },
    {
        name: 'ALTO',
        istatCode: '001004005'
    },
    {
        name: 'ALTO RENO TERME',
        istatCode: '008037062'
    },
    {
        name: 'ALTO SERMENZA',
        istatCode: '001002170'
    },
    {
        name: 'ALTOFONTE',
        istatCode: '019082005'
    },
    {
        name: 'ALTOMONTE',
        istatCode: '018078009'
    },
    {
        name: 'ALTOPASCIO',
        istatCode: '009046001'
    },
    {
        name: 'ALTOPIANO DELLA VIGOLANA',
        istatCode: '004022236'
    },
    {
        name: 'ALVIANO',
        istatCode: '010055003'
    },
    {
        name: 'ALVIGNANO',
        istatCode: '015061003'
    },
    {
        name: 'ALVITO',
        istatCode: '012060004'
    },
    {
        name: 'ALZANO LOMBARDO',
        istatCode: '003016008'
    },
    {
        name: 'ALZANO MAGGIORE',
        istatCode: '003016803'
    },
    {
        name: 'ALZANO SCRIVIA',
        istatCode: '001006008'
    },
    {
        name: 'ALZATE BRIANZA',
        istatCode: '003013007'
    },
    {
        name: 'AMALFI',
        istatCode: '015065006'
    },
    {
        name: 'AMANDOLA',
        istatCode: '011109002'
    },
    {
        name: 'AMANTEA',
        istatCode: '018078010'
    },
    {
        name: 'AMARO',
        istatCode: '006030002'
    },
    {
        name: 'AMARONI',
        istatCode: '018079003'
    },
    {
        name: 'AMASENO',
        istatCode: '012060005'
    },
    {
        name: 'AMATO',
        istatCode: '018079004'
    },
    {
        name: 'AMATRICE',
        istatCode: '012057002'
    },
    {
        name: 'AMBIVERE',
        istatCode: '003016009'
    },
    {
        name: 'AMBLAR',
        istatCode: '004022004'
    },
    {
        name: 'AMBLAR-DON',
        istatCode: '004022237'
    },
    {
        name: 'AMEGLIA',
        istatCode: '007011001'
    },
    {
        name: 'AMELIA',
        istatCode: '010055004'
    },
    {
        name: 'AMENDOLARA',
        istatCode: '018078011'
    },
    {
        name: 'AMENO',
        istatCode: '001003002'
    },
    {
        name: 'AMOROSI',
        istatCode: '015062002'
    },
    {
        name: 'AMPEZZO',
        istatCode: '006030003'
    },
    {
        name: 'ANACAPRI',
        istatCode: '015063004'
    },
    {
        name: 'ANAGNI',
        istatCode: '012060006'
    },
    {
        name: 'ANCARANO',
        istatCode: '013067002'
    },
    {
        name: 'ANCONA',
        istatCode: '011042002'
    },
    {
        name: 'ANDALI',
        istatCode: '018079005'
    },
    {
        name: 'ANDALO',
        istatCode: '004022005'
    },
    {
        name: 'ANDALO VALTELLINO',
        istatCode: '003014003'
    },
    {
        name: 'ANDEZENO',
        istatCode: '001001009'
    },
    {
        name: 'ANDORA',
        istatCode: '007009006'
    },
    {
        name: 'ANDORNO MICCA',
        istatCode: '001096002'
    },
    {
        name: 'ANDRANO',
        istatCode: '016075005'
    },
    {
        name: 'ANDRATE',
        istatCode: '001001010'
    },
    {
        name: 'ANDREIS',
        istatCode: '006093001'
    },
    {
        name: 'ANDRETTA',
        istatCode: '015064003'
    },
    {
        name: 'ANDRIA',
        istatCode: '016110001'
    },
    {
        name: 'ANDRIANO - ANDRIAN',
        istatCode: '004021002'
    },
    {
        name: 'ANELA',
        istatCode: '020090004'
    },
    {
        name: 'ANFO',
        istatCode: '003017005'
    },
    {
        name: 'ANGERA',
        istatCode: '003012003'
    },
    {
        name: 'ANGHIARI',
        istatCode: '009051001'
    },
    {
        name: 'ANGIARI',
        istatCode: '005023003'
    },
    {
        name: 'ANGOLO TERME',
        istatCode: '003017006'
    },
    {
        name: 'ANGRI',
        istatCode: '015065007'
    },
    {
        name: 'ANGROGNA',
        istatCode: '001001011'
    },
    {
        name: 'ANGUILLARA SABAZIA',
        istatCode: '012058005'
    },
    {
        name: 'ANGUILLARA VENETA',
        istatCode: '005028004'
    },
    {
        name: 'ANNICCO',
        istatCode: '003019003'
    },
    {
        name: 'ANNONE DI BRIANZA',
        istatCode: '003097003'
    },
    {
        name: 'ANNONE VENETO',
        istatCode: '005027001'
    },
    {
        name: 'ANOIA',
        istatCode: '018080003'
    },
    {
        name: 'ANTEGNATE',
        istatCode: '003016010'
    },
    {
        name: 'ANTERIVO - ALTREI',
        istatCode: '004021003'
    },
    {
        name: 'ANTEY-SAINT-ANDRE\'',
        istatCode: '002007002'
    },
    {
        name: 'ANTICOLI CORRADO',
        istatCode: '012058006'
    },
    {
        name: 'ANTIGNANO',
        istatCode: '001005003'
    },
    {
        name: 'ANTILLO',
        istatCode: '019083004'
    },
    {
        name: 'ANTONIMINA',
        istatCode: '018080004'
    },
    {
        name: 'ANTRODOCO',
        istatCode: '012057003'
    },
    {
        name: 'ANTRONA SCHIERANCO',
        istatCode: '001103001'
    },
    {
        name: 'ANVERSA DEGLI ABRUZZI',
        istatCode: '013066004'
    },
    {
        name: 'ANZANO DEL PARCO',
        istatCode: '003013009'
    },
    {
        name: 'ANZANO DI PUGLIA',
        istatCode: '016071003'
    },
    {
        name: 'ANZI',
        istatCode: '017076004'
    },
    {
        name: 'ANZIO',
        istatCode: '012058007'
    },
    {
        name: 'ANZOLA DELL\'EMILIA',
        istatCode: '008037001'
    },
    {
        name: 'ANZOLA D\'OSSOLA',
        istatCode: '001103002'
    },
    {
        name: 'AOSTA',
        istatCode: '002007003'
    },
    {
        name: 'APECCHIO',
        istatCode: '011041002'
    },
    {
        name: 'APICE',
        istatCode: '015062003'
    },
    {
        name: 'APIRO',
        istatCode: '011043002'
    },
    {
        name: 'APOLLOSA',
        istatCode: '015062004'
    },
    {
        name: 'APPIANO GENTILE',
        istatCode: '003013010'
    },
    {
        name: 'APPIANO SULLA STRADA DEL VINO - EPPAN AN DER WEINSTRASSE',
        istatCode: '004021004'
    },
    {
        name: 'APPIGNANO',
        istatCode: '011043003'
    },
    {
        name: 'APPIGNANO DEL TRONTO',
        istatCode: '011044005'
    },
    {
        name: 'APRICA',
        istatCode: '003014004'
    },
    {
        name: 'APRICALE',
        istatCode: '007008002'
    },
    {
        name: 'APRICENA',
        istatCode: '016071004'
    },
    {
        name: 'APRIGLIANO',
        istatCode: '018078012'
    },
    {
        name: 'APRILIA',
        istatCode: '012059001'
    },
    {
        name: 'APUANIA',
        istatCode: '009045802'
    },
    {
        name: 'AQUARA',
        istatCode: '015065008'
    },
    {
        name: 'AQUILA DI ARROSCIA',
        istatCode: '007008003'
    },
    {
        name: 'AQUILEIA',
        istatCode: '006030004'
    },
    {
        name: 'AQUILONIA',
        istatCode: '015064004'
    },
    {
        name: 'AQUINO',
        istatCode: '012060007'
    },
    {
        name: 'ARADEO',
        istatCode: '016075006'
    },
    {
        name: 'ARAGONA',
        istatCode: '019084003'
    },
    {
        name: 'ARAMENGO',
        istatCode: '001005004'
    },
    {
        name: 'ARBA',
        istatCode: '006093002'
    },
    {
        name: 'ARBOREA',
        istatCode: '020095006'
    },
    {
        name: 'ARBORIO',
        istatCode: '001002006'
    },
    {
        name: 'ARBUS',
        istatCode: '020111001'
    },
    {
        name: 'ARCADE',
        istatCode: '005026002'
    },
    {
        name: 'ARCE',
        istatCode: '012060008'
    },
    {
        name: 'ARCENE',
        istatCode: '003016011'
    },
    {
        name: 'ARCEVIA',
        istatCode: '011042003'
    },
    {
        name: 'ARCHI',
        istatCode: '013069002'
    },
    {
        name: 'ARCIDOSSO',
        istatCode: '009053001'
    },
    {
        name: 'ARCINAZZO ROMANO',
        istatCode: '012058008'
    },
    {
        name: 'ARCISATE',
        istatCode: '003012004'
    },
    {
        name: 'ARCO',
        istatCode: '004022006'
    },
    {
        name: 'ARCOLA',
        istatCode: '007011002'
    },
    {
        name: 'ARCOLE',
        istatCode: '005023004'
    },
    {
        name: 'ARCONATE',
        istatCode: '003015007'
    },
    {
        name: 'ARCORE',
        istatCode: '003108004'
    },
    {
        name: 'ARCUGNANO',
        istatCode: '005024006'
    },
    {
        name: 'ARDARA',
        istatCode: '020090005'
    },
    {
        name: 'ARDAULI',
        istatCode: '020095007'
    },
    {
        name: 'ARDEA',
        istatCode: '012058117'
    },
    {
        name: 'ARDENNO',
        istatCode: '003014005'
    },
    {
        name: 'ARDESIO',
        istatCode: '003016012'
    },
    {
        name: 'ARDORE',
        istatCode: '018080005'
    },
    {
        name: 'ARENA',
        istatCode: '018102002'
    },
    {
        name: 'ARENA PO',
        istatCode: '003018005'
    },
    {
        name: 'ARENZANO',
        istatCode: '007010001'
    },
    {
        name: 'ARESE',
        istatCode: '003015009'
    },
    {
        name: 'AREZZO',
        istatCode: '009051002'
    },
    {
        name: 'ARGEGNO',
        istatCode: '003013011'
    },
    {
        name: 'ARGELATO',
        istatCode: '008037002'
    },
    {
        name: 'ARGENTA',
        istatCode: '008038001'
    },
    {
        name: 'ARGENTERA',
        istatCode: '001004006'
    },
    {
        name: 'ARGUELLO',
        istatCode: '001004007'
    },
    {
        name: 'ARGUSTO',
        istatCode: '018079007'
    },
    {
        name: 'ARI',
        istatCode: '013069003'
    },
    {
        name: 'ARIANO IRPINO',
        istatCode: '015064005'
    },
    {
        name: 'ARIANO NEL POLESINE',
        istatCode: '005029002'
    },
    {
        name: 'ARICCIA',
        istatCode: '012058009'
    },
    {
        name: 'ARIELLI',
        istatCode: '013069004'
    },
    {
        name: 'ARIENZO',
        istatCode: '015061004'
    },
    {
        name: 'ARIENZO SANFELICE',
        istatCode: '015061802'
    },
    {
        name: 'ARIGNANO',
        istatCode: '001001012'
    },
    {
        name: 'ARITZO',
        istatCode: '020091001'
    },
    {
        name: 'ARIZZANO',
        istatCode: '001103003'
    },
    {
        name: 'ARLENA DI CASTRO',
        istatCode: '012056002'
    },
    {
        name: 'ARLUNO',
        istatCode: '003015010'
    },
    {
        name: 'ARMENO',
        istatCode: '001003006'
    },
    {
        name: 'ARMENTO',
        istatCode: '017076005'
    },
    {
        name: 'ARMO',
        istatCode: '007008004'
    },
    {
        name: 'ARMUNGIA',
        istatCode: '020111002'
    },
    {
        name: 'ARNAD',
        istatCode: '002007004'
    },
    {
        name: 'ARNARA',
        istatCode: '012060009'
    },
    {
        name: 'ARNASCO',
        istatCode: '007009007'
    },
    {
        name: 'ARNESANO',
        istatCode: '016075007'
    },
    {
        name: 'AROLA',
        istatCode: '001103004'
    },
    {
        name: 'ARONA',
        istatCode: '001003008'
    },
    {
        name: 'AROSIO',
        istatCode: '003013012'
    },
    {
        name: 'ARPAIA',
        istatCode: '015062005'
    },
    {
        name: 'ARPAISE',
        istatCode: '015062006'
    },
    {
        name: 'ARPINO',
        istatCode: '012060010'
    },
    {
        name: 'ARQUA\' PETRARCA',
        istatCode: '005028005'
    },
    {
        name: 'ARQUA\' POLESINE',
        istatCode: '005029003'
    },
    {
        name: 'ARQUATA DEL TRONTO',
        istatCode: '011044006'
    },
    {
        name: 'ARQUATA SCRIVIA',
        istatCode: '001006009'
    },
    {
        name: 'ARRE',
        istatCode: '005028006'
    },
    {
        name: 'ARRONE',
        istatCode: '010055005'
    },
    {
        name: 'ARSAGO SEPRIO',
        istatCode: '003012005'
    },
    {
        name: 'ARSIE\'',
        istatCode: '005025004'
    },
    {
        name: 'ARSIERO',
        istatCode: '005024007'
    },
    {
        name: 'ARSITA',
        istatCode: '013067003'
    },
    {
        name: 'ARSOLI',
        istatCode: '012058010'
    },
    {
        name: 'ARTA TERME',
        istatCode: '006030005'
    },
    {
        name: 'ARTEGNA',
        istatCode: '006030006'
    },
    {
        name: 'ARTENA',
        istatCode: '012058011'
    },
    {
        name: 'ARTOGNE',
        istatCode: '003017007'
    },
    {
        name: 'ARVIER',
        istatCode: '002007005'
    },
    {
        name: 'ARZACHENA',
        istatCode: '020090006'
    },
    {
        name: 'ARZAGO D\'ADDA',
        istatCode: '003016013'
    },
    {
        name: 'ARZANA',
        istatCode: '020091002'
    },
    {
        name: 'ARZANO',
        istatCode: '015063005'
    },
    {
        name: 'ARZENE',
        istatCode: '006093003'
    },
    {
        name: 'ARZERGRANDE',
        istatCode: '005028007'
    },
    {
        name: 'ARZIGNANO',
        istatCode: '005024008'
    },
    {
        name: 'ASCEA',
        istatCode: '015065009'
    },
    {
        name: 'ASCIANO',
        istatCode: '009052002'
    },
    {
        name: 'ASCOLI PICENO',
        istatCode: '011044007'
    },
    {
        name: 'ASCOLI SATRIANO',
        istatCode: '016071005'
    },
    {
        name: 'ASCREA',
        istatCode: '012057004'
    },
    {
        name: 'ASIAGO',
        istatCode: '005024009'
    },
    {
        name: 'ASIGLIANO VENETO',
        istatCode: '005024010'
    },
    {
        name: 'ASIGLIANO VERCELLESE',
        istatCode: '001002007'
    },
    {
        name: 'ASOLA',
        istatCode: '003020002'
    },
    {
        name: 'ASOLO',
        istatCode: '005026003'
    },
    {
        name: 'ASSAGO',
        istatCode: '003015011'
    },
    {
        name: 'ASSEMINI',
        istatCode: '020092003'
    },
    {
        name: 'ASSISI',
        istatCode: '010054001'
    },
    {
        name: 'ASSO',
        istatCode: '003013013'
    },
    {
        name: 'ASSOLO',
        istatCode: '020095008'
    },
    {
        name: 'ASSORO',
        istatCode: '019086003'
    },
    {
        name: 'ASTI',
        istatCode: '001005005'
    },
    {
        name: 'ASUNI',
        istatCode: '020095009'
    },
    {
        name: 'ATELETA',
        istatCode: '013066005'
    },
    {
        name: 'ATELLA',
        istatCode: '017076006'
    },
    {
        name: 'ATELLA DI NAPOLI',
        istatCode: '015061803'
    },
    {
        name: 'ATENA LUCANA',
        istatCode: '015065010'
    },
    {
        name: 'ATESSA',
        istatCode: '013069005'
    },
    {
        name: 'ATINA',
        istatCode: '012060011'
    },
    {
        name: 'ATRANI',
        istatCode: '015065011'
    },
    {
        name: 'ATRI',
        istatCode: '013067004'
    },
    {
        name: 'ATRIPALDA',
        istatCode: '015064006'
    },
    {
        name: 'ATTIGLIANO',
        istatCode: '010055006'
    },
    {
        name: 'ATTIMIS',
        istatCode: '006030007'
    },
    {
        name: 'ATZARA',
        istatCode: '020091003'
    },
    {
        name: 'AUDITORE',
        istatCode: '011041003'
    },
    {
        name: 'AUGUSTA',
        istatCode: '019089001'
    },
    {
        name: 'AULETTA',
        istatCode: '015065012'
    },
    {
        name: 'AULLA',
        istatCode: '009045001'
    },
    {
        name: 'AURANO',
        istatCode: '001103005'
    },
    {
        name: 'AURIGO',
        istatCode: '007008005'
    },
    {
        name: 'AURONZO DI CADORE',
        istatCode: '005025005'
    },
    {
        name: 'AUSONIA',
        istatCode: '012060012'
    },
    {
        name: 'AUSTIS',
        istatCode: '020091004'
    },
    {
        name: 'AVEGNO',
        istatCode: '007010002'
    },
    {
        name: 'AVELENGO - HAFLING',
        istatCode: '004021005'
    },
    {
        name: 'AVELLA',
        istatCode: '015064007'
    },
    {
        name: 'AVELLINO',
        istatCode: '015064008'
    },
    {
        name: 'AVENONE',
        istatCode: '003017805'
    },
    {
        name: 'AVERARA',
        istatCode: '003016014'
    },
    {
        name: 'AVERSA',
        istatCode: '015061005'
    },
    {
        name: 'AVETRANA',
        istatCode: '016073001'
    },
    {
        name: 'AVEZZANO',
        istatCode: '013066006'
    },
    {
        name: 'AVIANO',
        istatCode: '006093004'
    },
    {
        name: 'AVIATICO',
        istatCode: '003016015'
    },
    {
        name: 'AVIGLIANA',
        istatCode: '001001013'
    },
    {
        name: 'AVIGLIANO',
        istatCode: '017076007'
    },
    {
        name: 'AVIGLIANO UMBRO',
        istatCode: '010055033'
    },
    {
        name: 'AVIO',
        istatCode: '004022007'
    },
    {
        name: 'AVISE',
        istatCode: '002007006'
    },
    {
        name: 'AVOLA',
        istatCode: '019089002'
    },
    {
        name: 'AVOLASCA',
        istatCode: '001006010'
    },
    {
        name: 'AYAS',
        istatCode: '002007007'
    },
    {
        name: 'AYMAVILLES',
        istatCode: '002007008'
    },
    {
        name: 'AZEGLIO',
        istatCode: '001001014'
    },
    {
        name: 'AZZANELLO',
        istatCode: '003019004'
    },
    {
        name: 'AZZANO D\'ASTI',
        istatCode: '001005006'
    },
    {
        name: 'AZZANO DECIMO',
        istatCode: '006093005'
    },
    {
        name: 'AZZANO MELLA',
        istatCode: '003017008'
    },
    {
        name: 'AZZANO SAN PAOLO',
        istatCode: '003016016'
    },
    {
        name: 'AZZATE',
        istatCode: '003012006'
    },
    {
        name: 'AZZIO',
        istatCode: '003012007'
    },
    {
        name: 'AZZONE',
        istatCode: '003016017'
    },
    {
        name: 'BACENO',
        istatCode: '001103006'
    },
    {
        name: 'BACOLI',
        istatCode: '015063006'
    },
    {
        name: 'BADALUCCO',
        istatCode: '007008006'
    },
    {
        name: 'BADESI',
        istatCode: '020090081'
    },
    {
        name: 'BADIA - ABTEI',
        istatCode: '004021006'
    },
    {
        name: 'BADIA CALAVENA',
        istatCode: '005023005'
    },
    {
        name: 'BADIA PAVESE',
        istatCode: '003018006'
    },
    {
        name: 'BADIA POLESINE',
        istatCode: '005029004'
    },
    {
        name: 'BADIA TEDALDA',
        istatCode: '009051003'
    },
    {
        name: 'BADOLATO',
        istatCode: '018079008'
    },
    {
        name: 'BAGALADI',
        istatCode: '018080006'
    },
    {
        name: 'BAGHERIA',
        istatCode: '019082006'
    },
    {
        name: 'BAGNACAVALLO',
        istatCode: '008039002'
    },
    {
        name: 'BAGNARA CALABRA',
        istatCode: '018080007'
    },
    {
        name: 'BAGNARA DI ROMAGNA',
        istatCode: '008039003'
    },
    {
        name: 'BAGNARIA',
        istatCode: '003018007'
    },
    {
        name: 'BAGNARIA ARSA',
        istatCode: '006030008'
    },
    {
        name: 'BAGNASCO',
        istatCode: '001004008'
    },
    {
        name: 'BAGNATICA',
        istatCode: '003016018'
    },
    {
        name: 'BAGNI DI LUCCA',
        istatCode: '009046002'
    },
    {
        name: 'BAGNO A RIPOLI',
        istatCode: '009048001'
    },
    {
        name: 'BAGNO DI ROMAGNA',
        istatCode: '008040001'
    },
    {
        name: 'BAGNOLI DEL TRIGNO',
        istatCode: '014094003'
    },
    {
        name: 'BAGNOLI DI SOPRA',
        istatCode: '005028008'
    },
    {
        name: 'BAGNOLI IRPINO',
        istatCode: '015064009'
    },
    {
        name: 'BAGNOLO CREMASCO',
        istatCode: '003019005'
    },
    {
        name: 'BAGNOLO DEL SALENTO',
        istatCode: '016075008'
    },
    {
        name: 'BAGNOLO DI PO',
        istatCode: '005029005'
    },
    {
        name: 'BAGNOLO IN PIANO',
        istatCode: '008035002'
    },
    {
        name: 'BAGNOLO MELLA',
        istatCode: '003017009'
    },
    {
        name: 'BAGNOLO PIEMONTE',
        istatCode: '001004009'
    },
    {
        name: 'BAGNOLO SAN VITO',
        istatCode: '003020003'
    },
    {
        name: 'BAGNONE',
        istatCode: '009045002'
    },
    {
        name: 'BAGNOREGIO',
        istatCode: '012056003'
    },
    {
        name: 'BAGOLINO',
        istatCode: '003017010'
    },
    {
        name: 'BAIA E LATINA',
        istatCode: '015061006'
    },
    {
        name: 'BAIANO',
        istatCode: '015064010'
    },
    {
        name: 'BAIRO',
        istatCode: '001001015'
    },
    {
        name: 'BAIRO TORRE',
        istatCode: '001001804'
    },
    {
        name: 'BAISO',
        istatCode: '008035003'
    },
    {
        name: 'BAJARDO',
        istatCode: '007008007'
    },
    {
        name: 'BALANGERO',
        istatCode: '001001016'
    },
    {
        name: 'BALDICHIERI D\'ASTI',
        istatCode: '001005007'
    },
    {
        name: 'BALDISSERO CANAVESE',
        istatCode: '001001017'
    },
    {
        name: 'BALDISSERO D\'ALBA',
        istatCode: '001004010'
    },
    {
        name: 'BALDISSERO TORINESE',
        istatCode: '001001018'
    },
    {
        name: 'BALESTRATE',
        istatCode: '019082007'
    },
    {
        name: 'BALESTRINO',
        istatCode: '007009008'
    },
    {
        name: 'BALLABIO',
        istatCode: '003097004'
    },
    {
        name: 'BALLAO',
        istatCode: '020111003'
    },
    {
        name: 'BALME',
        istatCode: '001001019'
    },
    {
        name: 'BALMUCCIA',
        istatCode: '001002008'
    },
    {
        name: 'BALOCCO',
        istatCode: '001002009'
    },
    {
        name: 'BALSORANO',
        istatCode: '013066007'
    },
    {
        name: 'BALVANO',
        istatCode: '017076008'
    },
    {
        name: 'BALZOLA',
        istatCode: '001006011'
    },
    {
        name: 'BANARI',
        istatCode: '020090007'
    },
    {
        name: 'BANCHETTE',
        istatCode: '001001020'
    },
    {
        name: 'BANCO',
        istatCode: '004022008'
    },
    {
        name: 'BANNIO ANZINO',
        istatCode: '001103007'
    },
    {
        name: 'BANZI',
        istatCode: '017076009'
    },
    {
        name: 'BAONE',
        istatCode: '005028009'
    },
    {
        name: 'BARADILI',
        istatCode: '020095010'
    },
    {
        name: 'BARAGIANO',
        istatCode: '017076010'
    },
    {
        name: 'BARANELLO',
        istatCode: '014070002'
    },
    {
        name: 'BARANO D\'ISCHIA',
        istatCode: '015063007'
    },
    {
        name: 'BARANZATE',
        istatCode: '003015250'
    },
    {
        name: 'BARASSO',
        istatCode: '003012008'
    },
    {
        name: 'BARATILI SAN PIETRO',
        istatCode: '020095011'
    },
    {
        name: 'BARBANIA',
        istatCode: '001001021'
    },
    {
        name: 'BARBARA',
        istatCode: '011042004'
    },
    {
        name: 'BARBARANO MOSSANO',
        istatCode: '005024124'
    },
    {
        name: 'BARBARANO ROMANO',
        istatCode: '012056004'
    },
    {
        name: 'BARBARANO VICENTINO',
        istatCode: '005024011'
    },
    {
        name: 'BARBARESCO',
        istatCode: '001004011'
    },
    {
        name: 'BARBARIGA',
        istatCode: '003017011'
    },
    {
        name: 'BARBATA',
        istatCode: '003016019'
    },
    {
        name: 'BARBERINO DI MUGELLO',
        istatCode: '009048002'
    },
    {
        name: 'BARBERINO TAVARNELLE',
        istatCode: '009048054'
    },
    {
        name: 'BARBERINO VAL D\'ELSA',
        istatCode: '009048003'
    },
    {
        name: 'BARBIANELLO',
        istatCode: '003018008'
    },
    {
        name: 'BARBIANO - BARBIAN',
        istatCode: '004021007'
    },
    {
        name: 'BARBONA',
        istatCode: '005028010'
    },
    {
        name: 'BARCELLONA POZZO DI GOTTO',
        istatCode: '019083005'
    },
    {
        name: 'BARCHI',
        istatCode: '011041004'
    },
    {
        name: 'BARCIS',
        istatCode: '006093006'
    },
    {
        name: 'BARD',
        istatCode: '002007009'
    },
    {
        name: 'BARDELLO',
        istatCode: '003012009'
    },
    {
        name: 'BARDI',
        istatCode: '008034002'
    },
    {
        name: 'BARDINETO',
        istatCode: '007009009'
    },
    {
        name: 'BARDOLINO',
        istatCode: '005023006'
    },
    {
        name: 'BARDONECCHIA',
        istatCode: '001001022'
    },
    {
        name: 'BAREGGIO',
        istatCode: '003015012'
    },
    {
        name: 'BARENGO',
        istatCode: '001003012'
    },
    {
        name: 'BARESSA',
        istatCode: '020095012'
    },
    {
        name: 'BARETE',
        istatCode: '013066008'
    },
    {
        name: 'BARGA',
        istatCode: '009046003'
    },
    {
        name: 'BARGAGLI',
        istatCode: '007010003'
    },
    {
        name: 'BARGE',
        istatCode: '001004012'
    },
    {
        name: 'BARGHE',
        istatCode: '003017012'
    },
    {
        name: 'BARI',
        istatCode: '016072006'
    },
    {
        name: 'BARI SARDO',
        istatCode: '020091005'
    },
    {
        name: 'BARIANO',
        istatCode: '003016020'
    },
    {
        name: 'BARICELLA',
        istatCode: '008037003'
    },
    {
        name: 'BARILE',
        istatCode: '017076011'
    },
    {
        name: 'BARISCIANO',
        istatCode: '013066009'
    },
    {
        name: 'BARLASSINA',
        istatCode: '003108005'
    },
    {
        name: 'BARLETTA',
        istatCode: '016110002'
    },
    {
        name: 'BARNI',
        istatCode: '003013015'
    },
    {
        name: 'BAROLO',
        istatCode: '001004013'
    },
    {
        name: 'BARONE CANAVESE',
        istatCode: '001001023'
    },
    {
        name: 'BARONISSI',
        istatCode: '015065013'
    },
    {
        name: 'BARRAFRANCA',
        istatCode: '019086004'
    },
    {
        name: 'BARRALI',
        istatCode: '020111004'
    },
    {
        name: 'BARREA',
        istatCode: '013066010'
    },
    {
        name: 'BARUMINI',
        istatCode: '020111005'
    },
    {
        name: 'BARZAGO',
        istatCode: '003097005'
    },
    {
        name: 'BARZANA',
        istatCode: '003016021'
    },
    {
        name: 'BARZANO\'',
        istatCode: '003097006'
    },
    {
        name: 'BARZIO',
        istatCode: '003097007'
    },
    {
        name: 'BASALUZZO',
        istatCode: '001006012'
    },
    {
        name: 'BASCAPE\'',
        istatCode: '003018009'
    },
    {
        name: 'BASCHI',
        istatCode: '010055007'
    },
    {
        name: 'BASCIANO',
        istatCode: '013067005'
    },
    {
        name: 'BASELGA DI PINE\'',
        istatCode: '004022009'
    },
    {
        name: 'BASELICE',
        istatCode: '015062007'
    },
    {
        name: 'BASIANO',
        istatCode: '003015014'
    },
    {
        name: 'BASICO\'',
        istatCode: '019083006'
    },
    {
        name: 'BASIGLIO',
        istatCode: '003015015'
    },
    {
        name: 'BASILIANO',
        istatCode: '006030009'
    },
    {
        name: 'BASSANO BRESCIANO',
        istatCode: '003017013'
    },
    {
        name: 'BASSANO DEL GRAPPA',
        istatCode: '005024012'
    },
    {
        name: 'BASSANO IN TEVERINA',
        istatCode: '012056006'
    },
    {
        name: 'BASSANO ROMANO',
        istatCode: '012056005'
    },
    {
        name: 'BASSIANO',
        istatCode: '012059002'
    },
    {
        name: 'BASSIGNANA',
        istatCode: '001006013'
    },
    {
        name: 'BASTIA',
        istatCode: '010054002'
    },
    {
        name: 'BASTIA MONDOVI\'',
        istatCode: '001004014'
    },
    {
        name: 'BASTIDA DE\' DOSSI',
        istatCode: '003018010'
    },
    {
        name: 'BASTIDA PANCARANA',
        istatCode: '003018011'
    },
    {
        name: 'BASTIGLIA',
        istatCode: '008036001'
    },
    {
        name: 'BATTAGLIA TERME',
        istatCode: '005028011'
    },
    {
        name: 'BATTIFOLLO',
        istatCode: '001004015'
    },
    {
        name: 'BATTIPAGLIA',
        istatCode: '015065014'
    },
    {
        name: 'BATTUDA',
        istatCode: '003018012'
    },
    {
        name: 'BAUCINA',
        istatCode: '019082008'
    },
    {
        name: 'BAULADU',
        istatCode: '020095013'
    },
    {
        name: 'BAUNEI',
        istatCode: '020091006'
    },
    {
        name: 'BAVENO',
        istatCode: '001103008'
    },
    {
        name: 'BAZZANO',
        istatCode: '008037004'
    },
    {
        name: 'BEDERO VALCUVIA',
        istatCode: '003012010'
    },
    {
        name: 'BEDIZZOLE',
        istatCode: '003017014'
    },
    {
        name: 'BEDOLLO',
        istatCode: '004022011'
    },
    {
        name: 'BEDONIA',
        istatCode: '008034003'
    },
    {
        name: 'BEDULITA',
        istatCode: '003016022'
    },
    {
        name: 'BEE',
        istatCode: '001103009'
    },
    {
        name: 'BEINASCO',
        istatCode: '001001024'
    },
    {
        name: 'BEINETTE',
        istatCode: '001004016'
    },
    {
        name: 'BELCASTRO',
        istatCode: '018079009'
    },
    {
        name: 'BELFIORE',
        istatCode: '005023007'
    },
    {
        name: 'BELFORTE ALL\'ISAURO',
        istatCode: '011041005'
    },
    {
        name: 'BELFORTE DEL CHIENTI',
        istatCode: '011043004'
    },
    {
        name: 'BELFORTE MONFERRATO',
        istatCode: '001006014'
    },
    {
        name: 'BELGIOIOSO',
        istatCode: '003018013'
    },
    {
        name: 'BELGIRATE',
        istatCode: '001103010'
    },
    {
        name: 'BELLA',
        istatCode: '017076012'
    },
    {
        name: 'BELLAGIO (A744)',
        istatCode: '003013019'
    },
    {
        name: 'BELLAGIO (M335)',
        istatCode: '003013250'
    },
    {
        name: 'BELLANO',
        istatCode: '003097008'
    },
    {
        name: 'BELLANTE',
        istatCode: '013067006'
    },
    {
        name: 'BELLARIA-IGEA MARINA',
        istatCode: '008099001'
    },
    {
        name: 'BELLEGRA',
        istatCode: '012058012'
    },
    {
        name: 'BELLINO',
        istatCode: '001004017'
    },
    {
        name: 'BELLINZAGO LOMBARDO',
        istatCode: '003015016'
    },
    {
        name: 'BELLINZAGO NOVARESE',
        istatCode: '001003016'
    },
    {
        name: 'BELLIZZI',
        istatCode: '015065158'
    },
    {
        name: 'BELLONA',
        istatCode: '015061007'
    },
    {
        name: 'BELLOSGUARDO',
        istatCode: '015065015'
    },
    {
        name: 'BELLUNO',
        istatCode: '005025006'
    },
    {
        name: 'BELLUSCO',
        istatCode: '003108006'
    },
    {
        name: 'BELMONTE CALABRO',
        istatCode: '018078013'
    },
    {
        name: 'BELMONTE CASTELLO',
        istatCode: '012060013'
    },
    {
        name: 'BELMONTE DEL SANNIO',
        istatCode: '014094004'
    },
    {
        name: 'BELMONTE IN SABINA',
        istatCode: '012057005'
    },
    {
        name: 'BELMONTE MEZZAGNO',
        istatCode: '019082009'
    },
    {
        name: 'BELMONTE PICENO',
        istatCode: '011109003'
    },
    {
        name: 'BELPASSO',
        istatCode: '019087007'
    },
    {
        name: 'BELSITO',
        istatCode: '018078014'
    },
    {
        name: 'BELVEDERE DI SPINELLO',
        istatCode: '018101001'
    },
    {
        name: 'BELVEDERE LANGHE',
        istatCode: '001004018'
    },
    {
        name: 'BELVEDERE MARITTIMO',
        istatCode: '018078015'
    },
    {
        name: 'BELVEDERE OSTRENSE',
        istatCode: '011042005'
    },
    {
        name: 'BELVEGLIO',
        istatCode: '001005008'
    },
    {
        name: 'BELVI',
        istatCode: '020091007'
    },
    {
        name: 'BEMA',
        istatCode: '003014006'
    },
    {
        name: 'BENE LARIO',
        istatCode: '003013021'
    },
    {
        name: 'BENE VAGIENNA',
        istatCode: '001004019'
    },
    {
        name: 'BENESTARE',
        istatCode: '018080008'
    },
    {
        name: 'BENETUTTI',
        istatCode: '020090008'
    },
    {
        name: 'BENEVELLO',
        istatCode: '001004020'
    },
    {
        name: 'BENEVENTO',
        istatCode: '015062008'
    },
    {
        name: 'BENNA',
        istatCode: '001096003'
    },
    {
        name: 'BENTIVOGLIO',
        istatCode: '008037005'
    },
    {
        name: 'BERBENNO',
        istatCode: '003016023'
    },
    {
        name: 'BERBENNO DI VALTELLINA',
        istatCode: '003014007'
    },
    {
        name: 'BERCETO',
        istatCode: '008034004'
    },
    {
        name: 'BERCHIDDA',
        istatCode: '020090009'
    },
    {
        name: 'BEREGAZZO CON FIGLIARO',
        istatCode: '003013022'
    },
    {
        name: 'BEREGUARDO',
        istatCode: '003018014'
    },
    {
        name: 'BERGAMASCO',
        istatCode: '001006015'
    },
    {
        name: 'BERGAMO',
        istatCode: '003016024'
    },
    {
        name: 'BERGANTINO',
        istatCode: '005029006'
    },
    {
        name: 'BERGEGGI',
        istatCode: '007009010'
    },
    {
        name: 'BERGOLO',
        istatCode: '001004021'
    },
    {
        name: 'BERLINGO',
        istatCode: '003017015'
    },
    {
        name: 'BERNALDA',
        istatCode: '017077003'
    },
    {
        name: 'BERNAREGGIO',
        istatCode: '003108007'
    },
    {
        name: 'BERNATE TICINO',
        istatCode: '003015019'
    },
    {
        name: 'BERNEZZO',
        istatCode: '001004022'
    },
    {
        name: 'BERRA',
        istatCode: '008038002'
    },
    {
        name: 'BERSONE',
        istatCode: '004022012'
    },
    {
        name: 'BERTINORO',
        istatCode: '008040003'
    },
    {
        name: 'BERTIOLO',
        istatCode: '006030010'
    },
    {
        name: 'BERTONICO',
        istatCode: '003098002'
    },
    {
        name: 'BERZANO DI SAN PIETRO',
        istatCode: '001005009'
    },
    {
        name: 'BERZANO DI TORTONA',
        istatCode: '001006016'
    },
    {
        name: 'BERZO DEMO',
        istatCode: '003017016'
    },
    {
        name: 'BERZO INFERIORE',
        istatCode: '003017017'
    },
    {
        name: 'BERZO SAN FERMO',
        istatCode: '003016025'
    },
    {
        name: 'BESANA IN BRIANZA',
        istatCode: '003108008'
    },
    {
        name: 'BESANO',
        istatCode: '003012011'
    },
    {
        name: 'BESATE',
        istatCode: '003015022'
    },
    {
        name: 'BESENELLO',
        istatCode: '004022013'
    },
    {
        name: 'BESENZONE',
        istatCode: '008033003'
    },
    {
        name: 'BESNATE',
        istatCode: '003012012'
    },
    {
        name: 'BESOZZO',
        istatCode: '003012013'
    },
    {
        name: 'BESSUDE',
        istatCode: '020090010'
    },
    {
        name: 'BETTOLA',
        istatCode: '008033004'
    },
    {
        name: 'BETTONA',
        istatCode: '010054003'
    },
    {
        name: 'BEURA-CARDEZZA',
        istatCode: '001103011'
    },
    {
        name: 'BEVAGNA',
        istatCode: '010054004'
    },
    {
        name: 'BEVERINO',
        istatCode: '007011003'
    },
    {
        name: 'BEVILACQUA',
        istatCode: '005023008'
    },
    {
        name: 'BEVILACQUA BOSCHI',
        istatCode: '005023803'
    },
    {
        name: 'BEZZECCA',
        istatCode: '004022014'
    },
    {
        name: 'BIANCAVILLA',
        istatCode: '019087008'
    },
    {
        name: 'BIANCHI',
        istatCode: '018078016'
    },
    {
        name: 'BIANCO',
        istatCode: '018080009'
    },
    {
        name: 'BIANDRATE',
        istatCode: '001003018'
    },
    {
        name: 'BIANDRONNO',
        istatCode: '003012014'
    },
    {
        name: 'BIANZANO',
        istatCode: '003016026'
    },
    {
        name: 'BIANZE\'',
        istatCode: '001002011'
    },
    {
        name: 'BIANZONE',
        istatCode: '003014008'
    },
    {
        name: 'BIASSONO',
        istatCode: '003108009'
    },
    {
        name: 'BIBBIANO',
        istatCode: '008035004'
    },
    {
        name: 'BIBBIENA',
        istatCode: '009051004'
    },
    {
        name: 'BIBBONA',
        istatCode: '009049001'
    },
    {
        name: 'BIBIANA',
        istatCode: '001001025'
    },
    {
        name: 'BICCARI',
        istatCode: '016071006'
    },
    {
        name: 'BICINICCO',
        istatCode: '006030011'
    },
    {
        name: 'BIDONI\'',
        istatCode: '020095014'
    },
    {
        name: 'BIELLA',
        istatCode: '001096004'
    },
    {
        name: 'BIENNO',
        istatCode: '003017018'
    },
    {
        name: 'BIENO',
        istatCode: '004022015'
    },
    {
        name: 'BIENTINA',
        istatCode: '009050001'
    },
    {
        name: 'BIGARELLO',
        istatCode: '003020004'
    },
    {
        name: 'BINAGO',
        istatCode: '003013023'
    },
    {
        name: 'BINASCO',
        istatCode: '003015024'
    },
    {
        name: 'BINETTO',
        istatCode: '016072008'
    },
    {
        name: 'BIOGLIO',
        istatCode: '001096005'
    },
    {
        name: 'BIONAZ',
        istatCode: '002007010'
    },
    {
        name: 'BIONE',
        istatCode: '003017019'
    },
    {
        name: 'BIRORI',
        istatCode: '020091008'
    },
    {
        name: 'BISACCIA',
        istatCode: '015064011'
    },
    {
        name: 'BISACQUINO',
        istatCode: '019082010'
    },
    {
        name: 'BISCEGLIE',
        istatCode: '016110003'
    },
    {
        name: 'BISEGNA',
        istatCode: '013066011'
    },
    {
        name: 'BISENTI',
        istatCode: '013067007'
    },
    {
        name: 'BISIGNANO',
        istatCode: '018078017'
    },
    {
        name: 'BISTAGNO',
        istatCode: '001006017'
    },
    {
        name: 'BISUSCHIO',
        istatCode: '003012015'
    },
    {
        name: 'BITETTO',
        istatCode: '016072010'
    },
    {
        name: 'BITONTO',
        istatCode: '016072011'
    },
    {
        name: 'BITRITTO',
        istatCode: '016072012'
    },
    {
        name: 'BITTI',
        istatCode: '020091009'
    },
    {
        name: 'BIVONA',
        istatCode: '019084004'
    },
    {
        name: 'BIVONGI',
        istatCode: '018080010'
    },
    {
        name: 'BIZZARONE',
        istatCode: '003013024'
    },
    {
        name: 'BLEGGIO',
        istatCode: '004022807'
    },
    {
        name: 'BLEGGIO INFERIORE',
        istatCode: '004022016'
    },
    {
        name: 'BLEGGIO SUPERIORE',
        istatCode: '004022017'
    },
    {
        name: 'BLELLO',
        istatCode: '003016027'
    },
    {
        name: 'BLERA',
        istatCode: '012056007'
    },
    {
        name: 'BLESSAGNO',
        istatCode: '003013025'
    },
    {
        name: 'BLEVIO',
        istatCode: '003013026'
    },
    {
        name: 'BLUFI',
        istatCode: '019082082'
    },
    {
        name: 'BOARA PISANI',
        istatCode: '005028012'
    },
    {
        name: 'BOBBIO',
        istatCode: '008033005'
    },
    {
        name: 'BOBBIO PELLICE',
        istatCode: '001001026'
    },
    {
        name: 'BOCA',
        istatCode: '001003019'
    },
    {
        name: 'BOCCHIGLIERO',
        istatCode: '018078018'
    },
    {
        name: 'BOCCIOLETO',
        istatCode: '001002014'
    },
    {
        name: 'BOCENAGO',
        istatCode: '004022018'
    },
    {
        name: 'BODIO LOMNAGO',
        istatCode: '003012016'
    },
    {
        name: 'BOFFALORA D\'ADDA',
        istatCode: '003098003'
    },
    {
        name: 'BOFFALORA SOPRA TICINO',
        istatCode: '003015026'
    },
    {
        name: 'BOGLIASCO',
        istatCode: '007010004'
    },
    {
        name: 'BOGNANCO',
        istatCode: '001103012'
    },
    {
        name: 'BOGOGNO',
        istatCode: '001003021'
    },
    {
        name: 'BOISSANO',
        istatCode: '007009011'
    },
    {
        name: 'BOJANO',
        istatCode: '014070003'
    },
    {
        name: 'BOLANO',
        istatCode: '007011004'
    },
    {
        name: 'BOLBENO',
        istatCode: '004022019'
    },
    {
        name: 'BOLGARE',
        istatCode: '003016028'
    },
    {
        name: 'BOLLATE',
        istatCode: '003015027'
    },
    {
        name: 'BOLLENGO',
        istatCode: '001001027'
    },
    {
        name: 'BOLOGNA',
        istatCode: '008037006'
    },
    {
        name: 'BOLOGNANO',
        istatCode: '013068003'
    },
    {
        name: 'BOLOGNETTA',
        istatCode: '019082011'
    },
    {
        name: 'BOLOGNOLA',
        istatCode: '011043005'
    },
    {
        name: 'BOLOTANA',
        istatCode: '020091010'
    },
    {
        name: 'BOLSENA',
        istatCode: '012056008'
    },
    {
        name: 'BOLTIERE',
        istatCode: '003016029'
    },
    {
        name: 'BOLZANO - BOZEN',
        istatCode: '004021008'
    },
    {
        name: 'BOLZANO NOVARESE',
        istatCode: '001003022'
    },
    {
        name: 'BOLZANO VICENTINO',
        istatCode: '005024013'
    },
    {
        name: 'BOMARZO',
        istatCode: '012056009'
    },
    {
        name: 'BOMBA',
        istatCode: '013069006'
    },
    {
        name: 'BOMPENSIERE',
        istatCode: '019085002'
    },
    {
        name: 'BOMPIETRO',
        istatCode: '019082012'
    },
    {
        name: 'BOMPORTO',
        istatCode: '008036002'
    },
    {
        name: 'BONARCADO',
        istatCode: '020095015'
    },
    {
        name: 'BONASSOLA',
        istatCode: '007011005'
    },
    {
        name: 'BONATE SOPRA',
        istatCode: '003016030'
    },
    {
        name: 'BONATE SOTTO',
        istatCode: '003016031'
    },
    {
        name: 'BONAVIGO',
        istatCode: '005023009'
    },
    {
        name: 'BONDENO',
        istatCode: '008038003'
    },
    {
        name: 'BONDO',
        istatCode: '004022020'
    },
    {
        name: 'BONDO BREGUZZO',
        istatCode: '004022809'
    },
    {
        name: 'BONDONE',
        istatCode: '004022021'
    },
    {
        name: 'BONEA',
        istatCode: '015062009'
    },
    {
        name: 'BONEFRO',
        istatCode: '014070004'
    },
    {
        name: 'BONEMERSE',
        istatCode: '003019006'
    },
    {
        name: 'BONIFATI',
        istatCode: '018078019'
    },
    {
        name: 'BONITO',
        istatCode: '015064012'
    },
    {
        name: 'BONNANARO',
        istatCode: '020090011'
    },
    {
        name: 'BONO',
        istatCode: '020090012'
    },
    {
        name: 'BONORVA',
        istatCode: '020090013'
    },
    {
        name: 'BONVICINO',
        istatCode: '001004023'
    },
    {
        name: 'BORBONA',
        istatCode: '012057006'
    },
    {
        name: 'BORCA DI CADORE',
        istatCode: '005025007'
    },
    {
        name: 'BORDANO',
        istatCode: '006030012'
    },
    {
        name: 'BORDIGHERA',
        istatCode: '007008008'
    },
    {
        name: 'BORDOLANO',
        istatCode: '003019007'
    },
    {
        name: 'BORE',
        istatCode: '008034005'
    },
    {
        name: 'BORETTO',
        istatCode: '008035005'
    },
    {
        name: 'BORGARELLO',
        istatCode: '003018015'
    },
    {
        name: 'BORGARO TORINESE',
        istatCode: '001001028'
    },
    {
        name: 'BORGETTO',
        istatCode: '019082013'
    },
    {
        name: 'BORGHETTO D\'ARROSCIA',
        istatCode: '007008009'
    },
    {
        name: 'BORGHETTO DI BORBERA',
        istatCode: '001006018'
    },
    {
        name: 'BORGHETTO DI VARA',
        istatCode: '007011006'
    },
    {
        name: 'BORGHETTO LODIGIANO',
        istatCode: '003098004'
    },
    {
        name: 'BORGHETTO SANTO SPIRITO',
        istatCode: '007009012'
    },
    {
        name: 'BORGHI',
        istatCode: '008040004'
    },
    {
        name: 'BORGIA',
        istatCode: '018079011'
    },
    {
        name: 'BORGIALLO',
        istatCode: '001001029'
    },
    {
        name: 'BORGIO VEREZZI',
        istatCode: '007009013'
    },
    {
        name: 'BORGO A MOZZANO',
        istatCode: '009046004'
    },
    {
        name: 'BORGO CHIESE',
        istatCode: '004022238'
    },
    {
        name: 'BORGO D\'ALE',
        istatCode: '001002015'
    },
    {
        name: 'BORGO D`ANAUNIA',
        istatCode: '004022252'
    },
    {
        name: 'BORGO DI TERZO',
        istatCode: '003016032'
    },
    {
        name: 'BORGO LARES',
        istatCode: '004022239'
    },
    {
        name: 'BORGO MANTOVANO',
        istatCode: '003020072'
    },
    {
        name: 'BORGO PACE',
        istatCode: '011041006'
    },
    {
        name: 'BORGO PANIGALE',
        istatCode: '008037801'
    },
    {
        name: 'BORGO PRIOLO',
        istatCode: '003018016'
    },
    {
        name: 'BORGO SAN DALMAZZO',
        istatCode: '001004025'
    },
    {
        name: 'BORGO SAN GIACOMO',
        istatCode: '003017020'
    },
    {
        name: 'BORGO SAN GIOVANNI',
        istatCode: '003098005'
    },
    {
        name: 'BORGO SAN LORENZO',
        istatCode: '009048004'
    },
    {
        name: 'BORGO SAN MARTINO',
        istatCode: '001006020'
    },
    {
        name: 'BORGO SAN SIRO',
        istatCode: '003018018'
    },
    {
        name: 'BORGO TICINO',
        istatCode: '001003025'
    },
    {
        name: 'BORGO TOSSIGNANO',
        istatCode: '008037007'
    },
    {
        name: 'BORGO VAL DI TARO',
        istatCode: '008034006'
    },
    {
        name: 'BORGO VALBELLUNA',
        istatCode: '005025074'
    },
    {
        name: 'BORGO VALSUGANA',
        istatCode: '004022022'
    },
    {
        name: 'BORGO VELINO',
        istatCode: '012057008'
    },
    {
        name: 'BORGO VENETO',
        istatCode: '005028107'
    },
    {
        name: 'BORGO VERCELLI',
        istatCode: '001002017'
    },
    {
        name: 'BORGO VIRGILIO',
        istatCode: '003020071'
    },
    {
        name: 'BORGOCARBONARA',
        istatCode: '003020073'
    },
    {
        name: 'BORGOFORTE',
        istatCode: '003020005'
    },
    {
        name: 'BORGOFRANCO D\'IVREA',
        istatCode: '001001030'
    },
    {
        name: 'BORGOFRANCO SUL PO',
        istatCode: '003020006'
    },
    {
        name: 'BORGOLAVEZZARO',
        istatCode: '001003023'
    },
    {
        name: 'BORGOMALE',
        istatCode: '001004024'
    },
    {
        name: 'BORGOMANERO',
        istatCode: '001003024'
    },
    {
        name: 'BORGOMARO',
        istatCode: '007008010'
    },
    {
        name: 'BORGOMASINO',
        istatCode: '001001031'
    },
    {
        name: 'BORGOMEZZAVALLE',
        istatCode: '001103078'
    },
    {
        name: 'BORGONE SUSA',
        istatCode: '001001032'
    },
    {
        name: 'BORGONOVO VAL TIDONE',
        istatCode: '008033006'
    },
    {
        name: 'BORGORATTO ALESSANDRINO',
        istatCode: '001006019'
    },
    {
        name: 'BORGORATTO MORMOROLO',
        istatCode: '003018017'
    },
    {
        name: 'BORGORICCO',
        istatCode: '005028013'
    },
    {
        name: 'BORGOROSE',
        istatCode: '012057007'
    },
    {
        name: 'BORGOSATOLLO',
        istatCode: '003017021'
    },
    {
        name: 'BORGOSESIA',
        istatCode: '001002016'
    },
    {
        name: 'BORGOUNITO',
        istatCode: '003016809'
    },
    {
        name: 'BORMIDA',
        istatCode: '007009014'
    },
    {
        name: 'BORMIO',
        istatCode: '003014009'
    },
    {
        name: 'BORNASCO',
        istatCode: '003018019'
    },
    {
        name: 'BORNATO',
        istatCode: '003017810'
    },
    {
        name: 'BORNO',
        istatCode: '003017022'
    },
    {
        name: 'BORONEDDU',
        istatCode: '020095016'
    },
    {
        name: 'BORORE',
        istatCode: '020091011'
    },
    {
        name: 'BORRELLO',
        istatCode: '013069007'
    },
    {
        name: 'BORRIANA',
        istatCode: '001096006'
    },
    {
        name: 'BORSO DEL GRAPPA',
        istatCode: '005026004'
    },
    {
        name: 'BORTIGALI',
        istatCode: '020091012'
    },
    {
        name: 'BORTIGIADAS',
        istatCode: '020090014'
    },
    {
        name: 'BORUTTA',
        istatCode: '020090015'
    },
    {
        name: 'BORZONASCA',
        istatCode: '007010005'
    },
    {
        name: 'BOSA',
        istatCode: '020095079'
    },
    {
        name: 'BOSARO',
        istatCode: '005029007'
    },
    {
        name: 'BOSCHI SANT\'ANNA',
        istatCode: '005023010'
    },
    {
        name: 'BOSCO CHIESANUOVA',
        istatCode: '005023011'
    },
    {
        name: 'BOSCO MARENGO',
        istatCode: '001006021'
    },
    {
        name: 'BOSCONERO',
        istatCode: '001001033'
    },
    {
        name: 'BOSCOREALE',
        istatCode: '015063008'
    },
    {
        name: 'BOSCOTRECASE',
        istatCode: '015063009'
    },
    {
        name: 'BOSENTINO',
        istatCode: '004022023'
    },
    {
        name: 'BOSIA',
        istatCode: '001004026'
    },
    {
        name: 'BOSIO',
        istatCode: '001006022'
    },
    {
        name: 'BOSISIO PARINI',
        istatCode: '003097009'
    },
    {
        name: 'BOSNASCO',
        istatCode: '003018020'
    },
    {
        name: 'BOSSICO',
        istatCode: '003016033'
    },
    {
        name: 'BOSSOLASCO',
        istatCode: '001004027'
    },
    {
        name: 'BOTRICELLO',
        istatCode: '018079012'
    },
    {
        name: 'BOTRUGNO',
        istatCode: '016075009'
    },
    {
        name: 'BOTTANUCO',
        istatCode: '003016034'
    },
    {
        name: 'BOTTICINO',
        istatCode: '003017023'
    },
    {
        name: 'BOTTICINO SERA',
        istatCode: '003017812'
    },
    {
        name: 'BOTTIDDA',
        istatCode: '020090016'
    },
    {
        name: 'BOVA',
        istatCode: '018080011'
    },
    {
        name: 'BOVA MARINA',
        istatCode: '018080013'
    },
    {
        name: 'BOVALINO',
        istatCode: '018080012'
    },
    {
        name: 'BOVEGNO',
        istatCode: '003017024'
    },
    {
        name: 'BOVES',
        istatCode: '001004028'
    },
    {
        name: 'BOVEZZO',
        istatCode: '003017025'
    },
    {
        name: 'BOVILLE ERNICA',
        istatCode: '012060014'
    },
    {
        name: 'BOVINO',
        istatCode: '016071007'
    },
    {
        name: 'BOVISIO-MASCIAGO',
        istatCode: '003108010'
    },
    {
        name: 'BOVOLENTA',
        istatCode: '005028014'
    },
    {
        name: 'BOVOLONE',
        istatCode: '005023012'
    },
    {
        name: 'BOZZOLE',
        istatCode: '001006023'
    },
    {
        name: 'BOZZOLO',
        istatCode: '003020007'
    },
    {
        name: 'BRA',
        istatCode: '001004029'
    },
    {
        name: 'BRACCA',
        istatCode: '003016035'
    },
    {
        name: 'BRACCA DI COSTA SERINA',
        istatCode: '003016553'
    },
    {
        name: 'BRACCIANO',
        istatCode: '012058013'
    },
    {
        name: 'BRACIGLIANO',
        istatCode: '015065016'
    },
    {
        name: 'BRAIES - PRAGS',
        istatCode: '004021009'
    },
    {
        name: 'BRALLO DI PREGOLA',
        istatCode: '003018021'
    },
    {
        name: 'BRANCALEONE',
        istatCode: '018080014'
    },
    {
        name: 'BRANDICO',
        istatCode: '003017026'
    },
    {
        name: 'BRANDIZZO',
        istatCode: '001001034'
    },
    {
        name: 'BRANZI',
        istatCode: '003016036'
    },
    {
        name: 'BRAONE',
        istatCode: '003017027'
    },
    {
        name: 'BREBBIA',
        istatCode: '003012017'
    },
    {
        name: 'BRECCIA',
        istatCode: '003013820'
    },
    {
        name: 'BREDA DI PIAVE',
        istatCode: '005026005'
    },
    {
        name: 'BREGANO',
        istatCode: '003012018'
    },
    {
        name: 'BREGANZE',
        istatCode: '005024014'
    },
    {
        name: 'BREGNANO',
        istatCode: '003013028'
    },
    {
        name: 'BREGUZZO',
        istatCode: '004022024'
    },
    {
        name: 'BREIA',
        istatCode: '001002019'
    },
    {
        name: 'BREMBATE',
        istatCode: '003016037'
    },
    {
        name: 'BREMBATE DI SOPRA',
        istatCode: '003016038'
    },
    {
        name: 'BREMBILLA',
        istatCode: '003016039'
    },
    {
        name: 'BREMBIO',
        istatCode: '003098006'
    },
    {
        name: 'BREME',
        istatCode: '003018022'
    },
    {
        name: 'BRENDOLA',
        istatCode: '005024015'
    },
    {
        name: 'BRENNA',
        istatCode: '003013029'
    },
    {
        name: 'BRENNERO - BRENNER',
        istatCode: '004021010'
    },
    {
        name: 'BRENO',
        istatCode: '003017028'
    },
    {
        name: 'BRENTA',
        istatCode: '003012019'
    },
    {
        name: 'BRENTINO BELLUNO',
        istatCode: '005023013'
    },
    {
        name: 'BRENTONICO',
        istatCode: '004022025'
    },
    {
        name: 'BRENZONE',
        istatCode: '005023014'
    },
    {
        name: 'BREONIO',
        istatCode: '005023805'
    },
    {
        name: 'BRESCELLO',
        istatCode: '008035006'
    },
    {
        name: 'BRESCIA',
        istatCode: '003017029'
    },
    {
        name: 'BRESIMO',
        istatCode: '004022026'
    },
    {
        name: 'BRESSANA BOTTARONE',
        istatCode: '003018023'
    },
    {
        name: 'BRESSANONE - BRIXEN',
        istatCode: '004021011'
    },
    {
        name: 'BRESSANVIDO',
        istatCode: '005024016'
    },
    {
        name: 'BRESSO',
        istatCode: '003015032'
    },
    {
        name: 'BREZ',
        istatCode: '004022027'
    },
    {
        name: 'BREZZO DI BEDERO',
        istatCode: '003012020'
    },
    {
        name: 'BRIAGLIA',
        istatCode: '001004030'
    },
    {
        name: 'BRIATICO',
        istatCode: '018102003'
    },
    {
        name: 'BRICHERASIO',
        istatCode: '001001035'
    },
    {
        name: 'BRIENNO',
        istatCode: '003013030'
    },
    {
        name: 'BRIENZA',
        istatCode: '017076013'
    },
    {
        name: 'BRIGA ALTA',
        istatCode: '001004031'
    },
    {
        name: 'BRIGA MARITTIMA',
        istatCode: '001004805'
    },
    {
        name: 'BRIGA NOVARESE',
        istatCode: '001003026'
    },
    {
        name: 'BRIGNANO GERA D\'ADDA',
        istatCode: '003016040'
    },
    {
        name: 'BRIGNANO-FRASCATA',
        istatCode: '001006024'
    },
    {
        name: 'BRINDISI',
        istatCode: '016074001'
    },
    {
        name: 'BRINDISI MONTAGNA',
        istatCode: '017076014'
    },
    {
        name: 'BRINZIO',
        istatCode: '003012021'
    },
    {
        name: 'BRIONA',
        istatCode: '001003027'
    },
    {
        name: 'BRIONE (BS)',
        istatCode: '003017030'
    },
    {
        name: 'BRIONE (TN)',
        istatCode: '004022028'
    },
    {
        name: 'BRIOSCO',
        istatCode: '003108011'
    },
    {
        name: 'BRISIGHELLA',
        istatCode: '008039004'
    },
    {
        name: 'BRISSAGO-VALTRAVAGLIA',
        istatCode: '003012022'
    },
    {
        name: 'BRISSOGNE',
        istatCode: '002007011'
    },
    {
        name: 'BRITTOLI',
        istatCode: '013068004'
    },
    {
        name: 'BRIVIO',
        istatCode: '003097010'
    },
    {
        name: 'BROCCOSTELLA',
        istatCode: '012060015'
    },
    {
        name: 'BROGLIANO',
        istatCode: '005024017'
    },
    {
        name: 'BROGNATURO',
        istatCode: '018102004'
    },
    {
        name: 'BROLO',
        istatCode: '019083007'
    },
    {
        name: 'BRONDELLO',
        istatCode: '001004032'
    },
    {
        name: 'BRONI',
        istatCode: '003018024'
    },
    {
        name: 'BRONTE',
        istatCode: '019087009'
    },
    {
        name: 'BRONZOLO - BRANZOLL',
        istatCode: '004021012'
    },
    {
        name: 'BROSSASCO',
        istatCode: '001004033'
    },
    {
        name: 'BROSSO',
        istatCode: '001001036'
    },
    {
        name: 'BROVELLO-CARPUGNINO',
        istatCode: '001103013'
    },
    {
        name: 'BROZOLO',
        istatCode: '001001037'
    },
    {
        name: 'BRUGHERIO',
        istatCode: '003108012'
    },
    {
        name: 'BRUGINE',
        istatCode: '005028015'
    },
    {
        name: 'BRUGNATO',
        istatCode: '007011007'
    },
    {
        name: 'BRUGNERA',
        istatCode: '006093007'
    },
    {
        name: 'BRUINO',
        istatCode: '001001038'
    },
    {
        name: 'BRUMANO',
        istatCode: '003016041'
    },
    {
        name: 'BRUNATE',
        istatCode: '003013032'
    },
    {
        name: 'BRUNELLO',
        istatCode: '003012023'
    },
    {
        name: 'BRUNICO - BRUNECK',
        istatCode: '004021013'
    },
    {
        name: 'BRUNO',
        istatCode: '001005010'
    },
    {
        name: 'BRUSAPORTO',
        istatCode: '003016042'
    },
    {
        name: 'BRUSASCO',
        istatCode: '001001039'
    },
    {
        name: 'BRUSASCO CAVAGNOLO',
        istatCode: '001001505'
    },
    {
        name: 'BRUSCIANO',
        istatCode: '015063010'
    },
    {
        name: 'BRUSIMPIANO',
        istatCode: '003012024'
    },
    {
        name: 'BRUSNENGO',
        istatCode: '001096007'
    },
    {
        name: 'BRUSSON',
        istatCode: '002007012'
    },
    {
        name: 'BRUZOLO',
        istatCode: '001001040'
    },
    {
        name: 'BRUZZANO ZEFFIRIO',
        istatCode: '018080015'
    },
    {
        name: 'BUBBIANO',
        istatCode: '003015035'
    },
    {
        name: 'BUBBIO',
        istatCode: '001005011'
    },
    {
        name: 'BUCCHERI',
        istatCode: '019089003'
    },
    {
        name: 'BUCCHIANICO',
        istatCode: '013069008'
    },
    {
        name: 'BUCCIANO',
        istatCode: '015062010'
    },
    {
        name: 'BUCCINASCO',
        istatCode: '003015036'
    },
    {
        name: 'BUCCINO',
        istatCode: '015065017'
    },
    {
        name: 'BUCINE',
        istatCode: '009051005'
    },
    {
        name: 'BUDDUSO\'',
        istatCode: '020090017'
    },
    {
        name: 'BUDOIA',
        istatCode: '006093008'
    },
    {
        name: 'BUDONI',
        istatCode: '020090091'
    },
    {
        name: 'BUDRIO',
        istatCode: '008037008'
    },
    {
        name: 'BUGGERRU',
        istatCode: '020111006'
    },
    {
        name: 'BUGGIANO',
        istatCode: '009047003'
    },
    {
        name: 'BUGLIO IN MONTE',
        istatCode: '003014010'
    },
    {
        name: 'BUGNARA',
        istatCode: '013066012'
    },
    {
        name: 'BUGUGGIATE',
        istatCode: '003012025'
    },
    {
        name: 'BUIE D\'ISTRIA',
        istatCode: '006702707'
    },
    {
        name: 'BUJA',
        istatCode: '006030013'
    },
    {
        name: 'BULCIAGO',
        istatCode: '003097011'
    },
    {
        name: 'BULGAROGRASSO',
        istatCode: '003013034'
    },
    {
        name: 'BULTEI',
        istatCode: '020090018'
    },
    {
        name: 'BULZI',
        istatCode: '020090019'
    },
    {
        name: 'BUONABITACOLO',
        istatCode: '015065018'
    },
    {
        name: 'BUONALBERGO',
        istatCode: '015062011'
    },
    {
        name: 'BUONCONVENTO',
        istatCode: '009052003'
    },
    {
        name: 'BUONVICINO',
        istatCode: '018078020'
    },
    {
        name: 'BURAGO DI MOLGORA',
        istatCode: '003108013'
    },
    {
        name: 'BURCEI',
        istatCode: '020111007'
    },
    {
        name: 'BURGIO',
        istatCode: '019084005'
    },
    {
        name: 'BURGOS',
        istatCode: '020090020'
    },
    {
        name: 'BURIASCO',
        istatCode: '001001041'
    },
    {
        name: 'BUROLO',
        istatCode: '001001042'
    },
    {
        name: 'BURONZO',
        istatCode: '001002021'
    },
    {
        name: 'BUSACHI',
        istatCode: '020095017'
    },
    {
        name: 'BUSALLA',
        istatCode: '007010006'
    },
    {
        name: 'BUSANA',
        istatCode: '008035007'
    },
    {
        name: 'BUSANO',
        istatCode: '001001043'
    },
    {
        name: 'BUSCA',
        istatCode: '001004034'
    },
    {
        name: 'BUSCATE',
        istatCode: '003015038'
    },
    {
        name: 'BUSCEMI',
        istatCode: '019089004'
    },
    {
        name: 'BUSETO PALIZZOLO',
        istatCode: '019081002'
    },
    {
        name: 'BUSNAGO',
        istatCode: '003108051'
    },
    {
        name: 'BUSO SARZANO',
        istatCode: '005029805'
    },
    {
        name: 'BUSSERO',
        istatCode: '003015040'
    },
    {
        name: 'BUSSETO',
        istatCode: '008034007'
    },
    {
        name: 'BUSSI SUL TIRINO',
        istatCode: '013068005'
    },
    {
        name: 'BUSSO',
        istatCode: '014070005'
    },
    {
        name: 'BUSSOLENGO',
        istatCode: '005023015'
    },
    {
        name: 'BUSSOLENO',
        istatCode: '001001044'
    },
    {
        name: 'BUSTO ARSIZIO',
        istatCode: '003012026'
    },
    {
        name: 'BUSTO GAROLFO',
        istatCode: '003015041'
    },
    {
        name: 'BUTERA',
        istatCode: '019085003'
    },
    {
        name: 'BUTI',
        istatCode: '009050002'
    },
    {
        name: 'BUTTAPIETRA',
        istatCode: '005023016'
    },
    {
        name: 'BUTTIGLIERA ALTA',
        istatCode: '001001045'
    },
    {
        name: 'BUTTIGLIERA D\'ASTI',
        istatCode: '001005012'
    },
    {
        name: 'BUTTRIO',
        istatCode: '006030014'
    },
    {
        name: 'CA\' D\'ANDREA',
        istatCode: '003019008'
    },
    {
        name: 'CABELLA LIGURE',
        istatCode: '001006025'
    },
    {
        name: 'CABIATE',
        istatCode: '003013035'
    },
    {
        name: 'CABRAS',
        istatCode: '020095018'
    },
    {
        name: 'CACCAMO',
        istatCode: '019082014'
    },
    {
        name: 'CACCURI',
        istatCode: '018101002'
    },
    {
        name: 'CADEGLIANO-VICONAGO',
        istatCode: '003012027'
    },
    {
        name: 'CADELBOSCO DI SOPRA',
        istatCode: '008035008'
    },
    {
        name: 'CADEO',
        istatCode: '008033007'
    },
    {
        name: 'CADERZONE',
        istatCode: '004022029'
    },
    {
        name: 'CADONEGHE',
        istatCode: '005028016'
    },
    {
        name: 'CADORAGO',
        istatCode: '003013036'
    },
    {
        name: 'CADREZZATE',
        istatCode: '003012028'
    },
    {
        name: 'CADREZZATE CON OSMATE',
        istatCode: '003012143'
    },
    {
        name: 'CAERANO DI SAN MARCO',
        istatCode: '005026006'
    },
    {
        name: 'CAFASSE',
        istatCode: '001001046'
    },
    {
        name: 'CAGGIANO',
        istatCode: '015065019'
    },
    {
        name: 'CAGLI',
        istatCode: '011041007'
    },
    {
        name: 'CAGLIARI',
        istatCode: '020092009'
    },
    {
        name: 'CAGLIO',
        istatCode: '003013037'
    },
    {
        name: 'CAGNANO AMITERNO',
        istatCode: '013066013'
    },
    {
        name: 'CAGNANO VARANO',
        istatCode: '016071008'
    },
    {
        name: 'CAGNO',
        istatCode: '003013038'
    },
    {
        name: 'CAGNO\'',
        istatCode: '004022030'
    },
    {
        name: 'CAIANELLO',
        istatCode: '015061008'
    },
    {
        name: 'CAIAZZO',
        istatCode: '015061009'
    },
    {
        name: 'CAINES - KUENS',
        istatCode: '004021014'
    },
    {
        name: 'CAINO',
        istatCode: '003017031'
    },
    {
        name: 'CAIOLO',
        istatCode: '003014011'
    },
    {
        name: 'CAIRANO',
        istatCode: '015064013'
    },
    {
        name: 'CAIRATE',
        istatCode: '003012029'
    },
    {
        name: 'CAIRO MONTENOTTE',
        istatCode: '007009015'
    },
    {
        name: 'CAIVANO',
        istatCode: '015063011'
    },
    {
        name: 'CALABRITTO',
        istatCode: '015064014'
    },
    {
        name: 'CALALZO DI CADORE',
        istatCode: '005025008'
    },
    {
        name: 'CALAMANDRANA',
        istatCode: '001005013'
    },
    {
        name: 'CALAMONACI',
        istatCode: '019084006'
    },
    {
        name: 'CALANGIANUS',
        istatCode: '020090021'
    },
    {
        name: 'CALANNA',
        istatCode: '018080016'
    },
    {
        name: 'CALASCA-CASTIGLIONE',
        istatCode: '001103014'
    },
    {
        name: 'CALASCIBETTA',
        istatCode: '019086005'
    },
    {
        name: 'CALASCIO',
        istatCode: '013066014'
    },
    {
        name: 'CALASETTA',
        istatCode: '020111008'
    },
    {
        name: 'CALATABIANO',
        istatCode: '019087010'
    },
    {
        name: 'CALATAFIMI-SEGESTA',
        istatCode: '019081003'
    },
    {
        name: 'CALAVINO',
        istatCode: '004022031'
    },
    {
        name: 'CALCATA',
        istatCode: '012056010'
    },
    {
        name: 'CALCERANICA AL LAGO',
        istatCode: '004022032'
    },
    {
        name: 'CALCI',
        istatCode: '009050003'
    },
    {
        name: 'CALCIANO',
        istatCode: '017077004'
    },
    {
        name: 'CALCINAIA',
        istatCode: '009050004'
    },
    {
        name: 'CALCINATE',
        istatCode: '003016043'
    },
    {
        name: 'CALCINATO',
        istatCode: '003017032'
    },
    {
        name: 'CALCIO',
        istatCode: '003016044'
    },
    {
        name: 'CALCO',
        istatCode: '003097012'
    },
    {
        name: 'CALDARO SULLA STRADA DEL VINO - KALTERN AN DER WEINSTRASSE',
        istatCode: '004021015'
    },
    {
        name: 'CALDAROLA',
        istatCode: '011043006'
    },
    {
        name: 'CALDERARA DI RENO',
        istatCode: '008037009'
    },
    {
        name: 'CALDES',
        istatCode: '004022033'
    },
    {
        name: 'CALDIERO',
        istatCode: '005023017'
    },
    {
        name: 'CALDOGNO',
        istatCode: '005024018'
    },
    {
        name: 'CALDONAZZO',
        istatCode: '004022034'
    },
    {
        name: 'CALENDASCO',
        istatCode: '008033008'
    },
    {
        name: 'CALENZANO',
        istatCode: '009048005'
    },
    {
        name: 'CALESTANO',
        istatCode: '008034008'
    },
    {
        name: 'CALICE AL CORNOVIGLIO',
        istatCode: '007011008'
    },
    {
        name: 'CALICE LIGURE',
        istatCode: '007009016'
    },
    {
        name: 'CALIMERA',
        istatCode: '016075010'
    },
    {
        name: 'CALITRI',
        istatCode: '015064015'
    },
    {
        name: 'CALIZZANO',
        istatCode: '007009017'
    },
    {
        name: 'CALLABIANA',
        istatCode: '001096008'
    },
    {
        name: 'CALLIANO (AT)',
        istatCode: '001005014'
    },
    {
        name: 'CALLIANO (TN)',
        istatCode: '004022035'
    },
    {
        name: 'CALOLZIOCORTE',
        istatCode: '003097013'
    },
    {
        name: 'CALOPEZZATI',
        istatCode: '018078021'
    },
    {
        name: 'CALOSSO',
        istatCode: '001005015'
    },
    {
        name: 'CALOVETO',
        istatCode: '018078022'
    },
    {
        name: 'CALTABELLOTTA',
        istatCode: '019084007'
    },
    {
        name: 'CALTAGIRONE',
        istatCode: '019087011'
    },
    {
        name: 'CALTANISSETTA',
        istatCode: '019085004'
    },
    {
        name: 'CALTAVUTURO',
        istatCode: '019082015'
    },
    {
        name: 'CALTIGNAGA',
        istatCode: '001003030'
    },
    {
        name: 'CALTO',
        istatCode: '005029008'
    },
    {
        name: 'CALTRANO',
        istatCode: '005024019'
    },
    {
        name: 'CALUSCO D\'ADDA',
        istatCode: '003016046'
    },
    {
        name: 'CALUSO',
        istatCode: '001001047'
    },
    {
        name: 'CALVAGESE DELLA RIVIERA',
        istatCode: '003017033'
    },
    {
        name: 'CALVANICO',
        istatCode: '015065020'
    },
    {
        name: 'CALVATONE',
        istatCode: '003019009'
    },
    {
        name: 'CALVELLO',
        istatCode: '017076015'
    },
    {
        name: 'CALVENE',
        istatCode: '005024020'
    },
    {
        name: 'CALVENZANO',
        istatCode: '003016047'
    },
    {
        name: 'CALVERA',
        istatCode: '017076016'
    },
    {
        name: 'CALVI',
        istatCode: '015062012'
    },
    {
        name: 'CALVI DELL\'UMBRIA',
        istatCode: '010055008'
    },
    {
        name: 'CALVI RISORTA',
        istatCode: '015061010'
    },
    {
        name: 'CALVI SAN NAZZARO',
        istatCode: '015062500'
    },
    {
        name: 'CALVIGNANO',
        istatCode: '003018025'
    },
    {
        name: 'CALVIGNASCO',
        istatCode: '003015042'
    },
    {
        name: 'CALVISANO',
        istatCode: '003017034'
    },
    {
        name: 'CALVIZZANO',
        istatCode: '015063012'
    },
    {
        name: 'CAMAGNA MONFERRATO',
        istatCode: '001006026'
    },
    {
        name: 'CAMAIORE',
        istatCode: '009046005'
    },
    {
        name: 'CAMAIRAGO',
        istatCode: '003098007'
    },
    {
        name: 'CAMANDONA',
        istatCode: '001096009'
    },
    {
        name: 'CAMARDA',
        istatCode: '013066803'
    },
    {
        name: 'CAMASTRA',
        istatCode: '019084008'
    },
    {
        name: 'CAMBIAGO',
        istatCode: '003015044'
    },
    {
        name: 'CAMBIANO',
        istatCode: '001001048'
    },
    {
        name: 'CAMBIASCA',
        istatCode: '001103015'
    },
    {
        name: 'CAMBURZANO',
        istatCode: '001096010'
    },
    {
        name: 'CAMERANA',
        istatCode: '001004035'
    },
    {
        name: 'CAMERANO',
        istatCode: '011042006'
    },
    {
        name: 'CAMERANO CASASCO',
        istatCode: '001005016'
    },
    {
        name: 'CAMERATA CORNELLO',
        istatCode: '003016048'
    },
    {
        name: 'CAMERATA NUOVA',
        istatCode: '012058014'
    },
    {
        name: 'CAMERATA PICENA',
        istatCode: '011042007'
    },
    {
        name: 'CAMERI',
        istatCode: '001003032'
    },
    {
        name: 'CAMERINO',
        istatCode: '011043007'
    },
    {
        name: 'CAMEROTA',
        istatCode: '015065021'
    },
    {
        name: 'CAMIGLIANO',
        istatCode: '015061011'
    },
    {
        name: 'CAMINATA',
        istatCode: '008033009'
    },
    {
        name: 'CAMINI',
        istatCode: '018080017'
    },
    {
        name: 'CAMINO',
        istatCode: '001006027'
    },
    {
        name: 'CAMINO AL TAGLIAMENTO',
        istatCode: '006030015'
    },
    {
        name: 'CAMISANO',
        istatCode: '003019010'
    },
    {
        name: 'CAMISANO VICENTINO',
        istatCode: '005024021'
    },
    {
        name: 'CAMMARATA',
        istatCode: '019084009'
    },
    {
        name: 'CAMNAGO VOLTA',
        istatCode: '003013831'
    },
    {
        name: 'CAMO',
        istatCode: '001004036'
    },
    {
        name: 'CAMOGLI',
        istatCode: '007010007'
    },
    {
        name: 'CAMPAGNA',
        istatCode: '015065022'
    },
    {
        name: 'CAMPAGNA LUPIA',
        istatCode: '005027002'
    },
    {
        name: 'CAMPAGNANO DI ROMA',
        istatCode: '012058015'
    },
    {
        name: 'CAMPAGNATICO',
        istatCode: '009053002'
    },
    {
        name: 'CAMPAGNOLA CREMASCA',
        istatCode: '003019011'
    },
    {
        name: 'CAMPAGNOLA EMILIA',
        istatCode: '008035009'
    },
    {
        name: 'CAMPANA',
        istatCode: '018078023'
    },
    {
        name: 'CAMPARADA',
        istatCode: '003108014'
    },
    {
        name: 'CAMPEGINE',
        istatCode: '008035010'
    },
    {
        name: 'CAMPELLO SUL CLITUNNO',
        istatCode: '010054005'
    },
    {
        name: 'CAMPERTOGNO',
        istatCode: '001002025'
    },
    {
        name: 'CAMPI BISENZIO',
        istatCode: '009048006'
    },
    {
        name: 'CAMPI SALENTINA',
        istatCode: '016075011'
    },
    {
        name: 'CAMPIGLIA CERVO',
        istatCode: '001096086'
    },
    {
        name: 'CAMPIGLIA DEI BERICI',
        istatCode: '005024022'
    },
    {
        name: 'CAMPIGLIA MARITTIMA',
        istatCode: '009049002'
    },
    {
        name: 'CAMPIGLIONE FENILE',
        istatCode: '001001049'
    },
    {
        name: 'CAMPIONE D\'ITALIA',
        istatCode: '003013040'
    },
    {
        name: 'CAMPITELLO DI FASSA',
        istatCode: '004022036'
    },
    {
        name: 'CAMPLI',
        istatCode: '013067008'
    },
    {
        name: 'CAMPO CALABRO',
        istatCode: '018080018'
    },
    {
        name: 'CAMPO DI GIOVE',
        istatCode: '013066015'
    },
    {
        name: 'CAMPO DI TRENS - FREIENFELD',
        istatCode: '004021016'
    },
    {
        name: 'CAMPO LIGURE',
        istatCode: '007010008'
    },
    {
        name: 'CAMPO NELL\'ELBA',
        istatCode: '009049003'
    },
    {
        name: 'CAMPO SAN MARTINO',
        istatCode: '005028020'
    },
    {
        name: 'CAMPO TURES - SAND IN TAUFERS',
        istatCode: '004021017'
    },
    {
        name: 'CAMPOBASSO',
        istatCode: '014070006'
    },
    {
        name: 'CAMPOBELLO DI LICATA',
        istatCode: '019084010'
    },
    {
        name: 'CAMPOBELLO DI MAZARA',
        istatCode: '019081004'
    },
    {
        name: 'CAMPOCHIARO',
        istatCode: '014070007'
    },
    {
        name: 'CAMPODARSEGO',
        istatCode: '005028017'
    },
    {
        name: 'CAMPODENNO',
        istatCode: '004022037'
    },
    {
        name: 'CAMPODIMELE',
        istatCode: '012059003'
    },
    {
        name: 'CAMPODIPIETRA',
        istatCode: '014070008'
    },
    {
        name: 'CAMPODOLCINO',
        istatCode: '003014012'
    },
    {
        name: 'CAMPODORO',
        istatCode: '005028018'
    },
    {
        name: 'CAMPOFELICE DI FITALIA',
        istatCode: '019082016'
    },
    {
        name: 'CAMPOFELICE DI ROCCELLA',
        istatCode: '019082017'
    },
    {
        name: 'CAMPOFILONE',
        istatCode: '011109004'
    },
    {
        name: 'CAMPOFIORITO',
        istatCode: '019082018'
    },
    {
        name: 'CAMPOFORMIDO',
        istatCode: '006030016'
    },
    {
        name: 'CAMPOFRANCO',
        istatCode: '019085005'
    },
    {
        name: 'CAMPOGALLIANO',
        istatCode: '008036003'
    },
    {
        name: 'CAMPOLATTARO',
        istatCode: '015062013'
    },
    {
        name: 'CAMPOLI APPENNINO',
        istatCode: '012060016'
    },
    {
        name: 'CAMPOLI DEL MONTE TABURNO',
        istatCode: '015062014'
    },
    {
        name: 'CAMPOLIETO',
        istatCode: '014070009'
    },
    {
        name: 'CAMPOLONGO AL TORRE',
        istatCode: '006030017'
    },
    {
        name: 'CAMPOLONGO MAGGIORE',
        istatCode: '005027003'
    },
    {
        name: 'CAMPOLONGO SUL BRENTA',
        istatCode: '005024023'
    },
    {
        name: 'CAMPOLONGO TAPOGLIANO',
        istatCode: '006030138'
    },
    {
        name: 'CAMPOMAGGIORE',
        istatCode: '017076017'
    },
    {
        name: 'CAMPOMARINO',
        istatCode: '014070010'
    },
    {
        name: 'CAMPOMORONE',
        istatCode: '007010009'
    },
    {
        name: 'CAMPONOGARA',
        istatCode: '005027004'
    },
    {
        name: 'CAMPORA',
        istatCode: '015065023'
    },
    {
        name: 'CAMPOREALE',
        istatCode: '019082019'
    },
    {
        name: 'CAMPORGIANO',
        istatCode: '009046006'
    },
    {
        name: 'CAMPOROSSO',
        istatCode: '007008011'
    },
    {
        name: 'CAMPOROTONDO DI FIASTRONE',
        istatCode: '011043008'
    },
    {
        name: 'CAMPOROTONDO ETNEO',
        istatCode: '019087012'
    },
    {
        name: 'CAMPOSAMPIERO',
        istatCode: '005028019'
    },
    {
        name: 'CAMPOSANO',
        istatCode: '015063013'
    },
    {
        name: 'CAMPOSANTO',
        istatCode: '008036004'
    },
    {
        name: 'CAMPOSPINOSO',
        istatCode: '003018026'
    },
    {
        name: 'CAMPOTOSTO',
        istatCode: '013066016'
    },
    {
        name: 'CAMPOVICO',
        istatCode: '003014803'
    },
    {
        name: 'CAMUGNANO',
        istatCode: '008037010'
    },
    {
        name: 'CANAL SAN BOVO',
        istatCode: '004022038'
    },
    {
        name: 'CANALE',
        istatCode: '001004037'
    },
    {
        name: 'CANALE D\'AGORDO',
        istatCode: '005025023'
    },
    {
        name: 'CANALE MONTERANO',
        istatCode: '012058016'
    },
    {
        name: 'CANARO',
        istatCode: '005029009'
    },
    {
        name: 'CANAZEI',
        istatCode: '004022039'
    },
    {
        name: 'CANCELLARA',
        istatCode: '017076018'
    },
    {
        name: 'CANCELLO ED ARNONE',
        istatCode: '015061012'
    },
    {
        name: 'CANDA',
        istatCode: '005029010'
    },
    {
        name: 'CANDELA',
        istatCode: '016071009'
    },
    {
        name: 'CANDELARA',
        istatCode: '011041801'
    },
    {
        name: 'CANDELO',
        istatCode: '001096012'
    },
    {
        name: 'CANDIA CANAVESE',
        istatCode: '001001050'
    },
    {
        name: 'CANDIA LOMELLINA',
        istatCode: '003018027'
    },
    {
        name: 'CANDIANA',
        istatCode: '005028021'
    },
    {
        name: 'CANDIDA',
        istatCode: '015064016'
    },
    {
        name: 'CANDIDONI',
        istatCode: '018080019'
    },
    {
        name: 'CANDIOLO',
        istatCode: '001001051'
    },
    {
        name: 'CANEGRATE',
        istatCode: '003015046'
    },
    {
        name: 'CANELLI',
        istatCode: '001005017'
    },
    {
        name: 'CANEPINA',
        istatCode: '012056011'
    },
    {
        name: 'CANEVA',
        istatCode: '006093009'
    },
    {
        name: 'CANEVINO',
        istatCode: '003018028'
    },
    {
        name: 'CANICATTI\'',
        istatCode: '019084011'
    },
    {
        name: 'CANICATTINI BAGNI',
        istatCode: '019089005'
    },
    {
        name: 'CANINO',
        istatCode: '012056012'
    },
    {
        name: 'CANISCHIO',
        istatCode: '001001052'
    },
    {
        name: 'CANISTRO',
        istatCode: '013066017'
    },
    {
        name: 'CANNA',
        istatCode: '018078024'
    },
    {
        name: 'CANNALONGA',
        istatCode: '015065024'
    },
    {
        name: 'CANNARA',
        istatCode: '010054006'
    },
    {
        name: 'CANNERO RIVIERA',
        istatCode: '001103016'
    },
    {
        name: 'CANNETO PAVESE',
        istatCode: '003018029'
    },
    {
        name: 'CANNETO SULL\'OGLIO',
        istatCode: '003020008'
    },
    {
        name: 'CANNOBIO',
        istatCode: '001103017'
    },
    {
        name: 'CANNOLE',
        istatCode: '016075012'
    },
    {
        name: 'CANOLO',
        istatCode: '018080020'
    },
    {
        name: 'CANONICA D\'ADDA',
        istatCode: '003016049'
    },
    {
        name: 'CANOSA DI PUGLIA',
        istatCode: '016110004'
    },
    {
        name: 'CANOSA SANNITA',
        istatCode: '013069010'
    },
    {
        name: 'CANOSIO',
        istatCode: '001004038'
    },
    {
        name: 'CANOSSA',
        istatCode: '008035018'
    },
    {
        name: 'CANSANO',
        istatCode: '013066018'
    },
    {
        name: 'CANTAGALLO',
        istatCode: '009100001'
    },
    {
        name: 'CANTALICE',
        istatCode: '012057009'
    },
    {
        name: 'CANTALUPA',
        istatCode: '001001053'
    },
    {
        name: 'CANTALUPO IN SABINA',
        istatCode: '012057010'
    },
    {
        name: 'CANTALUPO LIGURE',
        istatCode: '001006028'
    },
    {
        name: 'CANTALUPO NEL SANNIO',
        istatCode: '014094005'
    },
    {
        name: 'CANTARANA',
        istatCode: '001005018'
    },
    {
        name: 'CANTELLO',
        istatCode: '003012030'
    },
    {
        name: 'CANTERANO',
        istatCode: '012058017'
    },
    {
        name: 'CANTIANO',
        istatCode: '011041008'
    },
    {
        name: 'CANTOIRA',
        istatCode: '001001054'
    },
    {
        name: 'CANTU\'',
        istatCode: '003013041'
    },
    {
        name: 'CANZANO',
        istatCode: '013067009'
    },
    {
        name: 'CANZO',
        istatCode: '003013042'
    },
    {
        name: 'CAORLE',
        istatCode: '005027005'
    },
    {
        name: 'CAORSO',
        istatCode: '008033010'
    },
    {
        name: 'CAPACCIO',
        istatCode: '015065025'
    },
    {
        name: 'CAPACI',
        istatCode: '019082020'
    },
    {
        name: 'CAPALBIO',
        istatCode: '009053003'
    },
    {
        name: 'CAPANNOLI',
        istatCode: '009050005'
    },
    {
        name: 'CAPANNORI',
        istatCode: '009046007'
    },
    {
        name: 'CAPENA',
        istatCode: '012058018'
    },
    {
        name: 'CAPERGNANICA',
        istatCode: '003019012'
    },
    {
        name: 'CAPESTRANO',
        istatCode: '013066019'
    },
    {
        name: 'CAPIAGO INTIMIANO',
        istatCode: '003013043'
    },
    {
        name: 'CAPISTRANO',
        istatCode: '018102005'
    },
    {
        name: 'CAPISTRELLO',
        istatCode: '013066020'
    },
    {
        name: 'CAPITIGNANO',
        istatCode: '013066021'
    },
    {
        name: 'CAPIZZI',
        istatCode: '019083008'
    },
    {
        name: 'CAPIZZONE',
        istatCode: '003016050'
    },
    {
        name: 'CAPO DI PONTE',
        istatCode: '003017035'
    },
    {
        name: 'CAPO D\'ORLANDO',
        istatCode: '019083009'
    },
    {
        name: 'CAPODIMONTE',
        istatCode: '012056013'
    },
    {
        name: 'CAPODISTRIA',
        istatCode: '006702709'
    },
    {
        name: 'CAPODRISE',
        istatCode: '015061013'
    },
    {
        name: 'CAPOLIVERI',
        istatCode: '009049004'
    },
    {
        name: 'CAPOLONA',
        istatCode: '009051006'
    },
    {
        name: 'CAPONAGO',
        istatCode: '003108052'
    },
    {
        name: 'CAPORCIANO',
        istatCode: '013066022'
    },
    {
        name: 'CAPOSELE',
        istatCode: '015064017'
    },
    {
        name: 'CAPOTERRA',
        istatCode: '020092011'
    },
    {
        name: 'CAPOVALLE',
        istatCode: '003017036'
    },
    {
        name: 'CAPPADOCIA',
        istatCode: '013066023'
    },
    {
        name: 'CAPPELLA CANTONE',
        istatCode: '003019013'
    },
    {
        name: 'CAPPELLA DE\' PICENARDI',
        istatCode: '003019014'
    },
    {
        name: 'CAPPELLA MAGGIORE',
        istatCode: '005026007'
    },
    {
        name: 'CAPPELLE SUL TAVO',
        istatCode: '013068006'
    },
    {
        name: 'CAPRACOTTA',
        istatCode: '014094006'
    },
    {
        name: 'CAPRAIA E LIMITE',
        istatCode: '009048008'
    },
    {
        name: 'CAPRAIA ISOLA',
        istatCode: '009049005'
    },
    {
        name: 'CAPRALBA',
        istatCode: '003019015'
    },
    {
        name: 'CAPRANICA',
        istatCode: '012056014'
    },
    {
        name: 'CAPRANICA PRENESTINA',
        istatCode: '012058019'
    },
    {
        name: 'CAPRARICA DI LECCE',
        istatCode: '016075013'
    },
    {
        name: 'CAPRAROLA',
        istatCode: '012056015'
    },
    {
        name: 'CAPRAUNA',
        istatCode: '001004039'
    },
    {
        name: 'CAPRESE MICHELANGELO',
        istatCode: '009051007'
    },
    {
        name: 'CAPREZZO',
        istatCode: '001103018'
    },
    {
        name: 'CAPRI',
        istatCode: '015063014'
    },
    {
        name: 'CAPRI LEONE',
        istatCode: '019083010'
    },
    {
        name: 'CAPRIANA',
        istatCode: '004022040'
    },
    {
        name: 'CAPRIANO DEL COLLE',
        istatCode: '003017037'
    },
    {
        name: 'CAPRIANO-AZZANO',
        istatCode: '003017508'
    },
    {
        name: 'CAPRIATA D\'ORBA',
        istatCode: '001006029'
    },
    {
        name: 'CAPRIATE D\'ADDA',
        istatCode: '003016813'
    },
    {
        name: 'CAPRIATE SAN GERVASIO',
        istatCode: '003016051'
    },
    {
        name: 'CAPRIATI A VOLTURNO',
        istatCode: '015061014'
    },
    {
        name: 'CAPRIE',
        istatCode: '001001055'
    },
    {
        name: 'CAPRIGLIA IRPINA',
        istatCode: '015064018'
    },
    {
        name: 'CAPRIGLIO',
        istatCode: '001005019'
    },
    {
        name: 'CAPRILE',
        istatCode: '001096013'
    },
    {
        name: 'CAPRINO BERGAMASCO',
        istatCode: '003016052'
    },
    {
        name: 'CAPRINO VERONESE',
        istatCode: '005023018'
    },
    {
        name: 'CAPRIOLO',
        istatCode: '003017038'
    },
    {
        name: 'CAPRIVA DEL FRIULI',
        istatCode: '006031001'
    },
    {
        name: 'CAPUA',
        istatCode: '015061015'
    },
    {
        name: 'CAPURSO',
        istatCode: '016072014'
    },
    {
        name: 'CARAFFA DEL BIANCO',
        istatCode: '018080021'
    },
    {
        name: 'CARAFFA DI CATANZARO',
        istatCode: '018079017'
    },
    {
        name: 'CARAGLIO',
        istatCode: '001004040'
    },
    {
        name: 'CARAMAGNA PIEMONTE',
        istatCode: '001004041'
    },
    {
        name: 'CARAMANICO TERME',
        istatCode: '013068007'
    },
    {
        name: 'CARANO',
        istatCode: '004022041'
    },
    {
        name: 'CARAPELLE',
        istatCode: '016071010'
    },
    {
        name: 'CARAPELLE CALVISIO',
        istatCode: '013066024'
    },
    {
        name: 'CARASCO',
        istatCode: '007010010'
    },
    {
        name: 'CARASSAI',
        istatCode: '011044010'
    },
    {
        name: 'CARATE BRIANZA',
        istatCode: '003108015'
    },
    {
        name: 'CARATE URIO',
        istatCode: '003013044'
    },
    {
        name: 'CARAVAGGIO',
        istatCode: '003016053'
    },
    {
        name: 'CARAVATE',
        istatCode: '003012031'
    },
    {
        name: 'CARAVINO',
        istatCode: '001001056'
    },
    {
        name: 'CARAVONICA',
        istatCode: '007008012'
    },
    {
        name: 'CARBOGNANO',
        istatCode: '012056016'
    },
    {
        name: 'CARBONARA',
        istatCode: '016072517'
    },
    {
        name: 'CARBONARA AL TICINO',
        istatCode: '003018030'
    },
    {
        name: 'CARBONARA DI NOLA',
        istatCode: '015063015'
    },
    {
        name: 'CARBONARA DI PO',
        istatCode: '003020009'
    },
    {
        name: 'CARBONARA SCRIVIA',
        istatCode: '001006030'
    },
    {
        name: 'CARBONATE',
        istatCode: '003013045'
    },
    {
        name: 'CARBONE',
        istatCode: '017076019'
    },
    {
        name: 'CARBONERA',
        istatCode: '005026008'
    },
    {
        name: 'CARBONIA',
        istatCode: '020111009'
    },
    {
        name: 'CARCARE',
        istatCode: '007009018'
    },
    {
        name: 'CARCERI',
        istatCode: '005028022'
    },
    {
        name: 'CARCOFORO',
        istatCode: '001002029'
    },
    {
        name: 'CARDANO AL CAMPO',
        istatCode: '003012032'
    },
    {
        name: 'CARDE\'',
        istatCode: '001004042'
    },
    {
        name: 'CARDEDU',
        istatCode: '020091103'
    },
    {
        name: 'CARDETO',
        istatCode: '018080022'
    },
    {
        name: 'CARDINALE',
        istatCode: '018079018'
    },
    {
        name: 'CARDITO',
        istatCode: '015063016'
    },
    {
        name: 'CAREGGINE',
        istatCode: '009046008'
    },
    {
        name: 'CAREMA',
        istatCode: '001001057'
    },
    {
        name: 'CARENNO',
        istatCode: '003097014'
    },
    {
        name: 'CARENTINO',
        istatCode: '001006031'
    },
    {
        name: 'CARERI',
        istatCode: '018080023'
    },
    {
        name: 'CARESANA',
        istatCode: '001002030'
    },
    {
        name: 'CARESANABLOT',
        istatCode: '001002031'
    },
    {
        name: 'CAREZZANO',
        istatCode: '001006032'
    },
    {
        name: 'CARFIZZI',
        istatCode: '018101003'
    },
    {
        name: 'CARGEGHE',
        istatCode: '020090022'
    },
    {
        name: 'CARIATI',
        istatCode: '018078025'
    },
    {
        name: 'CARIFE',
        istatCode: '015064019'
    },
    {
        name: 'CARIGNANO',
        istatCode: '001001058'
    },
    {
        name: 'CARIMATE',
        istatCode: '003013046'
    },
    {
        name: 'CARINARO',
        istatCode: '015061016'
    },
    {
        name: 'CARINI',
        istatCode: '019082021'
    },
    {
        name: 'CARINOLA',
        istatCode: '015061017'
    },
    {
        name: 'CARISIO',
        istatCode: '001002032'
    },
    {
        name: 'CARISOLO',
        istatCode: '004022042'
    },
    {
        name: 'CARLANTINO',
        istatCode: '016071011'
    },
    {
        name: 'CARLAZZO',
        istatCode: '003013047'
    },
    {
        name: 'CARLENTINI',
        istatCode: '019089006'
    },
    {
        name: 'CARLINO',
        istatCode: '006030018'
    },
    {
        name: 'CARLOFORTE',
        istatCode: '020111010'
    },
    {
        name: 'CARLOPOLI',
        istatCode: '018079020'
    },
    {
        name: 'CARMAGNOLA',
        istatCode: '001001059'
    },
    {
        name: 'CARMIANO',
        istatCode: '016075014'
    },
    {
        name: 'CARMIGNANO',
        istatCode: '009100002'
    },
    {
        name: 'CARMIGNANO DI BRENTA',
        istatCode: '005028023'
    },
    {
        name: 'CARNAGO',
        istatCode: '003012033'
    },
    {
        name: 'CARNATE',
        istatCode: '003108016'
    },
    {
        name: 'CAROBBIO DEGLI ANGELI',
        istatCode: '003016055'
    },
    {
        name: 'CAROLEI',
        istatCode: '018078026'
    },
    {
        name: 'CARONA',
        istatCode: '003016056'
    },
    {
        name: 'CARONIA',
        istatCode: '019083011'
    },
    {
        name: 'CARONNO PERTUSELLA',
        istatCode: '003012034'
    },
    {
        name: 'CARONNO VARESINO',
        istatCode: '003012035'
    },
    {
        name: 'CAROSINO',
        istatCode: '016073002'
    },
    {
        name: 'CAROVIGNO',
        istatCode: '016074002'
    },
    {
        name: 'CAROVILLI',
        istatCode: '014094007'
    },
    {
        name: 'CARPANETO PIACENTINO',
        istatCode: '008033011'
    },
    {
        name: 'CARPANZANO',
        istatCode: '018078027'
    },
    {
        name: 'CARPASIO',
        istatCode: '007008013'
    },
    {
        name: 'CARPEGNA',
        istatCode: '011041009'
    },
    {
        name: 'CARPENEDOLO',
        istatCode: '003017039'
    },
    {
        name: 'CARPENETO',
        istatCode: '001006033'
    },
    {
        name: 'CARPI',
        istatCode: '008036005'
    },
    {
        name: 'CARPIANO',
        istatCode: '003015050'
    },
    {
        name: 'CARPIGNANO SALENTINO',
        istatCode: '016075015'
    },
    {
        name: 'CARPIGNANO SESIA',
        istatCode: '001003036'
    },
    {
        name: 'CARPINETI',
        istatCode: '008035011'
    },
    {
        name: 'CARPINETO DELLA NORA',
        istatCode: '013068008'
    },
    {
        name: 'CARPINETO ROMANO',
        istatCode: '012058020'
    },
    {
        name: 'CARPINETO SINELLO',
        istatCode: '013069011'
    },
    {
        name: 'CARPINO',
        istatCode: '016071012'
    },
    {
        name: 'CARPINONE',
        istatCode: '014094008'
    },
    {
        name: 'CARRARA',
        istatCode: '009045003'
    },
    {
        name: 'CARRARA SAN GIORGIO',
        istatCode: '005028024'
    },
    {
        name: 'CARRARA SANTO STEFANO',
        istatCode: '005028025'
    },
    {
        name: 'CARRE\'',
        istatCode: '005024024'
    },
    {
        name: 'CARREGA LIGURE',
        istatCode: '001006034'
    },
    {
        name: 'CARRO',
        istatCode: '007011009'
    },
    {
        name: 'CARRODANO',
        istatCode: '007011010'
    },
    {
        name: 'CARROSIO',
        istatCode: '001006035'
    },
    {
        name: 'CARRU\'',
        istatCode: '001004043'
    },
    {
        name: 'CARSOLI',
        istatCode: '013066025'
    },
    {
        name: 'CARTIGLIANO',
        istatCode: '005024025'
    },
    {
        name: 'CARTIGNANO',
        istatCode: '001004044'
    },
    {
        name: 'CARTOCETO',
        istatCode: '011041010'
    },
    {
        name: 'CARTOSIO',
        istatCode: '001006036'
    },
    {
        name: 'CARTURA',
        istatCode: '005028026'
    },
    {
        name: 'CARUGATE',
        istatCode: '003015051'
    },
    {
        name: 'CARUGO',
        istatCode: '003013048'
    },
    {
        name: 'CARUGO AROSIO',
        istatCode: '003013839'
    },
    {
        name: 'CARUNCHIO',
        istatCode: '013069012'
    },
    {
        name: 'CARVICO',
        istatCode: '003016057'
    },
    {
        name: 'CARZANO',
        istatCode: '004022043'
    },
    {
        name: 'CASABONA',
        istatCode: '018101004'
    },
    {
        name: 'CASACALENDA',
        istatCode: '014070011'
    },
    {
        name: 'CASACANDITELLA',
        istatCode: '013069013'
    },
    {
        name: 'CASAGIOVE',
        istatCode: '015061018'
    },
    {
        name: 'CASAL CERMELLI',
        istatCode: '001006037'
    },
    {
        name: 'CASAL DI PRINCIPE',
        istatCode: '015061019'
    },
    {
        name: 'CASAL VELINO',
        istatCode: '015065028'
    },
    {
        name: 'CASALANGUIDA',
        istatCode: '013069014'
    },
    {
        name: 'CASALATTICO',
        istatCode: '012060017'
    },
    {
        name: 'CASALBA',
        istatCode: '015061804'
    },
    {
        name: 'CASALBELTRAME',
        istatCode: '001003037'
    },
    {
        name: 'CASALBORDINO',
        istatCode: '013069015'
    },
    {
        name: 'CASALBORE',
        istatCode: '015064020'
    },
    {
        name: 'CASALBORGONE',
        istatCode: '001001060'
    },
    {
        name: 'CASALBUONO',
        istatCode: '015065026'
    },
    {
        name: 'CASALBUTTANO ED UNITI',
        istatCode: '003019016'
    },
    {
        name: 'CASALCIPRANO',
        istatCode: '014070012'
    },
    {
        name: 'CASALDUNI',
        istatCode: '015062015'
    },
    {
        name: 'CASALE CORTE CERRO',
        istatCode: '001103019'
    },
    {
        name: 'CASALE CREMASCO',
        istatCode: '003019826'
    },
    {
        name: 'CASALE CREMASCO-VIDOLASCO',
        istatCode: '003019017'
    },
    {
        name: 'CASALE DI SCODOSIA',
        istatCode: '005028027'
    },
    {
        name: 'CASALE LITTA',
        istatCode: '003012036'
    },
    {
        name: 'CASALE MARITTIMO',
        istatCode: '009050006'
    },
    {
        name: 'CASALE MONFERRATO',
        istatCode: '001006039'
    },
    {
        name: 'CASALE SUL SILE',
        istatCode: '005026009'
    },
    {
        name: 'CASALECCHIO DI RENO',
        istatCode: '008037011'
    },
    {
        name: 'CASALEGGIO BOIRO',
        istatCode: '001006038'
    },
    {
        name: 'CASALEGGIO CASTELLAZZO',
        istatCode: '001003831'
    },
    {
        name: 'CASALEGGIO NOVARA',
        istatCode: '001003039'
    },
    {
        name: 'CASALEONE',
        istatCode: '005023019'
    },
    {
        name: 'CASALETTO CEREDANO',
        istatCode: '003019018'
    },
    {
        name: 'CASALETTO DI SOPRA',
        istatCode: '003019019'
    },
    {
        name: 'CASALETTO LODIGIANO',
        istatCode: '003098008'
    },
    {
        name: 'CASALETTO SPARTANO',
        istatCode: '015065027'
    },
    {
        name: 'CASALETTO VAPRIO',
        istatCode: '003019020'
    },
    {
        name: 'CASALFIUMANESE',
        istatCode: '008037012'
    },
    {
        name: 'CASALGRANDE',
        istatCode: '008035012'
    },
    {
        name: 'CASALGRASSO',
        istatCode: '001004045'
    },
    {
        name: 'CASALI DEL MANCO',
        istatCode: '018078156'
    },
    {
        name: 'CASALINCONTRADA',
        istatCode: '013069016'
    },
    {
        name: 'CASALINO',
        istatCode: '001003040'
    },
    {
        name: 'CASALMAGGIORE',
        istatCode: '003019021'
    },
    {
        name: 'CASALMAIOCCO',
        istatCode: '003098009'
    },
    {
        name: 'CASALMORANO',
        istatCode: '003019022'
    },
    {
        name: 'CASALMORO',
        istatCode: '003020010'
    },
    {
        name: 'CASALNOCETO',
        istatCode: '001006040'
    },
    {
        name: 'CASALNUOVO DI NAPOLI',
        istatCode: '015063017'
    },
    {
        name: 'CASALNUOVO MONTEROTARO',
        istatCode: '016071013'
    },
    {
        name: 'CASALOLDO',
        istatCode: '003020011'
    },
    {
        name: 'CASALPUSTERLENGO',
        istatCode: '003098010'
    },
    {
        name: 'CASALROMANO',
        istatCode: '003020012'
    },
    {
        name: 'CASALSERUGO',
        istatCode: '005028028'
    },
    {
        name: 'CASALUCE',
        istatCode: '015061020'
    },
    {
        name: 'CASALVECCHIO DI PUGLIA',
        istatCode: '016071014'
    },
    {
        name: 'CASALVECCHIO SICULO',
        istatCode: '019083012'
    },
    {
        name: 'CASALVIERI',
        istatCode: '012060018'
    },
    {
        name: 'CASALVOLONE',
        istatCode: '001003041'
    },
    {
        name: 'CASALZUIGNO',
        istatCode: '003012037'
    },
    {
        name: 'CASAMARCIANO',
        istatCode: '015063018'
    },
    {
        name: 'CASAMASSIMA',
        istatCode: '016072015'
    },
    {
        name: 'CASAMICCIOLA TERME',
        istatCode: '015063019'
    },
    {
        name: 'CASANDRINO',
        istatCode: '015063020'
    },
    {
        name: 'CASANOVA ELVO',
        istatCode: '001002033'
    },
    {
        name: 'CASANOVA LERRONE',
        istatCode: '007009019'
    },
    {
        name: 'CASANOVA LONATI',
        istatCode: '003018031'
    },
    {
        name: 'CASAPE',
        istatCode: '012058021'
    },
    {
        name: 'CASAPESENNA',
        istatCode: '015061103'
    },
    {
        name: 'CASAPINTA',
        istatCode: '001096014'
    },
    {
        name: 'CASAPROTA',
        istatCode: '012057011'
    },
    {
        name: 'CASAPULLA',
        istatCode: '015061021'
    },
    {
        name: 'CASARANO',
        istatCode: '016075016'
    },
    {
        name: 'CASARGO',
        istatCode: '003097015'
    },
    {
        name: 'CASARILE',
        istatCode: '003015055'
    },
    {
        name: 'CASARSA DELLA DELIZIA',
        istatCode: '006093010'
    },
    {
        name: 'CASARZA LIGURE',
        istatCode: '007010011'
    },
    {
        name: 'CASASCO',
        istatCode: '001006041'
    },
    {
        name: 'CASASCO D\'INTELVI',
        istatCode: '003013050'
    },
    {
        name: 'CASATENOVO',
        istatCode: '003097016'
    },
    {
        name: 'CASATISMA',
        istatCode: '003018032'
    },
    {
        name: 'CASAVATORE',
        istatCode: '015063021'
    },
    {
        name: 'CASAZZA',
        istatCode: '003016058'
    },
    {
        name: 'CASCIA',
        istatCode: '010054007'
    },
    {
        name: 'CASCIAGO',
        istatCode: '003012038'
    },
    {
        name: 'CASCIANA TERME',
        istatCode: '009050007'
    },
    {
        name: 'CASCIANA TERME LARI',
        istatCode: '009050040'
    },
    {
        name: 'CASCINA',
        istatCode: '009050008'
    },
    {
        name: 'CASCINETTE D\'IVREA',
        istatCode: '001001061'
    },
    {
        name: 'CASEI GEROLA',
        istatCode: '003018033'
    },
    {
        name: 'CASELETTE',
        istatCode: '001001062'
    },
    {
        name: 'CASELLA',
        istatCode: '007010012'
    },
    {
        name: 'CASELLE IN PITTARI',
        istatCode: '015065029'
    },
    {
        name: 'CASELLE LANDI',
        istatCode: '003098011'
    },
    {
        name: 'CASELLE LURANI',
        istatCode: '003098012'
    },
    {
        name: 'CASELLE TORINESE',
        istatCode: '001001063'
    },
    {
        name: 'CASERTA',
        istatCode: '015061022'
    },
    {
        name: 'CASEZ',
        istatCode: '004022044'
    },
    {
        name: 'CASIER',
        istatCode: '005026010'
    },
    {
        name: 'CASIGNANA',
        istatCode: '018080024'
    },
    {
        name: 'CASINA',
        istatCode: '008035013'
    },
    {
        name: 'CASIRATE D\'ADDA',
        istatCode: '003016059'
    },
    {
        name: 'CASLETTO',
        istatCode: '003013842'
    },
    {
        name: 'CASLINO D\'ERBA',
        istatCode: '003013052'
    },
    {
        name: 'CASNATE CON BERNATE',
        istatCode: '003013053'
    },
    {
        name: 'CASNIGO',
        istatCode: '003016060'
    },
    {
        name: 'CASOLA DI NAPOLI',
        istatCode: '015063022'
    },
    {
        name: 'CASOLA IN LUNIGIANA',
        istatCode: '009045004'
    },
    {
        name: 'CASOLA VALSENIO',
        istatCode: '008039005'
    },
    {
        name: 'CASOLE BRUZIO',
        istatCode: '018078028'
    },
    {
        name: 'CASOLE D\'ELSA',
        istatCode: '009052004'
    },
    {
        name: 'CASOLI',
        istatCode: '013069017'
    },
    {
        name: 'CASORATE PRIMO',
        istatCode: '003018034'
    },
    {
        name: 'CASORATE SEMPIONE',
        istatCode: '003012039'
    },
    {
        name: 'CASOREZZO',
        istatCode: '003015058'
    },
    {
        name: 'CASORIA',
        istatCode: '015063023'
    },
    {
        name: 'CASORZO',
        istatCode: '001005020'
    },
    {
        name: 'CASPERIA',
        istatCode: '012057012'
    },
    {
        name: 'CASPOGGIO',
        istatCode: '003014013'
    },
    {
        name: 'CASSACCO',
        istatCode: '006030019'
    },
    {
        name: 'CASSAGO BRIANZA',
        istatCode: '003097017'
    },
    {
        name: 'CASSANO ALLO IONIO',
        istatCode: '018078029'
    },
    {
        name: 'CASSANO D\'ADDA',
        istatCode: '003015059'
    },
    {
        name: 'CASSANO DELLE MURGE',
        istatCode: '016072016'
    },
    {
        name: 'CASSANO IRPINO',
        istatCode: '015064021'
    },
    {
        name: 'CASSANO MAGNAGO',
        istatCode: '003012040'
    },
    {
        name: 'CASSANO SPINOLA',
        istatCode: '001006191'
    },
    {
        name: 'CASSANO SPINOLA - Sopp',
        istatCode: '001006042'
    },
    {
        name: 'CASSANO VALCUVIA',
        istatCode: '003012041'
    },
    {
        name: 'CASSARO',
        istatCode: '019089007'
    },
    {
        name: 'CASSIGLIO',
        istatCode: '003016061'
    },
    {
        name: 'CASSINA DE\' PECCHI',
        istatCode: '003015060'
    },
    {
        name: 'CASSINA RIZZARDI',
        istatCode: '003013055'
    },
    {
        name: 'CASSINA VALSASSINA',
        istatCode: '003097018'
    },
    {
        name: 'CASSINASCO',
        istatCode: '001005021'
    },
    {
        name: 'CASSINE',
        istatCode: '001006043'
    },
    {
        name: 'CASSINELLE',
        istatCode: '001006044'
    },
    {
        name: 'CASSINETTA DI LUGAGNANO',
        istatCode: '003015061'
    },
    {
        name: 'CASSINO',
        istatCode: '012060019'
    },
    {
        name: 'CASSOLA',
        istatCode: '005024026'
    },
    {
        name: 'CASSOLNOVO',
        istatCode: '003018035'
    },
    {
        name: 'CASTAGNARO',
        istatCode: '005023020'
    },
    {
        name: 'CASTAGNETO CARDUCCI',
        istatCode: '009049006'
    },
    {
        name: 'CASTAGNETO PO',
        istatCode: '001001064'
    },
    {
        name: 'CASTAGNITO',
        istatCode: '001004046'
    },
    {
        name: 'CASTAGNOLE DELLE LANZE',
        istatCode: '001005022'
    },
    {
        name: 'CASTAGNOLE MONFERRATO',
        istatCode: '001005023'
    },
    {
        name: 'CASTAGNOLE PIEMONTE',
        istatCode: '001001065'
    },
    {
        name: 'CASTANA',
        istatCode: '003018036'
    },
    {
        name: 'CASTANO PRIMO',
        istatCode: '003015062'
    },
    {
        name: 'CASTEGGIO',
        istatCode: '003018037'
    },
    {
        name: 'CASTEGNATO',
        istatCode: '003017040'
    },
    {
        name: 'CASTEGNERO',
        istatCode: '005024027'
    },
    {
        name: 'CASTEL BARONIA',
        istatCode: '015064022'
    },
    {
        name: 'CASTEL BOGLIONE',
        istatCode: '001005024'
    },
    {
        name: 'CASTEL BOLOGNESE',
        istatCode: '008039006'
    },
    {
        name: 'CASTEL CAMPAGNANO',
        istatCode: '015061023'
    },
    {
        name: 'CASTEL CASTAGNA',
        istatCode: '013067010'
    },
    {
        name: 'CASTEL COLONNA',
        istatCode: '011042009'
    },
    {
        name: 'CASTEL CONDINO',
        istatCode: '004022045'
    },
    {
        name: 'CASTEL D\'AIANO',
        istatCode: '008037013'
    },
    {
        name: 'CASTEL D\'ARIO',
        istatCode: '003020014'
    },
    {
        name: 'CASTEL D\'AZZANO',
        istatCode: '005023021'
    },
    {
        name: 'CASTEL DEL GIUDICE',
        istatCode: '014094009'
    },
    {
        name: 'CASTEL DEL MONTE',
        istatCode: '013066026'
    },
    {
        name: 'CASTEL DEL PIANO',
        istatCode: '009053004'
    },
    {
        name: 'CASTEL DEL RIO',
        istatCode: '008037014'
    },
    {
        name: 'CASTEL DI CASIO',
        istatCode: '008037015'
    },
    {
        name: 'CASTEL DI IERI',
        istatCode: '013066027'
    },
    {
        name: 'CASTEL DI IUDICA',
        istatCode: '019087013'
    },
    {
        name: 'CASTEL DI LAMA',
        istatCode: '011044011'
    },
    {
        name: 'CASTEL DI LUCIO',
        istatCode: '019083013'
    },
    {
        name: 'CASTEL DI SANGRO',
        istatCode: '013066028'
    },
    {
        name: 'CASTEL DI SASSO',
        istatCode: '015061024'
    },
    {
        name: 'CASTEL DI TORA',
        istatCode: '012057013'
    },
    {
        name: 'CASTEL FOCOGNANO',
        istatCode: '009051008'
    },
    {
        name: 'CASTEL FRENTANO',
        istatCode: '013069018'
    },
    {
        name: 'CASTEL GABBIANO',
        istatCode: '003019024'
    },
    {
        name: 'CASTEL GANDOLFO',
        istatCode: '012058022'
    },
    {
        name: 'CASTEL GIORGIO',
        istatCode: '010055009'
    },
    {
        name: 'CASTEL GOFFREDO',
        istatCode: '003020015'
    },
    {
        name: 'CASTEL GUELFO DI BOLOGNA',
        istatCode: '008037016'
    },
    {
        name: 'CASTEL IVANO',
        istatCode: '004022240'
    },
    {
        name: 'CASTEL MADAMA',
        istatCode: '012058023'
    },
    {
        name: 'CASTEL MAGGIORE',
        istatCode: '008037019'
    },
    {
        name: 'CASTEL MELLA',
        istatCode: '003017042'
    },
    {
        name: 'CASTEL MORRONE',
        istatCode: '015061026'
    },
    {
        name: 'CASTEL RITALDI',
        istatCode: '010054008'
    },
    {
        name: 'CASTEL ROCCHERO',
        istatCode: '001005032'
    },
    {
        name: 'CASTEL ROZZONE',
        istatCode: '003016063'
    },
    {
        name: 'CASTEL SAN GIORGIO',
        istatCode: '015065034'
    },
    {
        name: 'CASTEL SAN GIOVANNI',
        istatCode: '008033013'
    },
    {
        name: 'CASTEL SAN LORENZO',
        istatCode: '015065035'
    },
    {
        name: 'CASTEL SAN NICCOLO\'',
        istatCode: '009051010'
    },
    {
        name: 'CASTEL SAN PIETRO ROMANO',
        istatCode: '012058025'
    },
    {
        name: 'CASTEL SAN PIETRO TERME',
        istatCode: '008037020'
    },
    {
        name: 'CASTEL SAN VINCENZO',
        istatCode: '014094012'
    },
    {
        name: 'CASTEL SANT\'ANGELO',
        istatCode: '012057015'
    },
    {
        name: 'CASTEL SANT\'ELIA',
        istatCode: '012056017'
    },
    {
        name: 'CASTEL VISCARDO',
        istatCode: '010055010'
    },
    {
        name: 'CASTEL VITTORIO',
        istatCode: '007008015'
    },
    {
        name: 'CASTEL VOLTURNO',
        istatCode: '015061027'
    },
    {
        name: 'CASTELBALDO',
        istatCode: '005028029'
    },
    {
        name: 'CASTELBELFORTE',
        istatCode: '003020013'
    },
    {
        name: 'CASTELBELLINO',
        istatCode: '011042008'
    },
    {
        name: 'CASTELBELLO-CIARDES - KASTELBELL-TSCHARS',
        istatCode: '004021018'
    },
    {
        name: 'CASTELBIANCO',
        istatCode: '007009020'
    },
    {
        name: 'CASTELBOTTACCIO',
        istatCode: '014070013'
    },
    {
        name: 'CASTELBUONO',
        istatCode: '019082022'
    },
    {
        name: 'CASTELCIVITA',
        istatCode: '015065030'
    },
    {
        name: 'CASTELCOVATI',
        istatCode: '003017041'
    },
    {
        name: 'CASTELCUCCO',
        istatCode: '005026011'
    },
    {
        name: 'CASTELDACCIA',
        istatCode: '019082023'
    },
    {
        name: 'CASTELDELCI',
        istatCode: '008099021'
    },
    {
        name: 'CASTELDELFINO',
        istatCode: '001004047'
    },
    {
        name: 'CASTELDIDONE',
        istatCode: '003019023'
    },
    {
        name: 'CASTELFIDARDO',
        istatCode: '011042010'
    },
    {
        name: 'CASTELFIORENTINO',
        istatCode: '009048010'
    },
    {
        name: 'CASTELFONDO',
        istatCode: '004022046'
    },
    {
        name: 'CASTELFORTE',
        istatCode: '012059004'
    },
    {
        name: 'CASTELFRANCI',
        istatCode: '015064023'
    },
    {
        name: 'CASTELFRANCO DI SOPRA',
        istatCode: '009051009'
    },
    {
        name: 'CASTELFRANCO DI SOTTO',
        istatCode: '009050009'
    },
    {
        name: 'CASTELFRANCO EMILIA',
        istatCode: '008036006'
    },
    {
        name: 'CASTELFRANCO IN MISCANO',
        istatCode: '015062016'
    },
    {
        name: 'CASTELFRANCO PIANDISCO',
        istatCode: '009051040'
    },
    {
        name: 'CASTELFRANCO VENETO',
        istatCode: '005026012'
    },
    {
        name: 'CASTELGERUNDO',
        istatCode: '003098062'
    },
    {
        name: 'CASTELGOMBERTO',
        istatCode: '005024028'
    },
    {
        name: 'CASTELGRANDE',
        istatCode: '017076021'
    },
    {
        name: 'CASTELGUGLIELMO',
        istatCode: '005029011'
    },
    {
        name: 'CASTELGUIDONE',
        istatCode: '013069019'
    },
    {
        name: 'CASTELLABATE',
        istatCode: '015065031'
    },
    {
        name: 'CASTELLAFIUME',
        istatCode: '013066029'
    },
    {
        name: 'CASTELL\'ALFERO',
        istatCode: '001005025'
    },
    {
        name: 'CASTELLALTO',
        istatCode: '013067011'
    },
    {
        name: 'CASTELLAMMARE DEL GOLFO',
        istatCode: '019081005'
    },
    {
        name: 'CASTELLAMMARE DI STABIA',
        istatCode: '015063024'
    },
    {
        name: 'CASTELLAMONTE',
        istatCode: '001001066'
    },
    {
        name: 'CASTELLANA GROTTE',
        istatCode: '016072017'
    },
    {
        name: 'CASTELLANA SICULA',
        istatCode: '019082024'
    },
    {
        name: 'CASTELLANETA',
        istatCode: '016073003'
    },
    {
        name: 'CASTELLANIA',
        istatCode: '001006045'
    },
    {
        name: 'CASTELLANZA',
        istatCode: '003012042'
    },
    {
        name: 'CASTELLAR',
        istatCode: '001004048'
    },
    {
        name: 'CASTELLAR GUIDOBONO',
        istatCode: '001006046'
    },
    {
        name: 'CASTELLARANO',
        istatCode: '008035014'
    },
    {
        name: 'CASTELLARO',
        istatCode: '007008014'
    },
    {
        name: 'CASTELL\'ARQUATO',
        istatCode: '008033012'
    },
    {
        name: 'CASTELL\'AZZARA',
        istatCode: '009053005'
    },
    {
        name: 'CASTELLAZZO BORMIDA',
        istatCode: '001006047'
    },
    {
        name: 'CASTELLAZZO NOVARESE',
        istatCode: '001003042'
    },
    {
        name: 'CASTELLEONE',
        istatCode: '003019025'
    },
    {
        name: 'CASTELLEONE DI SUASA',
        istatCode: '011042011'
    },
    {
        name: 'CASTELLERO',
        istatCode: '001005026'
    },
    {
        name: 'CASTELLETTO CERVO',
        istatCode: '001096015'
    },
    {
        name: 'CASTELLETTO D\'ERRO',
        istatCode: '001006048'
    },
    {
        name: 'CASTELLETTO DI BRANDUZZO',
        istatCode: '003018038'
    },
    {
        name: 'CASTELLETTO D\'ORBA',
        istatCode: '001006049'
    },
    {
        name: 'CASTELLETTO MERLI',
        istatCode: '001006050'
    },
    {
        name: 'CASTELLETTO MOLINA',
        istatCode: '001005027'
    },
    {
        name: 'CASTELLETTO MONFERRATO',
        istatCode: '001006051'
    },
    {
        name: 'CASTELLETTO SOPRA TICINO',
        istatCode: '001003043'
    },
    {
        name: 'CASTELLETTO STURA',
        istatCode: '001004049'
    },
    {
        name: 'CASTELLETTO UZZONE',
        istatCode: '001004050'
    },
    {
        name: 'CASTELLI',
        istatCode: '013067012'
    },
    {
        name: 'CASTELLI CALEPIO',
        istatCode: '003016062'
    },
    {
        name: 'CASTELLI CUSIANI',
        istatCode: '001003516'
    },
    {
        name: 'CASTELLINA IN CHIANTI',
        istatCode: '009052005'
    },
    {
        name: 'CASTELLINA MARITTIMA',
        istatCode: '009050010'
    },
    {
        name: 'CASTELLINALDO D\'ALBA',
        istatCode: '001004051'
    },
    {
        name: 'CASTELLINO DEL BIFERNO',
        istatCode: '014070014'
    },
    {
        name: 'CASTELLINO TANARO',
        istatCode: '001004052'
    },
    {
        name: 'CASTELLIRI',
        istatCode: '012060020'
    },
    {
        name: 'CASTELLO CABIAGLIO',
        istatCode: '003012043'
    },
    {
        name: 'CASTELLO D\'AGOGNA',
        istatCode: '003018039'
    },
    {
        name: 'CASTELLO D\'ARGILE',
        istatCode: '008037017'
    },
    {
        name: 'CASTELLO DEL MATESE',
        istatCode: '015061025'
    },
    {
        name: 'CASTELLO DELL\'ACQUA',
        istatCode: '003014014'
    },
    {
        name: 'CASTELLO DI ANNONE',
        istatCode: '001005028'
    },
    {
        name: 'CASTELLO DI BRIANZA',
        istatCode: '003097019'
    },
    {
        name: 'CASTELLO DI CISTERNA',
        istatCode: '015063025'
    },
    {
        name: 'CASTELLO DI GODEGO',
        istatCode: '005026013'
    },
    {
        name: 'CASTELLO DI SERRAVALLE',
        istatCode: '008037018'
    },
    {
        name: 'CASTELLO LAVAZZO',
        istatCode: '005025009'
    },
    {
        name: 'CASTELLO TESINO',
        istatCode: '004022048'
    },
    {
        name: 'CASTELLO-MOLINA DI FIEMME',
        istatCode: '004022047'
    },
    {
        name: 'CASTELLONORATO',
        istatCode: '012059801'
    },
    {
        name: 'CASTELLUCCHIO',
        istatCode: '003020016'
    },
    {
        name: 'CASTELLUCCIO DEI SAURI',
        istatCode: '016071015'
    },
    {
        name: 'CASTELLUCCIO INFERIORE',
        istatCode: '017076022'
    },
    {
        name: 'CASTELLUCCIO SUPERIORE',
        istatCode: '017076023'
    },
    {
        name: 'CASTELLUCCIO VALMAGGIORE',
        istatCode: '016071016'
    },
    {
        name: 'CASTELL\'UMBERTO',
        istatCode: '019083014'
    },
    {
        name: 'CASTELMAGNO',
        istatCode: '001004053'
    },
    {
        name: 'CASTELMARTE',
        istatCode: '003013058'
    },
    {
        name: 'CASTELMASSA',
        istatCode: '005029012'
    },
    {
        name: 'CASTELMAURO',
        istatCode: '014070015'
    },
    {
        name: 'CASTELMEZZANO',
        istatCode: '017076024'
    },
    {
        name: 'CASTELMOLA',
        istatCode: '019083015'
    },
    {
        name: 'CASTELNOVETTO',
        istatCode: '003018040'
    },
    {
        name: 'CASTELNOVO BARIANO',
        istatCode: '005029013'
    },
    {
        name: 'CASTELNOVO DEL FRIULI',
        istatCode: '006093011'
    },
    {
        name: 'CASTELNOVO DI SOTTO',
        istatCode: '008035015'
    },
    {
        name: 'CASTELNOVO NE\' MONTI',
        istatCode: '008035016'
    },
    {
        name: 'CASTELNUOVO',
        istatCode: '004022049'
    },
    {
        name: 'CASTELNUOVO BELBO',
        istatCode: '001005029'
    },
    {
        name: 'CASTELNUOVO BERARDENGA',
        istatCode: '009052006'
    },
    {
        name: 'CASTELNUOVO BOCCA D\'ADDA',
        istatCode: '003098013'
    },
    {
        name: 'CASTELNUOVO BORMIDA',
        istatCode: '001006052'
    },
    {
        name: 'CASTELNUOVO BOZZENTE',
        istatCode: '003013059'
    },
    {
        name: 'CASTELNUOVO CALCEA',
        istatCode: '001005030'
    },
    {
        name: 'CASTELNUOVO CILENTO',
        istatCode: '015065032'
    },
    {
        name: 'CASTELNUOVO DEL GARDA',
        istatCode: '005023022'
    },
    {
        name: 'CASTELNUOVO DELLA DAUNIA',
        istatCode: '016071017'
    },
    {
        name: 'CASTELNUOVO DI CEVA',
        istatCode: '001004054'
    },
    {
        name: 'CASTELNUOVO DI CONZA',
        istatCode: '015065033'
    },
    {
        name: 'CASTELNUOVO DI FARFA',
        istatCode: '012057014'
    },
    {
        name: 'CASTELNUOVO DI GARFAGNANA',
        istatCode: '009046009'
    },
    {
        name: 'CASTELNUOVO DI PORTO',
        istatCode: '012058024'
    },
    {
        name: 'CASTELNUOVO DI VAL DI CECINA',
        istatCode: '009050011'
    },
    {
        name: 'CASTELNUOVO DON BOSCO',
        istatCode: '001005031'
    },
    {
        name: 'CASTELNUOVO MAGRA',
        istatCode: '007011011'
    },
    {
        name: 'CASTELNUOVO NIGRA',
        istatCode: '001001067'
    },
    {
        name: 'CASTELNUOVO PARANO',
        istatCode: '012060021'
    },
    {
        name: 'CASTELNUOVO RANGONE',
        istatCode: '008036007'
    },
    {
        name: 'CASTELNUOVO SCRIVIA',
        istatCode: '001006053'
    },
    {
        name: 'CASTELPAGANO',
        istatCode: '015062017'
    },
    {
        name: 'CASTELPETROSO',
        istatCode: '014094010'
    },
    {
        name: 'CASTELPIZZUTO',
        istatCode: '014094011'
    },
    {
        name: 'CASTELPLANIO',
        istatCode: '011042012'
    },
    {
        name: 'CASTELPOTO',
        istatCode: '015062018'
    },
    {
        name: 'CASTELRAIMONDO',
        istatCode: '011043009'
    },
    {
        name: 'CASTELROTTO - KASTELRUTH',
        istatCode: '004021019'
    },
    {
        name: 'CASTELSANTANGELO SUL NERA',
        istatCode: '011043010'
    },
    {
        name: 'CASTELSARACENO',
        istatCode: '017076025'
    },
    {
        name: 'CASTELSARDO',
        istatCode: '020090023'
    },
    {
        name: 'CASTELSEPRIO',
        istatCode: '003012044'
    },
    {
        name: 'CASTELSILANO',
        istatCode: '018101005'
    },
    {
        name: 'CASTELSPINA',
        istatCode: '001006054'
    },
    {
        name: 'CASTELTERMINI',
        istatCode: '019084012'
    },
    {
        name: 'CASTELVECCANA',
        istatCode: '003012045'
    },
    {
        name: 'CASTELVECCHIO CALVISIO',
        istatCode: '013066030'
    },
    {
        name: 'CASTELVECCHIO DI ROCCA BARBENA',
        istatCode: '007009021'
    },
    {
        name: 'CASTELVECCHIO SUBEQUO',
        istatCode: '013066031'
    },
    {
        name: 'CASTELVENERE',
        istatCode: '015062019'
    },
    {
        name: 'CASTELVERDE',
        istatCode: '003019026'
    },
    {
        name: 'CASTELVERRINO',
        istatCode: '014094013'
    },
    {
        name: 'CASTELVETERE IN VAL FORTORE',
        istatCode: '015062020'
    },
    {
        name: 'CASTELVETERE SUL CALORE',
        istatCode: '015064024'
    },
    {
        name: 'CASTELVETRANO',
        istatCode: '019081006'
    },
    {
        name: 'CASTELVETRO DI MODENA',
        istatCode: '008036008'
    },
    {
        name: 'CASTELVETRO PIACENTINO',
        istatCode: '008033014'
    },
    {
        name: 'CASTELVISCONTI',
        istatCode: '003019027'
    },
    {
        name: 'CASTENASO',
        istatCode: '008037021'
    },
    {
        name: 'CASTENEDOLO',
        istatCode: '003017043'
    },
    {
        name: 'CASTIADAS',
        istatCode: '020111011'
    },
    {
        name: 'CASTIGLION FIBOCCHI',
        istatCode: '009051011'
    },
    {
        name: 'CASTIGLION FIORENTINO',
        istatCode: '009051012'
    },
    {
        name: 'CASTIGLIONE A CASAURIA',
        istatCode: '013068009'
    },
    {
        name: 'CASTIGLIONE CHIAVARESE',
        istatCode: '007010013'
    },
    {
        name: 'CASTIGLIONE COSENTINO',
        istatCode: '018078030'
    },
    {
        name: 'CASTIGLIONE D\'ADDA',
        istatCode: '003098014'
    },
    {
        name: 'CASTIGLIONE DEI PEPOLI',
        istatCode: '008037022'
    },
    {
        name: 'CASTIGLIONE DEL GENOVESI',
        istatCode: '015065036'
    },
    {
        name: 'CASTIGLIONE DEL LAGO',
        istatCode: '010054009'
    },
    {
        name: 'CASTIGLIONE DELLA PESCAIA',
        istatCode: '009053006'
    },
    {
        name: 'CASTIGLIONE DELLE STIVIERE',
        istatCode: '003020017'
    },
    {
        name: 'CASTIGLIONE DI GARFAGNANA',
        istatCode: '009046010'
    },
    {
        name: 'CASTIGLIONE DI SICILIA',
        istatCode: '019087014'
    },
    {
        name: 'CASTIGLIONE D\'INTELVI',
        istatCode: '003013060'
    },
    {
        name: 'CASTIGLIONE D\'ORCIA',
        istatCode: '009052007'
    },
    {
        name: 'CASTIGLIONE FALLETTO',
        istatCode: '001004055'
    },
    {
        name: 'CASTIGLIONE IN TEVERINA',
        istatCode: '012056018'
    },
    {
        name: 'CASTIGLIONE MESSER MARINO',
        istatCode: '013069020'
    },
    {
        name: 'CASTIGLIONE MESSER RAIMONDO',
        istatCode: '013067013'
    },
    {
        name: 'CASTIGLIONE OLONA',
        istatCode: '003012046'
    },
    {
        name: 'CASTIGLIONE TINELLA',
        istatCode: '001004056'
    },
    {
        name: 'CASTIGLIONE TORINESE',
        istatCode: '001001068'
    },
    {
        name: 'CASTIGNANO',
        istatCode: '011044012'
    },
    {
        name: 'CASTILENTI',
        istatCode: '013067014'
    },
    {
        name: 'CASTINO',
        istatCode: '001004057'
    },
    {
        name: 'CASTIONE ANDEVENNO',
        istatCode: '003014015'
    },
    {
        name: 'CASTIONE DELLA PRESOLANA',
        istatCode: '003016064'
    },
    {
        name: 'CASTIONS DI STRADA',
        istatCode: '006030020'
    },
    {
        name: 'CASTIRAGA VIDARDO',
        istatCode: '003098015'
    },
    {
        name: 'CASTO',
        istatCode: '003017044'
    },
    {
        name: 'CASTORANO',
        istatCode: '011044013'
    },
    {
        name: 'CASTREZZATO',
        istatCode: '003017045'
    },
    {
        name: 'CASTRI DI LECCE',
        istatCode: '016075017'
    },
    {
        name: 'CASTRIGNANO DE\' GRECI',
        istatCode: '016075018'
    },
    {
        name: 'CASTRIGNANO DEL CAPO',
        istatCode: '016075019'
    },
    {
        name: 'CASTRO (BG)',
        istatCode: '003016065'
    },
    {
        name: 'CASTRO DEI VOLSCI',
        istatCode: '012060023'
    },
    {
        name: 'CASTRO (LE)',
        istatCode: '016075096'
    },
    {
        name: 'CASTROCARO TERME E TERRA DEL SOLE',
        istatCode: '008040005'
    },
    {
        name: 'CASTROCIELO',
        istatCode: '012060022'
    },
    {
        name: 'CASTROFILIPPO',
        istatCode: '019084013'
    },
    {
        name: 'CASTROLIBERO',
        istatCode: '018078031'
    },
    {
        name: 'CASTRONNO',
        istatCode: '003012047'
    },
    {
        name: 'CASTRONUOVO DI SANT\'ANDREA',
        istatCode: '017076026'
    },
    {
        name: 'CASTRONUOVO DI SICILIA',
        istatCode: '019082025'
    },
    {
        name: 'CASTROPIGNANO',
        istatCode: '014070016'
    },
    {
        name: 'CASTROREALE',
        istatCode: '019083016'
    },
    {
        name: 'CASTROREGIO',
        istatCode: '018078032'
    },
    {
        name: 'CASTROVILLARI',
        istatCode: '018078033'
    },
    {
        name: 'CATAFORIO',
        istatCode: '018080803'
    },
    {
        name: 'CATANIA',
        istatCode: '019087015'
    },
    {
        name: 'CATANZARO',
        istatCode: '018079023'
    },
    {
        name: 'CATENANUOVA',
        istatCode: '019086006'
    },
    {
        name: 'CATIGNANO',
        istatCode: '013068010'
    },
    {
        name: 'CATTOLICA',
        istatCode: '008099002'
    },
    {
        name: 'CATTOLICA ERACLEA',
        istatCode: '019084014'
    },
    {
        name: 'CAULONIA',
        istatCode: '018080025'
    },
    {
        name: 'CAUTANO',
        istatCode: '015062021'
    },
    {
        name: 'CAVA DE\' TIRRENI',
        istatCode: '015065037'
    },
    {
        name: 'CAVA MANARA',
        istatCode: '003018041'
    },
    {
        name: 'CAVACURTA',
        istatCode: '003098016'
    },
    {
        name: 'CAVAGLIA\'',
        istatCode: '001096016'
    },
    {
        name: 'CAVAGLIETTO',
        istatCode: '001003044'
    },
    {
        name: 'CAVAGLIO D\'AGOGNA',
        istatCode: '001003045'
    },
    {
        name: 'CAVAGLIO-SPOCCIA',
        istatCode: '001103020'
    },
    {
        name: 'CAVAGNOLO',
        istatCode: '001001069'
    },
    {
        name: 'CAVAION VERONESE',
        istatCode: '005023023'
    },
    {
        name: 'CAVALESE',
        istatCode: '004022050'
    },
    {
        name: 'CAVALLASCA',
        istatCode: '003013061'
    },
    {
        name: 'CAVALLERLEONE',
        istatCode: '001004058'
    },
    {
        name: 'CAVALLERMAGGIORE',
        istatCode: '001004059'
    },
    {
        name: 'CAVALLINO',
        istatCode: '016075020'
    },
    {
        name: 'CAVALLINO-TREPORTI',
        istatCode: '005027044'
    },
    {
        name: 'CAVALLIRIO',
        istatCode: '001003047'
    },
    {
        name: 'CAVARENO',
        istatCode: '004022051'
    },
    {
        name: 'CAVARGNA',
        istatCode: '003013062'
    },
    {
        name: 'CAVARIA CON PREMEZZO',
        istatCode: '003012048'
    },
    {
        name: 'CAVARZERE',
        istatCode: '005027006'
    },
    {
        name: 'CAVASO DEL TOMBA',
        istatCode: '005026014'
    },
    {
        name: 'CAVASSO NUOVO',
        istatCode: '006093012'
    },
    {
        name: 'CAVATORE',
        istatCode: '001006055'
    },
    {
        name: 'CAVAZZO CARNICO',
        istatCode: '006030021'
    },
    {
        name: 'CAVE',
        istatCode: '012058026'
    },
    {
        name: 'CAVEDAGO',
        istatCode: '004022052'
    },
    {
        name: 'CAVEDINE',
        istatCode: '004022053'
    },
    {
        name: 'CAVENAGO D\'ADDA',
        istatCode: '003098017'
    },
    {
        name: 'CAVENAGO DI BRIANZA',
        istatCode: '003108017'
    },
    {
        name: 'CAVERNAGO',
        istatCode: '003016066'
    },
    {
        name: 'CAVEZZO',
        istatCode: '008036009'
    },
    {
        name: 'CAVIZZANA',
        istatCode: '004022054'
    },
    {
        name: 'CAVOUR',
        istatCode: '001001070'
    },
    {
        name: 'CAVRIAGO',
        istatCode: '008035017'
    },
    {
        name: 'CAVRIANA',
        istatCode: '003020018'
    },
    {
        name: 'CAVRIGLIA',
        istatCode: '009051013'
    },
    {
        name: 'CAZZAGO BRABBIA',
        istatCode: '003012049'
    },
    {
        name: 'CAZZAGO SAN MARTINO',
        istatCode: '003017046'
    },
    {
        name: 'CAZZANO DI TRAMIGNA',
        istatCode: '005023024'
    },
    {
        name: 'CAZZANO SANT\'ANDREA',
        istatCode: '003016067'
    },
    {
        name: 'CECCANO',
        istatCode: '012060024'
    },
    {
        name: 'CECIMA',
        istatCode: '003018042'
    },
    {
        name: 'CECINA',
        istatCode: '009049007'
    },
    {
        name: 'CEDEGOLO',
        istatCode: '003017047'
    },
    {
        name: 'CEDRASCO',
        istatCode: '003014016'
    },
    {
        name: 'CEFALA\' DIANA',
        istatCode: '019082026'
    },
    {
        name: 'CEFALU\'',
        istatCode: '019082027'
    },
    {
        name: 'CEGGIA',
        istatCode: '005027007'
    },
    {
        name: 'CEGLIE MESSAPICA',
        istatCode: '016074003'
    },
    {
        name: 'CELANO',
        istatCode: '013066032'
    },
    {
        name: 'CELENZA SUL TRIGNO',
        istatCode: '013069021'
    },
    {
        name: 'CELENZA VALFORTORE',
        istatCode: '016071018'
    },
    {
        name: 'CELICO',
        istatCode: '018078034'
    },
    {
        name: 'CELLA DATI',
        istatCode: '003019028'
    },
    {
        name: 'CELLA MONTE',
        istatCode: '001006056'
    },
    {
        name: 'CELLAMARE',
        istatCode: '016072018'
    },
    {
        name: 'CELLARA',
        istatCode: '018078035'
    },
    {
        name: 'CELLARENGO',
        istatCode: '001005033'
    },
    {
        name: 'CELLATICA',
        istatCode: '003017048'
    },
    {
        name: 'CELLE DI BULGHERIA',
        istatCode: '015065038'
    },
    {
        name: 'CELLE DI MACRA',
        istatCode: '001004060'
    },
    {
        name: 'CELLE DI SAN VITO',
        istatCode: '016071019'
    },
    {
        name: 'CELLE ENOMONDO',
        istatCode: '001005034'
    },
    {
        name: 'CELLE LIGURE',
        istatCode: '007009022'
    },
    {
        name: 'CELLENO',
        istatCode: '012056019'
    },
    {
        name: 'CELLERE',
        istatCode: '012056020'
    },
    {
        name: 'CELLINO ATTANASIO',
        istatCode: '013067015'
    },
    {
        name: 'CELLINO SAN MARCO',
        istatCode: '016074004'
    },
    {
        name: 'CELLIO',
        istatCode: '001002038'
    },
    {
        name: 'CELLIO CON BREIA',
        istatCode: '001002171'
    },
    {
        name: 'CELLOLE',
        istatCode: '015061102'
    },
    {
        name: 'CEMBRA',
        istatCode: '004022055'
    },
    {
        name: 'CEMBRA LISIGNAGO',
        istatCode: '004022241'
    },
    {
        name: 'CENADI',
        istatCode: '018079024'
    },
    {
        name: 'CENATE D`ARGON',
        istatCode: '003016816'
    },
    {
        name: 'CENATE SOPRA',
        istatCode: '003016068'
    },
    {
        name: 'CENATE SOTTO',
        istatCode: '003016069'
    },
    {
        name: 'CENCENIGHE AGORDINO',
        istatCode: '005025010'
    },
    {
        name: 'CENE',
        istatCode: '003016070'
    },
    {
        name: 'CENESELLI',
        istatCode: '005029014'
    },
    {
        name: 'CENGIO',
        istatCode: '007009023'
    },
    {
        name: 'CENTA SAN NICOLO\'',
        istatCode: '004022056'
    },
    {
        name: 'CENTALLO',
        istatCode: '001004061'
    },
    {
        name: 'CENTO',
        istatCode: '008038004'
    },
    {
        name: 'CENTOLA',
        istatCode: '015065039'
    },
    {
        name: 'CENTRACHE',
        istatCode: '018079025'
    },
    {
        name: 'CENTRISOLA',
        istatCode: '003016817'
    },
    {
        name: 'CENTRO VALLE INTELVI',
        istatCode: '003013254'
    },
    {
        name: 'CENTURIPE',
        istatCode: '019086007'
    },
    {
        name: 'CEPAGATTI',
        istatCode: '013068011'
    },
    {
        name: 'CEPPALONI',
        istatCode: '015062022'
    },
    {
        name: 'CEPPO MORELLI',
        istatCode: '001103021'
    },
    {
        name: 'CEPRANO',
        istatCode: '012060025'
    },
    {
        name: 'CERAMI',
        istatCode: '019086008'
    },
    {
        name: 'CERANESI',
        istatCode: '007010014'
    },
    {
        name: 'CERANO',
        istatCode: '001003049'
    },
    {
        name: 'CERANO D\'INTELVI',
        istatCode: '003013063'
    },
    {
        name: 'CERANOVA',
        istatCode: '003018043'
    },
    {
        name: 'CERASO',
        istatCode: '015065040'
    },
    {
        name: 'CERCEMAGGIORE',
        istatCode: '014070017'
    },
    {
        name: 'CERCENASCO',
        istatCode: '001001071'
    },
    {
        name: 'CERCEPICCOLA',
        istatCode: '014070018'
    },
    {
        name: 'CERCHIARA DI CALABRIA',
        istatCode: '018078036'
    },
    {
        name: 'CERCHIO',
        istatCode: '013066033'
    },
    {
        name: 'CERCINO',
        istatCode: '003014017'
    },
    {
        name: 'CERCIVENTO',
        istatCode: '006030022'
    },
    {
        name: 'CERCOLA',
        istatCode: '015063026'
    },
    {
        name: 'CERDA',
        istatCode: '019082028'
    },
    {
        name: 'CEREA',
        istatCode: '005023025'
    },
    {
        name: 'CEREGNANO',
        istatCode: '005029015'
    },
    {
        name: 'CERENZIA',
        istatCode: '018101006'
    },
    {
        name: 'CERES',
        istatCode: '001001072'
    },
    {
        name: 'CERESARA',
        istatCode: '003020019'
    },
    {
        name: 'CERESETO',
        istatCode: '001006057'
    },
    {
        name: 'CERESOLE ALBA',
        istatCode: '001004062'
    },
    {
        name: 'CERESOLE REALE',
        istatCode: '001001073'
    },
    {
        name: 'CERETE',
        istatCode: '003016071'
    },
    {
        name: 'CERETTO LOMELLINA',
        istatCode: '003018044'
    },
    {
        name: 'CERGNAGO',
        istatCode: '003018045'
    },
    {
        name: 'CERIALE',
        istatCode: '007009024'
    },
    {
        name: 'CERIANA',
        istatCode: '007008016'
    },
    {
        name: 'CERIANO LAGHETTO',
        istatCode: '003108018'
    },
    {
        name: 'CERIGNALE',
        istatCode: '008033015'
    },
    {
        name: 'CERIGNOLA',
        istatCode: '016071020'
    },
    {
        name: 'CERISANO',
        istatCode: '018078037'
    },
    {
        name: 'CERMENATE',
        istatCode: '003013064'
    },
    {
        name: 'CERMES - TSCHERMS',
        istatCode: '004021020'
    },
    {
        name: 'CERMIGNANO',
        istatCode: '013067016'
    },
    {
        name: 'CERNOBBIO',
        istatCode: '003013065'
    },
    {
        name: 'CERNUSCO LOMBARDONE',
        istatCode: '003097020'
    },
    {
        name: 'CERNUSCO MONTEVECCHIA',
        istatCode: '003013854'
    },
    {
        name: 'CERNUSCO SUL NAVIGLIO',
        istatCode: '003015070'
    },
    {
        name: 'CERRETO CASTELLO',
        istatCode: '001096017'
    },
    {
        name: 'CERRETO D\'ASTI',
        istatCode: '001005035'
    },
    {
        name: 'CERRETO D\'ESI',
        istatCode: '011042013'
    },
    {
        name: 'CERRETO DI SPOLETO',
        istatCode: '010054010'
    },
    {
        name: 'CERRETO GRUE',
        istatCode: '001006058'
    },
    {
        name: 'CERRETO GUIDI',
        istatCode: '009048011'
    },
    {
        name: 'CERRETO LAZIALE',
        istatCode: '012058027'
    },
    {
        name: 'CERRETO SANNITA',
        istatCode: '015062023'
    },
    {
        name: 'CERRETTO LANGHE',
        istatCode: '001004063'
    },
    {
        name: 'CERRINA MONFERRATO',
        istatCode: '001006059'
    },
    {
        name: 'CERRIONE',
        istatCode: '001096018'
    },
    {
        name: 'CERRO AL LAMBRO',
        istatCode: '003015071'
    },
    {
        name: 'CERRO AL VOLTURNO',
        istatCode: '014094014'
    },
    {
        name: 'CERRO MAGGIORE',
        istatCode: '003015072'
    },
    {
        name: 'CERRO TANARO',
        istatCode: '001005036'
    },
    {
        name: 'CERRO VERONESE',
        istatCode: '005023026'
    },
    {
        name: 'CERSOSIMO',
        istatCode: '017076027'
    },
    {
        name: 'CERTALDO',
        istatCode: '009048012'
    },
    {
        name: 'CERTOSA DI PAVIA',
        istatCode: '003018046'
    },
    {
        name: 'CERVA',
        istatCode: '018079027'
    },
    {
        name: 'CERVARA DI ROMA',
        istatCode: '012058028'
    },
    {
        name: 'CERVARESE SANTA CROCE',
        istatCode: '005028030'
    },
    {
        name: 'CERVARO',
        istatCode: '012060026'
    },
    {
        name: 'CERVASCA',
        istatCode: '001004064'
    },
    {
        name: 'CERVATTO',
        istatCode: '001002041'
    },
    {
        name: 'CERVENO',
        istatCode: '003017049'
    },
    {
        name: 'CERVERE',
        istatCode: '001004065'
    },
    {
        name: 'CERVESINA',
        istatCode: '003018047'
    },
    {
        name: 'CERVETERI',
        istatCode: '012058029'
    },
    {
        name: 'CERVIA',
        istatCode: '008039007'
    },
    {
        name: 'CERVICATI',
        istatCode: '018078038'
    },
    {
        name: 'CERVIGNANO D\'ADDA',
        istatCode: '003098018'
    },
    {
        name: 'CERVIGNANO DEL FRIULI',
        istatCode: '006030023'
    },
    {
        name: 'CERVINARA',
        istatCode: '015064025'
    },
    {
        name: 'CERVINO',
        istatCode: '015061028'
    },
    {
        name: 'CERVO',
        istatCode: '007008017'
    },
    {
        name: 'CERZETO',
        istatCode: '018078039'
    },
    {
        name: 'CESA',
        istatCode: '015061029'
    },
    {
        name: 'CESANA BRIANZA',
        istatCode: '003097021'
    },
    {
        name: 'CESANA TORINESE',
        istatCode: '001001074'
    },
    {
        name: 'CESANO BOSCONE',
        istatCode: '003015074'
    },
    {
        name: 'CESANO MADERNO',
        istatCode: '003108019'
    },
    {
        name: 'CESARA',
        istatCode: '001103022'
    },
    {
        name: 'CESARO\'',
        istatCode: '019083017'
    },
    {
        name: 'CESATE',
        istatCode: '003015076'
    },
    {
        name: 'CESELLO BRIANZA',
        istatCode: '003013855'
    },
    {
        name: 'CESENA',
        istatCode: '008040007'
    },
    {
        name: 'CESENATICO',
        istatCode: '008040008'
    },
    {
        name: 'CESINALI',
        istatCode: '015064026'
    },
    {
        name: 'CESIO',
        istatCode: '007008018'
    },
    {
        name: 'CESIOMAGGIORE',
        istatCode: '005025011'
    },
    {
        name: 'CESSALTO',
        istatCode: '005026015'
    },
    {
        name: 'CESSANITI',
        istatCode: '018102006'
    },
    {
        name: 'CESSAPALOMBO',
        istatCode: '011043011'
    },
    {
        name: 'CESSOLE',
        istatCode: '001005037'
    },
    {
        name: 'CETARA',
        istatCode: '015065041'
    },
    {
        name: 'CETO',
        istatCode: '003017050'
    },
    {
        name: 'CETO-CERVENO',
        istatCode: '003017823'
    },
    {
        name: 'CETONA',
        istatCode: '009052008'
    },
    {
        name: 'CETRARO',
        istatCode: '018078040'
    },
    {
        name: 'CEVA',
        istatCode: '001004066'
    },
    {
        name: 'CEVO',
        istatCode: '003017051'
    },
    {
        name: 'CHALLAND-SAINT-ANSELME',
        istatCode: '002007013'
    },
    {
        name: 'CHALLAND-SAINT-VICTOR',
        istatCode: '002007014'
    },
    {
        name: 'CHALLANT SAINT ANSELME ET CHALLANT SAINT VICTOR',
        istatCode: '002007801'
    },
    {
        name: 'CHAMBAVE',
        istatCode: '002007015'
    },
    {
        name: 'CHAMOIS',
        istatCode: '002007016'
    },
    {
        name: 'CHAMPDEPRAZ',
        istatCode: '002007017'
    },
    {
        name: 'CHAMPORCHER',
        istatCode: '002007018'
    },
    {
        name: 'CHARVENSOD',
        istatCode: '002007019'
    },
    {
        name: 'CHATILLON',
        istatCode: '002007020'
    },
    {
        name: 'CHERASCO',
        istatCode: '001004067'
    },
    {
        name: 'CHEREMULE',
        istatCode: '020090024'
    },
    {
        name: 'CHIALAMBERTO',
        istatCode: '001001075'
    },
    {
        name: 'CHIAMPO',
        istatCode: '005024029'
    },
    {
        name: 'CHIANCHE',
        istatCode: '015064027'
    },
    {
        name: 'CHIANCIANO TERME',
        istatCode: '009052009'
    },
    {
        name: 'CHIANNI',
        istatCode: '009050012'
    },
    {
        name: 'CHIANOCCO',
        istatCode: '001001076'
    },
    {
        name: 'CHIARAMONTE GULFI',
        istatCode: '019088002'
    },
    {
        name: 'CHIARAMONTI',
        istatCode: '020090025'
    },
    {
        name: 'CHIARANO',
        istatCode: '005026016'
    },
    {
        name: 'CHIARAVALLE',
        istatCode: '011042014'
    },
    {
        name: 'CHIARAVALLE CENTRALE',
        istatCode: '018079029'
    },
    {
        name: 'CHIARI',
        istatCode: '003017052'
    },
    {
        name: 'CHIAROMONTE',
        istatCode: '017076028'
    },
    {
        name: 'CHIAUCI',
        istatCode: '014094015'
    },
    {
        name: 'CHIAVARI',
        istatCode: '007010015'
    },
    {
        name: 'CHIAVAZZA',
        istatCode: '001002810'
    },
    {
        name: 'CHIAVENNA',
        istatCode: '003014018'
    },
    {
        name: 'CHIAVERANO',
        istatCode: '001001077'
    },
    {
        name: 'CHIENES - KIENS',
        istatCode: '004021021'
    },
    {
        name: 'CHIERI',
        istatCode: '001001078'
    },
    {
        name: 'CHIES D\'ALPAGO',
        istatCode: '005025012'
    },
    {
        name: 'CHIESA IN VALMALENCO',
        istatCode: '003014019'
    },
    {
        name: 'CHIESANUOVA',
        istatCode: '001001079'
    },
    {
        name: 'CHIESINA UZZANESE',
        istatCode: '009047022'
    },
    {
        name: 'CHIETI',
        istatCode: '013069022'
    },
    {
        name: 'CHIEUTI',
        istatCode: '016071021'
    },
    {
        name: 'CHIEVE',
        istatCode: '003019029'
    },
    {
        name: 'CHIGNOLO D\'ISOLA',
        istatCode: '003016072'
    },
    {
        name: 'CHIGNOLO PO',
        istatCode: '003018048'
    },
    {
        name: 'CHIOGGIA',
        istatCode: '005027008'
    },
    {
        name: 'CHIOMONTE',
        istatCode: '001001080'
    },
    {
        name: 'CHIONS',
        istatCode: '006093013'
    },
    {
        name: 'CHIOPRIS-VISCONE',
        istatCode: '006030024'
    },
    {
        name: 'CHITIGNANO',
        istatCode: '009051014'
    },
    {
        name: 'CHIUDUNO',
        istatCode: '003016073'
    },
    {
        name: 'CHIUPPANO',
        istatCode: '005024030'
    },
    {
        name: 'CHIURO',
        istatCode: '003014020'
    },
    {
        name: 'CHIUSA - KLAUSEN',
        istatCode: '004021022'
    },
    {
        name: 'CHIUSA DI PESIO',
        istatCode: '001004068'
    },
    {
        name: 'CHIUSA DI SAN MICHELE',
        istatCode: '001001081'
    },
    {
        name: 'CHIUSA SCLAFANI',
        istatCode: '019082029'
    },
    {
        name: 'CHIUSAFORTE',
        istatCode: '006030025'
    },
    {
        name: 'CHIUSANICO',
        istatCode: '007008019'
    },
    {
        name: 'CHIUSANO D\'ASTI',
        istatCode: '001005038'
    },
    {
        name: 'CHIUSANO DI SAN DOMENICO',
        istatCode: '015064028'
    },
    {
        name: 'CHIUSAVECCHIA',
        istatCode: '007008020'
    },
    {
        name: 'CHIUSDINO',
        istatCode: '009052010'
    },
    {
        name: 'CHIUSI',
        istatCode: '009052011'
    },
    {
        name: 'CHIUSI DELLA VERNA',
        istatCode: '009051015'
    },
    {
        name: 'CHIVASSO',
        istatCode: '001001082'
    },
    {
        name: 'CIAMPINO',
        istatCode: '012058118'
    },
    {
        name: 'CIANCIANA',
        istatCode: '019084015'
    },
    {
        name: 'CIBIANA DI CADORE',
        istatCode: '005025013'
    },
    {
        name: 'CICAGNA',
        istatCode: '007010016'
    },
    {
        name: 'CICALA',
        istatCode: '018079030'
    },
    {
        name: 'CICCIANO',
        istatCode: '015063027'
    },
    {
        name: 'CICERALE',
        istatCode: '015065042'
    },
    {
        name: 'CICILIANO',
        istatCode: '012058030'
    },
    {
        name: 'CICOGNOLO',
        istatCode: '003019030'
    },
    {
        name: 'CICONIO',
        istatCode: '001001083'
    },
    {
        name: 'CIGLIANO',
        istatCode: '001002042'
    },
    {
        name: 'CIGLIE\'',
        istatCode: '001004069'
    },
    {
        name: 'CIGOGNOLA',
        istatCode: '003018049'
    },
    {
        name: 'CIGOLE',
        istatCode: '003017053'
    },
    {
        name: 'CILAVEGNA',
        istatCode: '003018050'
    },
    {
        name: 'CIMADOLMO',
        istatCode: '005026017'
    },
    {
        name: 'CIMBERGO',
        istatCode: '003017054'
    },
    {
        name: 'CIMEGO',
        istatCode: '004022057'
    },
    {
        name: 'CIMINA\'',
        istatCode: '018080026'
    },
    {
        name: 'CIMINNA',
        istatCode: '019082030'
    },
    {
        name: 'CIMITILE',
        istatCode: '015063028'
    },
    {
        name: 'CIMOLAIS',
        istatCode: '006093014'
    },
    {
        name: 'CIMONE',
        istatCode: '004022058'
    },
    {
        name: 'CINAGLIO',
        istatCode: '001005039'
    },
    {
        name: 'CINETO ROMANO',
        istatCode: '012058031'
    },
    {
        name: 'CINGIA DE\' BOTTI',
        istatCode: '003019031'
    },
    {
        name: 'CINGOLI',
        istatCode: '011043012'
    },
    {
        name: 'CINIGIANO',
        istatCode: '009053007'
    },
    {
        name: 'CINISELLO BALSAMO',
        istatCode: '003015077'
    },
    {
        name: 'CINISI',
        istatCode: '019082031'
    },
    {
        name: 'CINO',
        istatCode: '003014021'
    },
    {
        name: 'CINQUEFRONDI',
        istatCode: '018080027'
    },
    {
        name: 'CINTANO',
        istatCode: '001001084'
    },
    {
        name: 'CINTE TESINO',
        istatCode: '004022059'
    },
    {
        name: 'CINTO CAOMAGGIORE',
        istatCode: '005027009'
    },
    {
        name: 'CINTO EUGANEO',
        istatCode: '005028031'
    },
    {
        name: 'CINZANO',
        istatCode: '001001085'
    },
    {
        name: 'CIORLANO',
        istatCode: '015061030'
    },
    {
        name: 'CIPRESSA',
        istatCode: '007008021'
    },
    {
        name: 'CIRCELLO',
        istatCode: '015062024'
    },
    {
        name: 'CIRIE\'',
        istatCode: '001001086'
    },
    {
        name: 'CIRIGLIANO',
        istatCode: '017077005'
    },
    {
        name: 'CIRIMIDO',
        istatCode: '003013068'
    },
    {
        name: 'CIRO\'',
        istatCode: '018101007'
    },
    {
        name: 'CIRO\' MARINA',
        istatCode: '018101008'
    },
    {
        name: 'CIS',
        istatCode: '004022060'
    },
    {
        name: 'CISANO BERGAMASCO',
        istatCode: '003016074'
    },
    {
        name: 'CISANO SUL NEVA',
        istatCode: '007009025'
    },
    {
        name: 'CISERANO',
        istatCode: '003016075'
    },
    {
        name: 'CISLAGO',
        istatCode: '003012050'
    },
    {
        name: 'CISLIANO',
        istatCode: '003015078'
    },
    {
        name: 'CISMON DEL GRAPPA',
        istatCode: '005024031'
    },
    {
        name: 'CISON DI VALMARINO',
        istatCode: '005026018'
    },
    {
        name: 'CISSONE',
        istatCode: '001004070'
    },
    {
        name: 'CISTERNA D\'ASTI',
        istatCode: '001005040'
    },
    {
        name: 'CISTERNA DI LATINA',
        istatCode: '012059005'
    },
    {
        name: 'CISTERNINO',
        istatCode: '016074005'
    },
    {
        name: 'CITERNA',
        istatCode: '010054011'
    },
    {
        name: 'CITTA\' DELLA PIEVE',
        istatCode: '010054012'
    },
    {
        name: 'CITTA\' DI CASTELLO',
        istatCode: '010054013'
    },
    {
        name: 'CITTA\' SANT\'ANGELO',
        istatCode: '013068012'
    },
    {
        name: 'CITTADELLA',
        istatCode: '005028032'
    },
    {
        name: 'CITTADUCALE',
        istatCode: '012057016'
    },
    {
        name: 'CITTANOVA',
        istatCode: '018080028'
    },
    {
        name: 'CITTAREALE',
        istatCode: '012057017'
    },
    {
        name: 'CITTIGLIO',
        istatCode: '003012051'
    },
    {
        name: 'CIVATE',
        istatCode: '003097022'
    },
    {
        name: 'CIVENNA',
        istatCode: '003013070'
    },
    {
        name: 'CIVEZZA',
        istatCode: '007008022'
    },
    {
        name: 'CIVEZZANO',
        istatCode: '004022061'
    },
    {
        name: 'CIVIASCO',
        istatCode: '001002043'
    },
    {
        name: 'CIVIDALE DEL FRIULI',
        istatCode: '006030026'
    },
    {
        name: 'CIVIDATE AL PIANO',
        istatCode: '003016076'
    },
    {
        name: 'CIVIDATE CAMUNO',
        istatCode: '003017055'
    },
    {
        name: 'CIVIDATE-MALEGNO',
        istatCode: '003017827'
    },
    {
        name: 'CIVITA',
        istatCode: '018078041'
    },
    {
        name: 'CIVITA CASTELLANA',
        istatCode: '012056021'
    },
    {
        name: 'CIVITA D\'ANTINO',
        istatCode: '013066034'
    },
    {
        name: 'CIVITACAMPOMARANO',
        istatCode: '014070019'
    },
    {
        name: 'CIVITALUPARELLA',
        istatCode: '013069023'
    },
    {
        name: 'CIVITANOVA DEL SANNIO',
        istatCode: '014094016'
    },
    {
        name: 'CIVITANOVA MARCHE',
        istatCode: '011043013'
    },
    {
        name: 'CIVITAQUANA',
        istatCode: '013068013'
    },
    {
        name: 'CIVITAVECCHIA',
        istatCode: '012058032'
    },
    {
        name: 'CIVITELLA ALFEDENA',
        istatCode: '013066035'
    },
    {
        name: 'CIVITELLA CASANOVA',
        istatCode: '013068014'
    },
    {
        name: 'CIVITELLA D\'AGLIANO',
        istatCode: '012056022'
    },
    {
        name: 'CIVITELLA DEL TRONTO',
        istatCode: '013067017'
    },
    {
        name: 'CIVITELLA DI ROMAGNA',
        istatCode: '008040009'
    },
    {
        name: 'CIVITELLA IN VAL DI CHIANA',
        istatCode: '009051016'
    },
    {
        name: 'CIVITELLA MESSER RAIMONDO',
        istatCode: '013069024'
    },
    {
        name: 'CIVITELLA PAGANICO',
        istatCode: '009053008'
    },
    {
        name: 'CIVITELLA ROVETO',
        istatCode: '013066036'
    },
    {
        name: 'CIVITELLA SAN PAOLO',
        istatCode: '012058033'
    },
    {
        name: 'CIVO',
        istatCode: '003014022'
    },
    {
        name: 'CLAINO CON OSTENO',
        istatCode: '003013071'
    },
    {
        name: 'CLAUT',
        istatCode: '006093015'
    },
    {
        name: 'CLAUZETTO',
        istatCode: '006093016'
    },
    {
        name: 'CLAVESANA',
        istatCode: '001004071'
    },
    {
        name: 'CLAVIERE',
        istatCode: '001001087'
    },
    {
        name: 'CLES',
        istatCode: '004022062'
    },
    {
        name: 'CLETO',
        istatCode: '018078042'
    },
    {
        name: 'CLIVIO',
        istatCode: '003012052'
    },
    {
        name: 'CLOZ',
        istatCode: '004022063'
    },
    {
        name: 'CLUSONE',
        istatCode: '003016077'
    },
    {
        name: 'COASSOLO TORINESE',
        istatCode: '001001088'
    },
    {
        name: 'COAZZE',
        istatCode: '001001089'
    },
    {
        name: 'COAZZOLO',
        istatCode: '001005041'
    },
    {
        name: 'COCCAGLIO',
        istatCode: '003017056'
    },
    {
        name: 'COCCONATO',
        istatCode: '001005042'
    },
    {
        name: 'COCQUIO-TREVISAGO',
        istatCode: '003012053'
    },
    {
        name: 'COCULLO',
        istatCode: '013066037'
    },
    {
        name: 'CODEVIGO',
        istatCode: '005028033'
    },
    {
        name: 'CODEVILLA',
        istatCode: '003018051'
    },
    {
        name: 'CODIGORO',
        istatCode: '008038005'
    },
    {
        name: 'CODOGNE\'',
        istatCode: '005026019'
    },
    {
        name: 'CODOGNO',
        istatCode: '003098019'
    },
    {
        name: 'CODROIPO',
        istatCode: '006030027'
    },
    {
        name: 'CODRONGIANOS',
        istatCode: '020090026'
    },
    {
        name: 'COGGIOLA',
        istatCode: '001096019'
    },
    {
        name: 'COGLIATE',
        istatCode: '003108020'
    },
    {
        name: 'COGNE',
        istatCode: '002007021'
    },
    {
        name: 'COGOLETO',
        istatCode: '007010017'
    },
    {
        name: 'COGOLLO DEL CENGIO',
        istatCode: '005024032'
    },
    {
        name: 'COGORNO',
        istatCode: '007010018'
    },
    {
        name: 'COLAZZA',
        istatCode: '001003051'
    },
    {
        name: 'COLBORDOLO',
        istatCode: '011041012'
    },
    {
        name: 'COLCERESA',
        istatCode: '005024126'
    },
    {
        name: 'COLERE',
        istatCode: '003016078'
    },
    {
        name: 'COLFELICE',
        istatCode: '012060027'
    },
    {
        name: 'COLI',
        istatCode: '008033016'
    },
    {
        name: 'COLICO',
        istatCode: '003097023'
    },
    {
        name: 'COLLAGNA',
        istatCode: '008035019'
    },
    {
        name: 'COLLALTO SABINO',
        istatCode: '012057018'
    },
    {
        name: 'COLLARMELE',
        istatCode: '013066038'
    },
    {
        name: 'COLLAZZONE',
        istatCode: '010054014'
    },
    {
        name: 'COLLE BRIANZA',
        istatCode: '003097024'
    },
    {
        name: 'COLLE D\'ANCHISE',
        istatCode: '014070020'
    },
    {
        name: 'COLLE DI TORA',
        istatCode: '012057019'
    },
    {
        name: 'COLLE DI VAL D\'ELSA',
        istatCode: '009052012'
    },
    {
        name: 'COLLE SAN MAGNO',
        istatCode: '012060029'
    },
    {
        name: 'COLLE SANNITA',
        istatCode: '015062025'
    },
    {
        name: 'COLLE SANTA LUCIA',
        istatCode: '005025014'
    },
    {
        name: 'COLLE UMBERTO',
        istatCode: '005026020'
    },
    {
        name: 'COLLEBEATO',
        istatCode: '003017057'
    },
    {
        name: 'COLLECCHIO',
        istatCode: '008034009'
    },
    {
        name: 'COLLECORVINO',
        istatCode: '013068015'
    },
    {
        name: 'COLLEDARA',
        istatCode: '013067018'
    },
    {
        name: 'COLLEDIMACINE',
        istatCode: '013069025'
    },
    {
        name: 'COLLEDIMEZZO',
        istatCode: '013069026'
    },
    {
        name: 'COLLEFERRO',
        istatCode: '012058034'
    },
    {
        name: 'COLLEGIOVE',
        istatCode: '012057020'
    },
    {
        name: 'COLLEGNO',
        istatCode: '001001090'
    },
    {
        name: 'COLLELONGO',
        istatCode: '013066039'
    },
    {
        name: 'COLLEPARDO',
        istatCode: '012060028'
    },
    {
        name: 'COLLEPASSO',
        istatCode: '016075021'
    },
    {
        name: 'COLLEPIETRO',
        istatCode: '013066040'
    },
    {
        name: 'COLLERETTO CASTELNUOVO',
        istatCode: '001001091'
    },
    {
        name: 'COLLERETTO GIACOSA',
        istatCode: '001001092'
    },
    {
        name: 'COLLESALVETTI',
        istatCode: '009049008'
    },
    {
        name: 'COLLESANO',
        istatCode: '019082032'
    },
    {
        name: 'COLLESCIPOLI',
        istatCode: '010055805'
    },
    {
        name: 'COLLETORTO',
        istatCode: '014070021'
    },
    {
        name: 'COLLEVECCHIO',
        istatCode: '012057021'
    },
    {
        name: 'COLLI A VOLTURNO',
        istatCode: '014094017'
    },
    {
        name: 'COLLI AL METAURO',
        istatCode: '011041069'
    },
    {
        name: 'COLLI DEL TRONTO',
        istatCode: '011044014'
    },
    {
        name: 'COLLI SUL VELINO',
        istatCode: '012057022'
    },
    {
        name: 'COLLI VERDI',
        istatCode: '003018193'
    },
    {
        name: 'COLLIANO',
        istatCode: '015065043'
    },
    {
        name: 'COLLINAS',
        istatCode: '020111012'
    },
    {
        name: 'COLLIO',
        istatCode: '003017058'
    },
    {
        name: 'COLLOBIANO',
        istatCode: '001002045'
    },
    {
        name: 'COLLOREDO DI MONTE ALBANO',
        istatCode: '006030028'
    },
    {
        name: 'COLMURANO',
        istatCode: '011043014'
    },
    {
        name: 'COLOBRARO',
        istatCode: '017077006'
    },
    {
        name: 'COLOGNA VENETA',
        istatCode: '005023027'
    },
    {
        name: 'COLOGNE',
        istatCode: '003017059'
    },
    {
        name: 'COLOGNO AL SERIO',
        istatCode: '003016079'
    },
    {
        name: 'COLOGNO MONZESE',
        istatCode: '003015081'
    },
    {
        name: 'COLOGNOLA AI COLLI',
        istatCode: '005023028'
    },
    {
        name: 'COLONNA',
        istatCode: '012058035'
    },
    {
        name: 'COLONNELLA',
        istatCode: '013067019'
    },
    {
        name: 'COLONNO',
        istatCode: '003013074'
    },
    {
        name: 'COLORINA',
        istatCode: '003014023'
    },
    {
        name: 'COLORNO',
        istatCode: '008034010'
    },
    {
        name: 'COLOSIMI',
        istatCode: '018078043'
    },
    {
        name: 'COLTURANO',
        istatCode: '003015082'
    },
    {
        name: 'COLVERDE',
        istatCode: '003013251'
    },
    {
        name: 'COLZATE',
        istatCode: '003016080'
    },
    {
        name: 'COMABBIO',
        istatCode: '003012054'
    },
    {
        name: 'COMACCHIO',
        istatCode: '008038006'
    },
    {
        name: 'COMANO',
        istatCode: '009045005'
    },
    {
        name: 'COMANO TERME',
        istatCode: '004022228'
    },
    {
        name: 'COMAZZO',
        istatCode: '003098020'
    },
    {
        name: 'COMEGLIANS',
        istatCode: '006030029'
    },
    {
        name: 'COMELICO SUPERIORE',
        istatCode: '005025015'
    },
    {
        name: 'COMERIO',
        istatCode: '003012055'
    },
    {
        name: 'COMEZZANO',
        istatCode: '003017832'
    },
    {
        name: 'COMEZZANO-CIZZAGO',
        istatCode: '003017060'
    },
    {
        name: 'COMIGNAGO',
        istatCode: '001003052'
    },
    {
        name: 'COMISO',
        istatCode: '019088003'
    },
    {
        name: 'COMITINI',
        istatCode: '019084016'
    },
    {
        name: 'COMIZIANO',
        istatCode: '015063029'
    },
    {
        name: 'COMMESSAGGIO',
        istatCode: '003020020'
    },
    {
        name: 'COMMEZZADURA',
        istatCode: '004022064'
    },
    {
        name: 'COMO',
        istatCode: '003013075'
    },
    {
        name: 'COMPIANO',
        istatCode: '008034011'
    },
    {
        name: 'COMUN NUOVO',
        istatCode: '003016081'
    },
    {
        name: 'COMUNANZA',
        istatCode: '011044015'
    },
    {
        name: 'CONA',
        istatCode: '005027010'
    },
    {
        name: 'CONCA CASALE',
        istatCode: '014094018'
    },
    {
        name: 'CONCA DEI MARINI',
        istatCode: '015065044'
    },
    {
        name: 'CONCA DELLA CAMPANIA',
        istatCode: '015061031'
    },
    {
        name: 'CONCADIRAME',
        istatCode: '005029807'
    },
    {
        name: 'CONCAMARISE',
        istatCode: '005023029'
    },
    {
        name: 'CONCEI',
        istatCode: '004022065'
    },
    {
        name: 'CONCERVIANO',
        istatCode: '012057023'
    },
    {
        name: 'CONCESIO',
        istatCode: '003017061'
    },
    {
        name: 'CONCO',
        istatCode: '005024033'
    },
    {
        name: 'CONCORDIA SAGITTARIA',
        istatCode: '005027011'
    },
    {
        name: 'CONCORDIA SULLA SECCHIA',
        istatCode: '008036010'
    },
    {
        name: 'CONCOREZZO',
        istatCode: '003108021'
    },
    {
        name: 'CONDINO',
        istatCode: '004022066'
    },
    {
        name: 'CONDOFURI',
        istatCode: '018080029'
    },
    {
        name: 'CONDOVE',
        istatCode: '001001093'
    },
    {
        name: 'CONDRO\'',
        istatCode: '019083018'
    },
    {
        name: 'CONEGLIANO',
        istatCode: '005026021'
    },
    {
        name: 'CONFIENZA',
        istatCode: '003018052'
    },
    {
        name: 'CONFIGNI',
        istatCode: '012057024'
    },
    {
        name: 'CONFLENTI',
        istatCode: '018079033'
    },
    {
        name: 'CONIOLO',
        istatCode: '001006060'
    },
    {
        name: 'CONSELICE',
        istatCode: '008039008'
    },
    {
        name: 'CONSELVE',
        istatCode: '005028034'
    },
    {
        name: 'CONSIGLIO DI RUMO',
        istatCode: '003013076'
    },
    {
        name: 'CONTA\'',
        istatCode: '004022242'
    },
    {
        name: 'CONTARINA',
        istatCode: '005029016'
    },
    {
        name: 'CONTESSA ENTELLINA',
        istatCode: '019082033'
    },
    {
        name: 'CONTIGLIANO',
        istatCode: '012057025'
    },
    {
        name: 'CONTRA',
        istatCode: '003013864'
    },
    {
        name: 'CONTRADA',
        istatCode: '015064029'
    },
    {
        name: 'CONTROGUERRA',
        istatCode: '013067020'
    },
    {
        name: 'CONTRONE',
        istatCode: '015065045'
    },
    {
        name: 'CONTURSI TERME',
        istatCode: '015065046'
    },
    {
        name: 'CONVERSANO',
        istatCode: '016072019'
    },
    {
        name: 'CONZA DELLA CAMPANIA',
        istatCode: '015064030'
    },
    {
        name: 'CONZANO',
        istatCode: '001006061'
    },
    {
        name: 'COPERTINO',
        istatCode: '016075022'
    },
    {
        name: 'COPIANO',
        istatCode: '003018053'
    },
    {
        name: 'COPPARO',
        istatCode: '008038007'
    },
    {
        name: 'CORANA',
        istatCode: '003018054'
    },
    {
        name: 'CORATO',
        istatCode: '016072020'
    },
    {
        name: 'CORBARA',
        istatCode: '015065047'
    },
    {
        name: 'CORBETTA',
        istatCode: '003015085'
    },
    {
        name: 'CORBOLA',
        istatCode: '005029017'
    },
    {
        name: 'CORCHIANO',
        istatCode: '012056023'
    },
    {
        name: 'CORCIANO',
        istatCode: '010054015'
    },
    {
        name: 'CORDENONS',
        istatCode: '006093017'
    },
    {
        name: 'CORDIGNANO',
        istatCode: '005026022'
    },
    {
        name: 'CORDOVADO',
        istatCode: '006093018'
    },
    {
        name: 'COREDO',
        istatCode: '004022067'
    },
    {
        name: 'COREGLIA ANTELMINELLI',
        istatCode: '009046011'
    },
    {
        name: 'COREGLIA LIGURE',
        istatCode: '007010019'
    },
    {
        name: 'CORENO AUSONIO',
        istatCode: '012060030'
    },
    {
        name: 'CORFINIO',
        istatCode: '013066041'
    },
    {
        name: 'CORI',
        istatCode: '012059006'
    },
    {
        name: 'CORIANO',
        istatCode: '008099003'
    },
    {
        name: 'CORIGLIANO CALABRO',
        istatCode: '018078044'
    },
    {
        name: 'CORIGLIANO D\'OTRANTO',
        istatCode: '016075023'
    },
    {
        name: 'CORIGLIANO-ROSSANO',
        istatCode: '018078157'
    },
    {
        name: 'CORINALDO',
        istatCode: '011042015'
    },
    {
        name: 'CORIO',
        istatCode: '001001094'
    },
    {
        name: 'CORLEONE',
        istatCode: '019082034'
    },
    {
        name: 'CORLETO MONFORTE',
        istatCode: '015065048'
    },
    {
        name: 'CORLETO PERTICARA',
        istatCode: '017076029'
    },
    {
        name: 'CORMANO',
        istatCode: '003015086'
    },
    {
        name: 'CORMONS',
        istatCode: '006031002'
    },
    {
        name: 'CORNA IMAGNA',
        istatCode: '003016082'
    },
    {
        name: 'CORNALBA',
        istatCode: '003016249'
    },
    {
        name: 'CORNALE',
        istatCode: '003018055'
    },
    {
        name: 'CORNALE E BASTIDA',
        istatCode: '003018191'
    },
    {
        name: 'CORNAREDO',
        istatCode: '003015087'
    },
    {
        name: 'CORNATE D\'ADDA',
        istatCode: '003108053'
    },
    {
        name: 'CORNEDO ALL\'ISARCO - KARNEID',
        istatCode: '004021023'
    },
    {
        name: 'CORNEDO VICENTINO',
        istatCode: '005024034'
    },
    {
        name: 'CORNEGLIANO LAUDENSE',
        istatCode: '003098021'
    },
    {
        name: 'CORNELIANO D\'ALBA',
        istatCode: '001004072'
    },
    {
        name: 'CORNIGLIO',
        istatCode: '008034012'
    },
    {
        name: 'CORNO DI ROSAZZO',
        istatCode: '006030030'
    },
    {
        name: 'CORNO GIOVINE',
        istatCode: '003098022'
    },
    {
        name: 'CORNOVECCHIO',
        istatCode: '003098023'
    },
    {
        name: 'CORNUDA',
        istatCode: '005026023'
    },
    {
        name: 'CORREGGIO',
        istatCode: '008035020'
    },
    {
        name: 'CORREZZANA',
        istatCode: '003108022'
    },
    {
        name: 'CORREZZOLA',
        istatCode: '005028035'
    },
    {
        name: 'CORRIDO',
        istatCode: '003013077'
    },
    {
        name: 'CORRIDONIA',
        istatCode: '011043015'
    },
    {
        name: 'CORROPOLI',
        istatCode: '013067021'
    },
    {
        name: 'CORSANO',
        istatCode: '016075024'
    },
    {
        name: 'CORSICO',
        istatCode: '003015093'
    },
    {
        name: 'CORSIONE',
        istatCode: '001005044'
    },
    {
        name: 'CORTACCIA SULLA STRADA DEL VINO - KURTATSCH AN DER WEINSTRASSE',
        istatCode: '004021024'
    },
    {
        name: 'CORTALE',
        istatCode: '018079034'
    },
    {
        name: 'CORTANDONE',
        istatCode: '001005045'
    },
    {
        name: 'CORTANZE',
        istatCode: '001005046'
    },
    {
        name: 'CORTAZZONE',
        istatCode: '001005047'
    },
    {
        name: 'CORTE BRUGNATELLA',
        istatCode: '008033017'
    },
    {
        name: 'CORTE DE\' CORTESI',
        istatCode: '003019507'
    },
    {
        name: 'CORTE DE\' CORTESI CON CIGNONE',
        istatCode: '003019032'
    },
    {
        name: 'CORTE DE\' FRATI',
        istatCode: '003019033'
    },
    {
        name: 'CORTE FRANCA',
        istatCode: '003017062'
    },
    {
        name: 'CORTE PALASIO',
        istatCode: '003098024'
    },
    {
        name: 'CORTEMAGGIORE',
        istatCode: '008033018'
    },
    {
        name: 'CORTEMILIA',
        istatCode: '001004073'
    },
    {
        name: 'CORTENO GOLGI',
        istatCode: '003017063'
    },
    {
        name: 'CORTENOVA (LC)',
        istatCode: '003097025'
    },
    {
        name: 'CORTENUOVA (BG)',
        istatCode: '003016083'
    },
    {
        name: 'CORTEOLONA',
        istatCode: '003018056'
    },
    {
        name: 'CORTEOLONA E GENZONE',
        istatCode: '003018192'
    },
    {
        name: 'CORTICELLE PIEVE',
        istatCode: '003017843'
    },
    {
        name: 'CORTIGLIONE',
        istatCode: '001005048'
    },
    {
        name: 'CORTILE SAN MARTINO',
        istatCode: '008034802'
    },
    {
        name: 'CORTINA D\'AMPEZZO',
        istatCode: '005025016'
    },
    {
        name: 'CORTINA SULLA STRADA DEL VINO - KURTINIG AN DER WEINSTRASSE',
        istatCode: '004021025'
    },
    {
        name: 'CORTINO',
        istatCode: '013067022'
    },
    {
        name: 'CORTONA',
        istatCode: '009051017'
    },
    {
        name: 'CORVARA',
        istatCode: '013068016'
    },
    {
        name: 'CORVARA IN BADIA - CORVARA',
        istatCode: '004021026'
    },
    {
        name: 'CORVINO SAN QUIRICO',
        istatCode: '003018057'
    },
    {
        name: 'CORZANO',
        istatCode: '003017064'
    },
    {
        name: 'COSEANO',
        istatCode: '006030031'
    },
    {
        name: 'COSENZA',
        istatCode: '018078045'
    },
    {
        name: 'COSIO DI ARROSCIA',
        istatCode: '007008023'
    },
    {
        name: 'COSIO VALTELLINO',
        istatCode: '003014024'
    },
    {
        name: 'COSOLETO',
        istatCode: '018080030'
    },
    {
        name: 'COSSANO BELBO',
        istatCode: '001004074'
    },
    {
        name: 'COSSANO CANAVESE',
        istatCode: '001001095'
    },
    {
        name: 'COSSATO',
        istatCode: '001096020'
    },
    {
        name: 'COSSERIA',
        istatCode: '007009026'
    },
    {
        name: 'COSSIGNANO',
        istatCode: '011044016'
    },
    {
        name: 'COSSILA',
        istatCode: '018002811'
    },
    {
        name: 'COSSOGNO',
        istatCode: '001103023'
    },
    {
        name: 'COSSOINE',
        istatCode: '020090027'
    },
    {
        name: 'COSSOMBRATO',
        istatCode: '001005049'
    },
    {
        name: 'COSTA DE\' NOBILI',
        istatCode: '003018058'
    },
    {
        name: 'COSTA DI MEZZATE',
        istatCode: '003016084'
    },
    {
        name: 'COSTA DI ROVIGO',
        istatCode: '005029018'
    },
    {
        name: 'COSTA DI SERINA',
        istatCode: '003016247'
    },
    {
        name: 'COSTA MASNAGA',
        istatCode: '003097026'
    },
    {
        name: 'COSTA VALLE IMAGNA',
        istatCode: '003016085'
    },
    {
        name: 'COSTA VESCOVATO',
        istatCode: '001006062'
    },
    {
        name: 'COSTA VOLPINO',
        istatCode: '003016086'
    },
    {
        name: 'COSTABISSARA',
        istatCode: '005024035'
    },
    {
        name: 'COSTACCIARO',
        istatCode: '010054016'
    },
    {
        name: 'COSTANZANA',
        istatCode: '001002047'
    },
    {
        name: 'COSTARAINERA',
        istatCode: '007008024'
    },
    {
        name: 'COSTERMANO',
        istatCode: '005023030'
    },
    {
        name: 'COSTIGLIOLE D\'ASTI',
        istatCode: '001005050'
    },
    {
        name: 'COSTIGLIOLE SALUZZO',
        istatCode: '001004075'
    },
    {
        name: 'COTIGNOLA',
        istatCode: '008039009'
    },
    {
        name: 'COTRONEI',
        istatCode: '018101009'
    },
    {
        name: 'COTTANELLO',
        istatCode: '012057026'
    },
    {
        name: 'COURMAYEUR',
        istatCode: '002007022'
    },
    {
        name: 'COVO',
        istatCode: '003016087'
    },
    {
        name: 'COZZO',
        istatCode: '003018059'
    },
    {
        name: 'CRACO',
        istatCode: '017077007'
    },
    {
        name: 'CRANDOLA VALSASSINA',
        istatCode: '003097027'
    },
    {
        name: 'CRAVAGLIANA',
        istatCode: '001002048'
    },
    {
        name: 'CRAVANZANA',
        istatCode: '001004076'
    },
    {
        name: 'CRAVEGGIA',
        istatCode: '001103024'
    },
    {
        name: 'CREAZZO',
        istatCode: '005024036'
    },
    {
        name: 'CRECCHIO',
        istatCode: '013069027'
    },
    {
        name: 'CREDARO',
        istatCode: '003016088'
    },
    {
        name: 'CREDERA RUBBIANO',
        istatCode: '003019034'
    },
    {
        name: 'CREMA',
        istatCode: '003019035'
    },
    {
        name: 'CREMELLA',
        istatCode: '003097028'
    },
    {
        name: 'CREMENAGA',
        istatCode: '003012056'
    },
    {
        name: 'CREMENO',
        istatCode: '003097029'
    },
    {
        name: 'CREMIA',
        istatCode: '003013083'
    },
    {
        name: 'CREMOLINO',
        istatCode: '001006063'
    },
    {
        name: 'CREMONA',
        istatCode: '003019036'
    },
    {
        name: 'CREMOSANO',
        istatCode: '003019037'
    },
    {
        name: 'CRESCENTINO',
        istatCode: '001002049'
    },
    {
        name: 'CRESPADORO',
        istatCode: '005024037'
    },
    {
        name: 'CRESPANO DEL GRAPPA',
        istatCode: '005026024'
    },
    {
        name: 'CRESPELLANO',
        istatCode: '008037023'
    },
    {
        name: 'CRESPIATICA',
        istatCode: '003098025'
    },
    {
        name: 'CRESPINA',
        istatCode: '009050013'
    },
    {
        name: 'CRESPINA LORENZANA',
        istatCode: '009050041'
    },
    {
        name: 'CRESPINO',
        istatCode: '005029019'
    },
    {
        name: 'CRESSA',
        istatCode: '001003055'
    },
    {
        name: 'CREVACUORE',
        istatCode: '001096021'
    },
    {
        name: 'CREVALCORE',
        istatCode: '008037024'
    },
    {
        name: 'CREVOLADOSSOLA',
        istatCode: '001103025'
    },
    {
        name: 'CRISPANO',
        istatCode: '015063030'
    },
    {
        name: 'CRISPIANO',
        istatCode: '016073004'
    },
    {
        name: 'CRISSOLO',
        istatCode: '001004077'
    },
    {
        name: 'CROCEFIESCHI',
        istatCode: '007010020'
    },
    {
        name: 'CROCETTA DEL MONTELLO',
        istatCode: '005026025'
    },
    {
        name: 'CRODO',
        istatCode: '001103026'
    },
    {
        name: 'CROGNALETO',
        istatCode: '013067023'
    },
    {
        name: 'CROPALATI',
        istatCode: '018078046'
    },
    {
        name: 'CROPANI',
        istatCode: '018079036'
    },
    {
        name: 'CROSA',
        istatCode: '001096022'
    },
    {
        name: 'CROSARA',
        istatCode: '005024802'
    },
    {
        name: 'CROSIA',
        istatCode: '018078047'
    },
    {
        name: 'CROSIO DELLA VALLE',
        istatCode: '003012057'
    },
    {
        name: 'CROTONE',
        istatCode: '018101010'
    },
    {
        name: 'CROTTA D\'ADDA',
        istatCode: '003019038'
    },
    {
        name: 'CROVA',
        istatCode: '001002052'
    },
    {
        name: 'CROVIANA',
        istatCode: '004022068'
    },
    {
        name: 'CRUCOLI',
        istatCode: '018101011'
    },
    {
        name: 'CRUSINALLO',
        istatCode: '001003845'
    },
    {
        name: 'CUASSO AL MONTE',
        istatCode: '003012058'
    },
    {
        name: 'CUCCARO MONFERRATO',
        istatCode: '001006064'
    },
    {
        name: 'CUCCARO VETERE',
        istatCode: '015065049'
    },
    {
        name: 'CUCCIAGO',
        istatCode: '003013084'
    },
    {
        name: 'CUCEGLIO',
        istatCode: '001001096'
    },
    {
        name: 'CUGGIONO',
        istatCode: '003015096'
    },
    {
        name: 'CUGLIATE-FABIASCO',
        istatCode: '003012059'
    },
    {
        name: 'CUGLIERI',
        istatCode: '020095019'
    },
    {
        name: 'CUGNOLI',
        istatCode: '013068017'
    },
    {
        name: 'CUMIANA',
        istatCode: '001001097'
    },
    {
        name: 'CUMIGNANO SUL NAVIGLIO',
        istatCode: '003019039'
    },
    {
        name: 'CUNARDO',
        istatCode: '003012060'
    },
    {
        name: 'CUNEO',
        istatCode: '001004078'
    },
    {
        name: 'CUNEVO',
        istatCode: '004022069'
    },
    {
        name: 'CUNICO',
        istatCode: '001005051'
    },
    {
        name: 'CUORGNE\'',
        istatCode: '001001098'
    },
    {
        name: 'CUPELLO',
        istatCode: '013069028'
    },
    {
        name: 'CUPRA MARITTIMA',
        istatCode: '011044017'
    },
    {
        name: 'CUPRAMONTANA',
        istatCode: '011042016'
    },
    {
        name: 'CURA CARPIGNANO',
        istatCode: '003018060'
    },
    {
        name: 'CURCURIS',
        istatCode: '020095077'
    },
    {
        name: 'CURDOMO',
        istatCode: '003016821'
    },
    {
        name: 'CUREGGIO',
        istatCode: '001003058'
    },
    {
        name: 'CURIGLIA CON MONTEVIASCO',
        istatCode: '003012061'
    },
    {
        name: 'CURINGA',
        istatCode: '018079039'
    },
    {
        name: 'CURINO',
        istatCode: '001096023'
    },
    {
        name: 'CURNO',
        istatCode: '003016089'
    },
    {
        name: 'CURON VENOSTA - GRAUN IM VINSCHGAU',
        istatCode: '004021027'
    },
    {
        name: 'CURSI',
        istatCode: '016075025'
    },
    {
        name: 'CURSOLO-ORASSO',
        istatCode: '001103027'
    },
    {
        name: 'CURTAROLO',
        istatCode: '005028036'
    },
    {
        name: 'CURTATONE',
        istatCode: '003020021'
    },
    {
        name: 'CURTI',
        istatCode: '015061032'
    },
    {
        name: 'CUSAGO',
        istatCode: '003015097'
    },
    {
        name: 'CUSANO MILANINO',
        istatCode: '003015098'
    },
    {
        name: 'CUSANO MUTRI',
        istatCode: '015062026'
    },
    {
        name: 'CUSINO',
        istatCode: '003013085'
    },
    {
        name: 'CUSIO',
        istatCode: '003016090'
    },
    {
        name: 'CUSTONACI',
        istatCode: '019081007'
    },
    {
        name: 'CUTIGLIANO',
        istatCode: '009047004'
    },
    {
        name: 'CUTRO',
        istatCode: '018101012'
    },
    {
        name: 'CUTROFIANO',
        istatCode: '016075026'
    },
    {
        name: 'CUVEGLIO',
        istatCode: '003012062'
    },
    {
        name: 'CUVIO',
        istatCode: '003012063'
    },
    {
        name: 'DAIANO',
        istatCode: '004022070'
    },
    {
        name: 'DAIRAGO',
        istatCode: '003015099'
    },
    {
        name: 'DALMINE',
        istatCode: '003016091'
    },
    {
        name: 'DAMBEL',
        istatCode: '004022071'
    },
    {
        name: 'DANTA DI CADORE',
        istatCode: '005025017'
    },
    {
        name: 'DAONE',
        istatCode: '004022072'
    },
    {
        name: 'DARE\'',
        istatCode: '004022073'
    },
    {
        name: 'DARFO BOARIO TERME',
        istatCode: '003017065'
    },
    {
        name: 'DASA\'',
        istatCode: '018102007'
    },
    {
        name: 'DAVAGNA',
        istatCode: '007010021'
    },
    {
        name: 'DAVERIO',
        istatCode: '003012064'
    },
    {
        name: 'DAVOLI',
        istatCode: '018079042'
    },
    {
        name: 'DAZIO',
        istatCode: '003014025'
    },
    {
        name: 'DECIMOMANNU',
        istatCode: '020092015'
    },
    {
        name: 'DECIMOPUTZU',
        istatCode: '020111013'
    },
    {
        name: 'DECOLLATURA',
        istatCode: '018079043'
    },
    {
        name: 'DEGO',
        istatCode: '007009027'
    },
    {
        name: 'DEIVA MARINA',
        istatCode: '007011012'
    },
    {
        name: 'DELEBIO',
        istatCode: '003014026'
    },
    {
        name: 'DELIA',
        istatCode: '019085006'
    },
    {
        name: 'DELIANUOVA',
        istatCode: '018080031'
    },
    {
        name: 'DELICETO',
        istatCode: '016071022'
    },
    {
        name: 'DELLO',
        istatCode: '003017066'
    },
    {
        name: 'DEMONTE',
        istatCode: '001004079'
    },
    {
        name: 'DENICE',
        istatCode: '001006065'
    },
    {
        name: 'DENNO',
        istatCode: '004022074'
    },
    {
        name: 'DERNICE',
        istatCode: '001006066'
    },
    {
        name: 'DEROVERE',
        istatCode: '003019040'
    },
    {
        name: 'DERUTA',
        istatCode: '010054017'
    },
    {
        name: 'DERVIO',
        istatCode: '003097030'
    },
    {
        name: 'DESANA',
        istatCode: '001002054'
    },
    {
        name: 'DESENZANO DEL GARDA',
        istatCode: '003017067'
    },
    {
        name: 'DESIO',
        istatCode: '003108023'
    },
    {
        name: 'DESULO',
        istatCode: '020091016'
    },
    {
        name: 'Dezzo di Scalve',
        istatCode: '003016824'
    },
    {
        name: 'DIAMANTE',
        istatCode: '018078048'
    },
    {
        name: 'DIANO ARENTINO',
        istatCode: '007008025'
    },
    {
        name: 'DIANO CASTELLO',
        istatCode: '007008026'
    },
    {
        name: 'DIANO D\'ALBA',
        istatCode: '001004080'
    },
    {
        name: 'DIANO MARINA',
        istatCode: '007008027'
    },
    {
        name: 'DIANO SAN PIETRO',
        istatCode: '007008028'
    },
    {
        name: 'DICOMANO',
        istatCode: '009048013'
    },
    {
        name: 'DIGNANO',
        istatCode: '006030032'
    },
    {
        name: 'DIMARO',
        istatCode: '004022075'
    },
    {
        name: 'DIMARO FOLGARIDA',
        istatCode: '004022233'
    },
    {
        name: 'DINAMI',
        istatCode: '018102008'
    },
    {
        name: 'DIPIGNANO',
        istatCode: '018078049'
    },
    {
        name: 'DISO',
        istatCode: '016075027'
    },
    {
        name: 'DIVIGNANO',
        istatCode: '001003060'
    },
    {
        name: 'DIZZASCO',
        istatCode: '003013087'
    },
    {
        name: 'DOBBIACO - TOBLACH',
        istatCode: '004021028'
    },
    {
        name: 'DOBERDO\' DEL LAGO',
        istatCode: '006031003'
    },
    {
        name: 'DOGLIANI',
        istatCode: '001004081'
    },
    {
        name: 'DOGLIOLA',
        istatCode: '013069029'
    },
    {
        name: 'DOGNA',
        istatCode: '006030033'
    },
    {
        name: 'DOLCE\'',
        istatCode: '005023031'
    },
    {
        name: 'DOLCEACQUA',
        istatCode: '007008029'
    },
    {
        name: 'DOLCEDO',
        istatCode: '007008030'
    },
    {
        name: 'DOLEGNA DEL COLLIO',
        istatCode: '006031004'
    },
    {
        name: 'DOLIANOVA',
        istatCode: '020111014'
    },
    {
        name: 'DOLO',
        istatCode: '005027012'
    },
    {
        name: 'DOLZAGO',
        istatCode: '003097031'
    },
    {
        name: 'DOMANICO',
        istatCode: '018078050'
    },
    {
        name: 'DOMASO',
        istatCode: '003013089'
    },
    {
        name: 'DOMEGGE DI CADORE',
        istatCode: '005025018'
    },
    {
        name: 'DOMICELLA',
        istatCode: '015064031'
    },
    {
        name: 'DOMODOSSOLA',
        istatCode: '001103028'
    },
    {
        name: 'DOMUS DE MARIA',
        istatCode: '020111015'
    },
    {
        name: 'DOMUSNOVAS',
        istatCode: '020111016'
    },
    {
        name: 'DON',
        istatCode: '004022076'
    },
    {
        name: 'DONADA',
        istatCode: '005029020'
    },
    {
        name: 'DONATO',
        istatCode: '001096024'
    },
    {
        name: 'DONGO',
        istatCode: '003013090'
    },
    {
        name: 'DONNAS',
        istatCode: '002007023'
    },
    {
        name: 'DONORI\'',
        istatCode: '020111017'
    },
    {
        name: 'DORGALI',
        istatCode: '020091017'
    },
    {
        name: 'DORIO',
        istatCode: '003097032'
    },
    {
        name: 'DORMELLETTO',
        istatCode: '001003062'
    },
    {
        name: 'DORNO',
        istatCode: '003018061'
    },
    {
        name: 'DORSINO',
        istatCode: '004022077'
    },
    {
        name: 'DORZANO',
        istatCode: '001096025'
    },
    {
        name: 'DOSOLO',
        istatCode: '003020022'
    },
    {
        name: 'DOSSENA',
        istatCode: '003016092'
    },
    {
        name: 'DOSSO DEL LIRO',
        istatCode: '003013092'
    },
    {
        name: 'DOUES',
        istatCode: '002007024'
    },
    {
        name: 'DOVADOLA',
        istatCode: '008040011'
    },
    {
        name: 'DOVERA',
        istatCode: '003019041'
    },
    {
        name: 'DOZZA',
        istatCode: '008037025'
    },
    {
        name: 'DRAGONI',
        istatCode: '015061033'
    },
    {
        name: 'DRAPIA',
        istatCode: '018102009'
    },
    {
        name: 'DRENA',
        istatCode: '004022078'
    },
    {
        name: 'DRENCHIA',
        istatCode: '006030034'
    },
    {
        name: 'DRESANO',
        istatCode: '003015101'
    },
    {
        name: 'DREZZO',
        istatCode: '003013093'
    },
    {
        name: 'DRIZZONA',
        istatCode: '003019042'
    },
    {
        name: 'DRO',
        istatCode: '004022079'
    },
    {
        name: 'DRONERO',
        istatCode: '001004082'
    },
    {
        name: 'DRUENTO',
        istatCode: '001001099'
    },
    {
        name: 'DRUOGNO',
        istatCode: '001103029'
    },
    {
        name: 'DUALCHI',
        istatCode: '020091018'
    },
    {
        name: 'DUBINO',
        istatCode: '003014027'
    },
    {
        name: 'DUE CARRARE',
        istatCode: '005028106'
    },
    {
        name: 'DUEVILLE',
        istatCode: '005024038'
    },
    {
        name: 'DUGENTA',
        istatCode: '015062027'
    },
    {
        name: 'DUINO-AURISINA',
        istatCode: '006032001'
    },
    {
        name: 'DUMENZA',
        istatCode: '003012065'
    },
    {
        name: 'DUNO',
        istatCode: '003012066'
    },
    {
        name: 'DURAZZANO',
        istatCode: '015062028'
    },
    {
        name: 'DURONIA',
        istatCode: '014070022'
    },
    {
        name: 'DUSINO SAN MICHELE',
        istatCode: '001005052'
    },
    {
        name: 'EBOLI',
        istatCode: '015065050'
    },
    {
        name: 'EDOLO',
        istatCode: '003017068'
    },
    {
        name: 'EGNA - NEUMARKT',
        istatCode: '004021029'
    },
    {
        name: 'ELICE',
        istatCode: '013068018'
    },
    {
        name: 'ELINI',
        istatCode: '020091019'
    },
    {
        name: 'ELLO',
        istatCode: '003097033'
    },
    {
        name: 'ELMAS',
        istatCode: '020092108'
    },
    {
        name: 'ELVA',
        istatCode: '001004083'
    },
    {
        name: 'EMARESE',
        istatCode: '002007025'
    },
    {
        name: 'EMPOLI',
        istatCode: '009048014'
    },
    {
        name: 'ENDINE GAIANO',
        istatCode: '003016093'
    },
    {
        name: 'ENEGO',
        istatCode: '005024039'
    },
    {
        name: 'ENEMONZO',
        istatCode: '006030035'
    },
    {
        name: 'ENNA',
        istatCode: '019086009'
    },
    {
        name: 'ENTRACQUE',
        istatCode: '001004084'
    },
    {
        name: 'ENTRATICO',
        istatCode: '003016094'
    },
    {
        name: 'ENVIE',
        istatCode: '001004085'
    },
    {
        name: 'EPISCOPIA',
        istatCode: '017076030'
    },
    {
        name: 'ERACLEA',
        istatCode: '005027013'
    },
    {
        name: 'ERBA',
        istatCode: '003013095'
    },
    {
        name: 'ERBE\'',
        istatCode: '005023032'
    },
    {
        name: 'ERBEZZO',
        istatCode: '005023033'
    },
    {
        name: 'ERBUSCO',
        istatCode: '003017069'
    },
    {
        name: 'ERCHIE',
        istatCode: '016074006'
    },
    {
        name: 'ERCOLANO',
        istatCode: '015063064'
    },
    {
        name: 'ERICE',
        istatCode: '019081008'
    },
    {
        name: 'ERLI',
        istatCode: '007009028'
    },
    {
        name: 'ERTO E CASSO',
        istatCode: '006093019'
    },
    {
        name: 'ERULA',
        istatCode: '020090088'
    },
    {
        name: 'ERVE',
        istatCode: '003097034'
    },
    {
        name: 'ESANATOGLIA',
        istatCode: '011043016'
    },
    {
        name: 'ESCALAPLANO',
        istatCode: '020111018'
    },
    {
        name: 'ESCOLCA',
        istatCode: '020111019'
    },
    {
        name: 'ESCOVEDU',
        istatCode: '020095803'
    },
    {
        name: 'ESINE',
        istatCode: '003017070'
    },
    {
        name: 'ESINO LARIO',
        istatCode: '003097035'
    },
    {
        name: 'ESPERIA',
        istatCode: '012060031'
    },
    {
        name: 'ESPORLATU',
        istatCode: '020090028'
    },
    {
        name: 'ESTE',
        istatCode: '005028037'
    },
    {
        name: 'ESTERZILI',
        istatCode: '020111020'
    },
    {
        name: 'ETROUBLES',
        istatCode: '002007026'
    },
    {
        name: 'EUPILIO',
        istatCode: '003013097'
    },
    {
        name: 'EXILLES',
        istatCode: '001001100'
    },
    {
        name: 'FABBRICA CURONE',
        istatCode: '001006067'
    },
    {
        name: 'FABBRICHE DI VALLICO',
        istatCode: '009046012'
    },
    {
        name: 'FABBRICHE DI VERGEMOLI',
        istatCode: '009046036'
    },
    {
        name: 'FABBRICO',
        istatCode: '008035021'
    },
    {
        name: 'FABRIANO',
        istatCode: '011042017'
    },
    {
        name: 'FABRICA DI ROMA',
        istatCode: '012056024'
    },
    {
        name: 'FABRIZIA',
        istatCode: '018102010'
    },
    {
        name: 'FABRO',
        istatCode: '010055011'
    },
    {
        name: 'FAEDIS',
        istatCode: '006030036'
    },
    {
        name: 'FAEDO',
        istatCode: '004022080'
    },
    {
        name: 'FAEDO VALTELLINO',
        istatCode: '003014028'
    },
    {
        name: 'FAENZA',
        istatCode: '008039010'
    },
    {
        name: 'FAETO',
        istatCode: '016071023'
    },
    {
        name: 'FAGAGNA',
        istatCode: '006030037'
    },
    {
        name: 'FAGGETO LARIO',
        istatCode: '003013098'
    },
    {
        name: 'FAGGIANO',
        istatCode: '016073005'
    },
    {
        name: 'FAGNANO ALTO',
        istatCode: '013066042'
    },
    {
        name: 'FAGNANO CASTELLO',
        istatCode: '018078051'
    },
    {
        name: 'FAGNANO OLONA',
        istatCode: '003012067'
    },
    {
        name: 'FAI DELLA PAGANELLA',
        istatCode: '004022081'
    },
    {
        name: 'FAICCHIO',
        istatCode: '015062029'
    },
    {
        name: 'FALCADE',
        istatCode: '005025019'
    },
    {
        name: 'FALCIANO DEL MASSICO',
        istatCode: '015061101'
    },
    {
        name: 'FALCONARA ALBANESE',
        istatCode: '018078052'
    },
    {
        name: 'FALCONARA MARITTIMA',
        istatCode: '011042018'
    },
    {
        name: 'FALCONE',
        istatCode: '019083019'
    },
    {
        name: 'FALERIA',
        istatCode: '012056025'
    },
    {
        name: 'FALERNA',
        istatCode: '018079047'
    },
    {
        name: 'FALERONE',
        istatCode: '011109005'
    },
    {
        name: 'FALLO',
        istatCode: '013069104'
    },
    {
        name: 'FALMENTA',
        istatCode: '001103030'
    },
    {
        name: 'FALOPPIO',
        istatCode: '003013099'
    },
    {
        name: 'FALVATERRA',
        istatCode: '012060032'
    },
    {
        name: 'FALZES - PFALZEN',
        istatCode: '004021030'
    },
    {
        name: 'FANANO',
        istatCode: '008036011'
    },
    {
        name: 'FANNA',
        istatCode: '006093020'
    },
    {
        name: 'FANO',
        istatCode: '011041013'
    },
    {
        name: 'FANO ADRIANO',
        istatCode: '013067024'
    },
    {
        name: 'FARA FILIORUM PETRI',
        istatCode: '013069030'
    },
    {
        name: 'FARA GERA D\'ADDA',
        istatCode: '003016096'
    },
    {
        name: 'FARA IN SABINA',
        istatCode: '012057027'
    },
    {
        name: 'FARA NOVARESE',
        istatCode: '001003065'
    },
    {
        name: 'FARA OLIVANA CON SOLA',
        istatCode: '003016097'
    },
    {
        name: 'FARA SAN MARTINO',
        istatCode: '013069031'
    },
    {
        name: 'FARA VICENTINO',
        istatCode: '005024040'
    },
    {
        name: 'FARDELLA',
        istatCode: '017076031'
    },
    {
        name: 'FARIGLIANO',
        istatCode: '001004086'
    },
    {
        name: 'FARINDOLA',
        istatCode: '013068019'
    },
    {
        name: 'FARINI',
        istatCode: '008033019'
    },
    {
        name: 'FARNESE',
        istatCode: '012056026'
    },
    {
        name: 'FARRA D\'ALPAGO',
        istatCode: '005025020'
    },
    {
        name: 'FARRA DI SOLIGO',
        istatCode: '005026026'
    },
    {
        name: 'FARRA D\'ISONZO',
        istatCode: '006031005'
    },
    {
        name: 'FASANO',
        istatCode: '016074007'
    },
    {
        name: 'FASCIA',
        istatCode: '007010022'
    },
    {
        name: 'FAUGLIA',
        istatCode: '009050014'
    },
    {
        name: 'FAULE',
        istatCode: '001004087'
    },
    {
        name: 'FAVALE DI MALVARO',
        istatCode: '007010023'
    },
    {
        name: 'FAVARA',
        istatCode: '019084017'
    },
    {
        name: 'FAVER',
        istatCode: '004022082'
    },
    {
        name: 'FAVIGNANA',
        istatCode: '019081009'
    },
    {
        name: 'FAVRIA',
        istatCode: '001001101'
    },
    {
        name: 'FAVRIA-OGLIANICO',
        istatCode: '001001824'
    },
    {
        name: 'FEISOGLIO',
        istatCode: '001004088'
    },
    {
        name: 'FELETTO',
        istatCode: '001001102'
    },
    {
        name: 'FELINO',
        istatCode: '008034013'
    },
    {
        name: 'FELITTO',
        istatCode: '015065051'
    },
    {
        name: 'FELIZZANO',
        istatCode: '001006068'
    },
    {
        name: 'FELONICA',
        istatCode: '003020023'
    },
    {
        name: 'FELTRE',
        istatCode: '005025021'
    },
    {
        name: 'FENEGRO\'',
        istatCode: '003013100'
    },
    {
        name: 'FENESTRELLE',
        istatCode: '001001103'
    },
    {
        name: 'FENIS',
        istatCode: '002007027'
    },
    {
        name: 'FERENTILLO',
        istatCode: '010055012'
    },
    {
        name: 'FERENTINO',
        istatCode: '012060033'
    },
    {
        name: 'FERLA',
        istatCode: '019089008'
    },
    {
        name: 'FERMIGNANO',
        istatCode: '011041014'
    },
    {
        name: 'FERMO',
        istatCode: '011109006'
    },
    {
        name: 'FERNO',
        istatCode: '003012068'
    },
    {
        name: 'FEROLETO ANTICO',
        istatCode: '018079048'
    },
    {
        name: 'FEROLETO DELLA CHIESA',
        istatCode: '018080032'
    },
    {
        name: 'FERRANDINA',
        istatCode: '017077008'
    },
    {
        name: 'FERRARA',
        istatCode: '008038008'
    },
    {
        name: 'FERRARA DI MONTE BALDO',
        istatCode: '005023034'
    },
    {
        name: 'FERRAZZANO',
        istatCode: '014070023'
    },
    {
        name: 'FERRERA DI VARESE',
        istatCode: '003012069'
    },
    {
        name: 'FERRERA ERBOGNONE',
        istatCode: '003018062'
    },
    {
        name: 'FERRERE',
        istatCode: '001005053'
    },
    {
        name: 'FERRIERE',
        istatCode: '008033020'
    },
    {
        name: 'FERRUZZANO',
        istatCode: '018080033'
    },
    {
        name: 'FERTILIA',
        istatCode: '015061805'
    },
    {
        name: 'FIAMIGNANO',
        istatCode: '012057028'
    },
    {
        name: 'FIANO',
        istatCode: '001001104'
    },
    {
        name: 'FIANO ROMANO',
        istatCode: '012058036'
    },
    {
        name: 'FIASTRA',
        istatCode: '011043017'
    },
    {
        name: 'FIAVE\'',
        istatCode: '004022083'
    },
    {
        name: 'FICARAZZI',
        istatCode: '019082035'
    },
    {
        name: 'FICAROLO',
        istatCode: '005029021'
    },
    {
        name: 'FICARRA',
        istatCode: '019083020'
    },
    {
        name: 'FICULLE',
        istatCode: '010055013'
    },
    {
        name: 'FIDENZA',
        istatCode: '008034014'
    },
    {
        name: 'FIE\' ALLO SCILIAR - VOELS AM SCHLERN',
        istatCode: '004021031'
    },
    {
        name: 'FIERA DI PRIMIERO',
        istatCode: '004022084'
    },
    {
        name: 'FIEROZZO',
        istatCode: '004022085'
    },
    {
        name: 'FIESCO',
        istatCode: '003019043'
    },
    {
        name: 'FIESOLE',
        istatCode: '009048015'
    },
    {
        name: 'FIESSE',
        istatCode: '003017071'
    },
    {
        name: 'FIESSO D\'ARTICO',
        istatCode: '005027014'
    },
    {
        name: 'FIESSO UMBERTIANO',
        istatCode: '005029022'
    },
    {
        name: 'FIGINO SERENZA',
        istatCode: '003013101'
    },
    {
        name: 'FIGLINE E INCISA VALDARNO',
        istatCode: '009048052'
    },
    {
        name: 'FIGLINE VALDARNO',
        istatCode: '009048016'
    },
    {
        name: 'FIGLINE VEGLIATURO',
        istatCode: '018078053'
    },
    {
        name: 'FILACCIANO',
        istatCode: '012058037'
    },
    {
        name: 'FILADELFIA',
        istatCode: '018102011'
    },
    {
        name: 'FILAGO',
        istatCode: '003016098'
    },
    {
        name: 'FILANDARI',
        istatCode: '018102012'
    },
    {
        name: 'FILATTIERA',
        istatCode: '009045006'
    },
    {
        name: 'FILETTINO',
        istatCode: '012060034'
    },
    {
        name: 'FILETTO',
        istatCode: '013069032'
    },
    {
        name: 'FILIANO',
        istatCode: '017076032'
    },
    {
        name: 'FILIGHERA',
        istatCode: '003018063'
    },
    {
        name: 'FILIGNANO',
        istatCode: '014094019'
    },
    {
        name: 'FILOGASO',
        istatCode: '018102013'
    },
    {
        name: 'FILOTTRANO',
        istatCode: '011042019'
    },
    {
        name: 'FINALE EMILIA',
        istatCode: '008036012'
    },
    {
        name: 'FINALE LIGURE',
        istatCode: '007009029'
    },
    {
        name: 'FINO DEL MONTE',
        istatCode: '003016099'
    },
    {
        name: 'FINO MORNASCO',
        istatCode: '003013102'
    },
    {
        name: 'FIORANO AL SERIO',
        istatCode: '003016100'
    },
    {
        name: 'FIORANO CANAVESE',
        istatCode: '001001105'
    },
    {
        name: 'FIORANO MODENESE',
        istatCode: '008036013'
    },
    {
        name: 'FIORDIMONTE',
        istatCode: '011043018'
    },
    {
        name: 'FIORENZUOLA D\'ARDA',
        istatCode: '008033021'
    },
    {
        name: 'FIRENZE',
        istatCode: '009048017'
    },
    {
        name: 'FIRENZUOLA',
        istatCode: '009048018'
    },
    {
        name: 'FIRMO',
        istatCode: '018078054'
    },
    {
        name: 'FISCAGLIA',
        istatCode: '008038027'
    },
    {
        name: 'FISCIANO',
        istatCode: '015065052'
    },
    {
        name: 'FIUGGI',
        istatCode: '012060035'
    },
    {
        name: 'FIUMALBO',
        istatCode: '008036014'
    },
    {
        name: 'FIUMARA',
        istatCode: '018080034'
    },
    {
        name: 'FIUME',
        istatCode: '006701706'
    },
    {
        name: 'FIUME VENETO',
        istatCode: '006093021'
    },
    {
        name: 'FIUMEDINISI',
        istatCode: '019083021'
    },
    {
        name: 'FIUMEFREDDO BRUZIO',
        istatCode: '018078055'
    },
    {
        name: 'FIUMEFREDDO DI SICILIA',
        istatCode: '019087016'
    },
    {
        name: 'FIUMICELLO',
        istatCode: '006030038'
    },
    {
        name: 'FIUMICELLO VILLA VICENTINA',
        istatCode: '006030190'
    },
    {
        name: 'FIUMICINO',
        istatCode: '012058120'
    },
    {
        name: 'FIUMINATA',
        istatCode: '011043019'
    },
    {
        name: 'FIVIZZANO',
        istatCode: '009045007'
    },
    {
        name: 'FLAIBANO',
        istatCode: '006030039'
    },
    {
        name: 'FLAVON',
        istatCode: '004022086'
    },
    {
        name: 'FLERO',
        istatCode: '003017072'
    },
    {
        name: 'FLORESTA',
        istatCode: '019083022'
    },
    {
        name: 'FLORIDIA',
        istatCode: '019089009'
    },
    {
        name: 'FLORINAS',
        istatCode: '020090029'
    },
    {
        name: 'FLUMERI',
        istatCode: '015064032'
    },
    {
        name: 'FLUMINIMAGGIORE',
        istatCode: '020111021'
    },
    {
        name: 'FLUSSIO',
        istatCode: '020095080'
    },
    {
        name: 'FOBELLO',
        istatCode: '001002057'
    },
    {
        name: 'FOGGIA',
        istatCode: '016071024'
    },
    {
        name: 'FOGLIANISE',
        istatCode: '015062030'
    },
    {
        name: 'FOGLIANO REDIPUGLIA',
        istatCode: '006031006'
    },
    {
        name: 'FOGLIZZO',
        istatCode: '001001106'
    },
    {
        name: 'FOIANO DELLA CHIANA',
        istatCode: '009051018'
    },
    {
        name: 'FOIANO DI VAL FORTORE',
        istatCode: '015062031'
    },
    {
        name: 'FOLGARIA',
        istatCode: '004022087'
    },
    {
        name: 'FOLIGNANO',
        istatCode: '011044020'
    },
    {
        name: 'FOLIGNO',
        istatCode: '010054018'
    },
    {
        name: 'FOLLINA',
        istatCode: '005026027'
    },
    {
        name: 'FOLLO',
        istatCode: '007011013'
    },
    {
        name: 'FOLLONICA',
        istatCode: '009053009'
    },
    {
        name: 'FOMBIO',
        istatCode: '003098026'
    },
    {
        name: 'FONDACHELLI-FANTINA',
        istatCode: '019083023'
    },
    {
        name: 'FONDI',
        istatCode: '012059007'
    },
    {
        name: 'FONDO',
        istatCode: '004022088'
    },
    {
        name: 'FONNI',
        istatCode: '020091024'
    },
    {
        name: 'FONTAINEMORE',
        istatCode: '002007028'
    },
    {
        name: 'FONTANA LIRI',
        istatCode: '012060036'
    },
    {
        name: 'FONTANAFREDDA',
        istatCode: '006093022'
    },
    {
        name: 'FONTANAROSA',
        istatCode: '015064033'
    },
    {
        name: 'FONTANELICE',
        istatCode: '008037026'
    },
    {
        name: 'FONTANELLA',
        istatCode: '003016101'
    },
    {
        name: 'FONTANELLATO',
        istatCode: '008034015'
    },
    {
        name: 'FONTANELLE',
        istatCode: '005026028'
    },
    {
        name: 'FONTANETO D\'AGOGNA',
        istatCode: '001003066'
    },
    {
        name: 'FONTANETTO PO',
        istatCode: '001002058'
    },
    {
        name: 'FONTANIGORDA',
        istatCode: '007010024'
    },
    {
        name: 'FONTANILE',
        istatCode: '001005054'
    },
    {
        name: 'FONTANIVA',
        istatCode: '005028038'
    },
    {
        name: 'FONTE',
        istatCode: '005026029'
    },
    {
        name: 'FONTE NUOVA',
        istatCode: '012058122'
    },
    {
        name: 'FONTECCHIO',
        istatCode: '013066043'
    },
    {
        name: 'FONTECHIARI',
        istatCode: '012060037'
    },
    {
        name: 'FONTEGRECA',
        istatCode: '015061034'
    },
    {
        name: 'FONTENO',
        istatCode: '003016102'
    },
    {
        name: 'FONTEVIVO',
        istatCode: '008034016'
    },
    {
        name: 'FONZASO',
        istatCode: '005025022'
    },
    {
        name: 'FOPPOLO',
        istatCode: '003016103'
    },
    {
        name: 'FORANO',
        istatCode: '012057029'
    },
    {
        name: 'FORCE',
        istatCode: '011044021'
    },
    {
        name: 'FORCHIA',
        istatCode: '015062032'
    },
    {
        name: 'FORCOLA',
        istatCode: '003014029'
    },
    {
        name: 'FORDONGIANUS',
        istatCode: '020095020'
    },
    {
        name: 'FORENZA',
        istatCode: '017076033'
    },
    {
        name: 'FORESTO SPARSO',
        istatCode: '003016104'
    },
    {
        name: 'FORGARIA NEL FRIULI',
        istatCode: '006030137'
    },
    {
        name: 'FORINO',
        istatCode: '015064034'
    },
    {
        name: 'FORIO',
        istatCode: '015063031'
    },
    {
        name: 'FORLI\'',
        istatCode: '008040012'
    },
    {
        name: 'FORLI\' DEL SANNIO',
        istatCode: '014094020'
    },
    {
        name: 'FORLIMPOPOLI',
        istatCode: '008040013'
    },
    {
        name: 'FORMAZZA',
        istatCode: '001103031'
    },
    {
        name: 'FORMELLO',
        istatCode: '012058038'
    },
    {
        name: 'FORMIA',
        istatCode: '012059008'
    },
    {
        name: 'FORMICOLA',
        istatCode: '015061035'
    },
    {
        name: 'FORMIGARA',
        istatCode: '003019044'
    },
    {
        name: 'FORMIGINE',
        istatCode: '008036015'
    },
    {
        name: 'FORMIGLIANA',
        istatCode: '001002059'
    },
    {
        name: 'FORMIGNANA',
        istatCode: '008038009'
    },
    {
        name: 'FORNACE',
        istatCode: '004022089'
    },
    {
        name: 'FORNELLI',
        istatCode: '014094021'
    },
    {
        name: 'FORNI AVOLTRI',
        istatCode: '006030040'
    },
    {
        name: 'FORNI DI SOPRA',
        istatCode: '006030041'
    },
    {
        name: 'FORNI DI SOTTO',
        istatCode: '006030042'
    },
    {
        name: 'FORNI IN VAL D\'ASTICO',
        istatCode: '005024803'
    },
    {
        name: 'FORNO CANAVESE',
        istatCode: '001001107'
    },
    {
        name: 'FORNO DI ZOLDO',
        istatCode: '005025024'
    },
    {
        name: 'FORNOVO DI TARO',
        istatCode: '008034017'
    },
    {
        name: 'FORNOVO SAN GIOVANNI',
        istatCode: '003016105'
    },
    {
        name: 'FORTE DEI MARMI',
        istatCode: '009046013'
    },
    {
        name: 'FORTEZZA - FRANZENSFESTE',
        istatCode: '004021032'
    },
    {
        name: 'FORTUNAGO',
        istatCode: '003018064'
    },
    {
        name: 'FORZA D\'AGRO\'',
        istatCode: '019083024'
    },
    {
        name: 'FOSCIANDORA',
        istatCode: '009046014'
    },
    {
        name: 'FOSDINOVO',
        istatCode: '009045008'
    },
    {
        name: 'FOSSA',
        istatCode: '013066044'
    },
    {
        name: 'FOSSACESIA',
        istatCode: '013069033'
    },
    {
        name: 'FOSSALTA DI PIAVE',
        istatCode: '005027015'
    },
    {
        name: 'FOSSALTA DI PORTOGRUARO',
        istatCode: '005027016'
    },
    {
        name: 'FOSSALTO',
        istatCode: '014070024'
    },
    {
        name: 'FOSSANO',
        istatCode: '001004089'
    },
    {
        name: 'FOSSARMATO',
        istatCode: '003018833'
    },
    {
        name: 'FOSSATO DI VICO',
        istatCode: '010054019'
    },
    {
        name: 'FOSSATO SERRALTA',
        istatCode: '018079052'
    },
    {
        name: 'FOSSO\'',
        istatCode: '005027017'
    },
    {
        name: 'FOSSOMBRONE',
        istatCode: '011041015'
    },
    {
        name: 'FOZA',
        istatCode: '005024041'
    },
    {
        name: 'FRABOSA SOPRANA',
        istatCode: '001004090'
    },
    {
        name: 'FRABOSA SOTTANA',
        istatCode: '001004091'
    },
    {
        name: 'FRACONALTO',
        istatCode: '001006069'
    },
    {
        name: 'FRAGAGNANO',
        istatCode: '016073006'
    },
    {
        name: 'FRAGNETO L\'ABATE',
        istatCode: '015062033'
    },
    {
        name: 'FRAGNETO MONFORTE',
        istatCode: '015062034'
    },
    {
        name: 'FRAINE',
        istatCode: '013069034'
    },
    {
        name: 'FRAMURA',
        istatCode: '007011014'
    },
    {
        name: 'FRANCAVILLA AL MARE',
        istatCode: '013069035'
    },
    {
        name: 'FRANCAVILLA ANGITOLA',
        istatCode: '018102014'
    },
    {
        name: 'FRANCAVILLA BISIO',
        istatCode: '001006070'
    },
    {
        name: 'FRANCAVILLA D\'ETE',
        istatCode: '011109007'
    },
    {
        name: 'FRANCAVILLA DI SICILIA',
        istatCode: '019083025'
    },
    {
        name: 'FRANCAVILLA FONTANA',
        istatCode: '016074008'
    },
    {
        name: 'FRANCAVILLA IN SINNI',
        istatCode: '017076034'
    },
    {
        name: 'FRANCAVILLA MARITTIMA',
        istatCode: '018078056'
    },
    {
        name: 'FRANCICA',
        istatCode: '018102015'
    },
    {
        name: 'FRANCOFONTE',
        istatCode: '019089010'
    },
    {
        name: 'FRANCOLISE',
        istatCode: '015061036'
    },
    {
        name: 'FRASCARO',
        istatCode: '001006071'
    },
    {
        name: 'FRASCAROLO',
        istatCode: '003018065'
    },
    {
        name: 'FRASCATI',
        istatCode: '012058039'
    },
    {
        name: 'FRASCINETO',
        istatCode: '018078057'
    },
    {
        name: 'FRASSILONGO',
        istatCode: '004022090'
    },
    {
        name: 'FRASSINELLE POLESINE',
        istatCode: '005029023'
    },
    {
        name: 'FRASSINELLO MONFERRATO',
        istatCode: '001006072'
    },
    {
        name: 'FRASSINELLO-OLIVOLA',
        istatCode: '001006527'
    },
    {
        name: 'FRASSINETO PO',
        istatCode: '001006073'
    },
    {
        name: 'FRASSINETTO',
        istatCode: '001001108'
    },
    {
        name: 'FRASSINO',
        istatCode: '001004092'
    },
    {
        name: 'FRASSINORO',
        istatCode: '008036016'
    },
    {
        name: 'FRASSO SABINO',
        istatCode: '012057030'
    },
    {
        name: 'FRASSO TELESINO',
        istatCode: '015062035'
    },
    {
        name: 'FRATTA POLESINE',
        istatCode: '005029024'
    },
    {
        name: 'FRATTA TODINA',
        istatCode: '010054020'
    },
    {
        name: 'FRATTAMAGGIORE',
        istatCode: '015063032'
    },
    {
        name: 'FRATTAMINORE',
        istatCode: '015063033'
    },
    {
        name: 'FRATTE ROSA',
        istatCode: '011041016'
    },
    {
        name: 'FRAZZANO\'',
        istatCode: '019083026'
    },
    {
        name: 'FREGONA',
        istatCode: '005026030'
    },
    {
        name: 'FRESAGRANDINARIA',
        istatCode: '013069036'
    },
    {
        name: 'FRESONARA',
        istatCode: '001006074'
    },
    {
        name: 'FRIGENTO',
        istatCode: '015064035'
    },
    {
        name: 'FRIGNANO',
        istatCode: '015061037'
    },
    {
        name: 'FRIGNANO MAGGIORE',
        istatCode: '015061512'
    },
    {
        name: 'FRINCO',
        istatCode: '001005055'
    },
    {
        name: 'FRISA',
        istatCode: '013069037'
    },
    {
        name: 'FRISANCO',
        istatCode: '006093024'
    },
    {
        name: 'FRONT',
        istatCode: '001001109'
    },
    {
        name: 'FRONTINO',
        istatCode: '011041017'
    },
    {
        name: 'FRONTONE',
        istatCode: '011041018'
    },
    {
        name: 'FRONTONE-SERRA',
        istatCode: '011000000'
    },
    {
        name: 'FROSINONE',
        istatCode: '012060038'
    },
    {
        name: 'FROSOLONE',
        istatCode: '014094022'
    },
    {
        name: 'FROSSASCO',
        istatCode: '001001110'
    },
    {
        name: 'FRUGAROLO',
        istatCode: '001006075'
    },
    {
        name: 'FUBINE',
        istatCode: '001006076'
    },
    {
        name: 'FUCECCHIO',
        istatCode: '009048019'
    },
    {
        name: 'FUIPIANO VALLE IMAGNA',
        istatCode: '003016106'
    },
    {
        name: 'FUMANE',
        istatCode: '005023035'
    },
    {
        name: 'FUMONE',
        istatCode: '012060039'
    },
    {
        name: 'FUNES - VILLNOESS',
        istatCode: '004021033'
    },
    {
        name: 'FURCI',
        istatCode: '013069038'
    },
    {
        name: 'FURCI SICULO',
        istatCode: '019083027'
    },
    {
        name: 'FURNARI',
        istatCode: '019083028'
    },
    {
        name: 'FURORE',
        istatCode: '015065053'
    },
    {
        name: 'FURTEI',
        istatCode: '020111022'
    },
    {
        name: 'FUSCALDO',
        istatCode: '018078058'
    },
    {
        name: 'FUSIGNANO',
        istatCode: '008039011'
    },
    {
        name: 'FUSINE',
        istatCode: '003014030'
    },
    {
        name: 'FUTANI',
        istatCode: '015065054'
    },
    {
        name: 'GABBIONETA-BINANUOVA',
        istatCode: '003019045'
    },
    {
        name: 'GABIANO',
        istatCode: '001006077'
    },
    {
        name: 'GABICCE MARE',
        istatCode: '011041019'
    },
    {
        name: 'GABY',
        istatCode: '002007029'
    },
    {
        name: 'GADESCO-PIEVE DELMONA',
        istatCode: '003019046'
    },
    {
        name: 'GADONI',
        istatCode: '020091025'
    },
    {
        name: 'GAETA',
        istatCode: '012059009'
    },
    {
        name: 'GAGGI',
        istatCode: '019083029'
    },
    {
        name: 'GAGGIANO',
        istatCode: '003015103'
    },
    {
        name: 'GAGGIO MONTANO',
        istatCode: '008037027'
    },
    {
        name: 'GAGLIANICO',
        istatCode: '001096026'
    },
    {
        name: 'GAGLIANO ATERNO',
        istatCode: '013066045'
    },
    {
        name: 'GAGLIANO CASTELFERRATO',
        istatCode: '019086010'
    },
    {
        name: 'GAGLIANO DEL CAPO',
        istatCode: '016075028'
    },
    {
        name: 'GAGLIATO',
        istatCode: '018079055'
    },
    {
        name: 'GAGLIOLE',
        istatCode: '011043020'
    },
    {
        name: 'GAIARINE',
        istatCode: '005026031'
    },
    {
        name: 'GAIBA',
        istatCode: '005029025'
    },
    {
        name: 'GAIOLA',
        istatCode: '001004093'
    },
    {
        name: 'GAIOLA MOIOLA',
        istatCode: '001004807'
    },
    {
        name: 'GAIOLE IN CHIANTI',
        istatCode: '009052013'
    },
    {
        name: 'GAIRO',
        istatCode: '020091026'
    },
    {
        name: 'GAIS - GAIS',
        istatCode: '004021034'
    },
    {
        name: 'GALATI MAMERTINO',
        istatCode: '019083030'
    },
    {
        name: 'GALATINA',
        istatCode: '016075029'
    },
    {
        name: 'GALATONE',
        istatCode: '016075030'
    },
    {
        name: 'GALATRO',
        istatCode: '018080035'
    },
    {
        name: 'GALBIATE',
        istatCode: '003097036'
    },
    {
        name: 'GALEATA',
        istatCode: '008040014'
    },
    {
        name: 'GALGAGNANO',
        istatCode: '003098027'
    },
    {
        name: 'GALLARATE',
        istatCode: '003012070'
    },
    {
        name: 'GALLESE',
        istatCode: '012056027'
    },
    {
        name: 'GALLIATE',
        istatCode: '001003068'
    },
    {
        name: 'GALLIATE LOMBARDO',
        istatCode: '003012071'
    },
    {
        name: 'GALLIAVOLA',
        istatCode: '003018066'
    },
    {
        name: 'GALLICANO',
        istatCode: '009046015'
    },
    {
        name: 'GALLICANO NEL LAZIO',
        istatCode: '012058040'
    },
    {
        name: 'GALLICCHIO',
        istatCode: '017076035'
    },
    {
        name: 'GALLICO',
        istatCode: '018080805'
    },
    {
        name: 'GALLIERA',
        istatCode: '008037028'
    },
    {
        name: 'GALLIERA VENETA',
        istatCode: '005028039'
    },
    {
        name: 'GALLINARO',
        istatCode: '012060040'
    },
    {
        name: 'GALLIO',
        istatCode: '005024042'
    },
    {
        name: 'GALLIPOLI',
        istatCode: '016075031'
    },
    {
        name: 'GALLO MATESE',
        istatCode: '015061038'
    },
    {
        name: 'GALLODORO',
        istatCode: '019083031'
    },
    {
        name: 'GALLUCCIO',
        istatCode: '015061039'
    },
    {
        name: 'GALTELLI',
        istatCode: '020091027'
    },
    {
        name: 'GALZIGNANO TERME',
        istatCode: '005028040'
    },
    {
        name: 'GAMALERO',
        istatCode: '001006078'
    },
    {
        name: 'GAMBARA',
        istatCode: '003017073'
    },
    {
        name: 'GAMBARANA',
        istatCode: '003018067'
    },
    {
        name: 'GAMBASCA',
        istatCode: '001004094'
    },
    {
        name: 'GAMBASSI TERME',
        istatCode: '009048020'
    },
    {
        name: 'GAMBATESA',
        istatCode: '014070025'
    },
    {
        name: 'GAMBELLARA',
        istatCode: '005024043'
    },
    {
        name: 'GAMBERALE',
        istatCode: '013069039'
    },
    {
        name: 'GAMBETTOLA',
        istatCode: '008040015'
    },
    {
        name: 'GAMBOLO\'',
        istatCode: '003018068'
    },
    {
        name: 'GAMBUGLIANO',
        istatCode: '005024044'
    },
    {
        name: 'GANDELLINO',
        istatCode: '003016107'
    },
    {
        name: 'GANDINO',
        istatCode: '003016108'
    },
    {
        name: 'GANDOSSO',
        istatCode: '003016109'
    },
    {
        name: 'GANGI',
        istatCode: '019082036'
    },
    {
        name: 'GARAGUSO',
        istatCode: '017077009'
    },
    {
        name: 'GARBAGNA',
        istatCode: '001006079'
    },
    {
        name: 'GARBAGNA NOVARESE',
        istatCode: '001003069'
    },
    {
        name: 'GARBAGNATE MILANESE',
        istatCode: '003015105'
    },
    {
        name: 'GARBAGNATE MONASTERO',
        istatCode: '003097037'
    },
    {
        name: 'GARDA',
        istatCode: '005023036'
    },
    {
        name: 'Gardolo',
        istatCode: '004022844'
    },
    {
        name: 'GARDONE RIVIERA',
        istatCode: '003017074'
    },
    {
        name: 'GARDONE VAL TROMPIA',
        istatCode: '003017075'
    },
    {
        name: 'GARESSIO',
        istatCode: '001004095'
    },
    {
        name: 'GARGALLO',
        istatCode: '001003070'
    },
    {
        name: 'GARGAZZONE - GARGAZON',
        istatCode: '004021035'
    },
    {
        name: 'GARGNANO',
        istatCode: '003017076'
    },
    {
        name: 'GARLASCO',
        istatCode: '003018069'
    },
    {
        name: 'GARLATE',
        istatCode: '003097038'
    },
    {
        name: 'GARLENDA',
        istatCode: '007009030'
    },
    {
        name: 'GARNIGA TERME',
        istatCode: '004022091'
    },
    {
        name: 'GARZENO',
        istatCode: '003013106'
    },
    {
        name: 'GARZIGLIANA',
        istatCode: '001001111'
    },
    {
        name: 'GASPERINA',
        istatCode: '018079056'
    },
    {
        name: 'GASSINO TORINESE',
        istatCode: '001001112'
    },
    {
        name: 'GATTATICO',
        istatCode: '008035022'
    },
    {
        name: 'GATTEO',
        istatCode: '008040016'
    },
    {
        name: 'GATTICO',
        istatCode: '001003071'
    },
    {
        name: 'GATTICO-VERUNO',
        istatCode: '001003166'
    },
    {
        name: 'GATTINARA',
        istatCode: '001002061'
    },
    {
        name: 'GAVARDO',
        istatCode: '003017077'
    },
    {
        name: 'GAVAZZANA',
        istatCode: '001006080'
    },
    {
        name: 'GAVELLO',
        istatCode: '005029026'
    },
    {
        name: 'GAVERINA TERME',
        istatCode: '003016110'
    },
    {
        name: 'GAVI',
        istatCode: '001006081'
    },
    {
        name: 'GAVIGNANO',
        istatCode: '012058041'
    },
    {
        name: 'GAVIRATE',
        istatCode: '003012072'
    },
    {
        name: 'GAVOI',
        istatCode: '020091028'
    },
    {
        name: 'GAVORRANO',
        istatCode: '009053010'
    },
    {
        name: 'GAZOLDO DEGLI IPPOLITI',
        istatCode: '003020024'
    },
    {
        name: 'GAZZADA SCHIANNO',
        istatCode: '003012073'
    },
    {
        name: 'GAZZANIGA',
        istatCode: '003016111'
    },
    {
        name: 'GAZZO',
        istatCode: '005028041'
    },
    {
        name: 'GAZZO VERONESE',
        istatCode: '005023037'
    },
    {
        name: 'GAZZOLA',
        istatCode: '008033022'
    },
    {
        name: 'GAZZUOLO',
        istatCode: '003020025'
    },
    {
        name: 'GELA',
        istatCode: '019085007'
    },
    {
        name: 'GEMMANO',
        istatCode: '008099004'
    },
    {
        name: 'GEMONA DEL FRIULI',
        istatCode: '006030043'
    },
    {
        name: 'GEMONIO',
        istatCode: '003012074'
    },
    {
        name: 'GENAZZANO',
        istatCode: '012058042'
    },
    {
        name: 'GENGA',
        istatCode: '011042020'
    },
    {
        name: 'GENIVOLTA',
        istatCode: '003019047'
    },
    {
        name: 'GENOLA',
        istatCode: '001004096'
    },
    {
        name: 'GENONI',
        istatCode: '020111023'
    },
    {
        name: 'GENOVA',
        istatCode: '007010025'
    },
    {
        name: 'GENURI',
        istatCode: '020111024'
    },
    {
        name: 'GENZANO DI LUCANIA',
        istatCode: '017076036'
    },
    {
        name: 'GENZANO DI ROMA',
        istatCode: '012058043'
    },
    {
        name: 'GENZONE',
        istatCode: '003018070'
    },
    {
        name: 'GERA LARIO',
        istatCode: '003013107'
    },
    {
        name: 'GERACE',
        istatCode: '018080036'
    },
    {
        name: 'GERACI SICULO',
        istatCode: '019082037'
    },
    {
        name: 'GERANO',
        istatCode: '012058044'
    },
    {
        name: 'GERENZAGO',
        istatCode: '003018071'
    },
    {
        name: 'GERENZANO',
        istatCode: '003012075'
    },
    {
        name: 'GERGEI',
        istatCode: '020111025'
    },
    {
        name: 'GERMAGNANO',
        istatCode: '001001113'
    },
    {
        name: 'GERMAGNO',
        istatCode: '001103032'
    },
    {
        name: 'GERMASINO',
        istatCode: '003013108'
    },
    {
        name: 'GERMIGNAGA',
        istatCode: '003012076'
    },
    {
        name: 'GEROCARNE',
        istatCode: '018102016'
    },
    {
        name: 'GEROLA ALTA',
        istatCode: '003014031'
    },
    {
        name: 'GEROSA',
        istatCode: '003016112'
    },
    {
        name: 'GERRE DE\' CAPRIOLI',
        istatCode: '003019048'
    },
    {
        name: 'GESICO',
        istatCode: '020111026'
    },
    {
        name: 'GESSATE',
        istatCode: '003015106'
    },
    {
        name: 'GESSOPALENA',
        istatCode: '013069040'
    },
    {
        name: 'GESTURI',
        istatCode: '020111027'
    },
    {
        name: 'GESUALDO',
        istatCode: '015064036'
    },
    {
        name: 'GHEDI',
        istatCode: '003017078'
    },
    {
        name: 'GHEMME',
        istatCode: '001003073'
    },
    {
        name: 'GHIFFA',
        istatCode: '001103033'
    },
    {
        name: 'GHILARZA',
        istatCode: '020095021'
    },
    {
        name: 'GHISALBA',
        istatCode: '003016113'
    },
    {
        name: 'GHISLARENGO',
        istatCode: '001002062'
    },
    {
        name: 'GIACCIANO CON BARUCHELLA',
        istatCode: '005029027'
    },
    {
        name: 'GIAGLIONE',
        istatCode: '001001114'
    },
    {
        name: 'GIANICO',
        istatCode: '003017079'
    },
    {
        name: 'GIANO DELL\'UMBRIA',
        istatCode: '010054021'
    },
    {
        name: 'GIANO VETUSTO',
        istatCode: '015061040'
    },
    {
        name: 'GIARDINELLO',
        istatCode: '019082038'
    },
    {
        name: 'GIARDINI-NAXOS',
        istatCode: '019083032'
    },
    {
        name: 'GIAROLE',
        istatCode: '001006082'
    },
    {
        name: 'GIARRATANA',
        istatCode: '019088004'
    },
    {
        name: 'GIARRE',
        istatCode: '019087017'
    },
    {
        name: 'GIAVE',
        istatCode: '020090030'
    },
    {
        name: 'GIAVENO',
        istatCode: '001001115'
    },
    {
        name: 'GIAVERA DEL MONTELLO',
        istatCode: '005026032'
    },
    {
        name: 'GIBA',
        istatCode: '020111028'
    },
    {
        name: 'GIBELLINA',
        istatCode: '019081010'
    },
    {
        name: 'GIFFLENGA',
        istatCode: '001096027'
    },
    {
        name: 'GIFFONE',
        istatCode: '018080037'
    },
    {
        name: 'GIFFONI SEI CASALI',
        istatCode: '015065055'
    },
    {
        name: 'GIFFONI VALLE PIANA',
        istatCode: '015065056'
    },
    {
        name: 'GIGNESE',
        istatCode: '001103034'
    },
    {
        name: 'GIGNOD',
        istatCode: '002007030'
    },
    {
        name: 'GILDONE',
        istatCode: '014070026'
    },
    {
        name: 'GIMIGLIANO',
        istatCode: '018079058'
    },
    {
        name: 'GINESTRA',
        istatCode: '017076099'
    },
    {
        name: 'GINESTRA DEGLI SCHIAVONI',
        istatCode: '015062036'
    },
    {
        name: 'GINOSA',
        istatCode: '016073007'
    },
    {
        name: 'GIOI',
        istatCode: '015065057'
    },
    {
        name: 'GIOIA DEI MARSI',
        istatCode: '013066046'
    },
    {
        name: 'GIOIA DEL COLLE',
        istatCode: '016072021'
    },
    {
        name: 'GIOIA SANNITICA',
        istatCode: '015061041'
    },
    {
        name: 'GIOIA TAURO',
        istatCode: '018080038'
    },
    {
        name: 'GIOIOSA IONICA',
        istatCode: '018080039'
    },
    {
        name: 'GIOIOSA MAREA',
        istatCode: '019083033'
    },
    {
        name: 'GIOVE',
        istatCode: '010055014'
    },
    {
        name: 'GIOVINAZZO',
        istatCode: '016072022'
    },
    {
        name: 'GIOVO',
        istatCode: '004022092'
    },
    {
        name: 'GIRASOLE',
        istatCode: '020091031'
    },
    {
        name: 'GIRIFALCO',
        istatCode: '018079059'
    },
    {
        name: 'GIRONICO',
        istatCode: '003013109'
    },
    {
        name: 'GISSI',
        istatCode: '013069041'
    },
    {
        name: 'GIUGGIANELLO',
        istatCode: '016075032'
    },
    {
        name: 'GIUGLIANO IN CAMPANIA',
        istatCode: '015063034'
    },
    {
        name: 'GIULIANA',
        istatCode: '019082039'
    },
    {
        name: 'GIULIANO DI ROMA',
        istatCode: '012060041'
    },
    {
        name: 'GIULIANO TEATINO',
        istatCode: '013069042'
    },
    {
        name: 'GIULIANOVA',
        istatCode: '013067025'
    },
    {
        name: 'GIUNCUGNANO',
        istatCode: '009046016'
    },
    {
        name: 'GIUNGANO',
        istatCode: '015065058'
    },
    {
        name: 'GIURDIGNANO',
        istatCode: '016075033'
    },
    {
        name: 'GIUSSAGO',
        istatCode: '003018072'
    },
    {
        name: 'GIUSSANO',
        istatCode: '003108024'
    },
    {
        name: 'GIUSTENICE',
        istatCode: '007009031'
    },
    {
        name: 'GIUSTINO',
        istatCode: '004022093'
    },
    {
        name: 'GIUSVALLA',
        istatCode: '007009032'
    },
    {
        name: 'GIVOLETTO',
        istatCode: '001001116'
    },
    {
        name: 'GIZZERIA',
        istatCode: '018079060'
    },
    {
        name: 'GLORENZA - GLURNS',
        istatCode: '004021036'
    },
    {
        name: 'GODEGA DI SANT\'URBANO',
        istatCode: '005026033'
    },
    {
        name: 'GODIASCO',
        istatCode: '003018073'
    },
    {
        name: 'GODRANO',
        istatCode: '019082040'
    },
    {
        name: 'GOITO',
        istatCode: '003020026'
    },
    {
        name: 'GOLASECCA',
        istatCode: '003012077'
    },
    {
        name: 'GOLESE',
        istatCode: '008034803'
    },
    {
        name: 'GOLFERENZO',
        istatCode: '003018074'
    },
    {
        name: 'GOLFO ARANCI',
        istatCode: '020090083'
    },
    {
        name: 'GOMBITO',
        istatCode: '003019049'
    },
    {
        name: 'GONARS',
        istatCode: '006030044'
    },
    {
        name: 'GONI',
        istatCode: '020111029'
    },
    {
        name: 'GONNESA',
        istatCode: '020111030'
    },
    {
        name: 'GONNOSCODINA',
        istatCode: '020095022'
    },
    {
        name: 'GONNOSFANADIGA',
        istatCode: '020111031'
    },
    {
        name: 'GONNOSNO\'',
        istatCode: '020095023'
    },
    {
        name: 'GONNOSTRAMATZA',
        istatCode: '020095024'
    },
    {
        name: 'GONZAGA',
        istatCode: '003020027'
    },
    {
        name: 'GORDONA',
        istatCode: '003014032'
    },
    {
        name: 'GORGA',
        istatCode: '012058045'
    },
    {
        name: 'GORGO AL MONTICANO',
        istatCode: '005026034'
    },
    {
        name: 'GORGOGLIONE',
        istatCode: '017077010'
    },
    {
        name: 'GORGONZOLA',
        istatCode: '003015108'
    },
    {
        name: 'GORIANO SICOLI',
        istatCode: '013066047'
    },
    {
        name: 'GORIZIA',
        istatCode: '006031007'
    },
    {
        name: 'GORLA MAGGIORE',
        istatCode: '003012078'
    },
    {
        name: 'GORLA MINORE',
        istatCode: '003012079'
    },
    {
        name: 'GORLAGO',
        istatCode: '003016114'
    },
    {
        name: 'GORLE',
        istatCode: '003016115'
    },
    {
        name: 'GORNATE OLONA',
        istatCode: '003012080'
    },
    {
        name: 'GORNO',
        istatCode: '003016116'
    },
    {
        name: 'GORO',
        istatCode: '008038025'
    },
    {
        name: 'GORRETO',
        istatCode: '007010026'
    },
    {
        name: 'GORZEGNO',
        istatCode: '001004097'
    },
    {
        name: 'GOSALDO',
        istatCode: '005025025'
    },
    {
        name: 'GOSSOLENGO',
        istatCode: '008033023'
    },
    {
        name: 'GOTTASECCA',
        istatCode: '001004098'
    },
    {
        name: 'GOTTOLENGO',
        istatCode: '003017080'
    },
    {
        name: 'GOVONE',
        istatCode: '001004099'
    },
    {
        name: 'GOZZANO',
        istatCode: '001003076'
    },
    {
        name: 'GRADARA',
        istatCode: '011041020'
    },
    {
        name: 'GRADISCA D\'ISONZO',
        istatCode: '006031008'
    },
    {
        name: 'GRADO',
        istatCode: '006031009'
    },
    {
        name: 'GRADOLI',
        istatCode: '012056028'
    },
    {
        name: 'GRAFFIGNANA',
        istatCode: '003098028'
    },
    {
        name: 'GRAFFIGNANO',
        istatCode: '012056029'
    },
    {
        name: 'GRAGLIA',
        istatCode: '001096028'
    },
    {
        name: 'GRAGNANO',
        istatCode: '015063035'
    },
    {
        name: 'GRAGNANO TREBBIENSE',
        istatCode: '008033024'
    },
    {
        name: 'GRAMMICHELE',
        istatCode: '019087018'
    },
    {
        name: 'GRANA',
        istatCode: '001005056'
    },
    {
        name: 'GRANAGLIONE',
        istatCode: '008037029'
    },
    {
        name: 'GRANAROLO DELL\'EMILIA',
        istatCode: '008037030'
    },
    {
        name: 'GRANCONA',
        istatCode: '005024045'
    },
    {
        name: 'GRANDATE',
        istatCode: '003013110'
    },
    {
        name: 'GRANDOLA ED UNITI',
        istatCode: '003013111'
    },
    {
        name: 'GRANITI',
        istatCode: '019083034'
    },
    {
        name: 'GRANOZZO CON MONTICELLO',
        istatCode: '001003077'
    },
    {
        name: 'GRANTOLA',
        istatCode: '003012081'
    },
    {
        name: 'GRANTORTO',
        istatCode: '005028042'
    },
    {
        name: 'GRANZE',
        istatCode: '005028043'
    },
    {
        name: 'GRASSANO',
        istatCode: '017077011'
    },
    {
        name: 'GRASSOBBIO',
        istatCode: '003016117'
    },
    {
        name: 'GRATTERI',
        istatCode: '019082041'
    },
    {
        name: 'GRAUNO',
        istatCode: '004022094'
    },
    {
        name: 'GRAVEDONA',
        istatCode: '003013112'
    },
    {
        name: 'GRAVEDONA ED UNITI',
        istatCode: '003013249'
    },
    {
        name: 'GRAVELLONA LOMELLINA',
        istatCode: '003018075'
    },
    {
        name: 'GRAVELLONA TOCE',
        istatCode: '001103035'
    },
    {
        name: 'GRAVERE',
        istatCode: '001001117'
    },
    {
        name: 'GRAVINA DI CATANIA',
        istatCode: '019087019'
    },
    {
        name: 'GRAVINA IN PUGLIA',
        istatCode: '016072023'
    },
    {
        name: 'GRAZZANISE',
        istatCode: '015061042'
    },
    {
        name: 'GRAZZANO BADOGLIO',
        istatCode: '001005057'
    },
    {
        name: 'GRECCIO',
        istatCode: '012057031'
    },
    {
        name: 'GRECI',
        istatCode: '015064037'
    },
    {
        name: 'GREGGIO',
        istatCode: '001002065'
    },
    {
        name: 'GREMIASCO',
        istatCode: '001006083'
    },
    {
        name: 'GRESSAN',
        istatCode: '002007031'
    },
    {
        name: 'GRESSONEY-LA-TRINITE\'',
        istatCode: '002007032'
    },
    {
        name: 'GRESSONEY-SAINT-JEAN',
        istatCode: '002007033'
    },
    {
        name: 'GREVE IN CHIANTI',
        istatCode: '009048021'
    },
    {
        name: 'GREZZAGO',
        istatCode: '003015110'
    },
    {
        name: 'GREZZANA',
        istatCode: '005023038'
    },
    {
        name: 'GRIANTE',
        istatCode: '003013113'
    },
    {
        name: 'GRICIGNANO DI AVERSA',
        istatCode: '015061043'
    },
    {
        name: 'GRIGNASCO',
        istatCode: '001003079'
    },
    {
        name: 'GRIGNO',
        istatCode: '004022095'
    },
    {
        name: 'GRIMACCO',
        istatCode: '006030045'
    },
    {
        name: 'GRIMALDI',
        istatCode: '018078059'
    },
    {
        name: 'GRINZANE CAVOUR',
        istatCode: '001004100'
    },
    {
        name: 'GRISIGNANO DI ZOCCO',
        istatCode: '005024046'
    },
    {
        name: 'GRISOLIA',
        istatCode: '018078060'
    },
    {
        name: 'GRIZZANA MORANDI',
        istatCode: '008037031'
    },
    {
        name: 'GROGNARDO',
        istatCode: '001006084'
    },
    {
        name: 'GROMO',
        istatCode: '003016118'
    },
    {
        name: 'GRONDONA',
        istatCode: '001006085'
    },
    {
        name: 'GRONE',
        istatCode: '003016119'
    },
    {
        name: 'GRONTARDO',
        istatCode: '003019050'
    },
    {
        name: 'GROPELLO CAIROLI',
        istatCode: '003018076'
    },
    {
        name: 'GROPPARELLO',
        istatCode: '008033025'
    },
    {
        name: 'GROSCAVALLO',
        istatCode: '001001118'
    },
    {
        name: 'GROSIO',
        istatCode: '003014033'
    },
    {
        name: 'GROSOTTO',
        istatCode: '003014034'
    },
    {
        name: 'GROSSETO',
        istatCode: '009053011'
    },
    {
        name: 'GROSSO',
        istatCode: '001001119'
    },
    {
        name: 'GROTTAFERRATA',
        istatCode: '012058046'
    },
    {
        name: 'GROTTAGLIE',
        istatCode: '016073008'
    },
    {
        name: 'GROTTAMINARDA',
        istatCode: '015064038'
    },
    {
        name: 'GROTTAMMARE',
        istatCode: '011044023'
    },
    {
        name: 'GROTTAZZOLINA',
        istatCode: '011109008'
    },
    {
        name: 'GROTTE',
        istatCode: '019084018'
    },
    {
        name: 'GROTTE DI CASTRO',
        istatCode: '012056030'
    },
    {
        name: 'GROTTERIA',
        istatCode: '018080040'
    },
    {
        name: 'GROTTOLE',
        istatCode: '017077012'
    },
    {
        name: 'GROTTOLELLA',
        istatCode: '015064039'
    },
    {
        name: 'GRUARO',
        istatCode: '005027018'
    },
    {
        name: 'GRUGLIASCO',
        istatCode: '001001120'
    },
    {
        name: 'GRUMELLO CREMONESE ED UNITI',
        istatCode: '003019051'
    },
    {
        name: 'GRUMELLO DEL MONTE',
        istatCode: '003016120'
    },
    {
        name: 'GRUMENTO NOVA',
        istatCode: '017076037'
    },
    {
        name: 'GRUMES',
        istatCode: '004022096'
    },
    {
        name: 'GRUMO APPULA',
        istatCode: '016072024'
    },
    {
        name: 'GRUMO NEVANO',
        istatCode: '015063036'
    },
    {
        name: 'GRUMOLO DELLE ABBADESSE',
        istatCode: '005024047'
    },
    {
        name: 'GUAGNANO',
        istatCode: '016075034'
    },
    {
        name: 'GUALDO',
        istatCode: '011043021'
    },
    {
        name: 'GUALDO CATTANEO',
        istatCode: '010054022'
    },
    {
        name: 'GUALDO TADINO',
        istatCode: '010054023'
    },
    {
        name: 'GUALTIERI',
        istatCode: '008035023'
    },
    {
        name: 'GUALTIERI SICAMINO\'',
        istatCode: '019083035'
    },
    {
        name: 'GUAMAGGIORE',
        istatCode: '020111032'
    },
    {
        name: 'GUANZATE',
        istatCode: '003013114'
    },
    {
        name: 'GUARCINO',
        istatCode: '012060042'
    },
    {
        name: 'GUARDA VENETA',
        istatCode: '005029028'
    },
    {
        name: 'GUARDABOSONE',
        istatCode: '001002066'
    },
    {
        name: 'GUARDAMIGLIO',
        istatCode: '003098029'
    },
    {
        name: 'GUARDAVALLE',
        istatCode: '018079061'
    },
    {
        name: 'GUARDEA',
        istatCode: '010055015'
    },
    {
        name: 'GUARDIA LOMBARDI',
        istatCode: '015064040'
    },
    {
        name: 'GUARDIA PERTICARA',
        istatCode: '017076038'
    },
    {
        name: 'GUARDIA PIEMONTESE',
        istatCode: '018078061'
    },
    {
        name: 'GUARDIA SANFRAMONDI',
        istatCode: '015062037'
    },
    {
        name: 'GUARDIAGRELE',
        istatCode: '013069043'
    },
    {
        name: 'GUARDIALFIERA',
        istatCode: '014070027'
    },
    {
        name: 'GUARDIAREGIA',
        istatCode: '014070028'
    },
    {
        name: 'GUARDISTALLO',
        istatCode: '009050015'
    },
    {
        name: 'GUARENE',
        istatCode: '001004101'
    },
    {
        name: 'GUASILA',
        istatCode: '020111033'
    },
    {
        name: 'GUASTALLA',
        istatCode: '008035024'
    },
    {
        name: 'GUAZZORA',
        istatCode: '001006086'
    },
    {
        name: 'GUBBIO',
        istatCode: '010054024'
    },
    {
        name: 'GUDO VISCONTI',
        istatCode: '003015112'
    },
    {
        name: 'GUGLIONESI',
        istatCode: '014070029'
    },
    {
        name: 'GUIDIZZOLO',
        istatCode: '003020028'
    },
    {
        name: 'GUIDONIA MONTECELIO',
        istatCode: '012058047'
    },
    {
        name: 'GUIGLIA',
        istatCode: '008036017'
    },
    {
        name: 'GUILMI',
        istatCode: '013069044'
    },
    {
        name: 'GURONE(fino al 18/01/1928)',
        istatCode: '003012853'
    },
    {
        name: 'GURRO',
        istatCode: '001103036'
    },
    {
        name: 'GUSPINI',
        istatCode: '020111034'
    },
    {
        name: 'GUSSAGO',
        istatCode: '003017081'
    },
    {
        name: 'GUSSOLA',
        istatCode: '003019052'
    },
    {
        name: 'HONE',
        istatCode: '002007034'
    },
    {
        name: 'IDRO',
        istatCode: '003017082'
    },
    {
        name: 'IGLESIAS',
        istatCode: '020111035'
    },
    {
        name: 'IGLIANO',
        istatCode: '001004102'
    },
    {
        name: 'ILBONO',
        istatCode: '020091032'
    },
    {
        name: 'ILLASI',
        istatCode: '005023039'
    },
    {
        name: 'ILLORAI',
        istatCode: '020090031'
    },
    {
        name: 'IMBERSAGO',
        istatCode: '003097039'
    },
    {
        name: 'IMER',
        istatCode: '004022097'
    },
    {
        name: 'IMOLA',
        istatCode: '008037032'
    },
    {
        name: 'IMPERIA',
        istatCode: '007008031'
    },
    {
        name: 'IMPRUNETA',
        istatCode: '009048022'
    },
    {
        name: 'INARZO',
        istatCode: '003012082'
    },
    {
        name: 'INCISA IN VAL D\'ARNO',
        istatCode: '009048023'
    },
    {
        name: 'INCISA SCAPACCINO',
        istatCode: '001005058'
    },
    {
        name: 'INCUDINE',
        istatCode: '003017083'
    },
    {
        name: 'INDUNO OLONA',
        istatCode: '003012083'
    },
    {
        name: 'INGRIA',
        istatCode: '001001121'
    },
    {
        name: 'INTIMIANO',
        istatCode: '003013886'
    },
    {
        name: 'Intra',
        istatCode: '001003859'
    },
    {
        name: 'INTRAGNA',
        istatCode: '001103037'
    },
    {
        name: 'INTROBIO',
        istatCode: '003097040'
    },
    {
        name: 'INTROD',
        istatCode: '002007035'
    },
    {
        name: 'INTRODACQUA',
        istatCode: '013066048'
    },
    {
        name: 'INTROZZO',
        istatCode: '003097041'
    },
    {
        name: 'INVERIGO',
        istatCode: '003013118'
    },
    {
        name: 'INVERNO E MONTELEONE',
        istatCode: '003018077'
    },
    {
        name: 'INVERSO PINASCA',
        istatCode: '001001122'
    },
    {
        name: 'INVERUNO',
        istatCode: '003015113'
    },
    {
        name: 'INVORIO',
        istatCode: '001003082'
    },
    {
        name: 'INZAGO',
        istatCode: '003015114'
    },
    {
        name: 'IONIA',
        istatCode: '019087801'
    },
    {
        name: 'IRGOLI',
        istatCode: '020091033'
    },
    {
        name: 'IRMA',
        istatCode: '003017084'
    },
    {
        name: 'IRSINA',
        istatCode: '017077013'
    },
    {
        name: 'ISASCA',
        istatCode: '001004103'
    },
    {
        name: 'ISCA SULLO IONIO',
        istatCode: '018079063'
    },
    {
        name: 'ISCHIA',
        istatCode: '015063037'
    },
    {
        name: 'ISCHIA DI CASTRO',
        istatCode: '012056031'
    },
    {
        name: 'ISCHITELLA',
        istatCode: '016071025'
    },
    {
        name: 'ISEO',
        istatCode: '003017085'
    },
    {
        name: 'ISERA',
        istatCode: '004022098'
    },
    {
        name: 'ISERNIA',
        istatCode: '014094023'
    },
    {
        name: 'ISILI',
        istatCode: '020111036'
    },
    {
        name: 'ISNELLO',
        istatCode: '019082042'
    },
    {
        name: 'ISOLA COMACINA',
        istatCode: '003013887'
    },
    {
        name: 'ISOLA D\'ASTI',
        istatCode: '001005059'
    },
    {
        name: 'ISOLA DEL CANTONE',
        istatCode: '007010027'
    },
    {
        name: 'ISOLA DEL GIGLIO',
        istatCode: '009053012'
    },
    {
        name: 'ISOLA DEL GRAN SASSO D\'ITALIA',
        istatCode: '013067026'
    },
    {
        name: 'ISOLA DEL LIRI',
        istatCode: '012060043'
    },
    {
        name: 'ISOLA DEL PIANO',
        istatCode: '011041021'
    },
    {
        name: 'ISOLA DELLA SCALA',
        istatCode: '005023040'
    },
    {
        name: 'ISOLA DELLE FEMMINE',
        istatCode: '019082043'
    },
    {
        name: 'ISOLA DI CAPO RIZZUTO',
        istatCode: '018101013'
    },
    {
        name: 'ISOLA DI FONDRA',
        istatCode: '003016121'
    },
    {
        name: 'ISOLA D\'ISTRIA',
        istatCode: '006702717'
    },
    {
        name: 'ISOLA DOVARESE',
        istatCode: '003019053'
    },
    {
        name: 'ISOLA RIZZA',
        istatCode: '005023041'
    },
    {
        name: 'ISOLA SAN GIULIO',
        istatCode: '001003861'
    },
    {
        name: 'ISOLA SANT\'ANTONIO',
        istatCode: '001006087'
    },
    {
        name: 'ISOLA VICENTINA',
        istatCode: '005024048'
    },
    {
        name: 'ISOLABELLA',
        istatCode: '001001123'
    },
    {
        name: 'ISOLABONA',
        istatCode: '007008032'
    },
    {
        name: 'ISOLE TREMITI',
        istatCode: '016071026'
    },
    {
        name: 'ISORELLA',
        istatCode: '003017086'
    },
    {
        name: 'ISPANI',
        istatCode: '015065059'
    },
    {
        name: 'ISPICA',
        istatCode: '019088005'
    },
    {
        name: 'ISPRA',
        istatCode: '003012084'
    },
    {
        name: 'ISSIGLIO',
        istatCode: '001001124'
    },
    {
        name: 'ISSIME',
        istatCode: '002007036'
    },
    {
        name: 'ISSO',
        istatCode: '003016122'
    },
    {
        name: 'ISSOGNE',
        istatCode: '002007037'
    },
    {
        name: 'ISTRANA',
        istatCode: '005026035'
    },
    {
        name: 'ITALA',
        istatCode: '019083036'
    },
    {
        name: 'ITRI',
        istatCode: '012059010'
    },
    {
        name: 'ITTIREDDU',
        istatCode: '020090032'
    },
    {
        name: 'ITTIRI',
        istatCode: '020090033'
    },
    {
        name: 'IVANO-FRACENA',
        istatCode: '004022099'
    },
    {
        name: 'IVREA',
        istatCode: '001001125'
    },
    {
        name: 'IZANO',
        istatCode: '003019054'
    },
    {
        name: 'JACURSO',
        istatCode: '018079065'
    },
    {
        name: 'JELSI',
        istatCode: '014070030'
    },
    {
        name: 'JENNE',
        istatCode: '012058048'
    },
    {
        name: 'JERAGO CON ORAGO',
        istatCode: '003012085'
    },
    {
        name: 'JERZU',
        istatCode: '020091035'
    },
    {
        name: 'JESI',
        istatCode: '011042021'
    },
    {
        name: 'JESOLO',
        istatCode: '005027019'
    },
    {
        name: 'JOLANDA DI SAVOIA',
        istatCode: '008038010'
    },
    {
        name: 'JONADI',
        istatCode: '018102017'
    },
    {
        name: 'JOPPOLO',
        istatCode: '018102018'
    },
    {
        name: 'JOPPOLO GIANCAXIO',
        istatCode: '019084019'
    },
    {
        name: 'JOVENCAN',
        istatCode: '002007038'
    },
    {
        name: 'LA CASSA',
        istatCode: '001001126'
    },
    {
        name: 'LA LOGGIA',
        istatCode: '001001127'
    },
    {
        name: 'LA MADDALENA',
        istatCode: '020090035'
    },
    {
        name: 'LA MAGDELEINE',
        istatCode: '002007039'
    },
    {
        name: 'LA MORRA',
        istatCode: '001004105'
    },
    {
        name: 'LA SALLE',
        istatCode: '002007040'
    },
    {
        name: 'LA SPEZIA',
        istatCode: '007011015'
    },
    {
        name: 'LA THUILE',
        istatCode: '002007041'
    },
    {
        name: 'LA VALLE - WENGEN',
        istatCode: '004021117'
    },
    {
        name: 'LA VALLE AGORDINA',
        istatCode: '005025027'
    },
    {
        name: 'La Valletta Brianza',
        istatCode: '003097092'
    },
    {
        name: 'LABICO',
        istatCode: '012058049'
    },
    {
        name: 'LABRO',
        istatCode: '012057032'
    },
    {
        name: 'LACCHIARELLA',
        istatCode: '003015115'
    },
    {
        name: 'LACCO AMENO',
        istatCode: '015063038'
    },
    {
        name: 'LACEDONIA',
        istatCode: '015064041'
    },
    {
        name: 'LACES - LATSCH',
        istatCode: '004021037'
    },
    {
        name: 'LACONI',
        istatCode: '020095082'
    },
    {
        name: 'LADISPOLI',
        istatCode: '012058116'
    },
    {
        name: 'LAERRU',
        istatCode: '020090034'
    },
    {
        name: 'LAGANADI',
        istatCode: '018080041'
    },
    {
        name: 'LAGHI',
        istatCode: '005024049'
    },
    {
        name: 'LAGLIO',
        istatCode: '003013119'
    },
    {
        name: 'LAGNASCO',
        istatCode: '001004104'
    },
    {
        name: 'LAGO',
        istatCode: '018078062'
    },
    {
        name: 'LAGONEGRO',
        istatCode: '017076039'
    },
    {
        name: 'LAGOSANTO',
        istatCode: '008038011'
    },
    {
        name: 'LAGUNDO - ALGUND',
        istatCode: '004021038'
    },
    {
        name: 'LAIGUEGLIA',
        istatCode: '007009033'
    },
    {
        name: 'LAINATE',
        istatCode: '003015116'
    },
    {
        name: 'LAINO',
        istatCode: '003013120'
    },
    {
        name: 'LAINO BORGO',
        istatCode: '018078063'
    },
    {
        name: 'LAINO BRUZIO',
        istatCode: '018078803'
    },
    {
        name: 'LAINO CASTELLO',
        istatCode: '018078064'
    },
    {
        name: 'LAION - LAJEN',
        istatCode: '004021039'
    },
    {
        name: 'LAIVES - LEIFERS',
        istatCode: '004021040'
    },
    {
        name: 'LAJATICO',
        istatCode: '009050016'
    },
    {
        name: 'LALLIO',
        istatCode: '003016123'
    },
    {
        name: 'LAMA DEI PELIGNI',
        istatCode: '013069045'
    },
    {
        name: 'LAMA MOCOGNO',
        istatCode: '008036018'
    },
    {
        name: 'LAMBRUGO',
        istatCode: '003013121'
    },
    {
        name: 'LAMEZIA TERME',
        istatCode: '018079160'
    },
    {
        name: 'LAMON',
        istatCode: '005025026'
    },
    {
        name: 'LAMPEDUSA E LINOSA',
        istatCode: '019084020'
    },
    {
        name: 'LAMPORECCHIO',
        istatCode: '009047005'
    },
    {
        name: 'LAMPORO',
        istatCode: '001002067'
    },
    {
        name: 'LANA - LANA',
        istatCode: '004021041'
    },
    {
        name: 'LANCIANO',
        istatCode: '013069046'
    },
    {
        name: 'LANDIONA',
        istatCode: '001003083'
    },
    {
        name: 'LANDRIANO',
        istatCode: '003018078'
    },
    {
        name: 'LANGHIRANO',
        istatCode: '008034018'
    },
    {
        name: 'LANGOSCO',
        istatCode: '003018079'
    },
    {
        name: 'LANUSEI',
        istatCode: '020091037'
    },
    {
        name: 'LANUVIO',
        istatCode: '012058050'
    },
    {
        name: 'LANZADA',
        istatCode: '003014036'
    },
    {
        name: 'LANZO D\'INTELVI',
        istatCode: '003013122'
    },
    {
        name: 'LANZO TORINESE',
        istatCode: '001001128'
    },
    {
        name: 'LAPEDONA',
        istatCode: '011109009'
    },
    {
        name: 'LAPIO',
        istatCode: '015064042'
    },
    {
        name: 'LAPPANO',
        istatCode: '018078065'
    },
    {
        name: 'L\'AQUILA',
        istatCode: '013066049'
    },
    {
        name: 'LARCIANO',
        istatCode: '009047006'
    },
    {
        name: 'LARDARO',
        istatCode: '004022100'
    },
    {
        name: 'LARDIRAGO',
        istatCode: '003018080'
    },
    {
        name: 'LARI',
        istatCode: '009050017'
    },
    {
        name: 'LARIANO',
        istatCode: '012058115'
    },
    {
        name: 'LARINO',
        istatCode: '014070031'
    },
    {
        name: 'LAS PLASSAS',
        istatCode: '020111037'
    },
    {
        name: 'LASA - LAAS',
        istatCode: '004021042'
    },
    {
        name: 'LASCARI',
        istatCode: '019082044'
    },
    {
        name: 'LASINO',
        istatCode: '004022101'
    },
    {
        name: 'LASNIGO',
        istatCode: '003013123'
    },
    {
        name: 'LASTEBASSE',
        istatCode: '005024050'
    },
    {
        name: 'LASTRA A SIGNA',
        istatCode: '009048024'
    },
    {
        name: 'LATERA',
        istatCode: '012056032'
    },
    {
        name: 'LATERINA',
        istatCode: '009051019'
    },
    {
        name: 'LATERINA PERGINE VALDARNO',
        istatCode: '009051042'
    },
    {
        name: 'LATERZA',
        istatCode: '016073009'
    },
    {
        name: 'LATIANO',
        istatCode: '016074009'
    },
    {
        name: 'LATINA',
        istatCode: '012059011'
    },
    {
        name: 'LATISANA',
        istatCode: '006030046'
    },
    {
        name: 'LATRONICO',
        istatCode: '017076040'
    },
    {
        name: 'LATTARICO',
        istatCode: '018078066'
    },
    {
        name: 'LAUCO',
        istatCode: '006030047'
    },
    {
        name: 'LAUREANA CILENTO',
        istatCode: '015065060'
    },
    {
        name: 'LAUREANA DI BORRELLO',
        istatCode: '018080042'
    },
    {
        name: 'LAUREGNO - LAUREIN',
        istatCode: '004021043'
    },
    {
        name: 'LAURENZANA',
        istatCode: '017076041'
    },
    {
        name: 'LAURIA',
        istatCode: '017076042'
    },
    {
        name: 'LAURIANO',
        istatCode: '001001129'
    },
    {
        name: 'LAURINO',
        istatCode: '015065061'
    },
    {
        name: 'LAURITO',
        istatCode: '015065062'
    },
    {
        name: 'LAURO',
        istatCode: '015064043'
    },
    {
        name: 'LAVAGNA',
        istatCode: '007010028'
    },
    {
        name: 'LAVAGNO',
        istatCode: '005023042'
    },
    {
        name: 'LAVARONE',
        istatCode: '004022102'
    },
    {
        name: 'LAVELLO',
        istatCode: '017076043'
    },
    {
        name: 'LAVENA PONTE TRESA',
        istatCode: '003012086'
    },
    {
        name: 'LAVENO',
        istatCode: '003012855'
    },
    {
        name: 'LAVENO-MOMBELLO',
        istatCode: '003012087'
    },
    {
        name: 'LAVENONE',
        istatCode: '003017087'
    },
    {
        name: 'LAVIANO',
        istatCode: '015065063'
    },
    {
        name: 'LAVINIA',
        istatCode: '007008818'
    },
    {
        name: 'LAVIS',
        istatCode: '004022103'
    },
    {
        name: 'LAZISE',
        istatCode: '005023043'
    },
    {
        name: 'LAZZATE',
        istatCode: '003108025'
    },
    {
        name: 'LECCE',
        istatCode: '016075035'
    },
    {
        name: 'LECCE NEI MARSI',
        istatCode: '013066050'
    },
    {
        name: 'LECCO',
        istatCode: '003097042'
    },
    {
        name: 'LEDRO',
        istatCode: '004022229'
    },
    {
        name: 'LEFFE',
        istatCode: '003016124'
    },
    {
        name: 'LEGGIUNO',
        istatCode: '003012088'
    },
    {
        name: 'LEGGIUNO-SANGIANO',
        istatCode: '003012525'
    },
    {
        name: 'LEGNAGO',
        istatCode: '005023044'
    },
    {
        name: 'LEGNANO',
        istatCode: '003015118'
    },
    {
        name: 'LEGNARO',
        istatCode: '005028044'
    },
    {
        name: 'LEI',
        istatCode: '020091038'
    },
    {
        name: 'LEINI\'',
        istatCode: '001001130'
    },
    {
        name: 'LEIVI',
        istatCode: '007010029'
    },
    {
        name: 'LEMIE',
        istatCode: '001001131'
    },
    {
        name: 'LENDINARA',
        istatCode: '005029029'
    },
    {
        name: 'LENI',
        istatCode: '019083037'
    },
    {
        name: 'LENNA',
        istatCode: '003016125'
    },
    {
        name: 'LENNO',
        istatCode: '003013125'
    },
    {
        name: 'LENO',
        istatCode: '003017088'
    },
    {
        name: 'LENOLA',
        istatCode: '012059012'
    },
    {
        name: 'LENTA',
        istatCode: '001002068'
    },
    {
        name: 'LENTATE SUL SEVESO',
        istatCode: '003108054'
    },
    {
        name: 'LENTELLA',
        istatCode: '013069047'
    },
    {
        name: 'LENTIAI',
        istatCode: '005025028'
    },
    {
        name: 'LENTINI',
        istatCode: '019089011'
    },
    {
        name: 'LEONESSA',
        istatCode: '012057033'
    },
    {
        name: 'LEONFORTE',
        istatCode: '019086011'
    },
    {
        name: 'LEPORANO',
        istatCode: '016073010'
    },
    {
        name: 'LEQUILE',
        istatCode: '016075036'
    },
    {
        name: 'LEQUIO BERRIA',
        istatCode: '001004106'
    },
    {
        name: 'LEQUIO TANARO',
        istatCode: '001004107'
    },
    {
        name: 'LERCARA FRIDDI',
        istatCode: '019082045'
    },
    {
        name: 'LERICI',
        istatCode: '007011016'
    },
    {
        name: 'LERMA',
        istatCode: '001006088'
    },
    {
        name: 'LESA',
        istatCode: '001003084'
    },
    {
        name: 'LESA-BELGIRATE',
        istatCode: '001003510'
    },
    {
        name: 'LESEGNO',
        istatCode: '001004108'
    },
    {
        name: 'LESIGNANO DE\' BAGNI',
        istatCode: '008034019'
    },
    {
        name: 'LESINA',
        istatCode: '016071027'
    },
    {
        name: 'LESMO',
        istatCode: '003108026'
    },
    {
        name: 'LESSOLO',
        istatCode: '001001132'
    },
    {
        name: 'LESSONA',
        istatCode: '001096085'
    },
    {
        name: 'LESSONA (E552)',
        istatCode: '001096029'
    },
    {
        name: 'LESTIZZA',
        istatCode: '006030048'
    },
    {
        name: 'LETINO',
        istatCode: '015061044'
    },
    {
        name: 'LETOJANNI',
        istatCode: '019083038'
    },
    {
        name: 'LETTERE',
        istatCode: '015063039'
    },
    {
        name: 'LETTOMANOPPELLO',
        istatCode: '013068020'
    },
    {
        name: 'LETTOPALENA',
        istatCode: '013069048'
    },
    {
        name: 'LEVANTO',
        istatCode: '007011017'
    },
    {
        name: 'LEVATE',
        istatCode: '003016126'
    },
    {
        name: 'LEVERANO',
        istatCode: '016075037'
    },
    {
        name: 'LEVICE',
        istatCode: '001004109'
    },
    {
        name: 'LEVICO TERME',
        istatCode: '004022104'
    },
    {
        name: 'LEVONE',
        istatCode: '001001133'
    },
    {
        name: 'LEZZENO',
        istatCode: '003013126'
    },
    {
        name: 'LIBERI',
        istatCode: '015061045'
    },
    {
        name: 'LIBRIZZI',
        istatCode: '019083039'
    },
    {
        name: 'LICATA',
        istatCode: '019084021'
    },
    {
        name: 'LICCIANA NARDI',
        istatCode: '009045009'
    },
    {
        name: 'LICENZA',
        istatCode: '012058051'
    },
    {
        name: 'LICODIA EUBEA',
        istatCode: '019087020'
    },
    {
        name: 'LIERNA',
        istatCode: '003097043'
    },
    {
        name: 'LIETO COLLE',
        istatCode: '003013891'
    },
    {
        name: 'LIGNANA',
        istatCode: '001002070'
    },
    {
        name: 'LIGNANO SABBIADORO',
        istatCode: '006030049'
    },
    {
        name: 'LIGONCHIO',
        istatCode: '008035025'
    },
    {
        name: 'LIGOSULLO',
        istatCode: '006030050'
    },
    {
        name: 'LILLIANES',
        istatCode: '002007042'
    },
    {
        name: 'LIMANA',
        istatCode: '005025029'
    },
    {
        name: 'LIMATOLA',
        istatCode: '015062038'
    },
    {
        name: 'LIMBADI',
        istatCode: '018102019'
    },
    {
        name: 'LIMBIATE',
        istatCode: '003108027'
    },
    {
        name: 'LIMENA',
        istatCode: '005028045'
    },
    {
        name: 'LIMIDO COMASCO',
        istatCode: '003013128'
    },
    {
        name: 'LIMINA',
        istatCode: '019083040'
    },
    {
        name: 'LIMONE PIEMONTE',
        istatCode: '001004110'
    },
    {
        name: 'LIMONE SUL GARDA',
        istatCode: '003017089'
    },
    {
        name: 'LIMONTA',
        istatCode: '003013892'
    },
    {
        name: 'LIMOSANO',
        istatCode: '014070032'
    },
    {
        name: 'LINAROLO',
        istatCode: '003018081'
    },
    {
        name: 'LINGUAGLOSSA',
        istatCode: '019087021'
    },
    {
        name: 'LIONI',
        istatCode: '015064044'
    },
    {
        name: 'LIPARI',
        istatCode: '019083041'
    },
    {
        name: 'LIPOMO',
        istatCode: '003013129'
    },
    {
        name: 'LIRIO',
        istatCode: '003018082'
    },
    {
        name: 'LISANZA',
        istatCode: '003012856'
    },
    {
        name: 'LISCATE',
        istatCode: '003015122'
    },
    {
        name: 'LISCIA',
        istatCode: '013069049'
    },
    {
        name: 'LISCIANO NICCONE',
        istatCode: '010054025'
    },
    {
        name: 'LISIGNAGO',
        istatCode: '004022105'
    },
    {
        name: 'LISIO',
        istatCode: '001004111'
    },
    {
        name: 'LISSONE',
        istatCode: '003108028'
    },
    {
        name: 'LIVERI',
        istatCode: '015063040'
    },
    {
        name: 'LIVIGNO',
        istatCode: '003014037'
    },
    {
        name: 'LIVINALLONGO DEL COL DI LANA',
        istatCode: '005025030'
    },
    {
        name: 'LIVO (CO)',
        istatCode: '003013130'
    },
    {
        name: 'LIVO (TN)',
        istatCode: '004022106'
    },
    {
        name: 'LIVORNO',
        istatCode: '009049009'
    },
    {
        name: 'LIVORNO FERRARIS',
        istatCode: '001002071'
    },
    {
        name: 'LIVRAGA',
        istatCode: '003098030'
    },
    {
        name: 'LIZZANELLO',
        istatCode: '016075038'
    },
    {
        name: 'LIZZANO',
        istatCode: '016073011'
    },
    {
        name: 'LIZZANO IN BELVEDERE',
        istatCode: '008037033'
    },
    {
        name: 'LOANO',
        istatCode: '007009034'
    },
    {
        name: 'LOAZZOLO',
        istatCode: '001005060'
    },
    {
        name: 'LOCANA',
        istatCode: '001001134'
    },
    {
        name: 'LOCATE DI TRIULZI',
        istatCode: '003015125'
    },
    {
        name: 'LOCATE VARESINO',
        istatCode: '003013131'
    },
    {
        name: 'LOCATELLO',
        istatCode: '003016127'
    },
    {
        name: 'LOCERI',
        istatCode: '020091039'
    },
    {
        name: 'LOCOROTONDO',
        istatCode: '016072025'
    },
    {
        name: 'LOCRI',
        istatCode: '018080043'
    },
    {
        name: 'LOCULI',
        istatCode: '020091040'
    },
    {
        name: 'LODE\'',
        istatCode: '020091041'
    },
    {
        name: 'LODI',
        istatCode: '003098031'
    },
    {
        name: 'LODI VECCHIO',
        istatCode: '003098032'
    },
    {
        name: 'LODINE',
        istatCode: '020091104'
    },
    {
        name: 'LODRINO',
        istatCode: '003017090'
    },
    {
        name: 'LOGRATO',
        istatCode: '003017091'
    },
    {
        name: 'LOIANO',
        istatCode: '008037034'
    },
    {
        name: 'LOIRI PORTO SAN PAOLO',
        istatCode: '020090084'
    },
    {
        name: 'LOMAGNA',
        istatCode: '003097044'
    },
    {
        name: 'LOMASO',
        istatCode: '004022107'
    },
    {
        name: 'LOMAZZO',
        istatCode: '003013133'
    },
    {
        name: 'LOMBARDORE',
        istatCode: '001001135'
    },
    {
        name: 'LOMBRIASCO',
        istatCode: '001001136'
    },
    {
        name: 'LOMELLO',
        istatCode: '003018083'
    },
    {
        name: 'LONA-LASES',
        istatCode: '004022108'
    },
    {
        name: 'LONATE CEPPINO',
        istatCode: '003012089'
    },
    {
        name: 'LONATE POZZOLO',
        istatCode: '003012090'
    },
    {
        name: 'LONATO',
        istatCode: '003017566'
    },
    {
        name: 'LONATO DEL GARDA',
        istatCode: '003017092'
    },
    {
        name: 'LONDA',
        istatCode: '009048025'
    },
    {
        name: 'LONGANO',
        istatCode: '014094024'
    },
    {
        name: 'LONGARE',
        istatCode: '005024051'
    },
    {
        name: 'LONGARONE (E672)',
        istatCode: '005025031'
    },
    {
        name: 'LONGARONE (M342)',
        istatCode: '005025071'
    },
    {
        name: 'LONGHENA',
        istatCode: '003017093'
    },
    {
        name: 'LONGI',
        istatCode: '019083042'
    },
    {
        name: 'LONGIANO',
        istatCode: '008040018'
    },
    {
        name: 'LONGOBARDI',
        istatCode: '018078067'
    },
    {
        name: 'LONGOBUCCO',
        istatCode: '018078068'
    },
    {
        name: 'LONGONE AL SEGRINO',
        istatCode: '003013134'
    },
    {
        name: 'LONGONE SABINO',
        istatCode: '012057034'
    },
    {
        name: 'LONIGO',
        istatCode: '005024052'
    },
    {
        name: 'LORANZE\'',
        istatCode: '001001137'
    },
    {
        name: 'LOREGGIA',
        istatCode: '005028046'
    },
    {
        name: 'LOREGLIA',
        istatCode: '001103038'
    },
    {
        name: 'LORENZAGO DI CADORE',
        istatCode: '005025032'
    },
    {
        name: 'LORENZANA',
        istatCode: '009050018'
    },
    {
        name: 'LOREO',
        istatCode: '005029030'
    },
    {
        name: 'LORETO',
        istatCode: '011042022'
    },
    {
        name: 'LORETO APRUTINO',
        istatCode: '013068021'
    },
    {
        name: 'LORIA',
        istatCode: '005026036'
    },
    {
        name: 'LORO CIUFFENNA',
        istatCode: '009051020'
    },
    {
        name: 'LORO PICENO',
        istatCode: '011043022'
    },
    {
        name: 'LORSICA',
        istatCode: '007010030'
    },
    {
        name: 'LOSETO',
        istatCode: '016072804'
    },
    {
        name: 'LOSINE',
        istatCode: '003017094'
    },
    {
        name: 'LOTZORAI',
        istatCode: '020091042'
    },
    {
        name: 'LOVERE',
        istatCode: '003016128'
    },
    {
        name: 'LOVERO',
        istatCode: '003014038'
    },
    {
        name: 'LOZIO',
        istatCode: '003017095'
    },
    {
        name: 'LOZZA',
        istatCode: '003012091'
    },
    {
        name: 'LOZZO ATESTINO',
        istatCode: '005028047'
    },
    {
        name: 'LOZZO DI CADORE',
        istatCode: '005025033'
    },
    {
        name: 'LOZZOLO',
        istatCode: '001002072'
    },
    {
        name: 'LU',
        istatCode: '001006089'
    },
    {
        name: 'LU E CUCCARO MONFERRATO',
        istatCode: '001006193'
    },
    {
        name: 'LUBRIANO',
        istatCode: '012056033'
    },
    {
        name: 'LUCCA',
        istatCode: '009046017'
    },
    {
        name: 'LUCCA SICULA',
        istatCode: '019084022'
    },
    {
        name: 'LUCERA',
        istatCode: '016071028'
    },
    {
        name: 'LUCIGNANO',
        istatCode: '009051021'
    },
    {
        name: 'LUCINASCO',
        istatCode: '007008033'
    },
    {
        name: 'LUCINO',
        istatCode: '003013896'
    },
    {
        name: 'LUCITO',
        istatCode: '014070033'
    },
    {
        name: 'LUCO DEI MARSI',
        istatCode: '013066051'
    },
    {
        name: 'LUCOLI',
        istatCode: '013066052'
    },
    {
        name: 'LUGAGNANO VAL D\'ARDA',
        istatCode: '008033026'
    },
    {
        name: 'LUGNACCO',
        istatCode: '001001138'
    },
    {
        name: 'LUGNANO IN TEVERINA',
        istatCode: '010055016'
    },
    {
        name: 'LUGO',
        istatCode: '008039012'
    },
    {
        name: 'LUGO DI VICENZA',
        istatCode: '005024053'
    },
    {
        name: 'LUINO',
        istatCode: '003012092'
    },
    {
        name: 'LUISAGO',
        istatCode: '003013135'
    },
    {
        name: 'LULA',
        istatCode: '020091043'
    },
    {
        name: 'LUMARZO',
        istatCode: '007010031'
    },
    {
        name: 'LUMEZZANE',
        istatCode: '003017096'
    },
    {
        name: 'LUNAMATRONA',
        istatCode: '020111038'
    },
    {
        name: 'LUNANO',
        istatCode: '011041022'
    },
    {
        name: 'LUNGAVILLA',
        istatCode: '003018084'
    },
    {
        name: 'LUNGRO',
        istatCode: '018078069'
    },
    {
        name: 'LUNI',
        istatCode: '007011020'
    },
    {
        name: 'LUOGOSANO',
        istatCode: '015064045'
    },
    {
        name: 'LUOGOSANTO',
        istatCode: '020090036'
    },
    {
        name: 'LUPARA',
        istatCode: '014070034'
    },
    {
        name: 'LURAGO D\'ERBA',
        istatCode: '003013136'
    },
    {
        name: 'LURAGO MARINONE',
        istatCode: '003013137'
    },
    {
        name: 'LURANO',
        istatCode: '003016129'
    },
    {
        name: 'LURAS',
        istatCode: '020090037'
    },
    {
        name: 'LURATE CACCIVIO',
        istatCode: '003013138'
    },
    {
        name: 'LUSCIANO',
        istatCode: '015061046'
    },
    {
        name: 'LUSERNA',
        istatCode: '004022109'
    },
    {
        name: 'LUSERNA SAN GIOVANNI',
        istatCode: '001001139'
    },
    {
        name: 'LUSERNETTA',
        istatCode: '001001140'
    },
    {
        name: 'LUSEVERA',
        istatCode: '006030051'
    },
    {
        name: 'LUSIA',
        istatCode: '005029031'
    },
    {
        name: 'LUSIANA',
        istatCode: '005024054'
    },
    {
        name: 'LUSIANA CONCO',
        istatCode: '005024127'
    },
    {
        name: 'LUSIGLIE\'',
        istatCode: '001001141'
    },
    {
        name: 'LUSON - LUESEN',
        istatCode: '004021044'
    },
    {
        name: 'LUSTRA',
        istatCode: '015065064'
    },
    {
        name: 'LUVINATE',
        istatCode: '003012093'
    },
    {
        name: 'LUZZANA',
        istatCode: '003016130'
    },
    {
        name: 'LUZZARA',
        istatCode: '008035026'
    },
    {
        name: 'LUZZI',
        istatCode: '018078070'
    },
    {
        name: 'MACCAGNO',
        istatCode: '003012094'
    },
    {
        name: 'MACCAGNO CON PINO E VEDDASCA',
        istatCode: '003012142'
    },
    {
        name: 'MACCASTORNA',
        istatCode: '003098033'
    },
    {
        name: 'MACCHIA D\'ISERNIA',
        istatCode: '014094025'
    },
    {
        name: 'MACCHIA VALFORTORE',
        istatCode: '014070035'
    },
    {
        name: 'MACCHIAGODENA',
        istatCode: '014094026'
    },
    {
        name: 'MACELLO',
        istatCode: '001001142'
    },
    {
        name: 'MACERATA',
        istatCode: '011043023'
    },
    {
        name: 'MACERATA CAMPANIA',
        istatCode: '015061047'
    },
    {
        name: 'MACERATA FELTRIA',
        istatCode: '011041023'
    },
    {
        name: 'MACHERIO',
        istatCode: '003108029'
    },
    {
        name: 'MACLODIO',
        istatCode: '003017097'
    },
    {
        name: 'MACOMER',
        istatCode: '020091044'
    },
    {
        name: 'MACRA',
        istatCode: '001004112'
    },
    {
        name: 'MACUGNAGA',
        istatCode: '001103039'
    },
    {
        name: 'MADDALONI',
        istatCode: '015061048'
    },
    {
        name: 'MADESIMO',
        istatCode: '003014035'
    },
    {
        name: 'MADIGNANO',
        istatCode: '003019055'
    },
    {
        name: 'MADONE',
        istatCode: '003016131'
    },
    {
        name: 'MADONNA DEL SASSO',
        istatCode: '001103040'
    },
    {
        name: 'MADRUZZO (E797)',
        istatCode: '004022858'
    },
    {
        name: 'MADRUZZO (M357)',
        istatCode: '004022243'
    },
    {
        name: 'MAENZA',
        istatCode: '012059013'
    },
    {
        name: 'MAFALDA',
        istatCode: '014070036'
    },
    {
        name: 'MAGASA',
        istatCode: '003017098'
    },
    {
        name: 'MAGENTA',
        istatCode: '003015130'
    },
    {
        name: 'MAGGIORA',
        istatCode: '001003088'
    },
    {
        name: 'MAGHERNO',
        istatCode: '003018085'
    },
    {
        name: 'MAGIONE',
        istatCode: '010054026'
    },
    {
        name: 'MAGISANO',
        istatCode: '018079068'
    },
    {
        name: 'MAGLIANO ALFIERI',
        istatCode: '001004113'
    },
    {
        name: 'MAGLIANO ALPI',
        istatCode: '001004114'
    },
    {
        name: 'MAGLIANO DE\' MARSI',
        istatCode: '013066053'
    },
    {
        name: 'MAGLIANO DI TENNA',
        istatCode: '011109010'
    },
    {
        name: 'MAGLIANO IN TOSCANA',
        istatCode: '009053013'
    },
    {
        name: 'MAGLIANO ROMANO',
        istatCode: '012058052'
    },
    {
        name: 'MAGLIANO SABINA',
        istatCode: '012057035'
    },
    {
        name: 'MAGLIANO VETERE',
        istatCode: '015065065'
    },
    {
        name: 'MAGLIE',
        istatCode: '016075039'
    },
    {
        name: 'MAGLIOLO',
        istatCode: '007009035'
    },
    {
        name: 'MAGLIONE',
        istatCode: '001001143'
    },
    {
        name: 'MAGNACAVALLO',
        istatCode: '003020029'
    },
    {
        name: 'MAGNAGO',
        istatCode: '003015131'
    },
    {
        name: 'MAGNANO',
        istatCode: '001096030'
    },
    {
        name: 'MAGNANO IN RIVIERA',
        istatCode: '006030052'
    },
    {
        name: 'MAGOMADAS',
        istatCode: '020095083'
    },
    {
        name: 'MAGRE\' SULLA STRADA DEL VINO - MARGREID AN DER WEINSTRASSE',
        istatCode: '004021045'
    },
    {
        name: 'MAGREGLIO',
        istatCode: '003013139'
    },
    {
        name: 'MAIDA',
        istatCode: '018079069'
    },
    {
        name: 'MAIERA\'',
        istatCode: '018078071'
    },
    {
        name: 'MAIERATO',
        istatCode: '018102020'
    },
    {
        name: 'MAIOLATI SPONTINI',
        istatCode: '011042023'
    },
    {
        name: 'MAIOLO',
        istatCode: '008099022'
    },
    {
        name: 'MAIORI',
        istatCode: '015065066'
    },
    {
        name: 'MAIRAGO',
        istatCode: '003098034'
    },
    {
        name: 'MAIRANO',
        istatCode: '003017099'
    },
    {
        name: 'MAISSANA',
        istatCode: '007011018'
    },
    {
        name: 'MAJANO',
        istatCode: '006030053'
    },
    {
        name: 'MALAGNINO',
        istatCode: '003019056'
    },
    {
        name: 'MALALBERGO',
        istatCode: '008037035'
    },
    {
        name: 'MALBORGHETTO VALBRUNA',
        istatCode: '006030054'
    },
    {
        name: 'MALCESINE',
        istatCode: '005023045'
    },
    {
        name: 'MALE\'',
        istatCode: '004022110'
    },
    {
        name: 'MALEGNO',
        istatCode: '003017100'
    },
    {
        name: 'MALEO',
        istatCode: '003098035'
    },
    {
        name: 'MALESCO',
        istatCode: '001103041'
    },
    {
        name: 'MALETTO',
        istatCode: '019087022'
    },
    {
        name: 'MALFA',
        istatCode: '019083043'
    },
    {
        name: 'MALGESSO',
        istatCode: '003012095'
    },
    {
        name: 'MALGRATE',
        istatCode: '003097045'
    },
    {
        name: 'MALITO',
        istatCode: '018078072'
    },
    {
        name: 'MALLARE',
        istatCode: '007009036'
    },
    {
        name: 'MALLES - MALS',
        istatCode: '004021843'
    },
    {
        name: 'MALLES VENOSTA - MALS',
        istatCode: '004021046'
    },
    {
        name: 'MALNATE',
        istatCode: '003012096'
    },
    {
        name: 'MALO',
        istatCode: '005024055'
    },
    {
        name: 'MALONNO',
        istatCode: '003017101'
    },
    {
        name: 'MALOSCO',
        istatCode: '004022111'
    },
    {
        name: 'MALTIGNANO',
        istatCode: '011044027'
    },
    {
        name: 'MALVAGNA',
        istatCode: '019083044'
    },
    {
        name: 'MALVICINO',
        istatCode: '001006090'
    },
    {
        name: 'MALVITO',
        istatCode: '018078073'
    },
    {
        name: 'MAMMOLA',
        istatCode: '018080044'
    },
    {
        name: 'MAMOIADA',
        istatCode: '020091046'
    },
    {
        name: 'MANCIANO',
        istatCode: '009053014'
    },
    {
        name: 'MANDANICI',
        istatCode: '019083045'
    },
    {
        name: 'MANDAS',
        istatCode: '020111039'
    },
    {
        name: 'MANDATORICCIO',
        istatCode: '018078074'
    },
    {
        name: 'MANDELA',
        istatCode: '012058053'
    },
    {
        name: 'MANDELLO DEL LARIO',
        istatCode: '003097046'
    },
    {
        name: 'MANDELLO VITTA',
        istatCode: '001003090'
    },
    {
        name: 'MANDURIA',
        istatCode: '016073012'
    },
    {
        name: 'MANERBA DEL GARDA',
        istatCode: '003017102'
    },
    {
        name: 'MANERBIO',
        istatCode: '003017103'
    },
    {
        name: 'MANFREDONIA',
        istatCode: '016071029'
    },
    {
        name: 'MANGO',
        istatCode: '001004115'
    },
    {
        name: 'MANGONE',
        istatCode: '018078075'
    },
    {
        name: 'MANIACE',
        istatCode: '019087057'
    },
    {
        name: 'MANIAGO',
        istatCode: '006093025'
    },
    {
        name: 'MANOCALZATI',
        istatCode: '015064046'
    },
    {
        name: 'MANOPPELLO',
        istatCode: '013068022'
    },
    {
        name: 'MANSUE\'',
        istatCode: '005026037'
    },
    {
        name: 'MANTA',
        istatCode: '001004116'
    },
    {
        name: 'MANTELLO',
        istatCode: '003014039'
    },
    {
        name: 'MANTOVA',
        istatCode: '003020030'
    },
    {
        name: 'MANZANO',
        istatCode: '006030055'
    },
    {
        name: 'MANZIANA',
        istatCode: '012058054'
    },
    {
        name: 'MAPELLO',
        istatCode: '003016132'
    },
    {
        name: 'MAPPANO',
        istatCode: '001001316'
    },
    {
        name: 'MARA',
        istatCode: '020090038'
    },
    {
        name: 'MARACALAGONIS',
        istatCode: '020092037'
    },
    {
        name: 'MARANELLO',
        istatCode: '008036019'
    },
    {
        name: 'MARANO DI NAPOLI',
        istatCode: '015063041'
    },
    {
        name: 'MARANO DI VALPOLICELLA',
        istatCode: '005023046'
    },
    {
        name: 'MARANO EQUO',
        istatCode: '012058055'
    },
    {
        name: 'MARANO LAGUNARE',
        istatCode: '006030056'
    },
    {
        name: 'MARANO MARCHESATO',
        istatCode: '018078076'
    },
    {
        name: 'MARANO PRINCIPATO',
        istatCode: '018078077'
    },
    {
        name: 'MARANO SUL PANARO',
        istatCode: '008036020'
    },
    {
        name: 'MARANO TICINO',
        istatCode: '001003091'
    },
    {
        name: 'MARANO VICENTINO',
        istatCode: '005024056'
    },
    {
        name: 'MARANOLA',
        istatCode: '012059803'
    },
    {
        name: 'MARANZANA',
        istatCode: '001005061'
    },
    {
        name: 'MARATEA',
        istatCode: '017076044'
    },
    {
        name: 'MARCALLO CON CASONE',
        istatCode: '003015134'
    },
    {
        name: 'MARCARIA',
        istatCode: '003020031'
    },
    {
        name: 'MARCEDUSA',
        istatCode: '018079071'
    },
    {
        name: 'MARCELLINA',
        istatCode: '012058056'
    },
    {
        name: 'MARCELLINARA',
        istatCode: '018079072'
    },
    {
        name: 'MARCETELLI',
        istatCode: '012057036'
    },
    {
        name: 'MARCHENO',
        istatCode: '003017104'
    },
    {
        name: 'MARCHIROLO',
        istatCode: '003012097'
    },
    {
        name: 'MARCIANA',
        istatCode: '009049010'
    },
    {
        name: 'MARCIANA MARINA',
        istatCode: '009049011'
    },
    {
        name: 'MARCIANISE',
        istatCode: '015061049'
    },
    {
        name: 'MARCIANO DELLA CHIANA',
        istatCode: '009051022'
    },
    {
        name: 'MARCIGNAGO',
        istatCode: '003018086'
    },
    {
        name: 'MARCON',
        istatCode: '005027020'
    },
    {
        name: 'MAREBBE - ENNEBERG',
        istatCode: '004021047'
    },
    {
        name: 'MARENE',
        istatCode: '001004117'
    },
    {
        name: 'MARENO DI PIAVE',
        istatCode: '005026038'
    },
    {
        name: 'MARENTINO',
        istatCode: '001001144'
    },
    {
        name: 'MARETTO',
        istatCode: '001005062'
    },
    {
        name: 'MARGARITA',
        istatCode: '001004118'
    },
    {
        name: 'MARGHERITA DI SAVOIA',
        istatCode: '016110005'
    },
    {
        name: 'MARGNO',
        istatCode: '003097047'
    },
    {
        name: 'MARIANA MANTOVANA',
        istatCode: '003020032'
    },
    {
        name: 'MARIANO COMENSE',
        istatCode: '003013143'
    },
    {
        name: 'MARIANO DEL FRIULI',
        istatCode: '006031010'
    },
    {
        name: 'MARIANOPOLI',
        istatCode: '019085008'
    },
    {
        name: 'MARIGLIANELLA',
        istatCode: '015063042'
    },
    {
        name: 'MARIGLIANO',
        istatCode: '015063043'
    },
    {
        name: 'MARINA DI GIOIOSA IONICA',
        istatCode: '018080045'
    },
    {
        name: 'MARINEO',
        istatCode: '019082046'
    },
    {
        name: 'MARINO',
        istatCode: '012058057'
    },
    {
        name: 'MARLENGO - MARLING',
        istatCode: '004021048'
    },
    {
        name: 'MARLIANA',
        istatCode: '009047007'
    },
    {
        name: 'MARMENTINO',
        istatCode: '003017105'
    },
    {
        name: 'MARMIROLO',
        istatCode: '003020033'
    },
    {
        name: 'MARMORA',
        istatCode: '001004119'
    },
    {
        name: 'MARNATE',
        istatCode: '003012098'
    },
    {
        name: 'MARONE',
        istatCode: '003017106'
    },
    {
        name: 'MAROPATI',
        istatCode: '018080046'
    },
    {
        name: 'MAROSTICA',
        istatCode: '005024057'
    },
    {
        name: 'MARRADI',
        istatCode: '009048026'
    },
    {
        name: 'MARRUBIU',
        istatCode: '020095025'
    },
    {
        name: 'MARSAGLIA',
        istatCode: '001004120'
    },
    {
        name: 'MARSALA',
        istatCode: '019081011'
    },
    {
        name: 'MARSCIANO',
        istatCode: '010054027'
    },
    {
        name: 'MARSICO NUOVO',
        istatCode: '017076045'
    },
    {
        name: 'MARSICOVETERE',
        istatCode: '017076046'
    },
    {
        name: 'MARTA',
        istatCode: '012056034'
    },
    {
        name: 'MARTANO',
        istatCode: '016075040'
    },
    {
        name: 'MARTELLAGO',
        istatCode: '005027021'
    },
    {
        name: 'MARTELLO - MARTELL',
        istatCode: '004021049'
    },
    {
        name: 'MARTIGNACCO',
        istatCode: '006030057'
    },
    {
        name: 'MARTIGNANA DI PO',
        istatCode: '003019057'
    },
    {
        name: 'MARTIGNANO',
        istatCode: '016075041'
    },
    {
        name: 'MARTINA FRANCA',
        istatCode: '016073013'
    },
    {
        name: 'MARTINENGO',
        istatCode: '003016133'
    },
    {
        name: 'MARTINIANA PO',
        istatCode: '001004121'
    },
    {
        name: 'MARTINSICURO',
        istatCode: '013067047'
    },
    {
        name: 'MARTIRANO',
        istatCode: '018079073'
    },
    {
        name: 'MARTIRANO LOMBARDO',
        istatCode: '018079074'
    },
    {
        name: 'MARTIS',
        istatCode: '020090039'
    },
    {
        name: 'MARTONE',
        istatCode: '018080047'
    },
    {
        name: 'MARUDO',
        istatCode: '003098036'
    },
    {
        name: 'MARUGGIO',
        istatCode: '016073014'
    },
    {
        name: 'MARZABOTTO',
        istatCode: '008037036'
    },
    {
        name: 'MARZANO',
        istatCode: '003018087'
    },
    {
        name: 'MARZANO APPIO',
        istatCode: '015061050'
    },
    {
        name: 'MARZANO DI NOLA',
        istatCode: '015064047'
    },
    {
        name: 'MARZI',
        istatCode: '018078078'
    },
    {
        name: 'MARZIO',
        istatCode: '003012099'
    },
    {
        name: 'MASAINAS',
        istatCode: '020111040'
    },
    {
        name: 'MASATE',
        istatCode: '003015136'
    },
    {
        name: 'MASCALI',
        istatCode: '019087023'
    },
    {
        name: 'MASCALUCIA',
        istatCode: '019087024'
    },
    {
        name: 'MASCHITO',
        istatCode: '017076047'
    },
    {
        name: 'MASCIAGO PRIMO',
        istatCode: '003012100'
    },
    {
        name: 'MASER',
        istatCode: '005026039'
    },
    {
        name: 'MASERA',
        istatCode: '001103042'
    },
    {
        name: 'MASERA\' DI PADOVA',
        istatCode: '005028048'
    },
    {
        name: 'MASERADA SUL PIAVE',
        istatCode: '005026040'
    },
    {
        name: 'MASI',
        istatCode: '005028049'
    },
    {
        name: 'MASI TORELLO',
        istatCode: '008038012'
    },
    {
        name: 'MASIO',
        istatCode: '001006091'
    },
    {
        name: 'MASLIANICO',
        istatCode: '003013144'
    },
    {
        name: 'MASON VICENTINO',
        istatCode: '005024058'
    },
    {
        name: 'MASONE',
        istatCode: '007010032'
    },
    {
        name: 'MASSA',
        istatCode: '009045010'
    },
    {
        name: 'MASSA D\'ALBE',
        istatCode: '013066054'
    },
    {
        name: 'MASSA DI SOMMA',
        istatCode: '015063092'
    },
    {
        name: 'MASSA E COZZILE',
        istatCode: '009047008'
    },
    {
        name: 'MASSA FERMANA',
        istatCode: '011109011'
    },
    {
        name: 'MASSA FISCAGLIA',
        istatCode: '008038013'
    },
    {
        name: 'MASSA LOMBARDA',
        istatCode: '008039013'
    },
    {
        name: 'MASSA LUBRENSE',
        istatCode: '015063044'
    },
    {
        name: 'MASSA MARITTIMA',
        istatCode: '009053015'
    },
    {
        name: 'MASSA MARTANA',
        istatCode: '010054028'
    },
    {
        name: 'MASSA SUPERIORE',
        istatCode: '005029810'
    },
    {
        name: 'MASSAFRA',
        istatCode: '016073015'
    },
    {
        name: 'MASSALENGO',
        istatCode: '003098037'
    },
    {
        name: 'MASSANZAGO',
        istatCode: '005028050'
    },
    {
        name: 'MASSAROSA',
        istatCode: '009046018'
    },
    {
        name: 'MASSAZZA',
        istatCode: '001096031'
    },
    {
        name: 'MASSELLO',
        istatCode: '001001145'
    },
    {
        name: 'MASSERANO',
        istatCode: '001096032'
    },
    {
        name: 'MASSIGNANO',
        istatCode: '011044029'
    },
    {
        name: 'MASSIMENO',
        istatCode: '004022112'
    },
    {
        name: 'MASSIMINO',
        istatCode: '007009037'
    },
    {
        name: 'MASSINO VISCONTI',
        istatCode: '001003093'
    },
    {
        name: 'MASSIOLA',
        istatCode: '001103043'
    },
    {
        name: 'MASULLAS',
        istatCode: '020095026'
    },
    {
        name: 'MATELICA',
        istatCode: '011043024'
    },
    {
        name: 'MATERA',
        istatCode: '017077014'
    },
    {
        name: 'MATHI',
        istatCode: '001001146'
    },
    {
        name: 'MATINO',
        istatCode: '016075042'
    },
    {
        name: 'MATRICE',
        istatCode: '014070037'
    },
    {
        name: 'MATTARELLO',
        istatCode: '004022867'
    },
    {
        name: 'MATTIE',
        istatCode: '001001147'
    },
    {
        name: 'MATTINATA',
        istatCode: '016071031'
    },
    {
        name: 'MAZARA DEL VALLO',
        istatCode: '019081012'
    },
    {
        name: 'MAZZANO',
        istatCode: '003017107'
    },
    {
        name: 'MAZZANO ROMANO',
        istatCode: '012058058'
    },
    {
        name: 'MAZZARINO',
        istatCode: '019085009'
    },
    {
        name: 'MAZZARRA\' SANT\'ANDREA',
        istatCode: '019083046'
    },
    {
        name: 'MAZZARRONE',
        istatCode: '019087056'
    },
    {
        name: 'MAZZE\'',
        istatCode: '001001148'
    },
    {
        name: 'MAZZIN',
        istatCode: '004022113'
    },
    {
        name: 'MAZZO DI VALTELLINA',
        istatCode: '003014040'
    },
    {
        name: 'MEANA DI SUSA',
        istatCode: '001001149'
    },
    {
        name: 'MEANA SARDO',
        istatCode: '020091047'
    },
    {
        name: 'MEANO',
        istatCode: '004022868'
    },
    {
        name: 'MECHEL',
        istatCode: '004022869'
    },
    {
        name: 'MEDA',
        istatCode: '003108030'
    },
    {
        name: 'MEDE',
        istatCode: '003018088'
    },
    {
        name: 'MEDEA',
        istatCode: '006031011'
    },
    {
        name: 'MEDESANO',
        istatCode: '008034020'
    },
    {
        name: 'MEDICINA',
        istatCode: '008037037'
    },
    {
        name: 'MEDIGLIA',
        istatCode: '003015139'
    },
    {
        name: 'MEDOLAGO',
        istatCode: '003016250'
    },
    {
        name: 'MEDOLE',
        istatCode: '003020034'
    },
    {
        name: 'MEDOLLA',
        istatCode: '008036021'
    },
    {
        name: 'MEDUNA DI LIVENZA',
        istatCode: '005026041'
    },
    {
        name: 'MEDUNO',
        istatCode: '006093026'
    },
    {
        name: 'MEGLIADINO SAN FIDENZIO',
        istatCode: '005028051'
    },
    {
        name: 'MEGLIADINO SAN VITALE',
        istatCode: '005028052'
    },
    {
        name: 'MEINA',
        istatCode: '001003095'
    },
    {
        name: 'MEL',
        istatCode: '005025034'
    },
    {
        name: 'MELARA',
        istatCode: '005029032'
    },
    {
        name: 'MELAZZO',
        istatCode: '001006092'
    },
    {
        name: 'MELDOLA',
        istatCode: '008040019'
    },
    {
        name: 'MELE',
        istatCode: '007010033'
    },
    {
        name: 'MELEGNANO',
        istatCode: '003015140'
    },
    {
        name: 'MELENDUGNO',
        istatCode: '016075043'
    },
    {
        name: 'MELETI',
        istatCode: '003098038'
    },
    {
        name: 'MELFI',
        istatCode: '017076048'
    },
    {
        name: 'MELICUCCA\'',
        istatCode: '018080048'
    },
    {
        name: 'MELICUCCO',
        istatCode: '018080049'
    },
    {
        name: 'MELILLI',
        istatCode: '019089012'
    },
    {
        name: 'MELISSA',
        istatCode: '018101014'
    },
    {
        name: 'MELISSANO',
        istatCode: '016075044'
    },
    {
        name: 'MELITO DI NAPOLI',
        istatCode: '015063045'
    },
    {
        name: 'MELITO DI PORTO SALVO',
        istatCode: '018080050'
    },
    {
        name: 'MELITO IRPINO',
        istatCode: '015064048'
    },
    {
        name: 'MELIZZANO',
        istatCode: '015062039'
    },
    {
        name: 'MELLE',
        istatCode: '001004122'
    },
    {
        name: 'MELLO',
        istatCode: '003014041'
    },
    {
        name: 'MELPIGNANO',
        istatCode: '016075045'
    },
    {
        name: 'MELTINA - MOELTEN',
        istatCode: '004021050'
    },
    {
        name: 'MELZO',
        istatCode: '003015142'
    },
    {
        name: 'MENAGGIO',
        istatCode: '003013145'
    },
    {
        name: 'MENAROLA',
        istatCode: '003014042'
    },
    {
        name: 'MENCONICO',
        istatCode: '003018089'
    },
    {
        name: 'MENDATICA',
        istatCode: '007008034'
    },
    {
        name: 'MENDICINO',
        istatCode: '018078079'
    },
    {
        name: 'MENFI',
        istatCode: '019084023'
    },
    {
        name: 'MENTANA',
        istatCode: '012058059'
    },
    {
        name: 'MEOLO',
        istatCode: '005027022'
    },
    {
        name: 'MERANA',
        istatCode: '001006093'
    },
    {
        name: 'MERANO - MERAN',
        istatCode: '004021051'
    },
    {
        name: 'MERATE',
        istatCode: '003097048'
    },
    {
        name: 'MERCALLO',
        istatCode: '003012101'
    },
    {
        name: 'MERCATELLO SUL METAURO',
        istatCode: '011041025'
    },
    {
        name: 'MERCATINO CONCA',
        istatCode: '011041026'
    },
    {
        name: 'MERCATO SAN SEVERINO',
        istatCode: '015065067'
    },
    {
        name: 'MERCATO SARACENO',
        istatCode: '008040020'
    },
    {
        name: 'MERCENASCO',
        istatCode: '001001150'
    },
    {
        name: 'MERCOGLIANO',
        istatCode: '015064049'
    },
    {
        name: 'MERETO DI TOMBA',
        istatCode: '006030058'
    },
    {
        name: 'MERGO',
        istatCode: '011042024'
    },
    {
        name: 'MERGOZZO',
        istatCode: '001103044'
    },
    {
        name: 'MERI\'',
        istatCode: '019083047'
    },
    {
        name: 'MERLARA',
        istatCode: '005028053'
    },
    {
        name: 'MERLINO',
        istatCode: '003098039'
    },
    {
        name: 'MERONE',
        istatCode: '003013147'
    },
    {
        name: 'MESAGNE',
        istatCode: '016074010'
    },
    {
        name: 'MESE',
        istatCode: '003014043'
    },
    {
        name: 'MESENZANA',
        istatCode: '003012102'
    },
    {
        name: 'MESERO',
        istatCode: '003015144'
    },
    {
        name: 'MESOLA',
        istatCode: '008038014'
    },
    {
        name: 'MESORACA',
        istatCode: '018101015'
    },
    {
        name: 'MESSINA',
        istatCode: '019083048'
    },
    {
        name: 'MESTRE',
        istatCode: '005027805'
    },
    {
        name: 'MESTRINO',
        istatCode: '005028054'
    },
    {
        name: 'META',
        istatCode: '015063046'
    },
    {
        name: 'MEUGLIANO',
        istatCode: '001001151'
    },
    {
        name: 'MEZZAGO',
        istatCode: '003108031'
    },
    {
        name: 'MEZZANA',
        istatCode: '004022114'
    },
    {
        name: 'MEZZANA BIGLI',
        istatCode: '003018090'
    },
    {
        name: 'MEZZANA MORTIGLIENGO',
        istatCode: '001096033'
    },
    {
        name: 'MEZZANA RABATTONE',
        istatCode: '003018091'
    },
    {
        name: 'MEZZANE DI SOTTO',
        istatCode: '005023047'
    },
    {
        name: 'MEZZANEGO',
        istatCode: '007010034'
    },
    {
        name: 'MEZZANI',
        istatCode: '008034021'
    },
    {
        name: 'MEZZANINO',
        istatCode: '003018092'
    },
    {
        name: 'MEZZANO',
        istatCode: '004022115'
    },
    {
        name: 'MEZZANO IMER',
        istatCode: '004022871'
    },
    {
        name: 'MEZZEGRA',
        istatCode: '003013148'
    },
    {
        name: 'MEZZENILE',
        istatCode: '001001152'
    },
    {
        name: 'MEZZOCORONA',
        istatCode: '004022116'
    },
    {
        name: 'MEZZOJUSO',
        istatCode: '019082047'
    },
    {
        name: 'MEZZOLDO',
        istatCode: '003016134'
    },
    {
        name: 'MEZZOLOMBARDO',
        istatCode: '004022117'
    },
    {
        name: 'MEZZOMERICO',
        istatCode: '001003097'
    },
    {
        name: 'MIAGLIANO',
        istatCode: '001096034'
    },
    {
        name: 'MIANE',
        istatCode: '005026042'
    },
    {
        name: 'MIASINO',
        istatCode: '001003098'
    },
    {
        name: 'MIAZZINA',
        istatCode: '001103045'
    },
    {
        name: 'MICIGLIANO',
        istatCode: '012057037'
    },
    {
        name: 'MIGGIANO',
        istatCode: '016075046'
    },
    {
        name: 'MIGLIANICO',
        istatCode: '013069050'
    },
    {
        name: 'MIGLIARINO',
        istatCode: '008038015'
    },
    {
        name: 'MIGLIARO',
        istatCode: '008038026'
    },
    {
        name: 'MIGLIERINA',
        istatCode: '018079077'
    },
    {
        name: 'MIGLIONICO',
        istatCode: '017077015'
    },
    {
        name: 'MIGNANEGO',
        istatCode: '007010035'
    },
    {
        name: 'MIGNANO MONTE LUNGO',
        istatCode: '015061051'
    },
    {
        name: 'MILANO',
        istatCode: '003015146'
    },
    {
        name: 'MILAZZO',
        istatCode: '019083049'
    },
    {
        name: 'MILENA',
        istatCode: '019085010'
    },
    {
        name: 'MILETO',
        istatCode: '018102021'
    },
    {
        name: 'MILIS',
        istatCode: '020095027'
    },
    {
        name: 'MILITELLO IN VAL DI CATANIA',
        istatCode: '019087025'
    },
    {
        name: 'MILITELLO ROSMARINO',
        istatCode: '019083050'
    },
    {
        name: 'MILLESIMO',
        istatCode: '007009038'
    },
    {
        name: 'MILO',
        istatCode: '019087026'
    },
    {
        name: 'MILZANO',
        istatCode: '003017108'
    },
    {
        name: 'MINEO',
        istatCode: '019087027'
    },
    {
        name: 'MINERBE',
        istatCode: '005023048'
    },
    {
        name: 'MINERBIO',
        istatCode: '008037038'
    },
    {
        name: 'MINERVINO DI LECCE',
        istatCode: '016075047'
    },
    {
        name: 'MINERVINO MURGE',
        istatCode: '016110006'
    },
    {
        name: 'MINORI',
        istatCode: '015065068'
    },
    {
        name: 'MINTURNO',
        istatCode: '012059014'
    },
    {
        name: 'MINUCCIANO',
        istatCode: '009046019'
    },
    {
        name: 'MIOGLIA',
        istatCode: '007009039'
    },
    {
        name: 'MIRA',
        istatCode: '005027023'
    },
    {
        name: 'MIRABELLA ECLANO',
        istatCode: '015064050'
    },
    {
        name: 'MIRABELLA IMBACCARI',
        istatCode: '019087028'
    },
    {
        name: 'MIRABELLO',
        istatCode: '008038016'
    },
    {
        name: 'MIRABELLO COMASCO',
        istatCode: '003013900'
    },
    {
        name: 'MIRABELLO MONFERRATO',
        istatCode: '001006094'
    },
    {
        name: 'MIRABELLO SANNITICO',
        istatCode: '014070038'
    },
    {
        name: 'MIRADOLO TERME',
        istatCode: '003018093'
    },
    {
        name: 'MIRANDA',
        istatCode: '014094027'
    },
    {
        name: 'MIRANDOLA',
        istatCode: '008036022'
    },
    {
        name: 'MIRANO',
        istatCode: '005027024'
    },
    {
        name: 'MIRTO',
        istatCode: '019083051'
    },
    {
        name: 'MISANO ADRIATICO',
        istatCode: '008099005'
    },
    {
        name: 'MISANO DI GERA D\'ADDA',
        istatCode: '003016135'
    },
    {
        name: 'MISILISCEMI',
        istatCode: '019081025'
    },
    {
        name: 'MISILMERI',
        istatCode: '019082048'
    },
    {
        name: 'MISINTO',
        istatCode: '003108032'
    },
    {
        name: 'MISSAGLIA',
        istatCode: '003097049'
    },
    {
        name: 'MISSANELLO',
        istatCode: '017076049'
    },
    {
        name: 'MISTERBIANCO',
        istatCode: '019087029'
    },
    {
        name: 'MISTRETTA',
        istatCode: '019083052'
    },
    {
        name: 'MIZZOLE',
        istatCode: '005023810'
    },
    {
        name: 'MOASCA',
        istatCode: '001005063'
    },
    {
        name: 'MOCCHIE',
        istatCode: '001001839'
    },
    {
        name: 'MOCONESI',
        istatCode: '007010036'
    },
    {
        name: 'MODENA',
        istatCode: '008036023'
    },
    {
        name: 'MODICA',
        istatCode: '019088006'
    },
    {
        name: 'MODIGLIANA',
        istatCode: '008040022'
    },
    {
        name: 'MODOLO',
        istatCode: '020095084'
    },
    {
        name: 'MODUGNO',
        istatCode: '016072027'
    },
    {
        name: 'MOENA',
        istatCode: '004022118'
    },
    {
        name: 'MOGGIO',
        istatCode: '003097050'
    },
    {
        name: 'MOGGIO UDINESE',
        istatCode: '006030059'
    },
    {
        name: 'MOGLIA',
        istatCode: '003020035'
    },
    {
        name: 'MOGLIANO',
        istatCode: '011043025'
    },
    {
        name: 'MOGLIANO VENETO',
        istatCode: '005026043'
    },
    {
        name: 'MOGORELLA',
        istatCode: '020095028'
    },
    {
        name: 'MOGORO',
        istatCode: '020095029'
    },
    {
        name: 'MOIANO',
        istatCode: '015062040'
    },
    {
        name: 'MOIMACCO',
        istatCode: '006030060'
    },
    {
        name: 'MOIO ALCANTARA',
        istatCode: '019083053'
    },
    {
        name: 'MOIO DE\' CALVI',
        istatCode: '003016136'
    },
    {
        name: 'MOIO DELLA CIVITELLA',
        istatCode: '015065069'
    },
    {
        name: 'MOIOLA',
        istatCode: '001004123'
    },
    {
        name: 'MOLA DI BARI',
        istatCode: '016072028'
    },
    {
        name: 'MOLARE',
        istatCode: '001006095'
    },
    {
        name: 'MOLAZZANA',
        istatCode: '009046020'
    },
    {
        name: 'MOLFETTA',
        istatCode: '016072029'
    },
    {
        name: 'MOLINA ATERNO',
        istatCode: '013066055'
    },
    {
        name: 'MOLINA DI LEDRO',
        istatCode: '004022119'
    },
    {
        name: 'MOLINARA',
        istatCode: '015062041'
    },
    {
        name: 'MOLINELLA',
        istatCode: '008037039'
    },
    {
        name: 'MOLINI DI TRIORA',
        istatCode: '007008035'
    },
    {
        name: 'MOLINO ALZANO',
        istatCode: '001006813'
    },
    {
        name: 'MOLINO DEI TORTI',
        istatCode: '001006096'
    },
    {
        name: 'MOLISE',
        istatCode: '014070039'
    },
    {
        name: 'MOLITERNO',
        istatCode: '017076050'
    },
    {
        name: 'MOLLIA',
        istatCode: '001002078'
    },
    {
        name: 'MOLOCHIO',
        istatCode: '018080051'
    },
    {
        name: 'MOLTENO',
        istatCode: '003097051'
    },
    {
        name: 'MOLTRASIO',
        istatCode: '003013152'
    },
    {
        name: 'MOLVENA',
        istatCode: '005024059'
    },
    {
        name: 'MOLVENO',
        istatCode: '004022120'
    },
    {
        name: 'MOMBALDONE',
        istatCode: '001005064'
    },
    {
        name: 'MOMBARCARO',
        istatCode: '001004124'
    },
    {
        name: 'MOMBAROCCIO',
        istatCode: '011041027'
    },
    {
        name: 'MOMBARUZZO',
        istatCode: '001005065'
    },
    {
        name: 'MOMBASIGLIO',
        istatCode: '001004125'
    },
    {
        name: 'MOMBELLO DI TORINO',
        istatCode: '001001153'
    },
    {
        name: 'MOMBELLO MONFERRATO',
        istatCode: '001006097'
    },
    {
        name: 'MOMBERCELLI',
        istatCode: '001005066'
    },
    {
        name: 'MOMO',
        istatCode: '001003100'
    },
    {
        name: 'MOMPANTERO',
        istatCode: '001001154'
    },
    {
        name: 'MOMPEO',
        istatCode: '012057038'
    },
    {
        name: 'MOMPERONE',
        istatCode: '001006098'
    },
    {
        name: 'MONACILIONI',
        istatCode: '014070040'
    },
    {
        name: 'MONALE',
        istatCode: '001005067'
    },
    {
        name: 'MONASTERACE',
        istatCode: '018080052'
    },
    {
        name: 'MONASTERO BORMIDA',
        istatCode: '001005068'
    },
    {
        name: 'MONASTERO DI LANZO',
        istatCode: '001001155'
    },
    {
        name: 'MONASTERO DI VASCO',
        istatCode: '001004126'
    },
    {
        name: 'MONASTEROLO CASOTTO',
        istatCode: '001004127'
    },
    {
        name: 'MONASTEROLO DEL CASTELLO',
        istatCode: '003016137'
    },
    {
        name: 'MONASTEROLO DI SAVIGLIANO',
        istatCode: '001004128'
    },
    {
        name: 'MONASTIER DI TREVISO',
        istatCode: '005026044'
    },
    {
        name: 'MONASTIR',
        istatCode: '020111041'
    },
    {
        name: 'MONCALIERI',
        istatCode: '001001156'
    },
    {
        name: 'MONCALVO',
        istatCode: '001005069'
    },
    {
        name: 'MONCENISIO',
        istatCode: '001001157'
    },
    {
        name: 'MONCESTINO',
        istatCode: '001006099'
    },
    {
        name: 'MONCHIERO',
        istatCode: '001004129'
    },
    {
        name: 'MONCHIO DELLE CORTI',
        istatCode: '008034022'
    },
    {
        name: 'MONCLASSICO',
        istatCode: '004022121'
    },
    {
        name: 'MONCRIVELLO',
        istatCode: '001002079'
    },
    {
        name: 'MONCUCCO TORINESE',
        istatCode: '001005070'
    },
    {
        name: 'MONDAINO',
        istatCode: '008099006'
    },
    {
        name: 'MONDAVIO',
        istatCode: '011041028'
    },
    {
        name: 'MONDOLFO',
        istatCode: '011041029'
    },
    {
        name: 'MONDOVI\'',
        istatCode: '001004130'
    },
    {
        name: 'MONDRAGONE',
        istatCode: '015061052'
    },
    {
        name: 'MONEGLIA',
        istatCode: '007010037'
    },
    {
        name: 'MONESIGLIO',
        istatCode: '001004131'
    },
    {
        name: 'MONFALCONE',
        istatCode: '006031012'
    },
    {
        name: 'MONFORTE D\'ALBA',
        istatCode: '001004132'
    },
    {
        name: 'MONFORTE SAN GIORGIO',
        istatCode: '019083054'
    },
    {
        name: 'MONFUMO',
        istatCode: '005026045'
    },
    {
        name: 'MONGARDINO',
        istatCode: '001005071'
    },
    {
        name: 'MONGHIDORO',
        istatCode: '008037040'
    },
    {
        name: 'MONGIANA',
        istatCode: '018102022'
    },
    {
        name: 'MONGIARDINO LIGURE',
        istatCode: '001006100'
    },
    {
        name: 'MONGIUFFI MELIA',
        istatCode: '019083055'
    },
    {
        name: 'MONGRANDO',
        istatCode: '001096035'
    },
    {
        name: 'MONGRASSANO',
        istatCode: '018078080'
    },
    {
        name: 'MONGUELFO - WELSBERG',
        istatCode: '004021052'
    },
    {
        name: 'MONGUZZO',
        istatCode: '003013153'
    },
    {
        name: 'MONIGA DEL GARDA',
        istatCode: '003017109'
    },
    {
        name: 'MONLEALE',
        istatCode: '001006101'
    },
    {
        name: 'MONNO',
        istatCode: '003017110'
    },
    {
        name: 'MONOPOLI',
        istatCode: '016072030'
    },
    {
        name: 'MONREALE',
        istatCode: '019082049'
    },
    {
        name: 'MONRUPINO',
        istatCode: '006032002'
    },
    {
        name: 'MONSAMPIETRO MORICO',
        istatCode: '011109012'
    },
    {
        name: 'MONSAMPOLO DEL TRONTO',
        istatCode: '011044031'
    },
    {
        name: 'MONSANO',
        istatCode: '011042025'
    },
    {
        name: 'MONSELICE',
        istatCode: '005028055'
    },
    {
        name: 'MONSERRATO',
        istatCode: '020092109'
    },
    {
        name: 'MONSUMMANO TERME',
        istatCode: '009047009'
    },
    {
        name: 'MONTA\'',
        istatCode: '001004133'
    },
    {
        name: 'MONTABONE',
        istatCode: '001005072'
    },
    {
        name: 'MONTACUTO',
        istatCode: '001006102'
    },
    {
        name: 'MONTAFIA',
        istatCode: '001005073'
    },
    {
        name: 'MONTAGANO',
        istatCode: '014070041'
    },
    {
        name: 'MONTAGNA - MONTAN',
        istatCode: '004021053'
    },
    {
        name: 'MONTAGNA IN VALTELLINA',
        istatCode: '003014044'
    },
    {
        name: 'MONTAGNANA',
        istatCode: '005028056'
    },
    {
        name: 'MONTAGNAREALE',
        istatCode: '019083056'
    },
    {
        name: 'MONTAGNE',
        istatCode: '004022122'
    },
    {
        name: 'MONTAGUTO',
        istatCode: '015064051'
    },
    {
        name: 'MONTAIONE',
        istatCode: '009048027'
    },
    {
        name: 'MONTALBANO ELICONA',
        istatCode: '019083057'
    },
    {
        name: 'MONTALBANO JONICO',
        istatCode: '017077016'
    },
    {
        name: 'MONTALCINO',
        istatCode: '009052037'
    },
    {
        name: 'MONTALCINO (fino al 31/12/2016)',
        istatCode: '009052014'
    },
    {
        name: 'MONTALDEO',
        istatCode: '001006103'
    },
    {
        name: 'MONTALDO BORMIDA',
        istatCode: '001006104'
    },
    {
        name: 'MONTALDO DI MONDOVI\'',
        istatCode: '001004134'
    },
    {
        name: 'MONTALDO ROERO',
        istatCode: '001004135'
    },
    {
        name: 'MONTALDO SCARAMPI',
        istatCode: '001005074'
    },
    {
        name: 'MONTALDO TORINESE',
        istatCode: '001001158'
    },
    {
        name: 'MONTALE',
        istatCode: '009047010'
    },
    {
        name: 'MONTALENGHE',
        istatCode: '001001159'
    },
    {
        name: 'MONTALLEGRO',
        istatCode: '019084024'
    },
    {
        name: 'MONTALTO CARPASIO',
        istatCode: '007008068'
    },
    {
        name: 'MONTALTO DELLE MARCHE',
        istatCode: '011044032'
    },
    {
        name: 'MONTALTO DI CASTRO',
        istatCode: '012056035'
    },
    {
        name: 'MONTALTO DORA',
        istatCode: '001001160'
    },
    {
        name: 'MONTALTO LIGURE',
        istatCode: '007008036'
    },
    {
        name: 'MONTALTO PAVESE',
        istatCode: '003018094'
    },
    {
        name: 'MONTALTO UFFUGO',
        istatCode: '018078081'
    },
    {
        name: 'MONTANARO',
        istatCode: '001001161'
    },
    {
        name: 'MONTANASO LOMBARDO',
        istatCode: '003098040'
    },
    {
        name: 'MONTANERA',
        istatCode: '001004136'
    },
    {
        name: 'MONTANO ANTILIA',
        istatCode: '015065070'
    },
    {
        name: 'MONTANO LUCINO',
        istatCode: '003013154'
    },
    {
        name: 'MONTAPPONE',
        istatCode: '011109013'
    },
    {
        name: 'MONTAQUILA',
        istatCode: '014094028'
    },
    {
        name: 'MONTASOLA',
        istatCode: '012057039'
    },
    {
        name: 'MONTAURO',
        istatCode: '018079080'
    },
    {
        name: 'MONTAZZOLI',
        istatCode: '013069051'
    },
    {
        name: 'MONTE ARGENTARIO',
        istatCode: '009053016'
    },
    {
        name: 'MONTE CASTELLO DI VIBIO',
        istatCode: '010054029'
    },
    {
        name: 'MONTE CAVALLO',
        istatCode: '011043027'
    },
    {
        name: 'MONTE CERIGNONE',
        istatCode: '011041031'
    },
    {
        name: 'MONTE COLOMBO',
        istatCode: '008099007'
    },
    {
        name: 'MONTE CREMASCO',
        istatCode: '003019058'
    },
    {
        name: 'MONTE DI CAPODISTRIA',
        istatCode: '006702722'
    },
    {
        name: 'MONTE DI MALO',
        istatCode: '005024063'
    },
    {
        name: 'MONTE DI PROCIDA',
        istatCode: '015063047'
    },
    {
        name: 'MONTE GIBERTO',
        istatCode: '011109016'
    },
    {
        name: 'MONTE ISOLA',
        istatCode: '003017111'
    },
    {
        name: 'MONTE MARENZO',
        istatCode: '003097052'
    },
    {
        name: 'MONTE PORZIO',
        istatCode: '011041038'
    },
    {
        name: 'MONTE PORZIO CATONE',
        istatCode: '012058064'
    },
    {
        name: 'MONTE RINALDO',
        istatCode: '011109021'
    },
    {
        name: 'MONTE ROBERTO',
        istatCode: '011042029'
    },
    {
        name: 'MONTE ROMANO',
        istatCode: '012056037'
    },
    {
        name: 'MONTE SAN BIAGIO',
        istatCode: '012059015'
    },
    {
        name: 'MONTE SAN GIACOMO',
        istatCode: '015065075'
    },
    {
        name: 'MONTE SAN GIOVANNI CAMPANO',
        istatCode: '012060044'
    },
    {
        name: 'MONTE SAN GIOVANNI IN SABINA',
        istatCode: '012057043'
    },
    {
        name: 'MONTE SAN GIUSTO',
        istatCode: '011043031'
    },
    {
        name: 'MONTE SAN MARTINO',
        istatCode: '011043032'
    },
    {
        name: 'MONTE SAN PIETRANGELI',
        istatCode: '011109023'
    },
    {
        name: 'MONTE SAN PIETRO',
        istatCode: '008037042'
    },
    {
        name: 'MONTE SAN SAVINO',
        istatCode: '009051025'
    },
    {
        name: 'MONTE SAN VITO',
        istatCode: '011042030'
    },
    {
        name: 'MONTE SANTA MARIA TIBERINA',
        istatCode: '010054032'
    },
    {
        name: 'MONTE SANT\'ANGELO',
        istatCode: '016071033'
    },
    {
        name: 'MONTE URANO',
        istatCode: '011109024'
    },
    {
        name: 'MONTE VIDON COMBATTE',
        istatCode: '011109025'
    },
    {
        name: 'MONTE VIDON CORRADO',
        istatCode: '011109026'
    },
    {
        name: 'MONTEBELLO DELLA BATTAGLIA',
        istatCode: '003018095'
    },
    {
        name: 'MONTEBELLO DI BERTONA',
        istatCode: '013068023'
    },
    {
        name: 'MONTEBELLO IONICO',
        istatCode: '018080053'
    },
    {
        name: 'MONTEBELLO SUL SANGRO',
        istatCode: '013069009'
    },
    {
        name: 'MONTEBELLO VICENTINO',
        istatCode: '005024060'
    },
    {
        name: 'MONTEBELLUNA',
        istatCode: '005026046'
    },
    {
        name: 'MONTEBRUNO',
        istatCode: '007010038'
    },
    {
        name: 'MONTEBUONO',
        istatCode: '012057040'
    },
    {
        name: 'MONTECALVO IN FOGLIA',
        istatCode: '011041030'
    },
    {
        name: 'MONTECALVO IRPINO',
        istatCode: '015064052'
    },
    {
        name: 'MONTECALVO VERSIGGIA',
        istatCode: '003018096'
    },
    {
        name: 'MONTECARLO',
        istatCode: '009046021'
    },
    {
        name: 'MONTECAROTTO',
        istatCode: '011042026'
    },
    {
        name: 'MONTECASSIANO',
        istatCode: '011043026'
    },
    {
        name: 'MONTECASTELLO',
        istatCode: '001006105'
    },
    {
        name: 'MONTECASTRILLI',
        istatCode: '010055017'
    },
    {
        name: 'MONTECATINI VAL DI CECINA',
        istatCode: '009050019'
    },
    {
        name: 'MONTECATINI VAL DI NIEVOLE',
        istatCode: '009047801'
    },
    {
        name: 'MONTECATINI-TERME',
        istatCode: '009047011'
    },
    {
        name: 'MONTECCHIA DI CROSARA',
        istatCode: '005023049'
    },
    {
        name: 'MONTECCHIO',
        istatCode: '010055018'
    },
    {
        name: 'MONTECCHIO EMILIA',
        istatCode: '008035027'
    },
    {
        name: 'MONTECCHIO MAGGIORE',
        istatCode: '005024061'
    },
    {
        name: 'MONTECCHIO PRECALCINO',
        istatCode: '005024062'
    },
    {
        name: 'MONTECHIARO D\'ACQUI',
        istatCode: '001006106'
    },
    {
        name: 'MONTECHIARO D\'ASTI',
        istatCode: '001005075'
    },
    {
        name: 'MONTECHIARO DENICE',
        istatCode: '001006816'
    },
    {
        name: 'MONTECHIARUGOLO',
        istatCode: '008034023'
    },
    {
        name: 'MONTECICCARDO',
        istatCode: '011041032'
    },
    {
        name: 'MONTECILFONE',
        istatCode: '014070042'
    },
    {
        name: 'MONTECOMPATRI',
        istatCode: '012058060'
    },
    {
        name: 'MONTECOPIOLO',
        istatCode: '011041033'
    },
    {
        name: 'MONTECOPIOLO',
        istatCode: '008099030'
    },
    {
        name: 'MONTECORICE',
        istatCode: '015065071'
    },
    {
        name: 'MONTECORVINO PUGLIANO',
        istatCode: '015065072'
    },
    {
        name: 'MONTECORVINO ROVELLA',
        istatCode: '015065073'
    },
    {
        name: 'MONTECOSARO',
        istatCode: '011043028'
    },
    {
        name: 'MONTECRESTESE',
        istatCode: '001103046'
    },
    {
        name: 'MONTECRETO',
        istatCode: '008036024'
    },
    {
        name: 'MONTEDINOVE',
        istatCode: '011044034'
    },
    {
        name: 'MONTEDORO',
        istatCode: '019085011'
    },
    {
        name: 'MONTEFALCIONE',
        istatCode: '015064053'
    },
    {
        name: 'MONTEFALCO',
        istatCode: '010054030'
    },
    {
        name: 'MONTEFALCONE APPENNINO',
        istatCode: '011109014'
    },
    {
        name: 'MONTEFALCONE DI VAL FORTORE',
        istatCode: '015062042'
    },
    {
        name: 'MONTEFALCONE NEL SANNIO',
        istatCode: '014070043'
    },
    {
        name: 'MONTEFANO',
        istatCode: '011043029'
    },
    {
        name: 'MONTEFELCINO',
        istatCode: '011041034'
    },
    {
        name: 'MONTEFERRANTE',
        istatCode: '013069052'
    },
    {
        name: 'MONTEFIASCONE',
        istatCode: '012056036'
    },
    {
        name: 'MONTEFINO',
        istatCode: '013067027'
    },
    {
        name: 'MONTEFIORE CONCA',
        istatCode: '008099008'
    },
    {
        name: 'MONTEFIORE DELL\'ASO',
        istatCode: '011044036'
    },
    {
        name: 'MONTEFIORINO',
        istatCode: '008036025'
    },
    {
        name: 'MONTEFLAVIO',
        istatCode: '012058061'
    },
    {
        name: 'MONTEFORTE CILENTO',
        istatCode: '015065074'
    },
    {
        name: 'MONTEFORTE D\'ALPONE',
        istatCode: '005023050'
    },
    {
        name: 'MONTEFORTE IRPINO',
        istatCode: '015064054'
    },
    {
        name: 'MONTEFORTINO',
        istatCode: '011109015'
    },
    {
        name: 'MONTEFRANCO',
        istatCode: '010055019'
    },
    {
        name: 'MONTEFREDANE',
        istatCode: '015064055'
    },
    {
        name: 'MONTEFUSCO',
        istatCode: '015064056'
    },
    {
        name: 'MONTEGABBIONE',
        istatCode: '010055020'
    },
    {
        name: 'MONTEGALDA',
        istatCode: '005024064'
    },
    {
        name: 'MONTEGALDELLA',
        istatCode: '005024065'
    },
    {
        name: 'MONTEGALLO',
        istatCode: '011044038'
    },
    {
        name: 'MONTEGIOCO',
        istatCode: '001006107'
    },
    {
        name: 'MONTEGIORDANO',
        istatCode: '018078082'
    },
    {
        name: 'MONTEGIORGIO',
        istatCode: '011109017'
    },
    {
        name: 'MONTEGRANARO',
        istatCode: '011109018'
    },
    {
        name: 'MONTEGRIDOLFO',
        istatCode: '008099009'
    },
    {
        name: 'MONTEGRIMANO',
        istatCode: '011041035'
    },
    {
        name: 'MONTEGRINO VALTRAVAGLIA',
        istatCode: '003012103'
    },
    {
        name: 'MONTEGROSSO D\'ASTI',
        istatCode: '001005076'
    },
    {
        name: 'MONTEGROSSO PIAN LATTE',
        istatCode: '007008037'
    },
    {
        name: 'MONTEGROTTO TERME',
        istatCode: '005028057'
    },
    {
        name: 'MONTEIASI',
        istatCode: '016073016'
    },
    {
        name: 'MONTELABBATE',
        istatCode: '011041036'
    },
    {
        name: 'MONTELANICO',
        istatCode: '012058062'
    },
    {
        name: 'MONTELAPIANO',
        istatCode: '013069053'
    },
    {
        name: 'MONTELEONE DI FERMO',
        istatCode: '011109019'
    },
    {
        name: 'MONTELEONE DI PUGLIA',
        istatCode: '016071032'
    },
    {
        name: 'MONTELEONE DI SPOLETO',
        istatCode: '010054031'
    },
    {
        name: 'MONTELEONE D\'ORVIETO',
        istatCode: '010055021'
    },
    {
        name: 'MONTELEONE ROCCA DORIA',
        istatCode: '020090040'
    },
    {
        name: 'MONTELEONE SABINO',
        istatCode: '012057041'
    },
    {
        name: 'MONTELEPRE',
        istatCode: '019082050'
    },
    {
        name: 'MONTELIBRETTI',
        istatCode: '012058063'
    },
    {
        name: 'MONTELLA',
        istatCode: '015064057'
    },
    {
        name: 'MONTELLO',
        istatCode: '003016139'
    },
    {
        name: 'MONTELONGO',
        istatCode: '014070044'
    },
    {
        name: 'MONTELPARO',
        istatCode: '011109020'
    },
    {
        name: 'MONTELUPO ALBESE',
        istatCode: '001004137'
    },
    {
        name: 'MONTELUPO FIORENTINO',
        istatCode: '009048028'
    },
    {
        name: 'MONTELUPONE',
        istatCode: '011043030'
    },
    {
        name: 'MONTEMAGGIORE AL METAURO',
        istatCode: '011041037'
    },
    {
        name: 'MONTEMAGGIORE BELSITO',
        istatCode: '019082051'
    },
    {
        name: 'MONTEMAGNO',
        istatCode: '001005077'
    },
    {
        name: 'MONTEMALE DI CUNEO',
        istatCode: '001004138'
    },
    {
        name: 'MONTEMARANO',
        istatCode: '015064058'
    },
    {
        name: 'MONTEMARCIANO',
        istatCode: '011042027'
    },
    {
        name: 'MONTEMARZINO',
        istatCode: '001006108'
    },
    {
        name: 'MONTEMESOLA',
        istatCode: '016073017'
    },
    {
        name: 'MONTEMEZZO',
        istatCode: '003013155'
    },
    {
        name: 'MONTEMIGNAIO',
        istatCode: '009051023'
    },
    {
        name: 'MONTEMILETTO',
        istatCode: '015064059'
    },
    {
        name: 'MONTEMILONE',
        istatCode: '017076051'
    },
    {
        name: 'MONTEMITRO',
        istatCode: '014070045'
    },
    {
        name: 'MONTEMONACO',
        istatCode: '011044044'
    },
    {
        name: 'MONTEMURLO',
        istatCode: '009100003'
    },
    {
        name: 'MONTEMURRO',
        istatCode: '017076052'
    },
    {
        name: 'MONTENARS',
        istatCode: '006030061'
    },
    {
        name: 'MONTENERO DI BISACCIA',
        istatCode: '014070046'
    },
    {
        name: 'MONTENERO SABINO',
        istatCode: '012057042'
    },
    {
        name: 'MONTENERO VAL COCCHIARA',
        istatCode: '014094029'
    },
    {
        name: 'MONTENERODOMO',
        istatCode: '013069054'
    },
    {
        name: 'MONTEODORISIO',
        istatCode: '013069055'
    },
    {
        name: 'MONTEPAONE',
        istatCode: '018079081'
    },
    {
        name: 'MONTEPARANO',
        istatCode: '016073018'
    },
    {
        name: 'MONTEPRANDONE',
        istatCode: '011044045'
    },
    {
        name: 'MONTEPULCIANO',
        istatCode: '009052015'
    },
    {
        name: 'MONTERADO',
        istatCode: '011042028'
    },
    {
        name: 'MONTERCHI',
        istatCode: '009051024'
    },
    {
        name: 'MONTEREALE',
        istatCode: '013066056'
    },
    {
        name: 'MONTEREALE VALCELLINA',
        istatCode: '006093027'
    },
    {
        name: 'MONTERENZIO',
        istatCode: '008037041'
    },
    {
        name: 'MONTERIGGIONI',
        istatCode: '009052016'
    },
    {
        name: 'MONTERODUNI',
        istatCode: '014094030'
    },
    {
        name: 'MONTERONI D\'ARBIA',
        istatCode: '009052017'
    },
    {
        name: 'MONTERONI DI LECCE',
        istatCode: '016075048'
    },
    {
        name: 'MONTEROSI',
        istatCode: '012056038'
    },
    {
        name: 'MONTEROSSO AL MARE',
        istatCode: '007011019'
    },
    {
        name: 'MONTEROSSO ALMO',
        istatCode: '019088007'
    },
    {
        name: 'MONTEROSSO CALABRO',
        istatCode: '018102023'
    },
    {
        name: 'MONTEROSSO GRANA',
        istatCode: '001004139'
    },
    {
        name: 'MONTEROTONDO',
        istatCode: '012058065'
    },
    {
        name: 'MONTEROTONDO MARITTIMO',
        istatCode: '009053027'
    },
    {
        name: 'MONTERUBBIANO',
        istatCode: '011109022'
    },
    {
        name: 'MONTESANO SALENTINO',
        istatCode: '016075049'
    },
    {
        name: 'MONTESANO SULLA MARCELLANA',
        istatCode: '015065076'
    },
    {
        name: 'MONTESARCHIO',
        istatCode: '015062043'
    },
    {
        name: 'MONTESCAGLIOSO',
        istatCode: '017077017'
    },
    {
        name: 'MONTESCANO',
        istatCode: '003018097'
    },
    {
        name: 'MONTESCHENO',
        istatCode: '001103047'
    },
    {
        name: 'MONTESCUDAIO',
        istatCode: '009050020'
    },
    {
        name: 'MONTESCUDO',
        istatCode: '008099010'
    },
    {
        name: 'MONTESCUDO-MONTE COLOMBO',
        istatCode: '008099029'
    },
    {
        name: 'MONTESE',
        istatCode: '008036026'
    },
    {
        name: 'MONTESEGALE',
        istatCode: '003018098'
    },
    {
        name: 'MONTESILVANO',
        istatCode: '013068024'
    },
    {
        name: 'MONTESPERTOLI',
        istatCode: '009048030'
    },
    {
        name: 'MONTEU DA PO',
        istatCode: '001001162'
    },
    {
        name: 'MONTEU ROERO',
        istatCode: '001004140'
    },
    {
        name: 'MONTEVAGO',
        istatCode: '019084025'
    },
    {
        name: 'MONTEVARCHI',
        istatCode: '009051026'
    },
    {
        name: 'MONTEVECCHIA',
        istatCode: '003097053'
    },
    {
        name: 'MONTEVEGLIO',
        istatCode: '008037043'
    },
    {
        name: 'MONTEVERDE',
        istatCode: '015064060'
    },
    {
        name: 'MONTEVERDI MARITTIMO',
        istatCode: '009050021'
    },
    {
        name: 'MONTEVIALE',
        istatCode: '005024066'
    },
    {
        name: 'MONTEZEMOLO',
        istatCode: '001004141'
    },
    {
        name: 'MONTI',
        istatCode: '020090041'
    },
    {
        name: 'MONTIANO',
        istatCode: '008040028'
    },
    {
        name: 'MONTICELLI BRUSATI',
        istatCode: '003017112'
    },
    {
        name: 'MONTICELLI D\'ONGINA',
        istatCode: '008033027'
    },
    {
        name: 'MONTICELLI PAVESE',
        istatCode: '003018099'
    },
    {
        name: 'MONTICELLO BRIANZA',
        istatCode: '003097054'
    },
    {
        name: 'MONTICELLO CONTE OTTO',
        istatCode: '005024067'
    },
    {
        name: 'MONTICELLO D\'ALBA',
        istatCode: '001004142'
    },
    {
        name: 'MONTICHIARI',
        istatCode: '003017113'
    },
    {
        name: 'MONTICIANO',
        istatCode: '009052018'
    },
    {
        name: 'MONTIERI',
        istatCode: '009053017'
    },
    {
        name: 'MONTIGLIO',
        istatCode: '001005078'
    },
    {
        name: 'MONTIGLIO MONFERRATO',
        istatCode: '001005121'
    },
    {
        name: 'MONTIGNOSO',
        istatCode: '009045011'
    },
    {
        name: 'MONTIRONE',
        istatCode: '003017114'
    },
    {
        name: 'MONTJOVET',
        istatCode: '002007043'
    },
    {
        name: 'MONTODINE',
        istatCode: '003019059'
    },
    {
        name: 'MONTOGGIO',
        istatCode: '007010039'
    },
    {
        name: 'MONTONE',
        istatCode: '010054033'
    },
    {
        name: 'MONTOPOLI DI SABINA',
        istatCode: '012057044'
    },
    {
        name: 'MONTOPOLI IN VAL D\'ARNO',
        istatCode: '009050022'
    },
    {
        name: 'MONTORFANO',
        istatCode: '003013157'
    },
    {
        name: 'MONTORIO AL VOMANO',
        istatCode: '013067028'
    },
    {
        name: 'MONTORIO NEI FRENTANI',
        istatCode: '014070047'
    },
    {
        name: 'MONTORIO ROMANO',
        istatCode: '012058066'
    },
    {
        name: 'MONTORIO VERONESE',
        istatCode: '005023811'
    },
    {
        name: 'MONTORO',
        istatCode: '015064121'
    },
    {
        name: 'MONTORO INFERIORE',
        istatCode: '015064061'
    },
    {
        name: 'MONTORO SUPERIORE',
        istatCode: '015064062'
    },
    {
        name: 'MONTORSO VICENTINO',
        istatCode: '005024068'
    },
    {
        name: 'MONTOTTONE',
        istatCode: '011109027'
    },
    {
        name: 'MONTRESTA',
        istatCode: '020095085'
    },
    {
        name: 'MONTU\' BECCARIA',
        istatCode: '003018100'
    },
    {
        name: 'MONVALLE',
        istatCode: '003012104'
    },
    {
        name: 'MONZA',
        istatCode: '003108033'
    },
    {
        name: 'MONZAMBANO',
        istatCode: '003020036'
    },
    {
        name: 'MONZUNO',
        istatCode: '008037044'
    },
    {
        name: 'MORANO CALABRO',
        istatCode: '018078083'
    },
    {
        name: 'MORANO SUL PO',
        istatCode: '001006109'
    },
    {
        name: 'MORANSENGO',
        istatCode: '001005079'
    },
    {
        name: 'MORARO',
        istatCode: '006031013'
    },
    {
        name: 'MORAZZONE',
        istatCode: '003012105'
    },
    {
        name: 'MORBEGNO',
        istatCode: '003014045'
    },
    {
        name: 'MORBELLO',
        istatCode: '001006110'
    },
    {
        name: 'MORCIANO DI LEUCA',
        istatCode: '016075050'
    },
    {
        name: 'MORCIANO DI ROMAGNA',
        istatCode: '008099011'
    },
    {
        name: 'MORCONE',
        istatCode: '015062044'
    },
    {
        name: 'MORDANO',
        istatCode: '008037045'
    },
    {
        name: 'MORENGO',
        istatCode: '003016140'
    },
    {
        name: 'MORES',
        istatCode: '020090042'
    },
    {
        name: 'MORESCO',
        istatCode: '011109028'
    },
    {
        name: 'MORETTA',
        istatCode: '001004143'
    },
    {
        name: 'MORFASSO',
        istatCode: '008033028'
    },
    {
        name: 'MORGANO',
        istatCode: '005026047'
    },
    {
        name: 'MORGEX',
        istatCode: '002007044'
    },
    {
        name: 'MORGONGIORI',
        istatCode: '020095030'
    },
    {
        name: 'MORI',
        istatCode: '004022123'
    },
    {
        name: 'MORIAGO DELLA BATTAGLIA',
        istatCode: '005026048'
    },
    {
        name: 'MORICONE',
        istatCode: '012058067'
    },
    {
        name: 'MORIGERATI',
        istatCode: '015065077'
    },
    {
        name: 'MORIMONDO',
        istatCode: '003015150'
    },
    {
        name: 'MORINO',
        istatCode: '013066057'
    },
    {
        name: 'MORIONDO TORINESE',
        istatCode: '001001163'
    },
    {
        name: 'MORLUPO',
        istatCode: '012058068'
    },
    {
        name: 'MORMANNO',
        istatCode: '018078084'
    },
    {
        name: 'MORNAGO',
        istatCode: '003012106'
    },
    {
        name: 'MORNESE',
        istatCode: '001006111'
    },
    {
        name: 'MORNICO AL SERIO',
        istatCode: '003016141'
    },
    {
        name: 'MORNICO LOSANA',
        istatCode: '003018101'
    },
    {
        name: 'MOROLO',
        istatCode: '012060045'
    },
    {
        name: 'MOROZZO',
        istatCode: '001004144'
    },
    {
        name: 'MORRA DE SANCTIS',
        istatCode: '015064063'
    },
    {
        name: 'MORRO D\'ALBA',
        istatCode: '011042031'
    },
    {
        name: 'MORRO D\'ORO',
        istatCode: '013067029'
    },
    {
        name: 'MORRO REATINO',
        istatCode: '012057045'
    },
    {
        name: 'MORRONE DEL SANNIO',
        istatCode: '014070048'
    },
    {
        name: 'MORROVALLE',
        istatCode: '011043033'
    },
    {
        name: 'MORSANO AL TAGLIAMENTO',
        istatCode: '006093028'
    },
    {
        name: 'MORSASCO',
        istatCode: '001006112'
    },
    {
        name: 'MORTARA',
        istatCode: '003018102'
    },
    {
        name: 'MORTEGLIANO',
        istatCode: '006030062'
    },
    {
        name: 'MORTERONE',
        istatCode: '003097055'
    },
    {
        name: 'MORUZZO',
        istatCode: '006030063'
    },
    {
        name: 'MOSCAZZANO',
        istatCode: '003019060'
    },
    {
        name: 'MOSCHIANO',
        istatCode: '015064064'
    },
    {
        name: 'MOSCIANO SANT\'ANGELO',
        istatCode: '013067030'
    },
    {
        name: 'MOSCUFO',
        istatCode: '013068025'
    },
    {
        name: 'MOSO IN PASSIRIA - MOOS IN PASSEIER',
        istatCode: '004021054'
    },
    {
        name: 'MOSSA',
        istatCode: '006031014'
    },
    {
        name: 'MOSSANO',
        istatCode: '005024069'
    },
    {
        name: 'MOSSO',
        istatCode: '001096084'
    },
    {
        name: 'MOSSO SANTA MARIA',
        istatCode: '001096036'
    },
    {
        name: 'MOTTA BALUFFI',
        istatCode: '003019061'
    },
    {
        name: 'MOTTA CAMASTRA',
        istatCode: '019083058'
    },
    {
        name: 'MOTTA D\'AFFERMO',
        istatCode: '019083059'
    },
    {
        name: 'MOTTA DE\' CONTI',
        istatCode: '001002082'
    },
    {
        name: 'MOTTA DI LIVENZA',
        istatCode: '005026049'
    },
    {
        name: 'MOTTA MONTECORVINO',
        istatCode: '016071034'
    },
    {
        name: 'MOTTA SAN GIOVANNI',
        istatCode: '018080054'
    },
    {
        name: 'MOTTA SANTA LUCIA',
        istatCode: '018079083'
    },
    {
        name: 'MOTTA SANT\'ANASTASIA',
        istatCode: '019087030'
    },
    {
        name: 'MOTTA VISCONTI',
        istatCode: '003015151'
    },
    {
        name: 'MOTTAFOLLONE',
        istatCode: '018078085'
    },
    {
        name: 'MOTTALCIATA',
        istatCode: '001096037'
    },
    {
        name: 'MOTTEGGIANA',
        istatCode: '003020037'
    },
    {
        name: 'MOTTOLA',
        istatCode: '016073019'
    },
    {
        name: 'MOZZAGROGNA',
        istatCode: '013069056'
    },
    {
        name: 'MOZZANICA',
        istatCode: '003016142'
    },
    {
        name: 'MOZZATE',
        istatCode: '003013159'
    },
    {
        name: 'MOZZECANE',
        istatCode: '005023051'
    },
    {
        name: 'MOZZO',
        istatCode: '003016143'
    },
    {
        name: 'MU',
        istatCode: '003017862'
    },
    {
        name: 'MUCCIA',
        istatCode: '011043034'
    },
    {
        name: 'MUGGIA',
        istatCode: '006032003'
    },
    {
        name: 'MUGGIO\'',
        istatCode: '003108034'
    },
    {
        name: 'MUGNANO DEL CARDINALE',
        istatCode: '015064065'
    },
    {
        name: 'MUGNANO DI NAPOLI',
        istatCode: '015063048'
    },
    {
        name: 'MULAZZANO',
        istatCode: '003098041'
    },
    {
        name: 'MULAZZO',
        istatCode: '009045012'
    },
    {
        name: 'MURA',
        istatCode: '003017115'
    },
    {
        name: 'MURAVERA',
        istatCode: '020111042'
    },
    {
        name: 'MURAZZANO',
        istatCode: '001004145'
    },
    {
        name: 'MURELLO',
        istatCode: '001004146'
    },
    {
        name: 'MURIALDO',
        istatCode: '007009040'
    },
    {
        name: 'MURISENGO',
        istatCode: '001006113'
    },
    {
        name: 'MURLO',
        istatCode: '009052019'
    },
    {
        name: 'MURO LECCESE',
        istatCode: '016075051'
    },
    {
        name: 'MURO LUCANO',
        istatCode: '017076053'
    },
    {
        name: 'MUROS',
        istatCode: '020090043'
    },
    {
        name: 'MUSCOLINE',
        istatCode: '003017116'
    },
    {
        name: 'MUSEI',
        istatCode: '020111043'
    },
    {
        name: 'MUSILE DI PIAVE',
        istatCode: '005027025'
    },
    {
        name: 'MUSSO',
        istatCode: '003013160'
    },
    {
        name: 'MUSSOLENTE',
        istatCode: '005024070'
    },
    {
        name: 'MUSSOMELI',
        istatCode: '019085012'
    },
    {
        name: 'MUZZANA DEL TURGNANO',
        istatCode: '006030064'
    },
    {
        name: 'MUZZANO',
        istatCode: '001096038'
    },
    {
        name: 'NAGO-TORBOLE',
        istatCode: '004022124'
    },
    {
        name: 'NALLES - NALS',
        istatCode: '004021055'
    },
    {
        name: 'NANNO',
        istatCode: '004022125'
    },
    {
        name: 'NANTO',
        istatCode: '005024071'
    },
    {
        name: 'NAPOLI',
        istatCode: '015063049'
    },
    {
        name: 'NARBOLIA',
        istatCode: '020095031'
    },
    {
        name: 'NARCAO',
        istatCode: '020111044'
    },
    {
        name: 'NARDO\'',
        istatCode: '016075052'
    },
    {
        name: 'NARDODIPACE',
        istatCode: '018102024'
    },
    {
        name: 'NARNI',
        istatCode: '010055022'
    },
    {
        name: 'NARO',
        istatCode: '019084026'
    },
    {
        name: 'NARZOLE',
        istatCode: '001004147'
    },
    {
        name: 'NASINO',
        istatCode: '007009041'
    },
    {
        name: 'NASO',
        istatCode: '019083060'
    },
    {
        name: 'NATURNO - NATURNS',
        istatCode: '004021056'
    },
    {
        name: 'NAVE',
        istatCode: '003017117'
    },
    {
        name: 'NAVE SAN ROCCO',
        istatCode: '004022126'
    },
    {
        name: 'NAVELLI',
        istatCode: '013066058'
    },
    {
        name: 'NAZ-SCIAVES - NATZ-SCHABS',
        istatCode: '004021057'
    },
    {
        name: 'NAZZANO',
        istatCode: '012058069'
    },
    {
        name: 'NE',
        istatCode: '007010040'
    },
    {
        name: 'NEBBIUNO',
        istatCode: '001003103'
    },
    {
        name: 'NEGRAR',
        istatCode: '005023052'
    },
    {
        name: 'NEIRONE',
        istatCode: '007010041'
    },
    {
        name: 'NEIVE',
        istatCode: '001004148'
    },
    {
        name: 'NEMBRO',
        istatCode: '003016144'
    },
    {
        name: 'NEMI',
        istatCode: '012058070'
    },
    {
        name: 'NEMOLI',
        istatCode: '017076054'
    },
    {
        name: 'NEONELI',
        istatCode: '020095032'
    },
    {
        name: 'NEPI',
        istatCode: '012056039'
    },
    {
        name: 'NERETO',
        istatCode: '013067031'
    },
    {
        name: 'NEROLA',
        istatCode: '012058071'
    },
    {
        name: 'NERVESA DELLA BATTAGLIA',
        istatCode: '005026050'
    },
    {
        name: 'NERVIANO',
        istatCode: '003015154'
    },
    {
        name: 'NESPOLO',
        istatCode: '012057046'
    },
    {
        name: 'NESSO',
        istatCode: '003013161'
    },
    {
        name: 'NETRO',
        istatCode: '001096039'
    },
    {
        name: 'NETTUNIA',
        istatCode: '012058802'
    },
    {
        name: 'NETTUNO',
        istatCode: '012058072'
    },
    {
        name: 'NEVIANO',
        istatCode: '016075053'
    },
    {
        name: 'NEVIANO DEGLI ARDUINI',
        istatCode: '008034024'
    },
    {
        name: 'NEVIGLIE',
        istatCode: '001004149'
    },
    {
        name: 'NIARDO',
        istatCode: '003017118'
    },
    {
        name: 'NIBBIANO',
        istatCode: '008033029'
    },
    {
        name: 'NIBBIOLA',
        istatCode: '001003104'
    },
    {
        name: 'NIBIONNO',
        istatCode: '003097056'
    },
    {
        name: 'NICASTRO',
        istatCode: '018079085'
    },
    {
        name: 'NICHELINO',
        istatCode: '001001164'
    },
    {
        name: 'NICOLOSI',
        istatCode: '019087031'
    },
    {
        name: 'NICORVO',
        istatCode: '003018103'
    },
    {
        name: 'NICOSIA',
        istatCode: '019086012'
    },
    {
        name: 'NICOTERA',
        istatCode: '018102025'
    },
    {
        name: 'NIELLA BELBO',
        istatCode: '001004150'
    },
    {
        name: 'NIELLA TANARO',
        istatCode: '001004151'
    },
    {
        name: 'NIMIS',
        istatCode: '006030065'
    },
    {
        name: 'NISCEMI',
        istatCode: '019085013'
    },
    {
        name: 'NISSORIA',
        istatCode: '019086013'
    },
    {
        name: 'NIZZA DI SICILIA',
        istatCode: '019083061'
    },
    {
        name: 'NIZZA MONFERRATO',
        istatCode: '001005080'
    },
    {
        name: 'NOALE',
        istatCode: '005027026'
    },
    {
        name: 'NOASCA',
        istatCode: '001001165'
    },
    {
        name: 'NOCARA',
        istatCode: '018078086'
    },
    {
        name: 'NOCCIANO',
        istatCode: '013068026'
    },
    {
        name: 'NOCERA INFERIORE',
        istatCode: '015065078'
    },
    {
        name: 'NOCERA SUPERIORE',
        istatCode: '015065079'
    },
    {
        name: 'NOCERA TERINESE',
        istatCode: '018079087'
    },
    {
        name: 'NOCERA UMBRA',
        istatCode: '010054034'
    },
    {
        name: 'NOCETO',
        istatCode: '008034025'
    },
    {
        name: 'NOCI',
        istatCode: '016072031'
    },
    {
        name: 'NOCIGLIA',
        istatCode: '016075054'
    },
    {
        name: 'NOEPOLI',
        istatCode: '017076055'
    },
    {
        name: 'NOGARA',
        istatCode: '005023053'
    },
    {
        name: 'NOGAREDO',
        istatCode: '004022127'
    },
    {
        name: 'NOGAROLE ROCCA',
        istatCode: '005023054'
    },
    {
        name: 'NOGAROLE VICENTINO',
        istatCode: '005024072'
    },
    {
        name: 'NOICATTARO',
        istatCode: '016072032'
    },
    {
        name: 'NOLA',
        istatCode: '015063050'
    },
    {
        name: 'NOLE',
        istatCode: '001001166'
    },
    {
        name: 'NOLI',
        istatCode: '007009042'
    },
    {
        name: 'NOMAGLIO',
        istatCode: '001001167'
    },
    {
        name: 'NOMI',
        istatCode: '004022128'
    },
    {
        name: 'NONANTOLA',
        istatCode: '008036027'
    },
    {
        name: 'NONE',
        istatCode: '001001168'
    },
    {
        name: 'NONIO',
        istatCode: '001103048'
    },
    {
        name: 'NORAGUGUME',
        istatCode: '020091050'
    },
    {
        name: 'NORBELLO',
        istatCode: '020095033'
    },
    {
        name: 'NORCIA',
        istatCode: '010054035'
    },
    {
        name: 'NORIGLIO',
        istatCode: '004022880'
    },
    {
        name: 'NORMA',
        istatCode: '012059016'
    },
    {
        name: 'NOSATE',
        istatCode: '003015155'
    },
    {
        name: 'NOTARESCO',
        istatCode: '013067032'
    },
    {
        name: 'NOTO',
        istatCode: '019089013'
    },
    {
        name: 'NOVA LEVANTE - WELSCHNOFEN',
        istatCode: '004021058'
    },
    {
        name: 'NOVA MILANESE',
        istatCode: '003108035'
    },
    {
        name: 'NOVA PONENTE - DEUTSCHNOFEN',
        istatCode: '004021059'
    },
    {
        name: 'NOVA SIRI',
        istatCode: '017077018'
    },
    {
        name: 'NOVAFELTRIA',
        istatCode: '008099023'
    },
    {
        name: 'NOVALEDO',
        istatCode: '004022129'
    },
    {
        name: 'NOVALESA',
        istatCode: '001001169'
    },
    {
        name: 'NOVARA',
        istatCode: '001003106'
    },
    {
        name: 'NOVARA DI SICILIA',
        istatCode: '019083062'
    },
    {
        name: 'NOVATE MEZZOLA',
        istatCode: '003014046'
    },
    {
        name: 'NOVATE MILANESE',
        istatCode: '003015157'
    },
    {
        name: 'NOVE',
        istatCode: '005024073'
    },
    {
        name: 'NOVEDRATE',
        istatCode: '003013163'
    },
    {
        name: 'NOVELLA',
        istatCode: '004022253'
    },
    {
        name: 'NOVELLARA',
        istatCode: '008035028'
    },
    {
        name: 'NOVELLO',
        istatCode: '001004152'
    },
    {
        name: 'NOVENTA DI PIAVE',
        istatCode: '005027027'
    },
    {
        name: 'NOVENTA PADOVANA',
        istatCode: '005028058'
    },
    {
        name: 'NOVENTA VICENTINA',
        istatCode: '005024074'
    },
    {
        name: 'NOVI DI MODENA',
        istatCode: '008036028'
    },
    {
        name: 'NOVI LIGURE',
        istatCode: '001006114'
    },
    {
        name: 'NOVI VELIA',
        istatCode: '015065080'
    },
    {
        name: 'NOVIGLIO',
        istatCode: '003015158'
    },
    {
        name: 'NOVOLI',
        istatCode: '016075055'
    },
    {
        name: 'NUCETTO',
        istatCode: '001004153'
    },
    {
        name: 'NUGHEDU SAN NICOLO\'',
        istatCode: '020090044'
    },
    {
        name: 'NUGHEDU SANTA VITTORIA',
        istatCode: '020095034'
    },
    {
        name: 'NULE',
        istatCode: '020090045'
    },
    {
        name: 'NULVI',
        istatCode: '020090046'
    },
    {
        name: 'NUMANA',
        istatCode: '011042032'
    },
    {
        name: 'NUORO',
        istatCode: '020091051'
    },
    {
        name: 'NURACHI',
        istatCode: '020095035'
    },
    {
        name: 'NURAGUS',
        istatCode: '020111045'
    },
    {
        name: 'NURALLAO',
        istatCode: '020111046'
    },
    {
        name: 'NURAMINIS',
        istatCode: '020111047'
    },
    {
        name: 'NURECI',
        istatCode: '020095036'
    },
    {
        name: 'NURRI',
        istatCode: '020111048'
    },
    {
        name: 'NUS',
        istatCode: '002007045'
    },
    {
        name: 'NUSCO',
        istatCode: '015064066'
    },
    {
        name: 'NUVOLENTO',
        istatCode: '003017119'
    },
    {
        name: 'NUVOLERA',
        istatCode: '003017120'
    },
    {
        name: 'NUXIS',
        istatCode: '020111049'
    },
    {
        name: 'OCCHIEPPO INFERIORE',
        istatCode: '001096040'
    },
    {
        name: 'OCCHIEPPO SUPERIORE',
        istatCode: '001096041'
    },
    {
        name: 'OCCHIOBELLO',
        istatCode: '005029033'
    },
    {
        name: 'OCCIMIANO',
        istatCode: '001006115'
    },
    {
        name: 'OCRE',
        istatCode: '013066059'
    },
    {
        name: 'ODALENGO GRANDE',
        istatCode: '001006116'
    },
    {
        name: 'ODALENGO PICCOLO',
        istatCode: '001006117'
    },
    {
        name: 'ODERZO',
        istatCode: '005026051'
    },
    {
        name: 'ODOLO',
        istatCode: '003017121'
    },
    {
        name: 'OFENA',
        istatCode: '013066060'
    },
    {
        name: 'OFFAGNA',
        istatCode: '011042033'
    },
    {
        name: 'OFFANENGO',
        istatCode: '003019062'
    },
    {
        name: 'OFFIDA',
        istatCode: '011044054'
    },
    {
        name: 'OFFLAGA',
        istatCode: '003017122'
    },
    {
        name: 'OGGEBBIO',
        istatCode: '001103049'
    },
    {
        name: 'OGGIONA CON SANTO STEFANO',
        istatCode: '003012107'
    },
    {
        name: 'OGGIONO',
        istatCode: '003097057'
    },
    {
        name: 'OGLIANICO',
        istatCode: '001001170'
    },
    {
        name: 'OGLIASTRO CILENTO',
        istatCode: '015065081'
    },
    {
        name: 'OLBIA',
        istatCode: '020090047'
    },
    {
        name: 'OLCENENGO',
        istatCode: '001002088'
    },
    {
        name: 'OLDENICO',
        istatCode: '001002089'
    },
    {
        name: 'OLEGGIO',
        istatCode: '001003108'
    },
    {
        name: 'OLEGGIO CASTELLO',
        istatCode: '001003109'
    },
    {
        name: 'OLEVANO DI LOMELLINA',
        istatCode: '003018104'
    },
    {
        name: 'OLEVANO ROMANO',
        istatCode: '012058073'
    },
    {
        name: 'OLEVANO SUL TUSCIANO',
        istatCode: '015065082'
    },
    {
        name: 'OLGIATE CALCO',
        istatCode: '003097507'
    },
    {
        name: 'OLGIATE COMASCO',
        istatCode: '003013165'
    },
    {
        name: 'OLGIATE MOLGORA',
        istatCode: '003097058'
    },
    {
        name: 'OLGIATE OLONA',
        istatCode: '003012108'
    },
    {
        name: 'OLGINATE',
        istatCode: '003097059'
    },
    {
        name: 'OLIENA',
        istatCode: '020091055'
    },
    {
        name: 'OLIVA GESSI',
        istatCode: '003018105'
    },
    {
        name: 'OLIVADI',
        istatCode: '018079088'
    },
    {
        name: 'OLIVERI',
        istatCode: '019083063'
    },
    {
        name: 'OLIVETO CITRA',
        istatCode: '015065083'
    },
    {
        name: 'OLIVETO LARIO',
        istatCode: '003097060'
    },
    {
        name: 'OLIVETO LUCANO',
        istatCode: '017077019'
    },
    {
        name: 'OLIVETTA SAN MICHELE',
        istatCode: '007008038'
    },
    {
        name: 'OLIVOLA',
        istatCode: '001006118'
    },
    {
        name: 'OLLASTRA',
        istatCode: '020095037'
    },
    {
        name: 'OLLOLAI',
        istatCode: '020091056'
    },
    {
        name: 'OLLOMONT',
        istatCode: '002007046'
    },
    {
        name: 'OLMEDO',
        istatCode: '020090048'
    },
    {
        name: 'OLMENETA',
        istatCode: '003019063'
    },
    {
        name: 'OLMO AL BREMBO',
        istatCode: '003016145'
    },
    {
        name: 'OLMO GENTILE',
        istatCode: '001005081'
    },
    {
        name: 'OLTRE IL COLLE',
        istatCode: '003016146'
    },
    {
        name: 'OLTRESSENDA ALTA',
        istatCode: '003016147'
    },
    {
        name: 'OLTRONA DI SAN MAMETTE',
        istatCode: '003013169'
    },
    {
        name: 'OLZAI',
        istatCode: '020091057'
    },
    {
        name: 'OME',
        istatCode: '003017123'
    },
    {
        name: 'OMEGNA',
        istatCode: '001103050'
    },
    {
        name: 'OMIGNANO',
        istatCode: '015065084'
    },
    {
        name: 'ONANI',
        istatCode: '020091058'
    },
    {
        name: 'ONANO',
        istatCode: '012056040'
    },
    {
        name: 'ONCINO',
        istatCode: '001004154'
    },
    {
        name: 'ONETA',
        istatCode: '003016148'
    },
    {
        name: 'ONIFAI',
        istatCode: '020091059'
    },
    {
        name: 'ONIFERI',
        istatCode: '020091060'
    },
    {
        name: 'ONO SAN PIETRO',
        istatCode: '003017124'
    },
    {
        name: 'ONORE',
        istatCode: '003016149'
    },
    {
        name: 'ONZO',
        istatCode: '007009043'
    },
    {
        name: 'OPERA',
        istatCode: '003015159'
    },
    {
        name: 'OPI',
        istatCode: '013066061'
    },
    {
        name: 'OPPEANO',
        istatCode: '005023055'
    },
    {
        name: 'OPPIDO LUCANO',
        istatCode: '017076056'
    },
    {
        name: 'OPPIDO MAMERTINA',
        istatCode: '018080055'
    },
    {
        name: 'ORA - AUER',
        istatCode: '004021060'
    },
    {
        name: 'ORANI',
        istatCode: '020091061'
    },
    {
        name: 'ORATINO',
        istatCode: '014070049'
    },
    {
        name: 'ORBASSANO',
        istatCode: '001001171'
    },
    {
        name: 'ORBETELLO',
        istatCode: '009053018'
    },
    {
        name: 'ORCIANO DI PESARO',
        istatCode: '011041040'
    },
    {
        name: 'ORCIANO PISANO',
        istatCode: '009050023'
    },
    {
        name: 'ORCO FEGLINO',
        istatCode: '007009044'
    },
    {
        name: 'ORDONA',
        istatCode: '016071063'
    },
    {
        name: 'ORERO',
        istatCode: '007010042'
    },
    {
        name: 'ORGIANO',
        istatCode: '005024075'
    },
    {
        name: 'ORGOSOLO',
        istatCode: '020091062'
    },
    {
        name: 'ORIA',
        istatCode: '016074011'
    },
    {
        name: 'ORICOLA',
        istatCode: '013066062'
    },
    {
        name: 'ORIGGIO',
        istatCode: '003012109'
    },
    {
        name: 'ORINO',
        istatCode: '003012110'
    },
    {
        name: 'ORINO-AZZIO',
        istatCode: '003012876'
    },
    {
        name: 'ORIO AL SERIO',
        istatCode: '003016150'
    },
    {
        name: 'ORIO CANAVESE',
        istatCode: '001001172'
    },
    {
        name: 'ORIO LITTA',
        istatCode: '003098042'
    },
    {
        name: 'ORIOLO',
        istatCode: '018078087'
    },
    {
        name: 'ORIOLO ROMANO',
        istatCode: '012056041'
    },
    {
        name: 'ORISTANO',
        istatCode: '020095038'
    },
    {
        name: 'ORMEA',
        istatCode: '001004155'
    },
    {
        name: 'ORMELLE',
        istatCode: '005026052'
    },
    {
        name: 'ORNAGO',
        istatCode: '003108036'
    },
    {
        name: 'ORNAVASSO',
        istatCode: '001103051'
    },
    {
        name: 'ORNICA',
        istatCode: '003016151'
    },
    {
        name: 'OROSEI',
        istatCode: '020091063'
    },
    {
        name: 'OROTELLI',
        istatCode: '020091064'
    },
    {
        name: 'ORRIA',
        istatCode: '015065085'
    },
    {
        name: 'ORROLI',
        istatCode: '020111050'
    },
    {
        name: 'ORSAGO',
        istatCode: '005026053'
    },
    {
        name: 'ORSARA BORMIDA',
        istatCode: '001006119'
    },
    {
        name: 'ORSARA DI PUGLIA',
        istatCode: '016071035'
    },
    {
        name: 'ORSENIGO',
        istatCode: '003013170'
    },
    {
        name: 'ORSOGNA',
        istatCode: '013069057'
    },
    {
        name: 'ORSOMARSO',
        istatCode: '018078088'
    },
    {
        name: 'ORTA DI ATELLA',
        istatCode: '015061053'
    },
    {
        name: 'ORTA NOVA',
        istatCode: '016071036'
    },
    {
        name: 'ORTA SAN GIULIO',
        istatCode: '001003112'
    },
    {
        name: 'ORTACESUS',
        istatCode: '020111051'
    },
    {
        name: 'ORTE',
        istatCode: '012056042'
    },
    {
        name: 'ORTELLE',
        istatCode: '016075056'
    },
    {
        name: 'ORTEZZANO',
        istatCode: '011109029'
    },
    {
        name: 'ORTIGNANO RAGGIOLO',
        istatCode: '009051027'
    },
    {
        name: 'ORTISEI - ST. ULRICH',
        istatCode: '004021061'
    },
    {
        name: 'ORTONA',
        istatCode: '013069058'
    },
    {
        name: 'ORTONA DEI MARSI',
        istatCode: '013066063'
    },
    {
        name: 'ORTONOVO',
        istatCode: '007011020'
    },
    {
        name: 'ORTOVERO',
        istatCode: '007009045'
    },
    {
        name: 'ORTUCCHIO',
        istatCode: '013066064'
    },
    {
        name: 'ORTUERI',
        istatCode: '020091066'
    },
    {
        name: 'ORUNE',
        istatCode: '020091067'
    },
    {
        name: 'ORVIETO',
        istatCode: '010055023'
    },
    {
        name: 'ORVINIO',
        istatCode: '012057047'
    },
    {
        name: 'ORZINUOVI',
        istatCode: '003017125'
    },
    {
        name: 'ORZIVECCHI',
        istatCode: '003017126'
    },
    {
        name: 'OSASCO',
        istatCode: '001001173'
    },
    {
        name: 'OSASIO',
        istatCode: '001001174'
    },
    {
        name: 'OSCHIRI',
        istatCode: '020090049'
    },
    {
        name: 'OSIDDA',
        istatCode: '020091068'
    },
    {
        name: 'OSIGLIA',
        istatCode: '007009046'
    },
    {
        name: 'OSILO',
        istatCode: '020090050'
    },
    {
        name: 'OSIMO',
        istatCode: '011042034'
    },
    {
        name: 'OSINI',
        istatCode: '020091069'
    },
    {
        name: 'OSIO SOPRA',
        istatCode: '003016152'
    },
    {
        name: 'OSIO SOTTO',
        istatCode: '003016153'
    },
    {
        name: 'OSMATE',
        istatCode: '003012111'
    },
    {
        name: 'OSNAGO',
        istatCode: '003097061'
    },
    {
        name: 'OSOPPO',
        istatCode: '006030066'
    },
    {
        name: 'OSPEDALETTI',
        istatCode: '007008039'
    },
    {
        name: 'OSPEDALETTO',
        istatCode: '004022130'
    },
    {
        name: 'OSPEDALETTO D\'ALPINOLO',
        istatCode: '015064067'
    },
    {
        name: 'OSPEDALETTO EUGANEO',
        istatCode: '005028059'
    },
    {
        name: 'OSPEDALETTO LODIGIANO',
        istatCode: '003098043'
    },
    {
        name: 'OSPITALE DI CADORE',
        istatCode: '005025035'
    },
    {
        name: 'OSPITALETTO',
        istatCode: '003017127'
    },
    {
        name: 'OSSAGO LODIGIANO',
        istatCode: '003098044'
    },
    {
        name: 'OSSANA',
        istatCode: '004022131'
    },
    {
        name: 'OSSI',
        istatCode: '020090051'
    },
    {
        name: 'OSSIMO',
        istatCode: '003017128'
    },
    {
        name: 'OSSONA',
        istatCode: '003015164'
    },
    {
        name: 'OSSUCCIO',
        istatCode: '003013172'
    },
    {
        name: 'OSTANA',
        istatCode: '001004156'
    },
    {
        name: 'OSTELLATO',
        istatCode: '008038017'
    },
    {
        name: 'OSTIANO',
        istatCode: '003019064'
    },
    {
        name: 'OSTIGLIA',
        istatCode: '003020038'
    },
    {
        name: 'OSTRA',
        istatCode: '011042035'
    },
    {
        name: 'OSTRA VETERE',
        istatCode: '011042036'
    },
    {
        name: 'OSTUNI',
        istatCode: '016074012'
    },
    {
        name: 'OTRANTO',
        istatCode: '016075057'
    },
    {
        name: 'OTRICOLI',
        istatCode: '010055024'
    },
    {
        name: 'OTTANA',
        istatCode: '020091070'
    },
    {
        name: 'OTTATI',
        istatCode: '015065086'
    },
    {
        name: 'OTTAVIANO',
        istatCode: '015063051'
    },
    {
        name: 'OTTIGLIO',
        istatCode: '001006120'
    },
    {
        name: 'OTTOBIANO',
        istatCode: '003018106'
    },
    {
        name: 'OTTONE',
        istatCode: '008033030'
    },
    {
        name: 'OULX',
        istatCode: '001001175'
    },
    {
        name: 'OVADA',
        istatCode: '001006121'
    },
    {
        name: 'OVARO',
        istatCode: '006030067'
    },
    {
        name: 'OVIGLIO',
        istatCode: '001006122'
    },
    {
        name: 'OVINDOLI',
        istatCode: '013066065'
    },
    {
        name: 'OVODDA',
        istatCode: '020091071'
    },
    {
        name: 'OYACE',
        istatCode: '002007047'
    },
    {
        name: 'OZEGNA',
        istatCode: '001001176'
    },
    {
        name: 'OZIERI',
        istatCode: '020090052'
    },
    {
        name: 'OZZANO DELL\'EMILIA',
        istatCode: '008037046'
    },
    {
        name: 'OZZANO MONFERRATO',
        istatCode: '001006123'
    },
    {
        name: 'OZZERO',
        istatCode: '003015165'
    },
    {
        name: 'PABILLONIS',
        istatCode: '020111052'
    },
    {
        name: 'PACE DEL MELA',
        istatCode: '019083064'
    },
    {
        name: 'PACECO',
        istatCode: '019081013'
    },
    {
        name: 'PACENTRO',
        istatCode: '013066066'
    },
    {
        name: 'PACHINO',
        istatCode: '019089014'
    },
    {
        name: 'PACIANO',
        istatCode: '010054036'
    },
    {
        name: 'PADENGHE SUL GARDA',
        istatCode: '003017129'
    },
    {
        name: 'PADERGNONE',
        istatCode: '004022132'
    },
    {
        name: 'PADERNA',
        istatCode: '001006124'
    },
    {
        name: 'PADERNELLO',
        istatCode: '003017868'
    },
    {
        name: 'PADERNO D\'ADDA',
        istatCode: '003097062'
    },
    {
        name: 'PADERNO DEL GRAPPA',
        istatCode: '005026054'
    },
    {
        name: 'PADERNO DUGNANO',
        istatCode: '003015166'
    },
    {
        name: 'PADERNO FRANCIACORTA',
        istatCode: '003017130'
    },
    {
        name: 'PADERNO PONCHIELLI',
        istatCode: '003019065'
    },
    {
        name: 'PADOVA',
        istatCode: '005028060'
    },
    {
        name: 'PADRIA',
        istatCode: '020090053'
    },
    {
        name: 'PADRU',
        istatCode: '020090090'
    },
    {
        name: 'PADULA',
        istatCode: '015065087'
    },
    {
        name: 'PADULI',
        istatCode: '015062045'
    },
    {
        name: 'PAESANA',
        istatCode: '001004157'
    },
    {
        name: 'PAESE',
        istatCode: '005026055'
    },
    {
        name: 'PAGANI',
        istatCode: '015065088'
    },
    {
        name: 'PAGANICA',
        istatCode: '013066804'
    },
    {
        name: 'PAGANICO SABINO',
        istatCode: '012057048'
    },
    {
        name: 'PAGAZZANO',
        istatCode: '003016154'
    },
    {
        name: 'PAGLIARA',
        istatCode: '019083065'
    },
    {
        name: 'PAGLIETA',
        istatCode: '013069059'
    },
    {
        name: 'PAGNACCO',
        istatCode: '006030068'
    },
    {
        name: 'PAGNO',
        istatCode: '001004158'
    },
    {
        name: 'PAGNONA',
        istatCode: '003097063'
    },
    {
        name: 'PAGO DEL VALLO DI LAURO',
        istatCode: '015064068'
    },
    {
        name: 'PAGO VEIANO',
        istatCode: '015062046'
    },
    {
        name: 'PAISCO LOVENO',
        istatCode: '003017131'
    },
    {
        name: 'PAITONE',
        istatCode: '003017132'
    },
    {
        name: 'PALADINA',
        istatCode: '003016155'
    },
    {
        name: 'PALAGANO',
        istatCode: '008036029'
    },
    {
        name: 'PALAGIANELLO',
        istatCode: '016073020'
    },
    {
        name: 'PALAGIANO',
        istatCode: '016073021'
    },
    {
        name: 'PALAGONIA',
        istatCode: '019087032'
    },
    {
        name: 'PALAIA',
        istatCode: '009050024'
    },
    {
        name: 'PALANZANO',
        istatCode: '008034026'
    },
    {
        name: 'PALATA',
        istatCode: '014070050'
    },
    {
        name: 'PALAU',
        istatCode: '020090054'
    },
    {
        name: 'PALAZZAGO',
        istatCode: '003016156'
    },
    {
        name: 'PALAZZO ADRIANO',
        istatCode: '019082052'
    },
    {
        name: 'PALAZZO CANAVESE',
        istatCode: '001001177'
    },
    {
        name: 'PALAZZO PIGNANO',
        istatCode: '003019066'
    },
    {
        name: 'PALAZZO SAN GERVASIO',
        istatCode: '017076057'
    },
    {
        name: 'PALAZZOLO ACREIDE',
        istatCode: '019089015'
    },
    {
        name: 'PALAZZOLO DELLO STELLA',
        istatCode: '006030069'
    },
    {
        name: 'PALAZZOLO SULL\'OGLIO',
        istatCode: '003017133'
    },
    {
        name: 'PALAZZOLO VERCELLESE',
        istatCode: '001002090'
    },
    {
        name: 'PALAZZUOLO SUL SENIO',
        istatCode: '009048031'
    },
    {
        name: 'PALENA',
        istatCode: '013069060'
    },
    {
        name: 'PALERMITI',
        istatCode: '018079089'
    },
    {
        name: 'PALERMO',
        istatCode: '019082053'
    },
    {
        name: 'PALESTRINA',
        istatCode: '012058074'
    },
    {
        name: 'PALESTRO',
        istatCode: '003018107'
    },
    {
        name: 'PALIANO',
        istatCode: '012060046'
    },
    {
        name: 'PALIZZI',
        istatCode: '018080056'
    },
    {
        name: 'PALLAGORIO',
        istatCode: '018101016'
    },
    {
        name: 'PALLANZA',
        istatCode: '001003874'
    },
    {
        name: 'PALLANZENO',
        istatCode: '001103052'
    },
    {
        name: 'PALLARE',
        istatCode: '007009047'
    },
    {
        name: 'PALMA CAMPANIA',
        istatCode: '015063052'
    },
    {
        name: 'PALMA DI MONTECHIARO',
        istatCode: '019084027'
    },
    {
        name: 'PALMANOVA',
        istatCode: '006030070'
    },
    {
        name: 'PALMARIGGI',
        istatCode: '016075058'
    },
    {
        name: 'PALMAS ARBOREA',
        istatCode: '020095039'
    },
    {
        name: 'PALMI',
        istatCode: '018080057'
    },
    {
        name: 'PALMIANO',
        istatCode: '011044056'
    },
    {
        name: 'PALMOLI',
        istatCode: '013069061'
    },
    {
        name: 'PALO DEL COLLE',
        istatCode: '016072033'
    },
    {
        name: 'PALOMBARA SABINA',
        istatCode: '012058075'
    },
    {
        name: 'PALOMBARO',
        istatCode: '013069062'
    },
    {
        name: 'PALOMONTE',
        istatCode: '015065089'
    },
    {
        name: 'PALOSCO',
        istatCode: '003016157'
    },
    {
        name: 'PALU\'',
        istatCode: '005023056'
    },
    {
        name: 'PALU\' DEL FERSINA',
        istatCode: '004022133'
    },
    {
        name: 'PALUDI',
        istatCode: '018078089'
    },
    {
        name: 'PALUZZA',
        istatCode: '006030071'
    },
    {
        name: 'PALVARETO',
        istatCode: '003019876'
    },
    {
        name: 'PAMPARATO',
        istatCode: '001004159'
    },
    {
        name: 'PANCALIERI',
        istatCode: '001001178'
    },
    {
        name: 'PANCARANA',
        istatCode: '003018108'
    },
    {
        name: 'PANCHIA\'',
        istatCode: '004022134'
    },
    {
        name: 'PANDINO',
        istatCode: '003019067'
    },
    {
        name: 'PANETTIERI',
        istatCode: '018078090'
    },
    {
        name: 'PANICALE',
        istatCode: '010054037'
    },
    {
        name: 'PANNARANO',
        istatCode: '015062047'
    },
    {
        name: 'PANNI',
        istatCode: '016071037'
    },
    {
        name: 'PANNONE',
        istatCode: '004022509'
    },
    {
        name: 'PANTELLERIA',
        istatCode: '019081014'
    },
    {
        name: 'PANTIGLIATE',
        istatCode: '003015167'
    },
    {
        name: 'PAOLA',
        istatCode: '018078091'
    },
    {
        name: 'PAOLISI',
        istatCode: '015062048'
    },
    {
        name: 'PAPASIDERO',
        istatCode: '018078092'
    },
    {
        name: 'PAPOZZE',
        istatCode: '005029034'
    },
    {
        name: 'PARABIAGO',
        istatCode: '003015168'
    },
    {
        name: 'PARABITA',
        istatCode: '016075059'
    },
    {
        name: 'PARATICO',
        istatCode: '003017134'
    },
    {
        name: 'PARCINES - PARTSCHINS',
        istatCode: '004021062'
    },
    {
        name: 'PARE\'',
        istatCode: '003013175'
    },
    {
        name: 'PARELLA',
        istatCode: '001001179'
    },
    {
        name: 'PARENTI',
        istatCode: '018078093'
    },
    {
        name: 'PARETE',
        istatCode: '015061054'
    },
    {
        name: 'PARETO',
        istatCode: '001006125'
    },
    {
        name: 'PARGHELIA',
        istatCode: '018102026'
    },
    {
        name: 'PARLASCO',
        istatCode: '003097064'
    },
    {
        name: 'PARMA',
        istatCode: '008034027'
    },
    {
        name: 'PARODI LIGURE',
        istatCode: '001006126'
    },
    {
        name: 'PAROLDO',
        istatCode: '001004160'
    },
    {
        name: 'PAROLISE',
        istatCode: '015064069'
    },
    {
        name: 'PARONA',
        istatCode: '003018109'
    },
    {
        name: 'PARRANO',
        istatCode: '010055025'
    },
    {
        name: 'PARRE',
        istatCode: '003016158'
    },
    {
        name: 'PARTANNA',
        istatCode: '019081015'
    },
    {
        name: 'PARTINICO',
        istatCode: '019082054'
    },
    {
        name: 'PARUZZARO',
        istatCode: '001003114'
    },
    {
        name: 'PARZANICA',
        istatCode: '003016159'
    },
    {
        name: 'PASIAN DI PRATO',
        istatCode: '006030072'
    },
    {
        name: 'PASIANO DI PORDENONE',
        istatCode: '006093029'
    },
    {
        name: 'PASPARDO',
        istatCode: '003017135'
    },
    {
        name: 'PASSERANO MARMORITO',
        istatCode: '001005082'
    },
    {
        name: 'PASSIGNANO SUL TRASIMENO',
        istatCode: '010054038'
    },
    {
        name: 'PASSIRANO',
        istatCode: '003017136'
    },
    {
        name: 'PASTENA',
        istatCode: '012060047'
    },
    {
        name: 'PASTORANO',
        istatCode: '015061055'
    },
    {
        name: 'PASTRENGO',
        istatCode: '005023057'
    },
    {
        name: 'PASTURANA',
        istatCode: '001006127'
    },
    {
        name: 'PASTURO',
        istatCode: '003097065'
    },
    {
        name: 'PATERNO',
        istatCode: '017076100'
    },
    {
        name: 'PATERNO\'',
        istatCode: '019087033'
    },
    {
        name: 'PATERNO CALABRO',
        istatCode: '018078094'
    },
    {
        name: 'PATERNOPOLI',
        istatCode: '015064070'
    },
    {
        name: 'PATRICA',
        istatCode: '012060048'
    },
    {
        name: 'PATTADA',
        istatCode: '020090055'
    },
    {
        name: 'PATTI',
        istatCode: '019083066'
    },
    {
        name: 'PATU\'',
        istatCode: '016075060'
    },
    {
        name: 'PAU',
        istatCode: '020095040'
    },
    {
        name: 'PAULARO',
        istatCode: '006030073'
    },
    {
        name: 'PAULI ARBAREI',
        istatCode: '020111053'
    },
    {
        name: 'PAULILATINO',
        istatCode: '020095041'
    },
    {
        name: 'PAULLO',
        istatCode: '003015169'
    },
    {
        name: 'PAUPISI',
        istatCode: '015062049'
    },
    {
        name: 'PAVAROLO',
        istatCode: '001001180'
    },
    {
        name: 'PAVIA',
        istatCode: '003018110'
    },
    {
        name: 'PAVIA DI UDINE',
        istatCode: '006030074'
    },
    {
        name: 'PAVONE CANAVESE',
        istatCode: '001001181'
    },
    {
        name: 'PAVONE DEL MELLA',
        istatCode: '003017137'
    },
    {
        name: 'PAVULLO NEL FRIGNANO',
        istatCode: '008036030'
    },
    {
        name: 'PAZZANO',
        istatCode: '018080058'
    },
    {
        name: 'PECCIOLI',
        istatCode: '009050025'
    },
    {
        name: 'PECCO',
        istatCode: '001001182'
    },
    {
        name: 'PECETTO DI VALENZA',
        istatCode: '001006128'
    },
    {
        name: 'PECETTO TORINESE',
        istatCode: '001001183'
    },
    {
        name: 'PECORARA',
        istatCode: '008033031'
    },
    {
        name: 'PEDACE',
        istatCode: '018078095'
    },
    {
        name: 'PEDANEA',
        istatCode: '002007865'
    },
    {
        name: 'PEDANEA',
        istatCode: '002007865'
    },
    {
        name: 'PEDARA',
        istatCode: '019087034'
    },
    {
        name: 'PEDASO',
        istatCode: '011109030'
    },
    {
        name: 'PEDAVENA',
        istatCode: '005025036'
    },
    {
        name: 'PEDEMONTE',
        istatCode: '005024076'
    },
    {
        name: 'PEDEROBBA',
        istatCode: '005026056'
    },
    {
        name: 'PEDESINA',
        istatCode: '003014047'
    },
    {
        name: 'PEDIVIGLIANO',
        istatCode: '018078096'
    },
    {
        name: 'PEDRENGO',
        istatCode: '003016160'
    },
    {
        name: 'PEGLIO (CO)',
        istatCode: '003013178'
    },
    {
        name: 'PEGLIO (PS)',
        istatCode: '011041041'
    },
    {
        name: 'PEGOGNAGA',
        istatCode: '003020039'
    },
    {
        name: 'PEIA',
        istatCode: '003016161'
    },
    {
        name: 'PEIO',
        istatCode: '004022136'
    },
    {
        name: 'PELAGO',
        istatCode: '009048032'
    },
    {
        name: 'PELLA',
        istatCode: '001003115'
    },
    {
        name: 'PELLARO',
        istatCode: '018080811'
    },
    {
        name: 'PELLEGRINO PARMENSE',
        istatCode: '008034028'
    },
    {
        name: 'PELLEZZANO',
        istatCode: '015065090'
    },
    {
        name: 'PELLIO INTELVI',
        istatCode: '003013179'
    },
    {
        name: 'PELLIZZANO',
        istatCode: '004022137'
    },
    {
        name: 'PELUGO',
        istatCode: '004022138'
    },
    {
        name: 'PENANGO',
        istatCode: '001005083'
    },
    {
        name: 'PENNA IN TEVERINA',
        istatCode: '010055026'
    },
    {
        name: 'PENNA SAN GIOVANNI',
        istatCode: '011043035'
    },
    {
        name: 'PENNA SANT\'ANDREA',
        istatCode: '013067033'
    },
    {
        name: 'PENNABILLI',
        istatCode: '008099024'
    },
    {
        name: 'PENNADOMO',
        istatCode: '013069063'
    },
    {
        name: 'PENNAPIEDIMONTE',
        istatCode: '013069064'
    },
    {
        name: 'PENNE',
        istatCode: '013068027'
    },
    {
        name: 'PENTONE',
        istatCode: '018079092'
    },
    {
        name: 'PERANO',
        istatCode: '013069065'
    },
    {
        name: 'PERAROLO DI CADORE',
        istatCode: '005025037'
    },
    {
        name: 'PERCA - PERCHA',
        istatCode: '004021063'
    },
    {
        name: 'PERCILE',
        istatCode: '012058076'
    },
    {
        name: 'PERDASDEFOGU',
        istatCode: '020091072'
    },
    {
        name: 'PERDAXIUS',
        istatCode: '020111054'
    },
    {
        name: 'PERDIFUMO',
        istatCode: '015065091'
    },
    {
        name: 'PEREGO',
        istatCode: '003097066'
    },
    {
        name: 'PERETO',
        istatCode: '013066067'
    },
    {
        name: 'PERFUGAS',
        istatCode: '020090056'
    },
    {
        name: 'PERGINE VALDARNO',
        istatCode: '009051028'
    },
    {
        name: 'PERGINE VALSUGANA',
        istatCode: '004022139'
    },
    {
        name: 'PERGOLA',
        istatCode: '011041043'
    },
    {
        name: 'PERINALDO',
        istatCode: '007008040'
    },
    {
        name: 'PERITO',
        istatCode: '015065092'
    },
    {
        name: 'PERLEDO',
        istatCode: '003097067'
    },
    {
        name: 'PERLETTO',
        istatCode: '001004161'
    },
    {
        name: 'PERLO',
        istatCode: '001004162'
    },
    {
        name: 'PERLOZ',
        istatCode: '002007048'
    },
    {
        name: 'PERNUMIA',
        istatCode: '005028061'
    },
    {
        name: 'PERO',
        istatCode: '003015170'
    },
    {
        name: 'PEROSA ARGENTINA',
        istatCode: '001001184'
    },
    {
        name: 'PEROSA CANAVESE',
        istatCode: '001001185'
    },
    {
        name: 'PERRERO',
        istatCode: '001001186'
    },
    {
        name: 'PERSICO DOSIMO',
        istatCode: '003019068'
    },
    {
        name: 'PERTENGO',
        istatCode: '001002091'
    },
    {
        name: 'PERTICA ALTA',
        istatCode: '003017139'
    },
    {
        name: 'PERTICA BASSA',
        istatCode: '003017140'
    },
    {
        name: 'PERTOSA',
        istatCode: '015065093'
    },
    {
        name: 'PERTUSIO',
        istatCode: '001001187'
    },
    {
        name: 'PERUGIA',
        istatCode: '010054039'
    },
    {
        name: 'PESARO',
        istatCode: '011041044'
    },
    {
        name: 'PESCAGLIA',
        istatCode: '009046022'
    },
    {
        name: 'PESCANTINA',
        istatCode: '005023058'
    },
    {
        name: 'PESCARA',
        istatCode: '013068028'
    },
    {
        name: 'PESCAROLO ED UNITI',
        istatCode: '003019069'
    },
    {
        name: 'PESCASSEROLI',
        istatCode: '013066068'
    },
    {
        name: 'PESCATE',
        istatCode: '003097068'
    },
    {
        name: 'PESCHE',
        istatCode: '014094031'
    },
    {
        name: 'PESCHICI',
        istatCode: '016071038'
    },
    {
        name: 'PESCHIERA BORROMEO',
        istatCode: '003015171'
    },
    {
        name: 'PESCHIERA DEL GARDA',
        istatCode: '005023059'
    },
    {
        name: 'PESCIA',
        istatCode: '009047012'
    },
    {
        name: 'PESCINA',
        istatCode: '013066069'
    },
    {
        name: 'PESCO SANNITA',
        istatCode: '015062050'
    },
    {
        name: 'PESCOCOSTANZO',
        istatCode: '013066070'
    },
    {
        name: 'PESCOLANCIANO',
        istatCode: '014094032'
    },
    {
        name: 'PESCOPAGANO',
        istatCode: '017076058'
    },
    {
        name: 'PESCOPENNATARO',
        istatCode: '014094033'
    },
    {
        name: 'PESCOROCCHIANO',
        istatCode: '012057049'
    },
    {
        name: 'PESCOSANSONESCO',
        istatCode: '013068029'
    },
    {
        name: 'PESCOSOLIDO',
        istatCode: '012060049'
    },
    {
        name: 'PESSANO CON BORNAGO',
        istatCode: '003015172'
    },
    {
        name: 'PESSINA CREMONESE',
        istatCode: '003019070'
    },
    {
        name: 'PESSINETTO',
        istatCode: '001001188'
    },
    {
        name: 'PETACCIATO',
        istatCode: '014070051'
    },
    {
        name: 'PETILIA POLICASTRO',
        istatCode: '018101017'
    },
    {
        name: 'PETINA',
        istatCode: '015065094'
    },
    {
        name: 'PETRALIA SOPRANA',
        istatCode: '019082055'
    },
    {
        name: 'PETRALIA SOTTANA',
        istatCode: '019082056'
    },
    {
        name: 'PETRELLA SALTO',
        istatCode: '012057050'
    },
    {
        name: 'PETRELLA TIFERNINA',
        istatCode: '014070052'
    },
    {
        name: 'PETRIANO',
        istatCode: '011041045'
    },
    {
        name: 'PETRIOLO',
        istatCode: '011043036'
    },
    {
        name: 'PETRITOLI',
        istatCode: '011109031'
    },
    {
        name: 'PETRIZZI',
        istatCode: '018079094'
    },
    {
        name: 'PETRONA\'',
        istatCode: '018079095'
    },
    {
        name: 'PETROSINO',
        istatCode: '019081024'
    },
    {
        name: 'PETRURO IRPINO',
        istatCode: '015064071'
    },
    {
        name: 'PETTENASCO',
        istatCode: '001003116'
    },
    {
        name: 'PETTINENGO',
        istatCode: '001096042'
    },
    {
        name: 'PETTINEO',
        istatCode: '019083067'
    },
    {
        name: 'PETTORANELLO DEL MOLISE',
        istatCode: '014094034'
    },
    {
        name: 'PETTORANO SUL GIZIO',
        istatCode: '013066071'
    },
    {
        name: 'PETTORAZZA GRIMANI',
        istatCode: '005029035'
    },
    {
        name: 'PEVERAGNO',
        istatCode: '001004163'
    },
    {
        name: 'PEZZANA',
        istatCode: '001002093'
    },
    {
        name: 'PEZZAZE',
        istatCode: '003017141'
    },
    {
        name: 'PEZZOLO VALLE UZZONE',
        istatCode: '001004164'
    },
    {
        name: 'PIACENZA',
        istatCode: '008033032'
    },
    {
        name: 'PIACENZA D\'ADIGE',
        istatCode: '005028062'
    },
    {
        name: 'PIADENA',
        istatCode: '003019071'
    },
    {
        name: 'PIADENA DRIZZONA',
        istatCode: '003019116'
    },
    {
        name: 'PIAGGE',
        istatCode: '011041046'
    },
    {
        name: 'PIAGGINE',
        istatCode: '015065095'
    },
    {
        name: 'PIAN CAMUNO',
        istatCode: '003017142'
    },
    {
        name: 'PIAN D\'ARTOGNE',
        istatCode: '003017542'
    },
    {
        name: 'PIAN DI SCO',
        istatCode: '009051029'
    },
    {
        name: 'PIANA CRIXIA',
        istatCode: '007009048'
    },
    {
        name: 'PIANA DEGLI ALBANESI',
        istatCode: '019082057'
    },
    {
        name: 'PIANA DI MONTE VERNA',
        istatCode: '015061056'
    },
    {
        name: 'PIANCASTAGNAIO',
        istatCode: '009052020'
    },
    {
        name: 'PIANCOGNO',
        istatCode: '003017206'
    },
    {
        name: 'PIANDIMELETO',
        istatCode: '011041047'
    },
    {
        name: 'PIANE CRATI',
        istatCode: '018078097'
    },
    {
        name: 'PIANELLA',
        istatCode: '013068030'
    },
    {
        name: 'PIANELLO DEL LARIO',
        istatCode: '003013183'
    },
    {
        name: 'PIANELLO VAL TIDONE',
        istatCode: '008033033'
    },
    {
        name: 'PIANENGO',
        istatCode: '003019072'
    },
    {
        name: 'PIANEZZA',
        istatCode: '001001189'
    },
    {
        name: 'PIANEZZE',
        istatCode: '005024077'
    },
    {
        name: 'PIANFEI',
        istatCode: '001004165'
    },
    {
        name: 'PIANICO',
        istatCode: '003016162'
    },
    {
        name: 'PIANIGA',
        istatCode: '005027028'
    },
    {
        name: 'PIANO DI SORRENTO',
        istatCode: '015063053'
    },
    {
        name: 'PIANOPOLI',
        istatCode: '018079096'
    },
    {
        name: 'PIANORO',
        istatCode: '008037047'
    },
    {
        name: 'PIANSANO',
        istatCode: '012056043'
    },
    {
        name: 'PIANTEDO',
        istatCode: '003014048'
    },
    {
        name: 'PIARIO',
        istatCode: '003016163'
    },
    {
        name: 'PIASCO',
        istatCode: '001004166'
    },
    {
        name: 'PIATEDA',
        istatCode: '003014049'
    },
    {
        name: 'PIATTO',
        istatCode: '001096043'
    },
    {
        name: 'PIAVON',
        istatCode: '005026802'
    },
    {
        name: 'PIAZZA AL SERCHIO',
        istatCode: '009046023'
    },
    {
        name: 'PIAZZA ARMERINA',
        istatCode: '019086014'
    },
    {
        name: 'PIAZZA BREMBANA',
        istatCode: '003016164'
    },
    {
        name: 'PIAZZATORRE',
        istatCode: '003016165'
    },
    {
        name: 'PIAZZOLA SUL BRENTA',
        istatCode: '005028063'
    },
    {
        name: 'PIAZZOLO',
        istatCode: '003016166'
    },
    {
        name: 'PICCIANO',
        istatCode: '013068031'
    },
    {
        name: 'PICERNO',
        istatCode: '017076059'
    },
    {
        name: 'PICINISCO',
        istatCode: '012060050'
    },
    {
        name: 'PICO',
        istatCode: '012060051'
    },
    {
        name: 'PIEA',
        istatCode: '001005084'
    },
    {
        name: 'PIEDICAVALLO',
        istatCode: '001096044'
    },
    {
        name: 'PIEDIMONTE ETNEO',
        istatCode: '019087035'
    },
    {
        name: 'PIEDIMONTE MATESE',
        istatCode: '015061057'
    },
    {
        name: 'PIEDIMONTE SAN GERMANO',
        istatCode: '012060052'
    },
    {
        name: 'PIEDIMULERA',
        istatCode: '001103053'
    },
    {
        name: 'PIEGARO',
        istatCode: '010054040'
    },
    {
        name: 'PIENZA',
        istatCode: '009052021'
    },
    {
        name: 'PIERANICA',
        istatCode: '003019073'
    },
    {
        name: 'PIETRA DE\' GIORGI',
        istatCode: '003018111'
    },
    {
        name: 'PIETRA LIGURE',
        istatCode: '007009049'
    },
    {
        name: 'PIETRA MARAZZI',
        istatCode: '001006129'
    },
    {
        name: 'PIETRABBONDANTE',
        istatCode: '014094035'
    },
    {
        name: 'PIETRABRUNA',
        istatCode: '007008041'
    },
    {
        name: 'PIETRACAMELA',
        istatCode: '013067034'
    },
    {
        name: 'PIETRACATELLA',
        istatCode: '014070053'
    },
    {
        name: 'PIETRACUPA',
        istatCode: '014070054'
    },
    {
        name: 'PIETRADEFUSI',
        istatCode: '015064072'
    },
    {
        name: 'PIETRAFERRAZZANA',
        istatCode: '013069103'
    },
    {
        name: 'PIETRAFITTA',
        istatCode: '018078098'
    },
    {
        name: 'PIETRAGALLA',
        istatCode: '017076060'
    },
    {
        name: 'PIETRALUNGA',
        istatCode: '010054041'
    },
    {
        name: 'PIETRAMELARA',
        istatCode: '015061058'
    },
    {
        name: 'PIETRAMONTECORVINO',
        istatCode: '016071039'
    },
    {
        name: 'PIETRANICO',
        istatCode: '013068032'
    },
    {
        name: 'PIETRAPAOLA',
        istatCode: '018078099'
    },
    {
        name: 'PIETRAPERTOSA',
        istatCode: '017076061'
    },
    {
        name: 'PIETRAPERZIA',
        istatCode: '019086015'
    },
    {
        name: 'PIETRAPORZIO',
        istatCode: '001004167'
    },
    {
        name: 'PIETRAROJA',
        istatCode: '015062051'
    },
    {
        name: 'PIETRARUBBIA',
        istatCode: '011041048'
    },
    {
        name: 'PIETRASANTA',
        istatCode: '009046024'
    },
    {
        name: 'PIETRASTORNINA',
        istatCode: '015064073'
    },
    {
        name: 'PIETRAVAIRANO',
        istatCode: '015061059'
    },
    {
        name: 'PIETRELCINA',
        istatCode: '015062052'
    },
    {
        name: 'PIEVE A NIEVOLE',
        istatCode: '009047013'
    },
    {
        name: 'PIEVE ALBIGNOLA',
        istatCode: '003018112'
    },
    {
        name: 'PIEVE D\'ALPAGO',
        istatCode: '005025038'
    },
    {
        name: 'PIEVE DEL CAIRO',
        istatCode: '003018113'
    },
    {
        name: 'PIEVE DEL GRAPPA',
        istatCode: '005026096'
    },
    {
        name: 'PIEVE DI BONO',
        istatCode: '004022140'
    },
    {
        name: 'PIEVE DI BONO-PREZZO',
        istatCode: '004022234'
    },
    {
        name: 'PIEVE DI CADORE',
        istatCode: '005025039'
    },
    {
        name: 'PIEVE DI CENTO',
        istatCode: '008037048'
    },
    {
        name: 'PIEVE DI CORIANO',
        istatCode: '003020040'
    },
    {
        name: 'PIEVE DI LEDRO',
        istatCode: '004022141'
    },
    {
        name: 'PIEVE DI SOLIGO',
        istatCode: '005026057'
    },
    {
        name: 'PIEVE DI TECO',
        istatCode: '007008042'
    },
    {
        name: 'PIEVE D\'OLMI',
        istatCode: '003019074'
    },
    {
        name: 'PIEVE EMANUELE',
        istatCode: '003015173'
    },
    {
        name: 'PIEVE FISSIRAGA',
        istatCode: '003098045'
    },
    {
        name: 'PIEVE FOSCIANA',
        istatCode: '009046025'
    },
    {
        name: 'PIEVE LIGURE',
        istatCode: '007010043'
    },
    {
        name: 'PIEVE PORTO MORONE',
        istatCode: '003018114'
    },
    {
        name: 'PIEVE SAN GIACOMO',
        istatCode: '003019075'
    },
    {
        name: 'PIEVE SANTO STEFANO',
        istatCode: '009051030'
    },
    {
        name: 'PIEVE TESINO',
        istatCode: '004022142'
    },
    {
        name: 'PIEVE TORINA',
        istatCode: '011043038'
    },
    {
        name: 'PIEVE VERGONTE',
        istatCode: '001103054'
    },
    {
        name: 'PIEVEBOVIGLIANA',
        istatCode: '011043037'
    },
    {
        name: 'PIEVEPELAGO',
        istatCode: '008036031'
    },
    {
        name: 'PIGLIO',
        istatCode: '012060053'
    },
    {
        name: 'PIGNA',
        istatCode: '007008043'
    },
    {
        name: 'PIGNATARO INTERAMNA',
        istatCode: '012060054'
    },
    {
        name: 'PIGNATARO MAGGIORE',
        istatCode: '015061060'
    },
    {
        name: 'PIGNOLA',
        istatCode: '017076062'
    },
    {
        name: 'PIGNONE',
        istatCode: '007011021'
    },
    {
        name: 'PIGRA',
        istatCode: '003013184'
    },
    {
        name: 'PILA',
        istatCode: '001002096'
    },
    {
        name: 'PIMENTEL',
        istatCode: '020111055'
    },
    {
        name: 'PIMONTE',
        istatCode: '015063054'
    },
    {
        name: 'PINAROLO PO',
        istatCode: '003018115'
    },
    {
        name: 'PINASCA',
        istatCode: '001001190'
    },
    {
        name: 'PINCARA',
        istatCode: '005029036'
    },
    {
        name: 'PINEROLO',
        istatCode: '001001191'
    },
    {
        name: 'PINETO',
        istatCode: '013067035'
    },
    {
        name: 'PINO D\'ASTI',
        istatCode: '001005085'
    },
    {
        name: 'PINO SULLA SPONDA DEL LAGO MAGGIORE',
        istatCode: '003012112'
    },
    {
        name: 'PINO TORINESE',
        istatCode: '001001192'
    },
    {
        name: 'PINZANO AL TAGLIAMENTO',
        istatCode: '006093030'
    },
    {
        name: 'PINZOLO',
        istatCode: '004022143'
    },
    {
        name: 'PIOBBICO',
        istatCode: '011041049'
    },
    {
        name: 'PIOBESI D\'ALBA',
        istatCode: '001004168'
    },
    {
        name: 'PIOBESI TORINESE',
        istatCode: '001001193'
    },
    {
        name: 'PIODE',
        istatCode: '001002097'
    },
    {
        name: 'PIOLTELLO',
        istatCode: '003015175'
    },
    {
        name: 'PIOMBINO',
        istatCode: '009049012'
    },
    {
        name: 'PIOMBINO DESE',
        istatCode: '005028064'
    },
    {
        name: 'PIORACO',
        istatCode: '011043039'
    },
    {
        name: 'PIOSSASCO',
        istatCode: '001001194'
    },
    {
        name: 'PIOVA\' MASSAIA',
        istatCode: '001005086'
    },
    {
        name: 'PIOVE DI SACCO',
        istatCode: '005028065'
    },
    {
        name: 'PIOVENE ROCCHETTE',
        istatCode: '005024078'
    },
    {
        name: 'PIOVERA',
        istatCode: '001006130'
    },
    {
        name: 'PIOZZANO',
        istatCode: '008033034'
    },
    {
        name: 'PIOZZO',
        istatCode: '001004169'
    },
    {
        name: 'PIRAINO',
        istatCode: '019083068'
    },
    {
        name: 'PIRANO',
        istatCode: '006702729'
    },
    {
        name: 'PIRRI',
        istatCode: '020092805'
    },
    {
        name: 'PISA',
        istatCode: '009050026'
    },
    {
        name: 'PISANO',
        istatCode: '001003119'
    },
    {
        name: 'PISCINA',
        istatCode: '001001195'
    },
    {
        name: 'PISCINAS',
        istatCode: '020111056'
    },
    {
        name: 'PISCIOTTA',
        istatCode: '015065096'
    },
    {
        name: 'PISOGNE',
        istatCode: '003017143'
    },
    {
        name: 'PISONIANO',
        istatCode: '012058077'
    },
    {
        name: 'PISTICCI',
        istatCode: '017077020'
    },
    {
        name: 'PISTOIA',
        istatCode: '009047014'
    },
    {
        name: 'PISTOLESA',
        istatCode: '001002098'
    },
    {
        name: 'PITEGLIO',
        istatCode: '009047015'
    },
    {
        name: 'PITIGLIANO',
        istatCode: '009053019'
    },
    {
        name: 'PIUBEGA',
        istatCode: '003020041'
    },
    {
        name: 'PIURO',
        istatCode: '003014050'
    },
    {
        name: 'PIVERONE',
        istatCode: '001001196'
    },
    {
        name: 'PIZZALE',
        istatCode: '003018116'
    },
    {
        name: 'PIZZIGHETTONE',
        istatCode: '003019076'
    },
    {
        name: 'PIZZO',
        istatCode: '018102027'
    },
    {
        name: 'PIZZOFERRATO',
        istatCode: '013069066'
    },
    {
        name: 'PIZZOLI',
        istatCode: '013066072'
    },
    {
        name: 'PIZZONE',
        istatCode: '014094036'
    },
    {
        name: 'PIZZONI',
        istatCode: '018102028'
    },
    {
        name: 'PLACANICA',
        istatCode: '018080059'
    },
    {
        name: 'PLATACI',
        istatCode: '018078100'
    },
    {
        name: 'PLATANIA',
        istatCode: '018079099'
    },
    {
        name: 'PLATI\'',
        istatCode: '018080060'
    },
    {
        name: 'PLAUS - PLAUS',
        istatCode: '004021064'
    },
    {
        name: 'PLESIO',
        istatCode: '003013185'
    },
    {
        name: 'PLOAGHE',
        istatCode: '020090057'
    },
    {
        name: 'PLODIO',
        istatCode: '007009050'
    },
    {
        name: 'POCAPAGLIA',
        istatCode: '001004170'
    },
    {
        name: 'POCENIA',
        istatCode: '006030075'
    },
    {
        name: 'PODENZANA',
        istatCode: '009045013'
    },
    {
        name: 'PODENZANO',
        istatCode: '008033035'
    },
    {
        name: 'POFI',
        istatCode: '012060055'
    },
    {
        name: 'POGGIARDO',
        istatCode: '016075061'
    },
    {
        name: 'POGGIBONSI',
        istatCode: '009052022'
    },
    {
        name: 'POGGIO A CAIANO',
        istatCode: '009100004'
    },
    {
        name: 'POGGIO BERNI',
        istatCode: '008099012'
    },
    {
        name: 'POGGIO BUSTONE',
        istatCode: '012057051'
    },
    {
        name: 'POGGIO CATINO',
        istatCode: '012057052'
    },
    {
        name: 'POGGIO IMPERIALE',
        istatCode: '016071040'
    },
    {
        name: 'POGGIO MIRTETO',
        istatCode: '012057053'
    },
    {
        name: 'POGGIO MOIANO',
        istatCode: '012057054'
    },
    {
        name: 'POGGIO NATIVO',
        istatCode: '012057055'
    },
    {
        name: 'POGGIO PICENZE',
        istatCode: '013066073'
    },
    {
        name: 'POGGIO RENATICO',
        istatCode: '008038018'
    },
    {
        name: 'POGGIO RUSCO',
        istatCode: '003020042'
    },
    {
        name: 'POGGIO SAN LORENZO',
        istatCode: '012057056'
    },
    {
        name: 'POGGIO SAN MARCELLO',
        istatCode: '011042037'
    },
    {
        name: 'POGGIO SAN VICINO',
        istatCode: '011043040'
    },
    {
        name: 'POGGIO SANNITA',
        istatCode: '014094037'
    },
    {
        name: 'POGGIO TORRIANA',
        istatCode: '008099028'
    },
    {
        name: 'POGGIODOMO',
        istatCode: '010054042'
    },
    {
        name: 'POGGIOFIORITO',
        istatCode: '013069067'
    },
    {
        name: 'POGGIOMARINO',
        istatCode: '015063055'
    },
    {
        name: 'POGGIOREALE',
        istatCode: '019081016'
    },
    {
        name: 'POGGIORSINI',
        istatCode: '016072034'
    },
    {
        name: 'POGGIRIDENTI',
        istatCode: '003014051'
    },
    {
        name: 'POGLIANO MILANESE',
        istatCode: '003015176'
    },
    {
        name: 'POGNANA LARIO',
        istatCode: '003013186'
    },
    {
        name: 'POGNANO',
        istatCode: '003016167'
    },
    {
        name: 'POGNO',
        istatCode: '001003120'
    },
    {
        name: 'POIANA MAGGIORE',
        istatCode: '005024079'
    },
    {
        name: 'POIRINO',
        istatCode: '001001197'
    },
    {
        name: 'POLA',
        istatCode: '006702731'
    },
    {
        name: 'POLAVENO',
        istatCode: '003017144'
    },
    {
        name: 'POLCENIGO',
        istatCode: '006093031'
    },
    {
        name: 'POLESELLA',
        istatCode: '005029037'
    },
    {
        name: 'POLESINE PARMENSE',
        istatCode: '008034029'
    },
    {
        name: 'POLESINE ZIBELLO',
        istatCode: '008034050'
    },
    {
        name: 'POLI',
        istatCode: '012058078'
    },
    {
        name: 'POLIA',
        istatCode: '018102029'
    },
    {
        name: 'POLICORO',
        istatCode: '017077021'
    },
    {
        name: 'POLIGNANO A MARE',
        istatCode: '016072035'
    },
    {
        name: 'POLINAGO',
        istatCode: '008036032'
    },
    {
        name: 'POLINO',
        istatCode: '010055027'
    },
    {
        name: 'POLISTENA',
        istatCode: '018080061'
    },
    {
        name: 'POLIZZI GENEROSA',
        istatCode: '019082058'
    },
    {
        name: 'POLLA',
        istatCode: '015065097'
    },
    {
        name: 'POLLEIN',
        istatCode: '002007049'
    },
    {
        name: 'POLLENA TROCCHIA',
        istatCode: '015063056'
    },
    {
        name: 'POLLENZA',
        istatCode: '011043041'
    },
    {
        name: 'POLLICA',
        istatCode: '015065098'
    },
    {
        name: 'POLLINA',
        istatCode: '019082059'
    },
    {
        name: 'POLLONE',
        istatCode: '001096046'
    },
    {
        name: 'POLLUTRI',
        istatCode: '013069068'
    },
    {
        name: 'POLONGHERA',
        istatCode: '001004171'
    },
    {
        name: 'POLPENAZZE DEL GARDA',
        istatCode: '003017145'
    },
    {
        name: 'POLVERARA',
        istatCode: '005028066'
    },
    {
        name: 'POLVERIGI',
        istatCode: '011042038'
    },
    {
        name: 'POMARANCE',
        istatCode: '009050027'
    },
    {
        name: 'POMARETTO',
        istatCode: '001001198'
    },
    {
        name: 'POMARICO',
        istatCode: '017077022'
    },
    {
        name: 'POMARO MONFERRATO',
        istatCode: '001006131'
    },
    {
        name: 'POMAROLO',
        istatCode: '004022144'
    },
    {
        name: 'POMBIA',
        istatCode: '001003121'
    },
    {
        name: 'POMETO',
        istatCode: '003018857'
    },
    {
        name: 'POMEZIA',
        istatCode: '012058079'
    },
    {
        name: 'POMIGLIANO D\'ARCO',
        istatCode: '015063057'
    },
    {
        name: 'POMPEI',
        istatCode: '015063058'
    },
    {
        name: 'POMPEIANA',
        istatCode: '007008044'
    },
    {
        name: 'POMPIANO',
        istatCode: '003017146'
    },
    {
        name: 'POMPONESCO',
        istatCode: '003020043'
    },
    {
        name: 'POMPU',
        istatCode: '020095042'
    },
    {
        name: 'PONCARALE',
        istatCode: '003017147'
    },
    {
        name: 'PONCARALE FLERO',
        istatCode: '003017874'
    },
    {
        name: 'PONDERANO',
        istatCode: '001096047'
    },
    {
        name: 'PONNA',
        istatCode: '003013187'
    },
    {
        name: 'PONSACCO',
        istatCode: '009050028'
    },
    {
        name: 'PONSO',
        istatCode: '005028067'
    },
    {
        name: 'PONTASSIEVE',
        istatCode: '009048033'
    },
    {
        name: 'PONTBOSET',
        istatCode: '002007050'
    },
    {
        name: 'PONT-CANAVESE',
        istatCode: '001001199'
    },
    {
        name: 'PONTE',
        istatCode: '015062053'
    },
    {
        name: 'PONTE BUGGIANESE',
        istatCode: '009047016'
    },
    {
        name: 'PONTE DELL\'OLIO',
        istatCode: '008033036'
    },
    {
        name: 'PONTE DI LEGNO',
        istatCode: '003017148'
    },
    {
        name: 'PONTE DI PIAVE',
        istatCode: '005026058'
    },
    {
        name: 'PONTE GARDENA - WAIDBRUCK',
        istatCode: '004021065'
    },
    {
        name: 'PONTE IN VALTELLINA',
        istatCode: '003014052'
    },
    {
        name: 'PONTE LAMBRO',
        istatCode: '003013188'
    },
    {
        name: 'PONTE NELLE ALPI',
        istatCode: '005025040'
    },
    {
        name: 'PONTE NIZZA',
        istatCode: '003018117'
    },
    {
        name: 'PONTE NOSSA',
        istatCode: '003016168'
    },
    {
        name: 'PONTE SAN NICOLO\'',
        istatCode: '005028069'
    },
    {
        name: 'PONTE SAN PIETRO',
        istatCode: '003016170'
    },
    {
        name: 'PONTEBBA',
        istatCode: '006030076'
    },
    {
        name: 'PONTECAGNANO FAIANO',
        istatCode: '015065099'
    },
    {
        name: 'PONTECCHIO POLESINE',
        istatCode: '005029038'
    },
    {
        name: 'PONTECHIANALE',
        istatCode: '001004172'
    },
    {
        name: 'PONTECORVO',
        istatCode: '012060056'
    },
    {
        name: 'PONTECURONE',
        istatCode: '001006132'
    },
    {
        name: 'PONTEDASSIO',
        istatCode: '007008045'
    },
    {
        name: 'PONTEDERA',
        istatCode: '009050029'
    },
    {
        name: 'PONTELANDOLFO',
        istatCode: '015062054'
    },
    {
        name: 'PONTELATONE',
        istatCode: '015061061'
    },
    {
        name: 'PONTELONGO',
        istatCode: '005028068'
    },
    {
        name: 'PONTENURE',
        istatCode: '008033037'
    },
    {
        name: 'PONTERANICA',
        istatCode: '003016169'
    },
    {
        name: 'PONTESTURA',
        istatCode: '001006133'
    },
    {
        name: 'PONTEVICO',
        istatCode: '003017149'
    },
    {
        name: 'PONTEY',
        istatCode: '002007051'
    },
    {
        name: 'PONTI',
        istatCode: '001006134'
    },
    {
        name: 'PONTI SUL MINCIO',
        istatCode: '003020044'
    },
    {
        name: 'PONTIDA',
        istatCode: '003016171'
    },
    {
        name: 'PONTINIA',
        istatCode: '012059017'
    },
    {
        name: 'PONTINVREA',
        istatCode: '007009051'
    },
    {
        name: 'PONTIROLO NUOVO',
        istatCode: '003016172'
    },
    {
        name: 'PONTOGLIO',
        istatCode: '003017150'
    },
    {
        name: 'PONTREMOLI',
        istatCode: '009045014'
    },
    {
        name: 'PONT-SAINT-MARTIN',
        istatCode: '002007052'
    },
    {
        name: 'PONZA',
        istatCode: '012059018'
    },
    {
        name: 'PONZANO DI FERMO',
        istatCode: '011109032'
    },
    {
        name: 'PONZANO MONFERRATO',
        istatCode: '001006135'
    },
    {
        name: 'PONZANO ROMANO',
        istatCode: '012058080'
    },
    {
        name: 'PONZANO VENETO',
        istatCode: '005026059'
    },
    {
        name: 'PONZONE',
        istatCode: '001006136'
    },
    {
        name: 'POPOLI',
        istatCode: '013068033'
    },
    {
        name: 'POPPI',
        istatCode: '009051031'
    },
    {
        name: 'PORANO',
        istatCode: '010055028'
    },
    {
        name: 'PORCARI',
        istatCode: '009046026'
    },
    {
        name: 'PORCIA',
        istatCode: '006093032'
    },
    {
        name: 'PORDENONE',
        istatCode: '006093033'
    },
    {
        name: 'PORLEZZA',
        istatCode: '003013189'
    },
    {
        name: 'PORNASSIO',
        istatCode: '007008046'
    },
    {
        name: 'PORPETTO',
        istatCode: '006030077'
    },
    {
        name: 'PORRETTA TERME',
        istatCode: '008037049'
    },
    {
        name: 'PORTACOMARO',
        istatCode: '001005087'
    },
    {
        name: 'PORTALBERA',
        istatCode: '003018118'
    },
    {
        name: 'PORTE',
        istatCode: '001001200'
    },
    {
        name: 'PORTE DI RENDENA',
        istatCode: '004022244'
    },
    {
        name: 'PORTICI',
        istatCode: '015063059'
    },
    {
        name: 'PORTICO DI CASERTA',
        istatCode: '015061062'
    },
    {
        name: 'PORTICO E SAN BENEDETTO',
        istatCode: '008040031'
    },
    {
        name: 'PORTIGLIOLA',
        istatCode: '018080062'
    },
    {
        name: 'PORTO AZZURRO',
        istatCode: '009049013'
    },
    {
        name: 'PORTO CERESIO',
        istatCode: '003012113'
    },
    {
        name: 'PORTO CESAREO',
        istatCode: '016075097'
    },
    {
        name: 'PORTO EMPEDOCLE',
        istatCode: '019084028'
    },
    {
        name: 'PORTO MANTOVANO',
        istatCode: '003020045'
    },
    {
        name: 'PORTO RECANATI',
        istatCode: '011043042'
    },
    {
        name: 'PORTO SAN GIORGIO',
        istatCode: '011109033'
    },
    {
        name: 'PORTO SANT\'ELPIDIO',
        istatCode: '011109034'
    },
    {
        name: 'PORTO TOLLE',
        istatCode: '005029039'
    },
    {
        name: 'PORTO TORRES',
        istatCode: '020090058'
    },
    {
        name: 'PORTO VALTRAVAGLIA',
        istatCode: '003012114'
    },
    {
        name: 'PORTO VIRO',
        istatCode: '005029052'
    },
    {
        name: 'PORTOBUFFOLE\'',
        istatCode: '005026060'
    },
    {
        name: 'PORTOCANNONE',
        istatCode: '014070055'
    },
    {
        name: 'PORTOFERRAIO',
        istatCode: '009049014'
    },
    {
        name: 'PORTOFINO',
        istatCode: '007010044'
    },
    {
        name: 'PORTOGRUARO',
        istatCode: '005027029'
    },
    {
        name: 'PORTOMAGGIORE',
        istatCode: '008038019'
    },
    {
        name: 'PORTOPALO DI CAPO PASSERO',
        istatCode: '019089020'
    },
    {
        name: 'PORTOSCUSO',
        istatCode: '020111057'
    },
    {
        name: 'PORTOVENERE',
        istatCode: '007011022'
    },
    {
        name: 'PORTULA',
        istatCode: '001096048'
    },
    {
        name: 'POSADA',
        istatCode: '020091073'
    },
    {
        name: 'POSINA',
        istatCode: '005024080'
    },
    {
        name: 'POSITANO',
        istatCode: '015065100'
    },
    {
        name: 'POSSAGNO',
        istatCode: '005026061'
    },
    {
        name: 'POSTA',
        istatCode: '012057057'
    },
    {
        name: 'POSTA FIBRENO',
        istatCode: '012060057'
    },
    {
        name: 'POSTAL - BURGSTALL',
        istatCode: '004021066'
    },
    {
        name: 'POSTALESIO',
        istatCode: '003014053'
    },
    {
        name: 'POSTIGLIONE',
        istatCode: '015065101'
    },
    {
        name: 'POSTUA',
        istatCode: '001002102'
    },
    {
        name: 'POTENZA',
        istatCode: '017076063'
    },
    {
        name: 'POTENZA PICENA',
        istatCode: '011043043'
    },
    {
        name: 'POVE DEL GRAPPA',
        istatCode: '005024081'
    },
    {
        name: 'POVEGLIANO',
        istatCode: '005026062'
    },
    {
        name: 'POVEGLIANO VERONESE',
        istatCode: '005023060'
    },
    {
        name: 'POVIGLIO',
        istatCode: '008035029'
    },
    {
        name: 'POVO',
        istatCode: '004022888'
    },
    {
        name: 'POVOLETTO',
        istatCode: '006030078'
    },
    {
        name: 'POZZA DI FASSA',
        istatCode: '004022145'
    },
    {
        name: 'POZZAGLIA SABINA',
        istatCode: '012057058'
    },
    {
        name: 'POZZAGLIO ED UNITI',
        istatCode: '003019077'
    },
    {
        name: 'POZZALLO',
        istatCode: '019088008'
    },
    {
        name: 'POZZILLI',
        istatCode: '014094038'
    },
    {
        name: 'POZZO ALTO',
        istatCode: '011041817'
    },
    {
        name: 'POZZO D\'ADDA',
        istatCode: '003015177'
    },
    {
        name: 'POZZOL GROPPO',
        istatCode: '001006137'
    },
    {
        name: 'POZZOLENGO',
        istatCode: '003017151'
    },
    {
        name: 'POZZOLEONE',
        istatCode: '005024082'
    },
    {
        name: 'POZZOLO FORMIGARO',
        istatCode: '001006138'
    },
    {
        name: 'POZZOMAGGIORE',
        istatCode: '020090059'
    },
    {
        name: 'POZZONOVO',
        istatCode: '005028070'
    },
    {
        name: 'POZZUOLI',
        istatCode: '015063060'
    },
    {
        name: 'POZZUOLO DEL FRIULI',
        istatCode: '006030079'
    },
    {
        name: 'POZZUOLO MARTESANA',
        istatCode: '003015178'
    },
    {
        name: 'PRADALUNGA',
        istatCode: '003016173'
    },
    {
        name: 'PRADAMANO',
        istatCode: '006030080'
    },
    {
        name: 'PRADLEVES',
        istatCode: '001004173'
    },
    {
        name: 'PRAGELATO',
        istatCode: '001001201'
    },
    {
        name: 'PRAIA A MARE',
        istatCode: '018078101'
    },
    {
        name: 'PRAIANO',
        istatCode: '015065102'
    },
    {
        name: 'PRALBOINO',
        istatCode: '003017152'
    },
    {
        name: 'PRALI',
        istatCode: '001001202'
    },
    {
        name: 'PRALORMO',
        istatCode: '001001203'
    },
    {
        name: 'PRALUNGO',
        istatCode: '001096049'
    },
    {
        name: 'PRAMAGGIORE',
        istatCode: '005027030'
    },
    {
        name: 'PRAMOLLO',
        istatCode: '001001204'
    },
    {
        name: 'PRAROLO',
        istatCode: '001002104'
    },
    {
        name: 'PRAROSTINO',
        istatCode: '001001205'
    },
    {
        name: 'PRASCO',
        istatCode: '001006139'
    },
    {
        name: 'PRASCORSANO',
        istatCode: '001001206'
    },
    {
        name: 'PRASO',
        istatCode: '004022146'
    },
    {
        name: 'PRATA CAMPORTACCIO',
        istatCode: '003014054'
    },
    {
        name: 'PRATA D\'ANSIDONIA',
        istatCode: '013066074'
    },
    {
        name: 'PRATA DI PORDENONE',
        istatCode: '006093034'
    },
    {
        name: 'PRATA DI PRINCIPATO ULTRA',
        istatCode: '015064074'
    },
    {
        name: 'PRATA SANNITA',
        istatCode: '015061063'
    },
    {
        name: 'PRATELLA',
        istatCode: '015061064'
    },
    {
        name: 'PRATIGLIONE',
        istatCode: '001001207'
    },
    {
        name: 'PRATO',
        istatCode: '009100005'
    },
    {
        name: 'PRATO ALLO STELVIO - PRAD AM STILFSER JOCH',
        istatCode: '004021067'
    },
    {
        name: 'PRATO CARNICO',
        istatCode: '006030081'
    },
    {
        name: 'PRATO SESIA',
        istatCode: '001003122'
    },
    {
        name: 'PRATOLA PELIGNA',
        istatCode: '013066075'
    },
    {
        name: 'PRATOLA SERRA',
        istatCode: '015064075'
    },
    {
        name: 'PRATOVECCHIO',
        istatCode: '009051032'
    },
    {
        name: 'PRATOVECCHIO STIA',
        istatCode: '009051041'
    },
    {
        name: 'PRAVISDOMINI',
        istatCode: '006093035'
    },
    {
        name: 'PRAY',
        istatCode: '001096050'
    },
    {
        name: 'PRAZZO',
        istatCode: '001004174'
    },
    {
        name: 'PRECENICCO',
        istatCode: '006030082'
    },
    {
        name: 'PRECI',
        istatCode: '010054043'
    },
    {
        name: 'PREDAIA',
        istatCode: '004022230'
    },
    {
        name: 'PREDAPPIO',
        istatCode: '008040032'
    },
    {
        name: 'PREDAZZO',
        istatCode: '004022147'
    },
    {
        name: 'PREDOI - PRETTAU',
        istatCode: '004021068'
    },
    {
        name: 'PREDORE',
        istatCode: '003016174'
    },
    {
        name: 'PREDOSA',
        istatCode: '001006140'
    },
    {
        name: 'PREGANZIOL',
        istatCode: '005026063'
    },
    {
        name: 'PREGNANA MILANESE',
        istatCode: '003015179'
    },
    {
        name: 'PRELA\'',
        istatCode: '007008047'
    },
    {
        name: 'PREMANA',
        istatCode: '003097069'
    },
    {
        name: 'PREMARIACCO',
        istatCode: '006030083'
    },
    {
        name: 'PREMENO',
        istatCode: '001103055'
    },
    {
        name: 'PREMIA',
        istatCode: '001103056'
    },
    {
        name: 'PREMILCUORE',
        istatCode: '008040033'
    },
    {
        name: 'PREMOLO',
        istatCode: '003016175'
    },
    {
        name: 'PREMOSELLO-CHIOVENDA',
        istatCode: '001103057'
    },
    {
        name: 'PREONE',
        istatCode: '006030084'
    },
    {
        name: 'PREORE',
        istatCode: '004022148'
    },
    {
        name: 'PREPOTTO',
        istatCode: '006030085'
    },
    {
        name: 'PRE\'-SAINT-DIDIER',
        istatCode: '002007053'
    },
    {
        name: 'PRESEGLIE',
        istatCode: '003017153'
    },
    {
        name: 'PRESENZANO',
        istatCode: '015061065'
    },
    {
        name: 'PRESEZZO',
        istatCode: '003016176'
    },
    {
        name: 'PRESICCE',
        istatCode: '016075062'
    },
    {
        name: 'PRESICCE-ACUARICA',
        istatCode: '016075098'
    },
    {
        name: 'PRESSANA',
        istatCode: '005023061'
    },
    {
        name: 'PRESTINE',
        istatCode: '003017154'
    },
    {
        name: 'PRETORO',
        istatCode: '013069069'
    },
    {
        name: 'PRETURO',
        istatCode: '013066805'
    },
    {
        name: 'PREVALLE',
        istatCode: '003017155'
    },
    {
        name: 'PREZZA',
        istatCode: '013066076'
    },
    {
        name: 'PREZZO',
        istatCode: '004022149'
    },
    {
        name: 'PRIERO',
        istatCode: '001004175'
    },
    {
        name: 'PRIERO MONTEZEMOLO',
        istatCode: '001004814'
    },
    {
        name: 'PRIGNANO CILENTO',
        istatCode: '015065103'
    },
    {
        name: 'PRIGNANO SULLA SECCHIA',
        istatCode: '008036033'
    },
    {
        name: 'PRIMALUNA',
        istatCode: '003097070'
    },
    {
        name: 'PRIMIERO',
        istatCode: '004022895'
    },
    {
        name: 'PRIMIERO SAN MARTINO DI CASTROZZA',
        istatCode: '004022245'
    },
    {
        name: 'PRIOCCA',
        istatCode: '001004176'
    },
    {
        name: 'PRIOLA',
        istatCode: '001004177'
    },
    {
        name: 'PRIOLO GARGALLO',
        istatCode: '019089021'
    },
    {
        name: 'PRIVERNO',
        istatCode: '012059019'
    },
    {
        name: 'PRIZZI',
        istatCode: '019082060'
    },
    {
        name: 'PROCENO',
        istatCode: '012056044'
    },
    {
        name: 'PROCIDA',
        istatCode: '015063061'
    },
    {
        name: 'PROPATA',
        istatCode: '007010045'
    },
    {
        name: 'PROSERPIO',
        istatCode: '003013192'
    },
    {
        name: 'PROSSEDI',
        istatCode: '012059020'
    },
    {
        name: 'PROVAGLIO D\'ISEO',
        istatCode: '003017156'
    },
    {
        name: 'PROVAGLIO VAL SABBIA',
        istatCode: '003017157'
    },
    {
        name: 'PROVES - PROVEIS',
        istatCode: '004021069'
    },
    {
        name: 'PROVVIDENTI',
        istatCode: '014070056'
    },
    {
        name: 'PRUNETTO',
        istatCode: '001004178'
    },
    {
        name: 'PUEGNAGO SUL GARDA',
        istatCode: '003017158'
    },
    {
        name: 'PUGLIANELLO',
        istatCode: '015062055'
    },
    {
        name: 'PULA',
        istatCode: '020092050'
    },
    {
        name: 'PULFERO',
        istatCode: '006030086'
    },
    {
        name: 'PULSANO',
        istatCode: '016073022'
    },
    {
        name: 'PUMENENGO',
        istatCode: '003016177'
    },
    {
        name: 'PUOS D\'ALPAGO',
        istatCode: '005025041'
    },
    {
        name: 'PUSIANO',
        istatCode: '003013193'
    },
    {
        name: 'PUTIFIGARI',
        istatCode: '020090060'
    },
    {
        name: 'PUTIGNANO',
        istatCode: '016072036'
    },
    {
        name: 'QUADRELLE',
        istatCode: '015064076'
    },
    {
        name: 'QUADRI',
        istatCode: '013069070'
    },
    {
        name: 'QUAGLIUZZO',
        istatCode: '001001208'
    },
    {
        name: 'QUALIANO',
        istatCode: '015063062'
    },
    {
        name: 'QUARANTI',
        istatCode: '001005088'
    },
    {
        name: 'QUAREGNA',
        istatCode: '001096051'
    },
    {
        name: 'QUAREGNA CERRETO',
        istatCode: '001096087'
    },
    {
        name: 'QUARGNENTO',
        istatCode: '001006141'
    },
    {
        name: 'QUARNA',
        istatCode: '001003877'
    },
    {
        name: 'QUARNA SOPRA',
        istatCode: '001103058'
    },
    {
        name: 'QUARNA SOTTO',
        istatCode: '001103059'
    },
    {
        name: 'QUARONA',
        istatCode: '001002107'
    },
    {
        name: 'QUARRATA',
        istatCode: '009047017'
    },
    {
        name: 'QUART',
        istatCode: '002007054'
    },
    {
        name: 'QUARTO',
        istatCode: '015063063'
    },
    {
        name: 'QUARTO D\'ALTINO',
        istatCode: '005027031'
    },
    {
        name: 'QUARTU SANT\'ELENA',
        istatCode: '020092051'
    },
    {
        name: 'QUARTUCCIU',
        istatCode: '020092105'
    },
    {
        name: 'QUASSOLO',
        istatCode: '001001209'
    },
    {
        name: 'QUATTORDIO',
        istatCode: '001006142'
    },
    {
        name: 'QUATTRO CASTELLA',
        istatCode: '008035030'
    },
    {
        name: 'QUERO',
        istatCode: '005025042'
    },
    {
        name: 'QUERO VAS',
        istatCode: '005025070'
    },
    {
        name: 'QUILIANO',
        istatCode: '007009052'
    },
    {
        name: 'QUINCINETTO',
        istatCode: '001001210'
    },
    {
        name: 'QUINDICI',
        istatCode: '015064077'
    },
    {
        name: 'QUINGENTOLE',
        istatCode: '003020046'
    },
    {
        name: 'QUINTANO',
        istatCode: '003019078'
    },
    {
        name: 'QUINTO DI TREVISO',
        istatCode: '005026064'
    },
    {
        name: 'QUINTO DI VALPANTENA',
        istatCode: '005023815'
    },
    {
        name: 'QUINTO VERCELLESE',
        istatCode: '001002108'
    },
    {
        name: 'QUINTO VICENTINO',
        istatCode: '005024083'
    },
    {
        name: 'QUINZANO D\'OGLIO',
        istatCode: '003017159'
    },
    {
        name: 'QUISTELLO',
        istatCode: '003020047'
    },
    {
        name: 'QUITTENGO',
        istatCode: '001096052'
    },
    {
        name: 'RABBI',
        istatCode: '004022150'
    },
    {
        name: 'RACALE',
        istatCode: '016075063'
    },
    {
        name: 'RACALMUTO',
        istatCode: '019084029'
    },
    {
        name: 'RACCONIGI',
        istatCode: '001004179'
    },
    {
        name: 'RACCUJA',
        istatCode: '019083069'
    },
    {
        name: 'RACINES - RATSCHINGS',
        istatCode: '004021070'
    },
    {
        name: 'RADDA IN CHIANTI',
        istatCode: '009052023'
    },
    {
        name: 'RADDUSA',
        istatCode: '019087036'
    },
    {
        name: 'RADICOFANI',
        istatCode: '009052024'
    },
    {
        name: 'RADICONDOLI',
        istatCode: '009052025'
    },
    {
        name: 'RAFFADALI',
        istatCode: '019084030'
    },
    {
        name: 'RAGALNA',
        istatCode: '019087058'
    },
    {
        name: 'RAGOGNA',
        istatCode: '006030087'
    },
    {
        name: 'RAGOLI',
        istatCode: '004022151'
    },
    {
        name: 'RAGUSA',
        istatCode: '019088009'
    },
    {
        name: 'RAGUSA IBLA(fino al 12/01/1927)',
        istatCode: '019088801'
    },
    {
        name: 'RAIANO',
        istatCode: '013066077'
    },
    {
        name: 'RAMACCA',
        istatCode: '019087037'
    },
    {
        name: 'RAMISETO',
        istatCode: '008035031'
    },
    {
        name: 'RAMO DI PALO',
        istatCode: '005029811'
    },
    {
        name: 'RAMPONIO VERNA',
        istatCode: '003013194'
    },
    {
        name: 'RANCIO VALCUVIA',
        istatCode: '003012115'
    },
    {
        name: 'RANCO',
        istatCode: '003012116'
    },
    {
        name: 'RANDAZZO',
        istatCode: '019087038'
    },
    {
        name: 'RANICA',
        istatCode: '003016178'
    },
    {
        name: 'RANZANICO',
        istatCode: '003016179'
    },
    {
        name: 'RANZO',
        istatCode: '007008048'
    },
    {
        name: 'RAPAGNANO',
        istatCode: '011109035'
    },
    {
        name: 'RAPALLO',
        istatCode: '007010046'
    },
    {
        name: 'RAPINO',
        istatCode: '013069071'
    },
    {
        name: 'RAPOLANO TERME',
        istatCode: '009052026'
    },
    {
        name: 'RAPOLLA',
        istatCode: '017076064'
    },
    {
        name: 'RAPONE',
        istatCode: '017076065'
    },
    {
        name: 'RASSA',
        istatCode: '001002110'
    },
    {
        name: 'RASUN ANTERSELVA - RASEN-ANTHOLZ',
        istatCode: '004021071'
    },
    {
        name: 'RASUN VALDAORA',
        istatCode: '004021872'
    },
    {
        name: 'RASURA',
        istatCode: '003014055'
    },
    {
        name: 'RAVANUSA',
        istatCode: '019084031'
    },
    {
        name: 'RAVARINO',
        istatCode: '008036034'
    },
    {
        name: 'RAVASCLETTO',
        istatCode: '006030088'
    },
    {
        name: 'RAVELLO',
        istatCode: '015065104'
    },
    {
        name: 'RAVENNA',
        istatCode: '008039014'
    },
    {
        name: 'RAVEO',
        istatCode: '006030089'
    },
    {
        name: 'RAVISCANINA',
        istatCode: '015061066'
    },
    {
        name: 'RE',
        istatCode: '001103060'
    },
    {
        name: 'REA',
        istatCode: '003018119'
    },
    {
        name: 'REALMONTE',
        istatCode: '019084032'
    },
    {
        name: 'REANA DEL ROIALE',
        istatCode: '006030090'
    },
    {
        name: 'REANO',
        istatCode: '001001211'
    },
    {
        name: 'REBBIO',
        istatCode: '003013925'
    },
    {
        name: 'RECALE',
        istatCode: '015061067'
    },
    {
        name: 'RECANATI',
        istatCode: '011043044'
    },
    {
        name: 'RECCO',
        istatCode: '007010047'
    },
    {
        name: 'RECETTO',
        istatCode: '001003129'
    },
    {
        name: 'RECOARO TERME',
        istatCode: '005024084'
    },
    {
        name: 'REDAVALLE',
        istatCode: '003018120'
    },
    {
        name: 'REDONDESCO',
        istatCode: '003020048'
    },
    {
        name: 'REFRANCORE',
        istatCode: '001005089'
    },
    {
        name: 'REFRONTOLO',
        istatCode: '005026065'
    },
    {
        name: 'REGALBUTO',
        istatCode: '019086016'
    },
    {
        name: 'REGGELLO',
        istatCode: '009048035'
    },
    {
        name: 'REGGIO DI CALABRIA',
        istatCode: '018080063'
    },
    {
        name: 'REGGIO NELL\'EMILIA',
        istatCode: '008035033'
    },
    {
        name: 'REGGIOLO',
        istatCode: '008035032'
    },
    {
        name: 'REINO',
        istatCode: '015062056'
    },
    {
        name: 'REITANO',
        istatCode: '019083070'
    },
    {
        name: 'REMANZACCO',
        istatCode: '006030091'
    },
    {
        name: 'REMEDELLO',
        istatCode: '003017160'
    },
    {
        name: 'REMEDELLO SOPRA',
        istatCode: '003017885'
    },
    {
        name: 'RENATE',
        istatCode: '003108037'
    },
    {
        name: 'RENATE VEDUGGIO',
        istatCode: '003015533'
    },
    {
        name: 'RENDE',
        istatCode: '018078102'
    },
    {
        name: 'RENON - RITTEN',
        istatCode: '004021072'
    },
    {
        name: 'RESANA',
        istatCode: '005026066'
    },
    {
        name: 'RESCALDINA',
        istatCode: '003015181'
    },
    {
        name: 'RESIA',
        istatCode: '006030092'
    },
    {
        name: 'RESIUTTA',
        istatCode: '006030093'
    },
    {
        name: 'RESUTTANO',
        istatCode: '019085014'
    },
    {
        name: 'RETORBIDO',
        istatCode: '003018121'
    },
    {
        name: 'REVELLO',
        istatCode: '001004180'
    },
    {
        name: 'REVERE',
        istatCode: '003020049'
    },
    {
        name: 'REVIGLIASCO D\'ASTI',
        istatCode: '001005090'
    },
    {
        name: 'REVINE LAGO',
        istatCode: '005026067'
    },
    {
        name: 'REVO\'',
        istatCode: '004022152'
    },
    {
        name: 'REZZAGO',
        istatCode: '003013195'
    },
    {
        name: 'REZZATO',
        istatCode: '003017161'
    },
    {
        name: 'REZZO',
        istatCode: '007008049'
    },
    {
        name: 'REZZOAGLIO',
        istatCode: '007010048'
    },
    {
        name: 'REZZONICO',
        istatCode: '003013926'
    },
    {
        name: 'RHEMES-NOTRE-DAME',
        istatCode: '002007055'
    },
    {
        name: 'RHEMES-SAINT-GEORGES',
        istatCode: '002007056'
    },
    {
        name: 'RHO',
        istatCode: '003015182'
    },
    {
        name: 'RIACE',
        istatCode: '018080064'
    },
    {
        name: 'RIALTO',
        istatCode: '007009053'
    },
    {
        name: 'RIANO',
        istatCode: '012058081'
    },
    {
        name: 'RIARDO',
        istatCode: '015061068'
    },
    {
        name: 'RIBERA',
        istatCode: '019084033'
    },
    {
        name: 'RIBORDONE',
        istatCode: '001001212'
    },
    {
        name: 'RICADI',
        istatCode: '018102030'
    },
    {
        name: 'RICALDONE',
        istatCode: '001006143'
    },
    {
        name: 'RICCIA',
        istatCode: '014070057'
    },
    {
        name: 'RICCIONE',
        istatCode: '008099013'
    },
    {
        name: 'RICCO\' DEL GOLFO DI SPEZIA',
        istatCode: '007011023'
    },
    {
        name: 'RICENGO',
        istatCode: '003019079'
    },
    {
        name: 'RICIGLIANO',
        istatCode: '015065105'
    },
    {
        name: 'RIESE PIO X',
        istatCode: '005026068'
    },
    {
        name: 'RIESI',
        istatCode: '019085015'
    },
    {
        name: 'RIETI',
        istatCode: '012057059'
    },
    {
        name: 'RIFIANO - RIFFIAN',
        istatCode: '004021073'
    },
    {
        name: 'RIFREDDO',
        istatCode: '001004181'
    },
    {
        name: 'RIGNANO FLAMINIO',
        istatCode: '012058082'
    },
    {
        name: 'RIGNANO GARGANICO',
        istatCode: '016071041'
    },
    {
        name: 'RIGNANO SULL\'ARNO',
        istatCode: '009048036'
    },
    {
        name: 'RIGOLATO',
        istatCode: '006030094'
    },
    {
        name: 'RIMA SAN GIUSEPPE',
        istatCode: '001002111'
    },
    {
        name: 'RIMASCO',
        istatCode: '001002112'
    },
    {
        name: 'RIMELLA',
        istatCode: '001002113'
    },
    {
        name: 'RIMINI',
        istatCode: '008099014'
    },
    {
        name: 'RIO',
        istatCode: '009049021'
    },
    {
        name: 'RIO DI PUSTERIA - MUEHLBACH',
        istatCode: '004021074'
    },
    {
        name: 'RIO MARINA',
        istatCode: '009049015'
    },
    {
        name: 'RIO NELL\'ELBA',
        istatCode: '009049016'
    },
    {
        name: 'RIO SALICETO',
        istatCode: '008035034'
    },
    {
        name: 'RIOFREDDO',
        istatCode: '012058083'
    },
    {
        name: 'RIOLA SARDO',
        istatCode: '020095043'
    },
    {
        name: 'RIOLO TERME',
        istatCode: '008039015'
    },
    {
        name: 'RIOLUNATO',
        istatCode: '008036035'
    },
    {
        name: 'RIOMAGGIORE',
        istatCode: '007011024'
    },
    {
        name: 'RIONERO IN VULTURE',
        istatCode: '017076066'
    },
    {
        name: 'RIONERO SANNITICO',
        istatCode: '014094039'
    },
    {
        name: 'RIPA TEATINA',
        istatCode: '013069072'
    },
    {
        name: 'RIPABOTTONI',
        istatCode: '014070058'
    },
    {
        name: 'RIPACANDIDA',
        istatCode: '017076067'
    },
    {
        name: 'RIPALIMOSANI',
        istatCode: '014070059'
    },
    {
        name: 'RIPALTA ARPINA',
        istatCode: '003019080'
    },
    {
        name: 'RIPALTA CREMASCA',
        istatCode: '003019081'
    },
    {
        name: 'RIPALTA GUERINA',
        istatCode: '003019082'
    },
    {
        name: 'RIPARBELLA',
        istatCode: '009050030'
    },
    {
        name: 'RIPATRANSONE',
        istatCode: '011044063'
    },
    {
        name: 'RIPE',
        istatCode: '011042039'
    },
    {
        name: 'RIPE SAN GINESIO',
        istatCode: '011043045'
    },
    {
        name: 'RIPI',
        istatCode: '012060058'
    },
    {
        name: 'RIPOSTO',
        istatCode: '019087039'
    },
    {
        name: 'RITTANA',
        istatCode: '001004182'
    },
    {
        name: 'RIVA DEL GARDA',
        istatCode: '004022153'
    },
    {
        name: 'RIVA DEL PO',
        istatCode: '008038029'
    },
    {
        name: 'RIVA DI SOLTO',
        istatCode: '003016180'
    },
    {
        name: 'RIVA LIGURE',
        istatCode: '007008050'
    },
    {
        name: 'RIVA PRESSO CHIERI',
        istatCode: '001001215'
    },
    {
        name: 'RIVA SANTO STEFANO',
        istatCode: '007008831'
    },
    {
        name: 'RIVA VALDOBBIA',
        istatCode: '001002114'
    },
    {
        name: 'RIVALBA',
        istatCode: '001001213'
    },
    {
        name: 'RIVALTA BORMIDA',
        istatCode: '001006144'
    },
    {
        name: 'RIVALTA DI TORINO',
        istatCode: '001001214'
    },
    {
        name: 'RIVAMONTE AGORDINO',
        istatCode: '005025043'
    },
    {
        name: 'RIVANAZZANO',
        istatCode: '003018122'
    },
    {
        name: 'RIVARA',
        istatCode: '001001216'
    },
    {
        name: 'RIVAROLO CANAVESE',
        istatCode: '001001217'
    },
    {
        name: 'RIVAROLO DEL RE ED UNITI',
        istatCode: '003019083'
    },
    {
        name: 'RIVAROLO MANTOVANO',
        istatCode: '003020050'
    },
    {
        name: 'RIVARONE',
        istatCode: '001006145'
    },
    {
        name: 'RIVAROSSA',
        istatCode: '001001218'
    },
    {
        name: 'RIVE',
        istatCode: '001002115'
    },
    {
        name: 'RIVE D\'ARCANO',
        istatCode: '006030095'
    },
    {
        name: 'RIVELLO',
        istatCode: '017076068'
    },
    {
        name: 'RIVERGARO',
        istatCode: '008033038'
    },
    {
        name: 'RIVIERA D\'ADDA',
        istatCode: '003016181'
    },
    {
        name: 'RIVIGNANO',
        istatCode: '006030096'
    },
    {
        name: 'RIVIGNANO TEOR',
        istatCode: '006030188'
    },
    {
        name: 'RIVISONDOLI',
        istatCode: '013066078'
    },
    {
        name: 'RIVODUTRI',
        istatCode: '012057060'
    },
    {
        name: 'RIVOLI',
        istatCode: '001001219'
    },
    {
        name: 'RIVOLI VERONESE',
        istatCode: '005023062'
    },
    {
        name: 'RIVOLTA D\'ADDA',
        istatCode: '003019084'
    },
    {
        name: 'RIZZICONI',
        istatCode: '018080065'
    },
    {
        name: 'RO',
        istatCode: '008038020'
    },
    {
        name: 'ROANA',
        istatCode: '005024085'
    },
    {
        name: 'ROASCHIA',
        istatCode: '001004183'
    },
    {
        name: 'ROASCIO',
        istatCode: '001004184'
    },
    {
        name: 'ROASIO',
        istatCode: '001002116'
    },
    {
        name: 'ROATTO',
        istatCode: '001005091'
    },
    {
        name: 'ROBASSOMERO',
        istatCode: '001001220'
    },
    {
        name: 'ROBBIATE',
        istatCode: '003097071'
    },
    {
        name: 'ROBBIO',
        istatCode: '003018123'
    },
    {
        name: 'ROBECCHETTO CON INDUNO',
        istatCode: '003015183'
    },
    {
        name: 'ROBECCO D\'OGLIO',
        istatCode: '003019085'
    },
    {
        name: 'ROBECCO PAVESE',
        istatCode: '003018124'
    },
    {
        name: 'ROBECCO SUL NAVIGLIO',
        istatCode: '003015184'
    },
    {
        name: 'ROBELLA',
        istatCode: '001005092'
    },
    {
        name: 'ROBILANTE',
        istatCode: '001004185'
    },
    {
        name: 'ROBURENT',
        istatCode: '001004186'
    },
    {
        name: 'ROCCA CANAVESE',
        istatCode: '001001221'
    },
    {
        name: 'ROCCA CANTERANO',
        istatCode: '012058084'
    },
    {
        name: 'ROCCA CIGLIE\'',
        istatCode: '001004188'
    },
    {
        name: 'ROCCA D\'ARAZZO',
        istatCode: '001005093'
    },
    {
        name: 'ROCCA D\'ARCE',
        istatCode: '012060059'
    },
    {
        name: 'ROCCA DE\' BALDI',
        istatCode: '001004189'
    },
    {
        name: 'ROCCA DE\' GIORGI',
        istatCode: '003018125'
    },
    {
        name: 'ROCCA DEL COLLE',
        istatCode: '003016854'
    },
    {
        name: 'ROCCA D\'EVANDRO',
        istatCode: '015061069'
    },
    {
        name: 'ROCCA DI BOTTE',
        istatCode: '013066080'
    },
    {
        name: 'ROCCA DI CAMBIO',
        istatCode: '013066081'
    },
    {
        name: 'ROCCA DI CAVE',
        istatCode: '012058085'
    },
    {
        name: 'ROCCA DI MEZZO',
        istatCode: '013066082'
    },
    {
        name: 'ROCCA DI NETO',
        istatCode: '018101019'
    },
    {
        name: 'ROCCA DI PAPA',
        istatCode: '012058086'
    },
    {
        name: 'ROCCA GRIMALDA',
        istatCode: '001006147'
    },
    {
        name: 'ROCCA IMPERIALE',
        istatCode: '018078103'
    },
    {
        name: 'ROCCA MASSIMA',
        istatCode: '012059022'
    },
    {
        name: 'ROCCA PIA',
        istatCode: '013066083'
    },
    {
        name: 'ROCCA PIETORE',
        istatCode: '005025044'
    },
    {
        name: 'ROCCA PRIORA',
        istatCode: '012058088'
    },
    {
        name: 'ROCCA SAN CASCIANO',
        istatCode: '008040036'
    },
    {
        name: 'ROCCA SAN FELICE',
        istatCode: '015064079'
    },
    {
        name: 'ROCCA SAN GIOVANNI',
        istatCode: '013069074'
    },
    {
        name: 'ROCCA SANTA MARIA',
        istatCode: '013067036'
    },
    {
        name: 'ROCCA SANTO STEFANO',
        istatCode: '012058089'
    },
    {
        name: 'ROCCA SINIBALDA',
        istatCode: '012057062'
    },
    {
        name: 'ROCCA SUSELLA',
        istatCode: '003018126'
    },
    {
        name: 'ROCCABASCERANA',
        istatCode: '015064078'
    },
    {
        name: 'ROCCABERNARDA',
        istatCode: '018101018'
    },
    {
        name: 'ROCCABIANCA',
        istatCode: '008034030'
    },
    {
        name: 'ROCCABRUNA',
        istatCode: '001004187'
    },
    {
        name: 'ROCCACASALE',
        istatCode: '013066079'
    },
    {
        name: 'ROCCADASPIDE',
        istatCode: '015065106'
    },
    {
        name: 'ROCCAFIORITA',
        istatCode: '019083071'
    },
    {
        name: 'ROCCAFLUVIONE',
        istatCode: '011044064'
    },
    {
        name: 'ROCCAFORTE DEL GRECO',
        istatCode: '018080066'
    },
    {
        name: 'ROCCAFORTE LIGURE',
        istatCode: '001006146'
    },
    {
        name: 'ROCCAFORTE MONDOVI\'',
        istatCode: '001004190'
    },
    {
        name: 'ROCCAFORZATA',
        istatCode: '016073023'
    },
    {
        name: 'ROCCAFRANCA',
        istatCode: '003017162'
    },
    {
        name: 'ROCCAGIOVINE',
        istatCode: '012058087'
    },
    {
        name: 'ROCCAGLORIOSA',
        istatCode: '015065107'
    },
    {
        name: 'ROCCAGORGA',
        istatCode: '012059021'
    },
    {
        name: 'ROCCALBEGNA',
        istatCode: '009053020'
    },
    {
        name: 'ROCCALUMERA',
        istatCode: '019083072'
    },
    {
        name: 'ROCCAMANDOLFI',
        istatCode: '014094040'
    },
    {
        name: 'ROCCAMENA',
        istatCode: '019082061'
    },
    {
        name: 'ROCCAMONFINA',
        istatCode: '015061070'
    },
    {
        name: 'ROCCAMONTEPIANO',
        istatCode: '013069073'
    },
    {
        name: 'ROCCAMORICE',
        istatCode: '013068034'
    },
    {
        name: 'ROCCANOVA',
        istatCode: '017076069'
    },
    {
        name: 'ROCCANTICA',
        istatCode: '012057061'
    },
    {
        name: 'ROCCAPALUMBA',
        istatCode: '019082062'
    },
    {
        name: 'ROCCAPIEMONTE',
        istatCode: '015065108'
    },
    {
        name: 'ROCCARAINOLA',
        istatCode: '015063065'
    },
    {
        name: 'ROCCARASO',
        istatCode: '013066084'
    },
    {
        name: 'ROCCAROMANA',
        istatCode: '015061071'
    },
    {
        name: 'ROCCASCALEGNA',
        istatCode: '013069075'
    },
    {
        name: 'ROCCASECCA',
        istatCode: '012060060'
    },
    {
        name: 'ROCCASECCA DEI VOLSCI',
        istatCode: '012059023'
    },
    {
        name: 'ROCCASICURA',
        istatCode: '014094041'
    },
    {
        name: 'ROCCASPARVERA',
        istatCode: '001004191'
    },
    {
        name: 'ROCCASPINALVETI',
        istatCode: '013069076'
    },
    {
        name: 'ROCCASTRADA',
        istatCode: '009053021'
    },
    {
        name: 'ROCCAVALDINA',
        istatCode: '019083073'
    },
    {
        name: 'ROCCAVERANO',
        istatCode: '001005094'
    },
    {
        name: 'ROCCAVIGNALE',
        istatCode: '007009054'
    },
    {
        name: 'ROCCAVIONE',
        istatCode: '001004192'
    },
    {
        name: 'ROCCAVIVARA',
        istatCode: '014070060'
    },
    {
        name: 'ROCCELLA IONICA',
        istatCode: '018080067'
    },
    {
        name: 'ROCCELLA VALDEMONE',
        istatCode: '019083074'
    },
    {
        name: 'ROCCHETTA A VOLTURNO',
        istatCode: '014094042'
    },
    {
        name: 'ROCCHETTA BELBO',
        istatCode: '001004193'
    },
    {
        name: 'ROCCHETTA DI VARA',
        istatCode: '007011025'
    },
    {
        name: 'ROCCHETTA E CROCE',
        istatCode: '015061072'
    },
    {
        name: 'ROCCHETTA LIGURE',
        istatCode: '001006148'
    },
    {
        name: 'ROCCHETTA NERVINA',
        istatCode: '007008051'
    },
    {
        name: 'ROCCHETTA PALAFEA',
        istatCode: '001005095'
    },
    {
        name: 'ROCCHETTA SANT\'ANTONIO',
        istatCode: '016071042'
    },
    {
        name: 'ROCCHETTA TANARO',
        istatCode: '001005096'
    },
    {
        name: 'RODANO',
        istatCode: '003015185'
    },
    {
        name: 'RODDI',
        istatCode: '001004194'
    },
    {
        name: 'RODDINO',
        istatCode: '001004195'
    },
    {
        name: 'RODELLO',
        istatCode: '001004196'
    },
    {
        name: 'RODENGO',
        istatCode: '003017888'
    },
    {
        name: 'RODENGO - RODENECK',
        istatCode: '004021075'
    },
    {
        name: 'RODENGO SAIANO',
        istatCode: '003017163'
    },
    {
        name: 'RODERO',
        istatCode: '003013197'
    },
    {
        name: 'RODI GARGANICO',
        istatCode: '016071043'
    },
    {
        name: 'RODI\' MILICI',
        istatCode: '019083075'
    },
    {
        name: 'RODIGO',
        istatCode: '003020051'
    },
    {
        name: 'ROE\' VOLCIANO',
        istatCode: '003017164'
    },
    {
        name: 'ROFRANO',
        istatCode: '015065109'
    },
    {
        name: 'ROGENO',
        istatCode: '003097072'
    },
    {
        name: 'ROGGIANO GRAVINA',
        istatCode: '018078104'
    },
    {
        name: 'ROGHUDI',
        istatCode: '018080068'
    },
    {
        name: 'ROGLIANO',
        istatCode: '018078105'
    },
    {
        name: 'ROGNANO',
        istatCode: '003018127'
    },
    {
        name: 'ROGNO',
        istatCode: '003016182'
    },
    {
        name: 'ROGOLO',
        istatCode: '003014056'
    },
    {
        name: 'ROIATE',
        istatCode: '012058090'
    },
    {
        name: 'ROIO DEL SANGRO',
        istatCode: '013069077'
    },
    {
        name: 'ROISAN',
        istatCode: '002007057'
    },
    {
        name: 'ROLETTO',
        istatCode: '001001222'
    },
    {
        name: 'ROLO',
        istatCode: '008035035'
    },
    {
        name: 'ROMA',
        istatCode: '012058091'
    },
    {
        name: 'ROMAGNANO',
        istatCode: '004022901'
    },
    {
        name: 'ROMAGNANO AL MONTE',
        istatCode: '015065110'
    },
    {
        name: 'ROMAGNANO SESIA',
        istatCode: '001003130'
    },
    {
        name: 'ROMAGNESE',
        istatCode: '003018128'
    },
    {
        name: 'ROMALLO',
        istatCode: '004022154'
    },
    {
        name: 'ROMANA',
        istatCode: '020090061'
    },
    {
        name: 'ROMANENGO',
        istatCode: '003019086'
    },
    {
        name: 'ROMANÒ BRIANZA',
        istatCode: '003013927'
    },
    {
        name: 'ROMANO CANAVESE',
        istatCode: '001001223'
    },
    {
        name: 'ROMANO D\'EZZELINO',
        istatCode: '005024086'
    },
    {
        name: 'ROMANO DI LOMBARDIA',
        istatCode: '003016183'
    },
    {
        name: 'ROMANS D\'ISONZO',
        istatCode: '006031015'
    },
    {
        name: 'ROMBIOLO',
        istatCode: '018102031'
    },
    {
        name: 'ROMENO',
        istatCode: '004022155'
    },
    {
        name: 'ROMENTINO',
        istatCode: '001003131'
    },
    {
        name: 'ROMETTA',
        istatCode: '019083076'
    },
    {
        name: 'RONAGO',
        istatCode: '003013199'
    },
    {
        name: 'RONCA\'',
        istatCode: '005023063'
    },
    {
        name: 'RONCADE',
        istatCode: '005026069'
    },
    {
        name: 'RONCADELLE',
        istatCode: '003017165'
    },
    {
        name: 'RONCARO',
        istatCode: '003018129'
    },
    {
        name: 'RONCEGNO',
        istatCode: '004022156'
    },
    {
        name: 'RONCELLO',
        istatCode: '003108055'
    },
    {
        name: 'RONCHI DEI LEGIONARI',
        istatCode: '006031016'
    },
    {
        name: 'RONCHI DI ALA',
        istatCode: '004022541'
    },
    {
        name: 'RONCHI VALSUGANA',
        istatCode: '004022157'
    },
    {
        name: 'RONCHIS',
        istatCode: '006030097'
    },
    {
        name: 'RONCIGLIONE',
        istatCode: '012056045'
    },
    {
        name: 'RONCO ALL\'ADIGE',
        istatCode: '005023064'
    },
    {
        name: 'RONCO BIELLESE',
        istatCode: '001096053'
    },
    {
        name: 'RONCO BRIANTINO',
        istatCode: '003108038'
    },
    {
        name: 'RONCO CANAVESE',
        istatCode: '001001224'
    },
    {
        name: 'RONCO SCRIVIA',
        istatCode: '007010049'
    },
    {
        name: 'RONCOBELLO',
        istatCode: '003016184'
    },
    {
        name: 'RONCOFERRARO',
        istatCode: '003020052'
    },
    {
        name: 'RONCOFREDDO',
        istatCode: '008040037'
    },
    {
        name: 'RONCOLA',
        istatCode: '003016185'
    },
    {
        name: 'RONCONE',
        istatCode: '004022158'
    },
    {
        name: 'RONDANINA',
        istatCode: '007010050'
    },
    {
        name: 'RONDISSONE',
        istatCode: '001001225'
    },
    {
        name: 'RONSECCO',
        istatCode: '001002118'
    },
    {
        name: 'RONZO-CHIENIS',
        istatCode: '004022135'
    },
    {
        name: 'RONZONE',
        istatCode: '004022159'
    },
    {
        name: 'ROPPOLO',
        istatCode: '001096054'
    },
    {
        name: 'RORA\'',
        istatCode: '001001226'
    },
    {
        name: 'ROSA\'',
        istatCode: '005024087'
    },
    {
        name: 'ROSALI',
        istatCode: '018080814'
    },
    {
        name: 'ROSARNO',
        istatCode: '018080069'
    },
    {
        name: 'ROSASCO',
        istatCode: '003018130'
    },
    {
        name: 'ROSATE',
        istatCode: '003015188'
    },
    {
        name: 'ROSAZZA',
        istatCode: '001096055'
    },
    {
        name: 'ROSCIANO',
        istatCode: '013068035'
    },
    {
        name: 'ROSCIGNO',
        istatCode: '015065111'
    },
    {
        name: 'ROSE',
        istatCode: '018078106'
    },
    {
        name: 'ROSELLO',
        istatCode: '013069078'
    },
    {
        name: 'ROSETO CAPO SPULICO',
        istatCode: '018078107'
    },
    {
        name: 'ROSETO DEGLI ABRUZZI',
        istatCode: '013067037'
    },
    {
        name: 'ROSETO VALFORTORE',
        istatCode: '016071044'
    },
    {
        name: 'ROSIGNANO MARITTIMO',
        istatCode: '009049017'
    },
    {
        name: 'ROSIGNANO MONFERRATO',
        istatCode: '001006149'
    },
    {
        name: 'ROSOLINA',
        istatCode: '005029040'
    },
    {
        name: 'ROSOLINI',
        istatCode: '019089016'
    },
    {
        name: 'ROSORA',
        istatCode: '011042040'
    },
    {
        name: 'ROSORA MERGO',
        istatCode: '011042803'
    },
    {
        name: 'ROSSA',
        istatCode: '001002121'
    },
    {
        name: 'ROSSANA',
        istatCode: '001004197'
    },
    {
        name: 'ROSSANO',
        istatCode: '018078108'
    },
    {
        name: 'ROSSANO VENETO',
        istatCode: '005024088'
    },
    {
        name: 'ROSSIGLIONE',
        istatCode: '007010051'
    },
    {
        name: 'ROSTA',
        istatCode: '001001228'
    },
    {
        name: 'ROTA D\'IMAGNA',
        istatCode: '003016186'
    },
    {
        name: 'ROTA GRECA',
        istatCode: '018078109'
    },
    {
        name: 'ROTELLA',
        istatCode: '011044065'
    },
    {
        name: 'ROTELLO',
        istatCode: '014070061'
    },
    {
        name: 'ROTONDA',
        istatCode: '017076070'
    },
    {
        name: 'ROTONDELLA',
        istatCode: '017077023'
    },
    {
        name: 'ROTONDI',
        istatCode: '015064080'
    },
    {
        name: 'ROTTOFRENO',
        istatCode: '008033039'
    },
    {
        name: 'ROTZO',
        istatCode: '005024089'
    },
    {
        name: 'ROURE',
        istatCode: '001001227'
    },
    {
        name: 'ROVAGNATE',
        istatCode: '003097073'
    },
    {
        name: 'ROVASENDA',
        istatCode: '001002122'
    },
    {
        name: 'ROVATO',
        istatCode: '003017166'
    },
    {
        name: 'ROVEGNO',
        istatCode: '007010052'
    },
    {
        name: 'ROVELLASCA',
        istatCode: '003013201'
    },
    {
        name: 'ROVELLO PORRO',
        istatCode: '003013202'
    },
    {
        name: 'ROVERBELLA',
        istatCode: '003020053'
    },
    {
        name: 'ROVERCHIARA',
        istatCode: '005023065'
    },
    {
        name: 'ROVERE\' DELLA LUNA',
        istatCode: '004022160'
    },
    {
        name: 'ROVERE\' VERONESE',
        istatCode: '005023067'
    },
    {
        name: 'ROVEREDO DI GUA\'',
        istatCode: '005023066'
    },
    {
        name: 'ROVEREDO IN PIANO',
        istatCode: '006093036'
    },
    {
        name: 'ROVERETO',
        istatCode: '004022161'
    },
    {
        name: 'ROVESCALA',
        istatCode: '003018131'
    },
    {
        name: 'ROVETTA',
        istatCode: '003016187'
    },
    {
        name: 'ROVETTA CON FINO',
        istatCode: '003016859'
    },
    {
        name: 'ROVIANO',
        istatCode: '012058092'
    },
    {
        name: 'ROVIGNO D\'ISTRIA',
        istatCode: '006702733'
    },
    {
        name: 'ROVIGO',
        istatCode: '005029041'
    },
    {
        name: 'ROVITO',
        istatCode: '018078110'
    },
    {
        name: 'ROVOLON',
        istatCode: '005028071'
    },
    {
        name: 'ROZZANO',
        istatCode: '003015189'
    },
    {
        name: 'RUBANO',
        istatCode: '005028072'
    },
    {
        name: 'RUBIANA',
        istatCode: '001001229'
    },
    {
        name: 'RUBIERA',
        istatCode: '008035036'
    },
    {
        name: 'RUDA',
        istatCode: '006030098'
    },
    {
        name: 'RUDIANO',
        istatCode: '003017167'
    },
    {
        name: 'RUEGLIO',
        istatCode: '001001230'
    },
    {
        name: 'RUFFANO',
        istatCode: '016075064'
    },
    {
        name: 'RUFFIA',
        istatCode: '001004198'
    },
    {
        name: 'RUFFRE\'',
        istatCode: '004022162'
    },
    {
        name: 'RUFINA',
        istatCode: '009048037'
    },
    {
        name: 'RUINAS',
        istatCode: '020095044'
    },
    {
        name: 'RUINO',
        istatCode: '003018132'
    },
    {
        name: 'RUMO',
        istatCode: '004022163'
    },
    {
        name: 'RUOTI',
        istatCode: '017076071'
    },
    {
        name: 'RUSSI',
        istatCode: '008039016'
    },
    {
        name: 'RUTIGLIANO',
        istatCode: '016072037'
    },
    {
        name: 'RUTINO',
        istatCode: '015065112'
    },
    {
        name: 'RUVIANO',
        istatCode: '015061073'
    },
    {
        name: 'RUVO DEL MONTE',
        istatCode: '017076072'
    },
    {
        name: 'RUVO DI PUGLIA',
        istatCode: '016072038'
    },
    {
        name: 'SABAUDIA',
        istatCode: '012059024'
    },
    {
        name: 'SABBIA',
        istatCode: '001002123'
    },
    {
        name: 'SABBIO CHIESE',
        istatCode: '003017168'
    },
    {
        name: 'SABBIONCELLO',
        istatCode: '003013930'
    },
    {
        name: 'SABBIONETA',
        istatCode: '003020054'
    },
    {
        name: 'SACCO',
        istatCode: '015065113'
    },
    {
        name: 'SACCOLONGO',
        istatCode: '005028073'
    },
    {
        name: 'SACILE',
        istatCode: '006093037'
    },
    {
        name: 'SACROFANO',
        istatCode: '012058093'
    },
    {
        name: 'SADALI',
        istatCode: '020111058'
    },
    {
        name: 'SAGAMA',
        istatCode: '020095086'
    },
    {
        name: 'SAGLIANO MICCA',
        istatCode: '001096056'
    },
    {
        name: 'SAGRADO',
        istatCode: '006031017'
    },
    {
        name: 'SAGRON MIS',
        istatCode: '004022164'
    },
    {
        name: 'SAINT-CHRISTOPHE',
        istatCode: '002007058'
    },
    {
        name: 'SAINT-DENIS',
        istatCode: '002007059'
    },
    {
        name: 'SAINT-MARCEL',
        istatCode: '002007060'
    },
    {
        name: 'SAINT-NICOLAS',
        istatCode: '002007061'
    },
    {
        name: 'SAINT-OYEN',
        istatCode: '002007062'
    },
    {
        name: 'SAINT-PIERRE',
        istatCode: '002007063'
    },
    {
        name: 'SAINT-RHEMY-EN-BOSSES',
        istatCode: '002007064'
    },
    {
        name: 'SAINT-VINCENT',
        istatCode: '002007065'
    },
    {
        name: 'SALA BAGANZA',
        istatCode: '008034031'
    },
    {
        name: 'SALA BIELLESE',
        istatCode: '001096057'
    },
    {
        name: 'SALA BOLOGNESE',
        istatCode: '008037050'
    },
    {
        name: 'SALA COMACINA',
        istatCode: '003013203'
    },
    {
        name: 'SALA CONSILINA',
        istatCode: '015065114'
    },
    {
        name: 'SALA MONFERRATO',
        istatCode: '001006150'
    },
    {
        name: 'SALANDRA',
        istatCode: '017077024'
    },
    {
        name: 'SALAPARUTA',
        istatCode: '019081017'
    },
    {
        name: 'SALARA',
        istatCode: '005029042'
    },
    {
        name: 'SALASCO',
        istatCode: '001002126'
    },
    {
        name: 'SALASSA',
        istatCode: '001001231'
    },
    {
        name: 'SALBERTRAND',
        istatCode: '001001232'
    },
    {
        name: 'SALCEDO',
        istatCode: '005024090'
    },
    {
        name: 'SALCITO',
        istatCode: '014070062'
    },
    {
        name: 'SALE',
        istatCode: '001006151'
    },
    {
        name: 'SALE DELLE LANGHE',
        istatCode: '001004199'
    },
    {
        name: 'SALE MARASINO',
        istatCode: '003017169'
    },
    {
        name: 'SALE SAN GIOVANNI',
        istatCode: '001004200'
    },
    {
        name: 'SALEMI',
        istatCode: '019081018'
    },
    {
        name: 'SALENTO',
        istatCode: '015065115'
    },
    {
        name: 'SALERANO CANAVESE',
        istatCode: '001001233'
    },
    {
        name: 'SALERANO SUL LAMBRO',
        istatCode: '003098046'
    },
    {
        name: 'SALERNO',
        istatCode: '015065116'
    },
    {
        name: 'SALETTO',
        istatCode: '005028074'
    },
    {
        name: 'SALGAREDA',
        istatCode: '005026070'
    },
    {
        name: 'SALI VERCELLESE',
        istatCode: '001002127'
    },
    {
        name: 'SALICE SALENTINO',
        istatCode: '016075065'
    },
    {
        name: 'SALICETO',
        istatCode: '001004201'
    },
    {
        name: 'SALISANO',
        istatCode: '012057063'
    },
    {
        name: 'SALIZZOLE',
        istatCode: '005023068'
    },
    {
        name: 'SALLE',
        istatCode: '013068036'
    },
    {
        name: 'SALMOUR',
        istatCode: '001004202'
    },
    {
        name: 'SALO\'',
        istatCode: '003017170'
    },
    {
        name: 'SALORNO - SALURN',
        istatCode: '004021076'
    },
    {
        name: 'SALSOMAGGIORE TERME',
        istatCode: '008034032'
    },
    {
        name: 'SALTARA',
        istatCode: '011041050'
    },
    {
        name: 'SALTRIO',
        istatCode: '003012117'
    },
    {
        name: 'SALUDECIO',
        istatCode: '008099015'
    },
    {
        name: 'SALUGGIA',
        istatCode: '001002128'
    },
    {
        name: 'SALUSSOLA',
        istatCode: '001096058'
    },
    {
        name: 'SALUZZO',
        istatCode: '001004203'
    },
    {
        name: 'SALVE',
        istatCode: '016075066'
    },
    {
        name: 'SALVIROLA',
        istatCode: '003019087'
    },
    {
        name: 'SALVITELLE',
        istatCode: '015065117'
    },
    {
        name: 'SALZA DI PINEROLO',
        istatCode: '001001234'
    },
    {
        name: 'SALZA IRPINA',
        istatCode: '015064081'
    },
    {
        name: 'SALZANO',
        istatCode: '005027032'
    },
    {
        name: 'SAMARATE',
        istatCode: '003012118'
    },
    {
        name: 'SAMASSI',
        istatCode: '020111059'
    },
    {
        name: 'SAMATZAI',
        istatCode: '020111060'
    },
    {
        name: 'SAMBIASE',
        istatCode: '018079105'
    },
    {
        name: 'SAMBUCA DI SICILIA',
        istatCode: '019084034'
    },
    {
        name: 'SAMBUCA PISTOIESE',
        istatCode: '009047018'
    },
    {
        name: 'SAMBUCI',
        istatCode: '012058094'
    },
    {
        name: 'SAMBUCO',
        istatCode: '001004204'
    },
    {
        name: 'SAMBUCO-PIETRAPORZIO',
        istatCode: '001004815'
    },
    {
        name: 'SAMMICHELE DI BARI',
        istatCode: '016072039'
    },
    {
        name: 'SAMO',
        istatCode: '018080070'
    },
    {
        name: 'SAMO DI CALABRIA',
        istatCode: '018080817'
    },
    {
        name: 'SAMOLACO',
        istatCode: '003014057'
    },
    {
        name: 'SAMONE (TN)',
        istatCode: '004022165'
    },
    {
        name: 'SAMONE (TO)',
        istatCode: '001001235'
    },
    {
        name: 'SAMPEYRE',
        istatCode: '001004205'
    },
    {
        name: 'SAMUGHEO',
        istatCode: '020095045'
    },
    {
        name: 'SAN BARTOLOMEO AL MARE',
        istatCode: '007008052'
    },
    {
        name: 'SAN BARTOLOMEO IN GALDO',
        istatCode: '015062057'
    },
    {
        name: 'SAN BARTOLOMEO VAL CAVARGNA',
        istatCode: '003013204'
    },
    {
        name: 'SAN BASILE',
        istatCode: '018078111'
    },
    {
        name: 'SAN BASILIO',
        istatCode: '020111061'
    },
    {
        name: 'SAN BASSANO',
        istatCode: '003019088'
    },
    {
        name: 'SAN BELLINO',
        istatCode: '005029043'
    },
    {
        name: 'SAN BENEDETTO BELBO',
        istatCode: '001004206'
    },
    {
        name: 'SAN BENEDETTO DEI MARSI',
        istatCode: '013066085'
    },
    {
        name: 'SAN BENEDETTO DEL TRONTO',
        istatCode: '011044066'
    },
    {
        name: 'SAN BENEDETTO IN PERILLIS',
        istatCode: '013066086'
    },
    {
        name: 'SAN BENEDETTO PO',
        istatCode: '003020055'
    },
    {
        name: 'SAN BENEDETTO ULLANO',
        istatCode: '018078112'
    },
    {
        name: 'SAN BENEDETTO VAL DI SAMBRO',
        istatCode: '008037051'
    },
    {
        name: 'SAN BENIGNO CANAVESE',
        istatCode: '001001236'
    },
    {
        name: 'SAN BERNARDINO',
        istatCode: '003019897'
    },
    {
        name: 'SAN BERNARDINO VERBANO',
        istatCode: '001103061'
    },
    {
        name: 'SAN BIAGIO DELLA CIMA',
        istatCode: '007008053'
    },
    {
        name: 'SAN BIAGIO DI CALLALTA',
        istatCode: '005026071'
    },
    {
        name: 'SAN BIAGIO PLATANI',
        istatCode: '019084035'
    },
    {
        name: 'SAN BIAGIO SARACINISCO',
        istatCode: '012060061'
    },
    {
        name: 'SAN BIASE',
        istatCode: '014070063'
    },
    {
        name: 'SAN BONIFACIO',
        istatCode: '005023069'
    },
    {
        name: 'SAN BUONO',
        istatCode: '013069079'
    },
    {
        name: 'SAN CALOGERO',
        istatCode: '018102032'
    },
    {
        name: 'SAN CANDIDO - INNICHEN',
        istatCode: '004021077'
    },
    {
        name: 'SAN CANZIAN D\'ISONZO',
        istatCode: '006031018'
    },
    {
        name: 'SAN CARLO CANAVESE',
        istatCode: '001001237'
    },
    {
        name: 'SAN CASCIANO DEI BAGNI',
        istatCode: '009052027'
    },
    {
        name: 'SAN CASCIANO IN VAL DI PESA',
        istatCode: '009048038'
    },
    {
        name: 'SAN CASSIANO',
        istatCode: '016075095'
    },
    {
        name: 'SAN CATALDO',
        istatCode: '019085016'
    },
    {
        name: 'SAN CESAREO',
        istatCode: '012058119'
    },
    {
        name: 'SAN CESARIO DI LECCE',
        istatCode: '016075068'
    },
    {
        name: 'SAN CESARIO SUL PANARO',
        istatCode: '008036036'
    },
    {
        name: 'SAN CHIRICO NUOVO',
        istatCode: '017076073'
    },
    {
        name: 'SAN CHIRICO RAPARO',
        istatCode: '017076074'
    },
    {
        name: 'SAN CIPIRELLO',
        istatCode: '019082063'
    },
    {
        name: 'SAN CIPRIANO D\'AVERSA',
        istatCode: '015061074'
    },
    {
        name: 'SAN CIPRIANO PICENTINO',
        istatCode: '015065118'
    },
    {
        name: 'SAN CIPRIANO PO',
        istatCode: '003018133'
    },
    {
        name: 'SAN CLEMENTE',
        istatCode: '008099016'
    },
    {
        name: 'SAN COLOMBANO AL LAMBRO',
        istatCode: '003015191'
    },
    {
        name: 'SAN COLOMBANO BELMONTE',
        istatCode: '001001238'
    },
    {
        name: 'SAN COLOMBANO CERTENOLI',
        istatCode: '007010053'
    },
    {
        name: 'SAN CONO',
        istatCode: '019087040'
    },
    {
        name: 'SAN COSMO ALBANESE',
        istatCode: '018078113'
    },
    {
        name: 'SAN COSTANTINO ALBANESE',
        istatCode: '017076075'
    },
    {
        name: 'SAN COSTANTINO CALABRO',
        istatCode: '018102033'
    },
    {
        name: 'SAN COSTANZO',
        istatCode: '011041051'
    },
    {
        name: 'SAN CRISTOFORO',
        istatCode: '001006152'
    },
    {
        name: 'SAN DAMIANO AL COLLE',
        istatCode: '003018134'
    },
    {
        name: 'SAN DAMIANO D\'ASTI',
        istatCode: '001005097'
    },
    {
        name: 'SAN DAMIANO MACRA',
        istatCode: '001004207'
    },
    {
        name: 'SAN DANIELE DEL FRIULI',
        istatCode: '006030099'
    },
    {
        name: 'SAN DANIELE PO',
        istatCode: '003019089'
    },
    {
        name: 'SAN DEMETRIO CORONE',
        istatCode: '018078114'
    },
    {
        name: 'SAN DEMETRIO NE\' VESTINI',
        istatCode: '013066087'
    },
    {
        name: 'SAN DIDERO',
        istatCode: '001001239'
    },
    {
        name: 'SAN DONA\' DI PIAVE',
        istatCode: '005027033'
    },
    {
        name: 'SAN DONACI',
        istatCode: '016074013'
    },
    {
        name: 'SAN DONATO DI LECCE',
        istatCode: '016075069'
    },
    {
        name: 'SAN DONATO DI NINEA',
        istatCode: '018078115'
    },
    {
        name: 'SAN DONATO MILANESE',
        istatCode: '003015192'
    },
    {
        name: 'SAN DONATO VAL DI COMINO',
        istatCode: '012060062'
    },
    {
        name: 'SAN DORLIGO DELLA VALLE',
        istatCode: '006032004'
    },
    {
        name: 'SAN FEDELE INTELVI',
        istatCode: '003013205'
    },
    {
        name: 'SAN FELE',
        istatCode: '017076076'
    },
    {
        name: 'SAN FELICE A CANCELLO',
        istatCode: '015061075'
    },
    {
        name: 'SAN FELICE CIRCEO',
        istatCode: '012059025'
    },
    {
        name: 'SAN FELICE DEL BENACO',
        istatCode: '003017171'
    },
    {
        name: 'SAN FELICE DEL MOLISE',
        istatCode: '014070064'
    },
    {
        name: 'SAN FELICE SUL PANARO',
        istatCode: '008036037'
    },
    {
        name: 'SAN FELICE/ST.FELIX(fino al 01/09/1974)',
        istatCode: '004021078'
    },
    {
        name: 'SAN FERDINANDO',
        istatCode: '018080097'
    },
    {
        name: 'SAN FERDINANDO DI PUGLIA',
        istatCode: '016110007'
    },
    {
        name: 'SAN FERMO DELLA BATTAGLIA',
        istatCode: '003013206'
    },
    {
        name: 'SAN FILI',
        istatCode: '018078116'
    },
    {
        name: 'SAN FILIPPO DEL MELA',
        istatCode: '019083077'
    },
    {
        name: 'SAN FIOR',
        istatCode: '005026072'
    },
    {
        name: 'SAN FIORANO',
        istatCode: '003098047'
    },
    {
        name: 'SAN FLORIANO DEL COLLIO',
        istatCode: '006031019'
    },
    {
        name: 'SAN FLORO',
        istatCode: '018079108'
    },
    {
        name: 'SAN FRANCESCO AL CAMPO',
        istatCode: '001001240'
    },
    {
        name: 'SAN FRATELLO',
        istatCode: '019083078'
    },
    {
        name: 'SAN GAVINO MONREALE',
        istatCode: '020111062'
    },
    {
        name: 'SAN GEMINI',
        istatCode: '010055029'
    },
    {
        name: 'SAN GENESIO ATESINO - JENESIEN',
        istatCode: '004021079'
    },
    {
        name: 'SAN GENESIO ED UNITI',
        istatCode: '003018135'
    },
    {
        name: 'SAN GENNARO VESUVIANO',
        istatCode: '015063066'
    },
    {
        name: 'SAN GERMANO CHISONE',
        istatCode: '001001242'
    },
    {
        name: 'SAN GERMANO DEI BERICI',
        istatCode: '005024092'
    },
    {
        name: 'SAN GERMANO VERCELLESE',
        istatCode: '001002131'
    },
    {
        name: 'SAN GERVASIO BRESCIANO',
        istatCode: '003017172'
    },
    {
        name: 'SAN GIACOMO DEGLI SCHIAVONI',
        istatCode: '014070065'
    },
    {
        name: 'SAN GIACOMO DELLE SEGNATE',
        istatCode: '003020056'
    },
    {
        name: 'SAN GIACOMO FILIPPO',
        istatCode: '003014058'
    },
    {
        name: 'SAN GIACOMO VERCELLESE',
        istatCode: '001002035'
    },
    {
        name: 'SAN GILLIO',
        istatCode: '001001243'
    },
    {
        name: 'SAN GILLIO TORINESE',
        istatCode: '001001860'
    },
    {
        name: 'SAN GIMIGNANO',
        istatCode: '009052028'
    },
    {
        name: 'SAN GINESIO',
        istatCode: '011043046'
    },
    {
        name: 'SAN GIORGIO A CREMANO',
        istatCode: '015063067'
    },
    {
        name: 'SAN GIORGIO A LIRI',
        istatCode: '012060063'
    },
    {
        name: 'SAN GIORGIO ALBANESE',
        istatCode: '018078118'
    },
    {
        name: 'SAN GIORGIO BIGARELLO',
        istatCode: '003020057'
    },
    {
        name: 'SAN GIORGIO CANAVESE',
        istatCode: '001001244'
    },
    {
        name: 'SAN GIORGIO DEL SANNIO',
        istatCode: '015062058'
    },
    {
        name: 'SAN GIORGIO DELLA RICHINVELDA',
        istatCode: '006093038'
    },
    {
        name: 'SAN GIORGIO DELLE PERTICHE',
        istatCode: '005028075'
    },
    {
        name: 'SAN GIORGIO DI LOMELLINA',
        istatCode: '003018136'
    },
    {
        name: 'SAN GIORGIO DI NOGARO',
        istatCode: '006030100'
    },
    {
        name: 'SAN GIORGIO DI PESARO',
        istatCode: '011041052'
    },
    {
        name: 'SAN GIORGIO DI PIANO',
        istatCode: '008037052'
    },
    {
        name: 'SAN GIORGIO IN BOSCO',
        istatCode: '005028076'
    },
    {
        name: 'SAN GIORGIO IONICO',
        istatCode: '016073024'
    },
    {
        name: 'SAN GIORGIO LA MOLARA',
        istatCode: '015062059'
    },
    {
        name: 'SAN GIORGIO LUCANO',
        istatCode: '017077025'
    },
    {
        name: 'SAN GIORGIO MONFERRATO',
        istatCode: '001006153'
    },
    {
        name: 'SAN GIORGIO MORGETO',
        istatCode: '018080071'
    },
    {
        name: 'SAN GIORGIO PIACENTINO',
        istatCode: '008033040'
    },
    {
        name: 'SAN GIORGIO SCARAMPI',
        istatCode: '001005098'
    },
    {
        name: 'SAN GIORGIO SU LEGNANO',
        istatCode: '003015194'
    },
    {
        name: 'SAN GIORIO DI SUSA',
        istatCode: '001001245'
    },
    {
        name: 'SAN GIOVANNI A PIRO',
        istatCode: '015065119'
    },
    {
        name: 'SAN GIOVANNI AL NATISONE',
        istatCode: '006030101'
    },
    {
        name: 'SAN GIOVANNI BIANCO',
        istatCode: '003016188'
    },
    {
        name: 'SAN GIOVANNI D\'ASSO',
        istatCode: '009052029'
    },
    {
        name: 'SAN GIOVANNI DEL DOSSO',
        istatCode: '003020058'
    },
    {
        name: 'SAN GIOVANNI DI FASSA/SèN JAN',
        istatCode: '004022250'
    },
    {
        name: 'SAN GIOVANNI DI GERACE',
        istatCode: '018080072'
    },
    {
        name: 'SAN GIOVANNI GEMINI',
        istatCode: '019084036'
    },
    {
        name: 'SAN GIOVANNI ILARIONE',
        istatCode: '005023070'
    },
    {
        name: 'SAN GIOVANNI IN CROCE',
        istatCode: '003019090'
    },
    {
        name: 'SAN GIOVANNI IN FIORE',
        istatCode: '018078119'
    },
    {
        name: 'SAN GIOVANNI IN GALDO',
        istatCode: '014070066'
    },
    {
        name: 'SAN GIOVANNI IN MARIGNANO',
        istatCode: '008099017'
    },
    {
        name: 'SAN GIOVANNI IN PERSICETO',
        istatCode: '008037053'
    },
    {
        name: 'SAN GIOVANNI INCARICO',
        istatCode: '012060064'
    },
    {
        name: 'SAN GIOVANNI LA PUNTA',
        istatCode: '019087041'
    },
    {
        name: 'SAN GIOVANNI LIPIONI',
        istatCode: '013069080'
    },
    {
        name: 'SAN GIOVANNI LUPATOTO',
        istatCode: '005023071'
    },
    {
        name: 'SAN GIOVANNI ROTONDO',
        istatCode: '016071046'
    },
    {
        name: 'SAN GIOVANNI SUERGIU',
        istatCode: '020111063'
    },
    {
        name: 'SAN GIOVANNI TEATINO',
        istatCode: '013069081'
    },
    {
        name: 'SAN GIOVANNI VALDARNO',
        istatCode: '009051033'
    },
    {
        name: 'SAN GIULIANO DEL SANNIO',
        istatCode: '014070067'
    },
    {
        name: 'SAN GIULIANO DI PUGLIA',
        istatCode: '014070068'
    },
    {
        name: 'SAN GIULIANO MILANESE',
        istatCode: '003015195'
    },
    {
        name: 'SAN GIULIANO TERME',
        istatCode: '009050031'
    },
    {
        name: 'SAN GIUSEPPE JATO',
        istatCode: '019082064'
    },
    {
        name: 'SAN GIUSEPPE VESUVIANO',
        istatCode: '015063068'
    },
    {
        name: 'SAN GIUSTINO',
        istatCode: '010054044'
    },
    {
        name: 'SAN GIUSTO CANAVESE',
        istatCode: '001001246'
    },
    {
        name: 'SAN GODENZO',
        istatCode: '009048039'
    },
    {
        name: 'SAN GREGORIO DA SASSOLA',
        istatCode: '012058095'
    },
    {
        name: 'SAN GREGORIO DI CATANIA',
        istatCode: '019087042'
    },
    {
        name: 'SAN GREGORIO D\'IPPONA',
        istatCode: '018102034'
    },
    {
        name: 'SAN GREGORIO MAGNO',
        istatCode: '015065120'
    },
    {
        name: 'SAN GREGORIO MATESE',
        istatCode: '015061076'
    },
    {
        name: 'SAN GREGORIO NELLE ALPI',
        istatCode: '005025045'
    },
    {
        name: 'SAN LAZZARO DI SAVENA',
        istatCode: '008037054'
    },
    {
        name: 'SAN LAZZARO PARMENSE',
        istatCode: '008034807'
    },
    {
        name: 'SAN LEO',
        istatCode: '008099025'
    },
    {
        name: 'SAN LEONARDO',
        istatCode: '006030102'
    },
    {
        name: 'SAN LEONARDO IN PASSIRIA - ST. LEONHARD IN PASSEIER',
        istatCode: '004021080'
    },
    {
        name: 'SAN LEUCIO DEL SANNIO',
        istatCode: '015062060'
    },
    {
        name: 'SAN LORENZELLO',
        istatCode: '015062061'
    },
    {
        name: 'SAN LORENZO',
        istatCode: '018080073'
    },
    {
        name: 'SAN LORENZO AL MARE',
        istatCode: '007008054'
    },
    {
        name: 'SAN LORENZO BELLIZZI',
        istatCode: '018078120'
    },
    {
        name: 'SAN LORENZO DEL VALLO',
        istatCode: '018078121'
    },
    {
        name: 'SAN LORENZO DI SEBATO - ST. LORENZEN',
        istatCode: '004021081'
    },
    {
        name: 'SAN LORENZO DORSINO',
        istatCode: '004022231'
    },
    {
        name: 'SAN LORENZO IN BANALE',
        istatCode: '004022166'
    },
    {
        name: 'SAN LORENZO IN CAMPO',
        istatCode: '011041054'
    },
    {
        name: 'SAN LORENZO ISONTINO',
        istatCode: '006031020'
    },
    {
        name: 'SAN LORENZO MAGGIORE',
        istatCode: '015062062'
    },
    {
        name: 'SAN LORENZO NUOVO',
        istatCode: '012056047'
    },
    {
        name: 'SAN LUCA',
        istatCode: '018080074'
    },
    {
        name: 'SAN LUCIDO',
        istatCode: '018078122'
    },
    {
        name: 'SAN LUPO',
        istatCode: '015062063'
    },
    {
        name: 'SAN MANGO D\'AQUINO',
        istatCode: '018079110'
    },
    {
        name: 'SAN MANGO PIEMONTE',
        istatCode: '015065121'
    },
    {
        name: 'SAN MANGO SUL CALORE',
        istatCode: '015064082'
    },
    {
        name: 'SAN MARCELLINO',
        istatCode: '015061077'
    },
    {
        name: 'SAN MARCELLO',
        istatCode: '011042041'
    },
    {
        name: 'SAN MARCELLO PISTOIESE',
        istatCode: '009047019'
    },
    {
        name: 'SAN MARCELLO PITEGLIO',
        istatCode: '009047024'
    },
    {
        name: 'SAN MARCO ARGENTANO',
        istatCode: '018078123'
    },
    {
        name: 'SAN MARCO D\'ALUNZIO',
        istatCode: '019083079'
    },
    {
        name: 'SAN MARCO DEI CAVOTI',
        istatCode: '015062064'
    },
    {
        name: 'SAN MARCO EVANGELISTA',
        istatCode: '015061104'
    },
    {
        name: 'SAN MARCO IN LAMIS',
        istatCode: '016071047'
    },
    {
        name: 'SAN MARCO LA CATOLA',
        istatCode: '016071048'
    },
    {
        name: 'SAN MARTINO',
        istatCode: '012056517'
    },
    {
        name: 'SAN MARTINO AL TAGLIAMENTO',
        istatCode: '006093039'
    },
    {
        name: 'SAN MARTINO ALFIERI',
        istatCode: '001005099'
    },
    {
        name: 'SAN MARTINO BUON ALBERGO',
        istatCode: '005023073'
    },
    {
        name: 'SAN MARTINO CANAVESE',
        istatCode: '001001247'
    },
    {
        name: 'SAN MARTINO D\'AGRI',
        istatCode: '017076077'
    },
    {
        name: 'SAN MARTINO DALL\'ARGINE',
        istatCode: '003020059'
    },
    {
        name: 'SAN MARTINO DE CALVI',
        istatCode: '003016863'
    },
    {
        name: 'SAN MARTINO DEL LAGO',
        istatCode: '003019091'
    },
    {
        name: 'SAN MARTINO DI FINITA',
        istatCode: '018078124'
    },
    {
        name: 'SAN MARTINO DI LUPARI',
        istatCode: '005028077'
    },
    {
        name: 'SAN MARTINO DI VENEZZE',
        istatCode: '005029044'
    },
    {
        name: 'SAN MARTINO IN BADIA - ST. MARTIN IN THURN',
        istatCode: '004021082'
    },
    {
        name: 'SAN MARTINO IN PASSIRIA - ST. MARTIN IN PASSEIER',
        istatCode: '004021083'
    },
    {
        name: 'SAN MARTINO IN PENSILIS',
        istatCode: '014070069'
    },
    {
        name: 'SAN MARTINO IN RIO',
        istatCode: '008035037'
    },
    {
        name: 'SAN MARTINO IN STRADA',
        istatCode: '003098048'
    },
    {
        name: 'SAN MARTINO SANNITA',
        istatCode: '015062065'
    },
    {
        name: 'SAN MARTINO SICCOMARIO',
        istatCode: '003018137'
    },
    {
        name: 'SAN MARTINO SULLA MARRUCINA',
        istatCode: '013069082'
    },
    {
        name: 'SAN MARTINO VALLE CAUDINA',
        istatCode: '015064083'
    },
    {
        name: 'SAN MARZANO DI SAN GIUSEPPE',
        istatCode: '016073025'
    },
    {
        name: 'SAN MARZANO MOASCA',
        istatCode: '001005812'
    },
    {
        name: 'SAN MARZANO OLIVETO',
        istatCode: '001005100'
    },
    {
        name: 'SAN MARZANO SUL SARNO',
        istatCode: '015065122'
    },
    {
        name: 'SAN MASSIMO',
        istatCode: '014070070'
    },
    {
        name: 'SAN MAURIZIO CANAVESE',
        istatCode: '001001248'
    },
    {
        name: 'SAN MAURIZIO D\'OPAGLIO',
        istatCode: '001003133'
    },
    {
        name: 'SAN MAURO CASTELVERDE',
        istatCode: '019082065'
    },
    {
        name: 'SAN MAURO CILENTO',
        istatCode: '015065123'
    },
    {
        name: 'SAN MAURO DI SALINE',
        istatCode: '005023074'
    },
    {
        name: 'SAN MAURO FORTE',
        istatCode: '017077026'
    },
    {
        name: 'SAN MAURO LA BRUCA',
        istatCode: '015065124'
    },
    {
        name: 'SAN MAURO MARCHESATO',
        istatCode: '018101020'
    },
    {
        name: 'SAN MAURO PASCOLI',
        istatCode: '008040041'
    },
    {
        name: 'SAN MAURO TORINESE',
        istatCode: '001001249'
    },
    {
        name: 'SAN MICHELE AL TAGLIAMENTO',
        istatCode: '005027034'
    },
    {
        name: 'SAN MICHELE ALL\'ADIGE',
        istatCode: '004022167'
    },
    {
        name: 'SAN MICHELE DI GANZARIA',
        istatCode: '019087043'
    },
    {
        name: 'SAN MICHELE DI SERINO',
        istatCode: '015064084'
    },
    {
        name: 'SAN MICHELE EXTRA',
        istatCode: '005023818'
    },
    {
        name: 'SAN MICHELE MONDOVI\'',
        istatCode: '001004210'
    },
    {
        name: 'SAN MICHELE SALENTINO',
        istatCode: '016074014'
    },
    {
        name: 'SAN MINIATO',
        istatCode: '009050032'
    },
    {
        name: 'SAN NAZARIO',
        istatCode: '005024093'
    },
    {
        name: 'SAN NAZZARO',
        istatCode: '015062066'
    },
    {
        name: 'SAN NAZZARO SESIA',
        istatCode: '001003134'
    },
    {
        name: 'SAN NAZZARO VAL CAVARGNA',
        istatCode: '003013207'
    },
    {
        name: 'SAN NICOLA ARCELLA',
        istatCode: '018078125'
    },
    {
        name: 'SAN NICOLA BARONIA',
        istatCode: '015064085'
    },
    {
        name: 'SAN NICOLA DA CRISSA',
        istatCode: '018102035'
    },
    {
        name: 'SAN NICOLA DELL\'ALTO',
        istatCode: '018101021'
    },
    {
        name: 'SAN NICOLA LA STRADA',
        istatCode: '015061078'
    },
    {
        name: 'SAN NICOLA MANFREDI',
        istatCode: '015062067'
    },
    {
        name: 'SAN NICOLO\' D\'ARCIDANO',
        istatCode: '020095046'
    },
    {
        name: 'SAN NICOLO\' DI COMELICO',
        istatCode: '005025046'
    },
    {
        name: 'SAN NICOLO\' GERREI',
        istatCode: '020111064'
    },
    {
        name: 'SAN PANCRAZIO - ST. PANKRAZ',
        istatCode: '004021084'
    },
    {
        name: 'SAN PANCRAZIO PARMENSE',
        istatCode: '008034809'
    },
    {
        name: 'SAN PANCRAZIO SALENTINO',
        istatCode: '016074015'
    },
    {
        name: 'SAN PAOLO',
        istatCode: '003017138'
    },
    {
        name: 'SAN PAOLO ALBANESE',
        istatCode: '017076020'
    },
    {
        name: 'SAN PAOLO BEL SITO',
        istatCode: '015063069'
    },
    {
        name: 'SAN PAOLO CERVO',
        istatCode: '001096060'
    },
    {
        name: 'SAN PAOLO D\'ARGON',
        istatCode: '003016189'
    },
    {
        name: 'SAN PAOLO DI CIVITATE',
        istatCode: '016071050'
    },
    {
        name: 'SAN PAOLO DI JESI',
        istatCode: '011042042'
    },
    {
        name: 'SAN PAOLO SOLBRITO',
        istatCode: '001005101'
    },
    {
        name: 'SAN PELLEGRINO TERME',
        istatCode: '003016190'
    },
    {
        name: 'SAN PIER D\'ARENA',
        istatCode: '007010823'
    },
    {
        name: 'SAN PIER D\'ISONZO',
        istatCode: '006031021'
    },
    {
        name: 'SAN PIER FEDELE',
        istatCode: '018080818'
    },
    {
        name: 'SAN PIER NICETO',
        istatCode: '019083080'
    },
    {
        name: 'SAN PIERO A SIEVE',
        istatCode: '009048040'
    },
    {
        name: 'SAN PIERO PATTI',
        istatCode: '019083081'
    },
    {
        name: 'SAN PIETRO A MAIDA',
        istatCode: '018079114'
    },
    {
        name: 'SAN PIETRO AL NATISONE',
        istatCode: '006030103'
    },
    {
        name: 'SAN PIETRO AL TANAGRO',
        istatCode: '015065125'
    },
    {
        name: 'SAN PIETRO APOSTOLO',
        istatCode: '018079115'
    },
    {
        name: 'SAN PIETRO AVELLANA',
        istatCode: '014094043'
    },
    {
        name: 'SAN PIETRO CLARENZA',
        istatCode: '019087044'
    },
    {
        name: 'SAN PIETRO DI BARBOZZA',
        istatCode: '005026805'
    },
    {
        name: 'SAN PIETRO DI CADORE',
        istatCode: '005025047'
    },
    {
        name: 'SAN PIETRO DI CARIDA\'',
        istatCode: '018080075'
    },
    {
        name: 'SAN PIETRO DI FELETTO',
        istatCode: '005026073'
    },
    {
        name: 'SAN PIETRO DI MORUBIO',
        istatCode: '005023075'
    },
    {
        name: 'SAN PIETRO IN AMANTEA',
        istatCode: '018078126'
    },
    {
        name: 'SAN PIETRO IN CARIANO',
        istatCode: '005023076'
    },
    {
        name: 'SAN PIETRO IN CASALE',
        istatCode: '008037055'
    },
    {
        name: 'SAN PIETRO IN CERRO',
        istatCode: '008033041'
    },
    {
        name: 'SAN PIETRO IN GU',
        istatCode: '005028078'
    },
    {
        name: 'SAN PIETRO IN GUARANO',
        istatCode: '018078127'
    },
    {
        name: 'SAN PIETRO IN LAMA',
        istatCode: '016075071'
    },
    {
        name: 'SAN PIETRO INFINE',
        istatCode: '015061079'
    },
    {
        name: 'SAN PIETRO MOSEZZO',
        istatCode: '001003135'
    },
    {
        name: 'SAN PIETRO MUSSOLINO',
        istatCode: '005024094'
    },
    {
        name: 'SAN PIETRO VAL LEMINA',
        istatCode: '001001250'
    },
    {
        name: 'SAN PIETRO VERNOTICO',
        istatCode: '016074016'
    },
    {
        name: 'SAN PIETRO VIMINARIO',
        istatCode: '005028079'
    },
    {
        name: 'SAN PIO DELLE CAMERE',
        istatCode: '013066088'
    },
    {
        name: 'SAN POLO DEI CAVALIERI',
        istatCode: '012058096'
    },
    {
        name: 'SAN POLO D\'ENZA',
        istatCode: '008035038'
    },
    {
        name: 'SAN POLO DI PIAVE',
        istatCode: '005026074'
    },
    {
        name: 'SAN POLO MATESE',
        istatCode: '014070071'
    },
    {
        name: 'SAN PONSO',
        istatCode: '001001251'
    },
    {
        name: 'SAN POSSIDONIO',
        istatCode: '008036038'
    },
    {
        name: 'SAN POTITO SANNITICO',
        istatCode: '015061080'
    },
    {
        name: 'SAN POTITO ULTRA',
        istatCode: '015064086'
    },
    {
        name: 'SAN PRISCO',
        istatCode: '015061081'
    },
    {
        name: 'SAN PROCOPIO',
        istatCode: '018080076'
    },
    {
        name: 'SAN PROSPERO',
        istatCode: '008036039'
    },
    {
        name: 'SAN QUIRICO D\'ORCIA',
        istatCode: '009052030'
    },
    {
        name: 'SAN QUIRINO',
        istatCode: '006093040'
    },
    {
        name: 'SAN RAFFAELE CIMENA',
        istatCode: '001001252'
    },
    {
        name: 'SAN REMO',
        istatCode: '007008055'
    },
    {
        name: 'SAN ROBERTO',
        istatCode: '018080077'
    },
    {
        name: 'SAN ROCCO AL PORTO',
        istatCode: '003098049'
    },
    {
        name: 'SAN ROMANO IN GARFAGNANA',
        istatCode: '009046027'
    },
    {
        name: 'SAN RUFO',
        istatCode: '015065126'
    },
    {
        name: 'SAN SALVATORE DI FITALIA',
        istatCode: '019083082'
    },
    {
        name: 'SAN SALVATORE MONFERRATO',
        istatCode: '001006154'
    },
    {
        name: 'SAN SALVATORE TELESINO',
        istatCode: '015062068'
    },
    {
        name: 'SAN SALVO',
        istatCode: '013069083'
    },
    {
        name: 'SAN SEBASTIANO AL VESUVIO',
        istatCode: '015063070'
    },
    {
        name: 'SAN SEBASTIANO CURONE',
        istatCode: '001006155'
    },
    {
        name: 'SAN SEBASTIANO DA PO',
        istatCode: '001001253'
    },
    {
        name: 'SAN SECONDO DI PINEROLO',
        istatCode: '001001254'
    },
    {
        name: 'SAN SECONDO PARMENSE',
        istatCode: '008034033'
    },
    {
        name: 'SAN SEVERINO LUCANO',
        istatCode: '017076078'
    },
    {
        name: 'SAN SEVERINO MARCHE',
        istatCode: '011043047'
    },
    {
        name: 'SAN SEVERO',
        istatCode: '016071051'
    },
    {
        name: 'SAN SIRO',
        istatCode: '003013248'
    },
    {
        name: 'SAN SOSSIO BARONIA',
        istatCode: '015064087'
    },
    {
        name: 'SAN SOSTENE',
        istatCode: '018079116'
    },
    {
        name: 'SAN SOSTI',
        istatCode: '018078128'
    },
    {
        name: 'SAN SPERATE',
        istatCode: '020111065'
    },
    {
        name: 'SAN TAMMARO',
        istatCode: '015061085'
    },
    {
        name: 'SAN TEODORO',
        istatCode: '020090092'
    },
    {
        name: 'SAN TEODORO (ME)',
        istatCode: '019083090'
    },
    {
        name: 'SAN TOMASO AGORDINO',
        istatCode: '005025049'
    },
    {
        name: 'SAN VALENTINO IN ABRUZZO CITERIORE',
        istatCode: '013068038'
    },
    {
        name: 'SAN VALENTINO TORIO',
        istatCode: '015065132'
    },
    {
        name: 'SAN VENANZO',
        istatCode: '010055030'
    },
    {
        name: 'SAN VENDEMIANO',
        istatCode: '005026076'
    },
    {
        name: 'SAN VERO MILIS',
        istatCode: '020095050'
    },
    {
        name: 'SAN VIGILIO',
        istatCode: '003017893'
    },
    {
        name: 'SAN VINCENZO',
        istatCode: '009049018'
    },
    {
        name: 'SAN VINCENZO LA COSTA',
        istatCode: '018078135'
    },
    {
        name: 'SAN VINCENZO VALLE ROVETO',
        istatCode: '013066092'
    },
    {
        name: 'SAN VITALIANO',
        istatCode: '015063075'
    },
    {
        name: 'SAN VITO',
        istatCode: '020111066'
    },
    {
        name: 'SAN VITO AL TAGLIAMENTO',
        istatCode: '006093041'
    },
    {
        name: 'SAN VITO AL TORRE',
        istatCode: '006030105'
    },
    {
        name: 'SAN VITO CHIETINO',
        istatCode: '013069086'
    },
    {
        name: 'SAN VITO DEI NORMANNI',
        istatCode: '016074017'
    },
    {
        name: 'SAN VITO DI CADORE',
        istatCode: '005025051'
    },
    {
        name: 'SAN VITO DI FAGAGNA',
        istatCode: '006030106'
    },
    {
        name: 'SAN VITO DI LEGUZZANO',
        istatCode: '005024096'
    },
    {
        name: 'SAN VITO LO CAPO',
        istatCode: '019081020'
    },
    {
        name: 'SAN VITO ROMANO',
        istatCode: '012058100'
    },
    {
        name: 'SAN VITO SULLO IONIO',
        istatCode: '018079122'
    },
    {
        name: 'SAN VITTORE DEL LAZIO',
        istatCode: '012060070'
    },
    {
        name: 'SAN VITTORE OLONA',
        istatCode: '003015201'
    },
    {
        name: 'SAN ZENO DI MONTAGNA',
        istatCode: '005023079'
    },
    {
        name: 'SAN ZENO NAVIGLIO',
        istatCode: '003017173'
    },
    {
        name: 'SAN ZENONE AL LAMBRO',
        istatCode: '003015202'
    },
    {
        name: 'SAN ZENONE AL PO',
        istatCode: '003018145'
    },
    {
        name: 'SAN ZENONE DEGLI EZZELINI',
        istatCode: '005026077'
    },
    {
        name: 'SANARICA',
        istatCode: '016075067'
    },
    {
        name: 'SANDIGLIANO',
        istatCode: '001096059'
    },
    {
        name: 'SANDRIGO',
        istatCode: '005024091'
    },
    {
        name: 'SANFRE\'',
        istatCode: '001004208'
    },
    {
        name: 'SANFRONT',
        istatCode: '001004209'
    },
    {
        name: 'SANGANO',
        istatCode: '001001241'
    },
    {
        name: 'SANGIANO',
        istatCode: '003012141'
    },
    {
        name: 'SANGINETO',
        istatCode: '018078117'
    },
    {
        name: 'SANGUINETTO',
        istatCode: '005023072'
    },
    {
        name: 'SANLURI',
        istatCode: '020111067'
    },
    {
        name: 'SANNAZZARO DE\' BURGONDI',
        istatCode: '003018138'
    },
    {
        name: 'SANNICANDRO DI BARI',
        istatCode: '016072040'
    },
    {
        name: 'SANNICANDRO GARGANICO',
        istatCode: '016071049'
    },
    {
        name: 'SANNICOLA',
        istatCode: '016075070'
    },
    {
        name: 'SANSEPOLCRO',
        istatCode: '009051034'
    },
    {
        name: 'SANT ANDREA DI GORIZIA',
        istatCode: '006031809'
    },
    {
        name: 'SANT APOLLINARE CON SELVA',
        istatCode: '005029813'
    },
    {
        name: 'Sant Eufemia Lamezia',
        istatCode: '018079120'
    },
    {
        name: 'SANTA BRIGIDA',
        istatCode: '003016191'
    },
    {
        name: 'SANTA CATERINA ALBANESE',
        istatCode: '018078129'
    },
    {
        name: 'SANTA CATERINA DELLO IONIO',
        istatCode: '018079117'
    },
    {
        name: 'SANTA CATERINA VILLARMOSA',
        istatCode: '019085017'
    },
    {
        name: 'SANTA CESAREA TERME',
        istatCode: '016075072'
    },
    {
        name: 'SANTA CRISTINA D\'ASPROMONTE',
        istatCode: '018080078'
    },
    {
        name: 'SANTA CRISTINA E BISSONE',
        istatCode: '003018139'
    },
    {
        name: 'SANTA CRISTINA GELA',
        istatCode: '019082066'
    },
    {
        name: 'SANTA CRISTINA VALGARDENA - ST. CHRISTINA IN GROEDEN',
        istatCode: '004021085'
    },
    {
        name: 'SANTA CROCE CAMERINA',
        istatCode: '019088010'
    },
    {
        name: 'SANTA CROCE DEL SANNIO',
        istatCode: '015062069'
    },
    {
        name: 'SANTA CROCE DI MAGLIANO',
        istatCode: '014070072'
    },
    {
        name: 'SANTA CROCE SULL\'ARNO',
        istatCode: '009050033'
    },
    {
        name: 'SANTA DOMENICA TALAO',
        istatCode: '018078130'
    },
    {
        name: 'SANTA DOMENICA VITTORIA',
        istatCode: '019083083'
    },
    {
        name: 'SANTA ELISABETTA',
        istatCode: '019084037'
    },
    {
        name: 'SANTA FIORA',
        istatCode: '009053022'
    },
    {
        name: 'SANTA FLAVIA',
        istatCode: '019082067'
    },
    {
        name: 'SANTA GIULETTA',
        istatCode: '003018140'
    },
    {
        name: 'SANTA GIUSTA',
        istatCode: '020095047'
    },
    {
        name: 'SANTA GIUSTINA',
        istatCode: '005025048'
    },
    {
        name: 'SANTA GIUSTINA IN COLLE',
        istatCode: '005028080'
    },
    {
        name: 'SANTA LUCE',
        istatCode: '009050034'
    },
    {
        name: 'SANTA LUCE ORCIANO',
        istatCode: '009050802'
    },
    {
        name: 'SANTA LUCIA DEL MELA',
        istatCode: '019083086'
    },
    {
        name: 'SANTA LUCIA DI PIAVE',
        istatCode: '005026075'
    },
    {
        name: 'SANTA LUCIA DI SERINO',
        istatCode: '015064088'
    },
    {
        name: 'SANTA MARGHERITA D\'ADIGE',
        istatCode: '005028081'
    },
    {
        name: 'SANTA MARGHERITA DI BELICE',
        istatCode: '019084038'
    },
    {
        name: 'SANTA MARGHERITA DI STAFFORA',
        istatCode: '003018142'
    },
    {
        name: 'SANTA MARGHERITA LIGURE',
        istatCode: '007010054'
    },
    {
        name: 'SANTA MARIA A MONTE',
        istatCode: '009050035'
    },
    {
        name: 'SANTA MARIA A VICO',
        istatCode: '015061082'
    },
    {
        name: 'SANTA MARIA CAPUA VETERE',
        istatCode: '015061083'
    },
    {
        name: 'SANTA MARIA COGHINAS',
        istatCode: '020090087'
    },
    {
        name: 'SANTA MARIA DEL CEDRO',
        istatCode: '018078132'
    },
    {
        name: 'SANTA MARIA DEL MOLISE',
        istatCode: '014094045'
    },
    {
        name: 'SANTA MARIA DELLA VERSA',
        istatCode: '003018143'
    },
    {
        name: 'SANTA MARIA DI LICODIA',
        istatCode: '019087047'
    },
    {
        name: 'SANTA MARIA DI ROVAGNATE',
        istatCode: '003013935'
    },
    {
        name: 'SANTA MARIA DI SALA',
        istatCode: '005027035'
    },
    {
        name: 'SANTA MARIA HOE\'',
        istatCode: '003097074'
    },
    {
        name: 'SANTA MARIA IMBARO',
        istatCode: '013069084'
    },
    {
        name: 'SANTA MARIA LA CARITA\'',
        istatCode: '015063090'
    },
    {
        name: 'SANTA MARIA LA FOSSA',
        istatCode: '015061084'
    },
    {
        name: 'SANTA MARIA LA LONGA',
        istatCode: '006030104'
    },
    {
        name: 'SANTA MARIA MAGGIORE',
        istatCode: '001103062'
    },
    {
        name: 'SANTA MARIA NUOVA',
        istatCode: '011042043'
    },
    {
        name: 'SANTA MARIA REZZONICO',
        istatCode: '003013210'
    },
    {
        name: 'SANTA MARINA',
        istatCode: '015065127'
    },
    {
        name: 'SANTA MARINA SALINA',
        istatCode: '019083087'
    },
    {
        name: 'SANTA MARINELLA',
        istatCode: '012058097'
    },
    {
        name: 'SANTA NINFA',
        istatCode: '019081019'
    },
    {
        name: 'SANTA PAOLINA',
        istatCode: '015064093'
    },
    {
        name: 'SANTA SEVERINA',
        istatCode: '018101022'
    },
    {
        name: 'SANTA SOFIA',
        istatCode: '008040043'
    },
    {
        name: 'SANTA SOFIA D\'EPIRO',
        istatCode: '018078133'
    },
    {
        name: 'SANTA TERESA DI RIVA',
        istatCode: '019083089'
    },
    {
        name: 'SANTA TERESA GALLURA',
        istatCode: '020090063'
    },
    {
        name: 'SANTA VENERINA',
        istatCode: '019087048'
    },
    {
        name: 'SANTA VITTORIA D\'ALBA',
        istatCode: '001004212'
    },
    {
        name: 'SANTA VITTORIA IN MATENANO',
        istatCode: '011109036'
    },
    {
        name: 'SANTADI',
        istatCode: '020111068'
    },
    {
        name: 'SANT\'AGAPITO',
        istatCode: '014094044'
    },
    {
        name: 'SANT\'AGATA BOLOGNESE',
        istatCode: '008037056'
    },
    {
        name: 'SANT\'AGATA DE\' GOTI',
        istatCode: '015062070'
    },
    {
        name: 'SANT\'AGATA DEL BIANCO',
        istatCode: '018080079'
    },
    {
        name: 'SANT\'AGATA DI ESARO',
        istatCode: '018078131'
    },
    {
        name: 'SANT\'AGATA DI MILITELLO',
        istatCode: '019083084'
    },
    {
        name: 'SANT\'AGATA DI PUGLIA',
        istatCode: '016071052'
    },
    {
        name: 'SANT\'AGATA FELTRIA',
        istatCode: '008099026'
    },
    {
        name: 'SANT\'AGATA FOSSILI',
        istatCode: '001006156'
    },
    {
        name: 'SANT\'AGATA LI BATTIATI',
        istatCode: '019087045'
    },
    {
        name: 'SANT\'AGATA SUL SANTERNO',
        istatCode: '008039017'
    },
    {
        name: 'SANT\'AGNELLO',
        istatCode: '015063071'
    },
    {
        name: 'SANT\'AGOSTINO',
        istatCode: '008038021'
    },
    {
        name: 'SANT\'ALBANO STURA',
        istatCode: '001004211'
    },
    {
        name: 'SANT\'ALESSIO CON VIALONE',
        istatCode: '003018141'
    },
    {
        name: 'SANT\'ALESSIO IN ASPROMONTE',
        istatCode: '018080080'
    },
    {
        name: 'SANT\'ALESSIO SICULO',
        istatCode: '019083085'
    },
    {
        name: 'SANT\'ALFIO',
        istatCode: '019087046'
    },
    {
        name: 'SANT\'AMBROGIO DI TORINO',
        istatCode: '001001255'
    },
    {
        name: 'SANT\'AMBROGIO DI VALPOLICELLA',
        istatCode: '005023077'
    },
    {
        name: 'SANT\'AMBROGIO SUL GARIGLIANO',
        istatCode: '012060065'
    },
    {
        name: 'SANT\'ANASTASIA',
        istatCode: '015063072'
    },
    {
        name: 'SANT\'ANATOLIA DI NARCO',
        istatCode: '010054045'
    },
    {
        name: 'SANT\'ANDREA APOSTOLO DELLO IONIO',
        istatCode: '018079118'
    },
    {
        name: 'SANT\'ANDREA DEL GARIGLIANO',
        istatCode: '012060066'
    },
    {
        name: 'SANT\'ANDREA DI CONZA',
        istatCode: '015064089'
    },
    {
        name: 'SANT\'ANDREA FRIUS',
        istatCode: '020111069'
    },
    {
        name: 'SANT\'ANGELO A CUPOLO',
        istatCode: '015062071'
    },
    {
        name: 'SANT\'ANGELO A FASANELLA',
        istatCode: '015065128'
    },
    {
        name: 'SANT\'ANGELO A SCALA',
        istatCode: '015064091'
    },
    {
        name: 'SANT\'ANGELO ALL\'ESCA',
        istatCode: '015064090'
    },
    {
        name: 'SANT\'ANGELO D\'ALIFE',
        istatCode: '015061086'
    },
    {
        name: 'SANT\'ANGELO DEI LOMBARDI',
        istatCode: '015064092'
    },
    {
        name: 'SANT\'ANGELO DEL PESCO',
        istatCode: '014094046'
    },
    {
        name: 'SANT\'ANGELO DI BROLO',
        istatCode: '019083088'
    },
    {
        name: 'SANT\'ANGELO DI PIOVE DI SACCO',
        istatCode: '005028082'
    },
    {
        name: 'SANT\'ANGELO IN LIZZOLA',
        istatCode: '011041056'
    },
    {
        name: 'SANT\'ANGELO IN PONTANO',
        istatCode: '011043048'
    },
    {
        name: 'SANT\'ANGELO IN VADO',
        istatCode: '011041057'
    },
    {
        name: 'SANT\'ANGELO LE FRATTE',
        istatCode: '017076079'
    },
    {
        name: 'SANT\'ANGELO LIMOSANO',
        istatCode: '014070073'
    },
    {
        name: 'SANT\'ANGELO LODIGIANO',
        istatCode: '003098050'
    },
    {
        name: 'SANT\'ANGELO LOMELLINA',
        istatCode: '003018144'
    },
    {
        name: 'SANT\'ANGELO MUXARO',
        istatCode: '019084039'
    },
    {
        name: 'SANT\'ANGELO ROMANO',
        istatCode: '012058098'
    },
    {
        name: 'SANT\'ANNA ARRESI',
        istatCode: '020111070'
    },
    {
        name: 'SANT\'ANNA D\'ALFAEDO',
        istatCode: '005023078'
    },
    {
        name: 'SANT\'ANTIMO',
        istatCode: '015063073'
    },
    {
        name: 'SANT\'ANTIOCO',
        istatCode: '020111071'
    },
    {
        name: 'SANT\'ANTONINO DI SUSA',
        istatCode: '001001256'
    },
    {
        name: 'SANT\'ANTONIO ABATE',
        istatCode: '015063074'
    },
    {
        name: 'SANT\'ANTONIO DI GALLURA',
        istatCode: '020090085'
    },
    {
        name: 'SANT\'APOLLINARE',
        istatCode: '012060067'
    },
    {
        name: 'SANT\'ARCANGELO',
        istatCode: '017076080'
    },
    {
        name: 'SANTARCANGELO DI ROMAGNA',
        istatCode: '008099018'
    },
    {
        name: 'SANT\'ARCANGELO TRIMONTE',
        istatCode: '015062078'
    },
    {
        name: 'SANT\'ARPINO',
        istatCode: '015061087'
    },
    {
        name: 'SANT\'ARSENIO',
        istatCode: '015065129'
    },
    {
        name: 'SANTE MARIE',
        istatCode: '013066089'
    },
    {
        name: 'SANT\'EGIDIO ALLA VIBRATA',
        istatCode: '013067038'
    },
    {
        name: 'SANT\'EGIDIO DEL MONTE ALBINO',
        istatCode: '015065130'
    },
    {
        name: 'SANT\'ELENA',
        istatCode: '005028083'
    },
    {
        name: 'SANT\'ELENA SANNITA',
        istatCode: '014094047'
    },
    {
        name: 'SANT\'ELIA A PIANISI',
        istatCode: '014070074'
    },
    {
        name: 'SANT\'ELIA FIUMERAPIDO',
        istatCode: '012060068'
    },
    {
        name: 'SANT\'ELPIDIO A MARE',
        istatCode: '011109037'
    },
    {
        name: 'SANTENA',
        istatCode: '001001257'
    },
    {
        name: 'SANTERAMO IN COLLE',
        istatCode: '016072041'
    },
    {
        name: 'SANT\'EUFEMIA A MAIELLA',
        istatCode: '013068037'
    },
    {
        name: 'SANT\'EUFEMIA D\'ASPROMONTE',
        istatCode: '018080081'
    },
    {
        name: 'SANT\'EUSANIO DEL SANGRO',
        istatCode: '013069085'
    },
    {
        name: 'SANT\'EUSANIO FORCONESE',
        istatCode: '013066090'
    },
    {
        name: 'SANTHIA\'',
        istatCode: '001002133'
    },
    {
        name: 'SANTI COSMA E DAMIANO',
        istatCode: '012059026'
    },
    {
        name: 'SANT\'ILARIO DELLO IONIO',
        istatCode: '018080082'
    },
    {
        name: 'SANT\'ILARIO D\'ENZA',
        istatCode: '008035039'
    },
    {
        name: 'SANT\'IPPOLITO',
        istatCode: '011041058'
    },
    {
        name: 'SANTO STEFANO AL MARE',
        istatCode: '007008056'
    },
    {
        name: 'SANTO STEFANO BELBO',
        istatCode: '001004213'
    },
    {
        name: 'SANTO STEFANO D\'AVETO',
        istatCode: '007010056'
    },
    {
        name: 'SANTO STEFANO DEL SOLE',
        istatCode: '015064095'
    },
    {
        name: 'SANTO STEFANO DI CADORE',
        istatCode: '005025050'
    },
    {
        name: 'SANTO STEFANO DI CAMASTRA',
        istatCode: '019083091'
    },
    {
        name: 'SANTO STEFANO DI MAGRA',
        istatCode: '007011026'
    },
    {
        name: 'SANTO STEFANO DI ROGLIANO',
        istatCode: '018078134'
    },
    {
        name: 'SANTO STEFANO DI SESSANIO',
        istatCode: '013066091'
    },
    {
        name: 'SANTO STEFANO IN ASPROMONTE',
        istatCode: '018080083'
    },
    {
        name: 'SANTO STEFANO LODIGIANO',
        istatCode: '003098051'
    },
    {
        name: 'SANTO STEFANO QUISQUINA',
        istatCode: '019084040'
    },
    {
        name: 'SANTO STEFANO ROERO',
        istatCode: '001004214'
    },
    {
        name: 'SANTO STEFANO TICINO',
        istatCode: '003015200'
    },
    {
        name: 'SANTO STINO DI LIVENZA',
        istatCode: '005027036'
    },
    {
        name: 'SANT\'OLCESE',
        istatCode: '007010055'
    },
    {
        name: 'SANTOMENNA',
        istatCode: '015065131'
    },
    {
        name: 'SANT\'OMERO',
        istatCode: '013067039'
    },
    {
        name: 'SANT\'OMOBONO IMAGNA',
        istatCode: '003016192'
    },
    {
        name: 'SANT\'OMOBONO TERME',
        istatCode: '003016252'
    },
    {
        name: 'SANT\'ONOFRIO',
        istatCode: '018102036'
    },
    {
        name: 'SANTOPADRE',
        istatCode: '012060069'
    },
    {
        name: 'SANT\'ORESTE',
        istatCode: '012058099'
    },
    {
        name: 'SANTORSO',
        istatCode: '005024095'
    },
    {
        name: 'SANT\'ORSOLA TERME',
        istatCode: '004022168'
    },
    {
        name: 'SANTU LUSSURGIU',
        istatCode: '020095049'
    },
    {
        name: 'SANT\'URBANO',
        istatCode: '005028084'
    },
    {
        name: 'SANZA',
        istatCode: '015065133'
    },
    {
        name: 'SANZENO',
        istatCode: '004022169'
    },
    {
        name: 'SAONARA',
        istatCode: '005028085'
    },
    {
        name: 'SAPONARA',
        istatCode: '019083092'
    },
    {
        name: 'SAPPADA',
        istatCode: '006030189'
    },
    {
        name: 'SAPRI',
        istatCode: '015065134'
    },
    {
        name: 'SARACENA',
        istatCode: '018078136'
    },
    {
        name: 'SARACINESCO',
        istatCode: '012058101'
    },
    {
        name: 'SARCEDO',
        istatCode: '005024097'
    },
    {
        name: 'SARCONI',
        istatCode: '017076081'
    },
    {
        name: 'SARDAGNA',
        istatCode: '004022910'
    },
    {
        name: 'SARDARA',
        istatCode: '020111072'
    },
    {
        name: 'SARDIGLIANO',
        istatCode: '001006157'
    },
    {
        name: 'SAREGO',
        istatCode: '005024098'
    },
    {
        name: 'SARENTINO - SARNTAL',
        istatCode: '004021086'
    },
    {
        name: 'SAREZZANO',
        istatCode: '001006158'
    },
    {
        name: 'SAREZZO',
        istatCode: '003017174'
    },
    {
        name: 'SARMATO',
        istatCode: '008033042'
    },
    {
        name: 'SARMEDE',
        istatCode: '005026078'
    },
    {
        name: 'SARNANO',
        istatCode: '011043049'
    },
    {
        name: 'SARNICO',
        istatCode: '003016193'
    },
    {
        name: 'SARNO',
        istatCode: '015065135'
    },
    {
        name: 'SARNONICO',
        istatCode: '004022170'
    },
    {
        name: 'SARONNO',
        istatCode: '003012119'
    },
    {
        name: 'SARRE',
        istatCode: '002007066'
    },
    {
        name: 'SARROCH',
        istatCode: '020092066'
    },
    {
        name: 'SARSINA',
        istatCode: '008040044'
    },
    {
        name: 'SARTEANO',
        istatCode: '009052031'
    },
    {
        name: 'SARTIRANA LOMELLINA',
        istatCode: '003018146'
    },
    {
        name: 'SARULE',
        istatCode: '020091077'
    },
    {
        name: 'SARZANA',
        istatCode: '007011027'
    },
    {
        name: 'SASSANO',
        istatCode: '015065136'
    },
    {
        name: 'SASSARI',
        istatCode: '020090064'
    },
    {
        name: 'SASSELLO',
        istatCode: '007009055'
    },
    {
        name: 'SASSETTA',
        istatCode: '009049019'
    },
    {
        name: 'SASSINORO',
        istatCode: '015062072'
    },
    {
        name: 'SASSO DI CASTALDA',
        istatCode: '017076082'
    },
    {
        name: 'SASSO MARCONI',
        istatCode: '008037057'
    },
    {
        name: 'SASSOCORVARO',
        istatCode: '011041059'
    },
    {
        name: 'SASSOCORVARO AUDITORE',
        istatCode: '011041071'
    },
    {
        name: 'SASSOFELTRIO',
        istatCode: '008099031'
    },
    {
        name: 'SASSOFELTRIO',
        istatCode: '011041060'
    },
    {
        name: 'SASSOFERRATO',
        istatCode: '011042044'
    },
    {
        name: 'SASSUOLO',
        istatCode: '008036040'
    },
    {
        name: 'SATRIANO',
        istatCode: '018079123'
    },
    {
        name: 'SATRIANO DI LUCANIA',
        istatCode: '017076083'
    },
    {
        name: 'SAURIS',
        istatCode: '006030107'
    },
    {
        name: 'SAUZE DI CESANA',
        istatCode: '001001258'
    },
    {
        name: 'SAUZE D\'OULX',
        istatCode: '001001259'
    },
    {
        name: 'SAVA',
        istatCode: '016073026'
    },
    {
        name: 'SAVELLI',
        istatCode: '018101023'
    },
    {
        name: 'SAVIANO',
        istatCode: '015063076'
    },
    {
        name: 'SAVIGLIANO',
        istatCode: '001004215'
    },
    {
        name: 'SAVIGNANO IRPINO',
        istatCode: '015064096'
    },
    {
        name: 'SAVIGNANO SUL PANARO',
        istatCode: '008036041'
    },
    {
        name: 'SAVIGNANO SUL RUBICONE',
        istatCode: '008040045'
    },
    {
        name: 'SAVIGNO',
        istatCode: '008037058'
    },
    {
        name: 'SAVIGNONE',
        istatCode: '007010057'
    },
    {
        name: 'SAVIORE DELL\'ADAMELLO',
        istatCode: '003017175'
    },
    {
        name: 'SAVOCA',
        istatCode: '019083093'
    },
    {
        name: 'SAVOGNA',
        istatCode: '006030108'
    },
    {
        name: 'SAVOGNA D\'ISONZO',
        istatCode: '006031022'
    },
    {
        name: 'SAVOIA DI LUCANIA',
        istatCode: '017076084'
    },
    {
        name: 'SAVONA',
        istatCode: '007009056'
    },
    {
        name: 'SCAFA',
        istatCode: '013068039'
    },
    {
        name: 'SCAFATI',
        istatCode: '015065137'
    },
    {
        name: 'SCAGNELLO',
        istatCode: '001004216'
    },
    {
        name: 'SCALA',
        istatCode: '015065138'
    },
    {
        name: 'SCALA COELI',
        istatCode: '018078137'
    },
    {
        name: 'SCALDASOLE',
        istatCode: '003018147'
    },
    {
        name: 'SCALEA',
        istatCode: '018078138'
    },
    {
        name: 'SCALENGHE',
        istatCode: '001001260'
    },
    {
        name: 'SCALETTA ZANCLEA',
        istatCode: '019083094'
    },
    {
        name: 'SCAMPITELLA',
        istatCode: '015064097'
    },
    {
        name: 'SCANDALE',
        istatCode: '018101024'
    },
    {
        name: 'SCANDELUZZA',
        istatCode: '001005102'
    },
    {
        name: 'SCANDIANO',
        istatCode: '008035040'
    },
    {
        name: 'SCANDICCI',
        istatCode: '009048041'
    },
    {
        name: 'SCANDOLARA RAVARA',
        istatCode: '003019092'
    },
    {
        name: 'SCANDOLARA RIPA D\'OGLIO',
        istatCode: '003019093'
    },
    {
        name: 'SCANDRIGLIA',
        istatCode: '012057064'
    },
    {
        name: 'SCANNO',
        istatCode: '013066093'
    },
    {
        name: 'SCANO DI MONTIFERRO',
        istatCode: '020095051'
    },
    {
        name: 'SCANSANO',
        istatCode: '009053023'
    },
    {
        name: 'SCANZANO JONICO',
        istatCode: '017077031'
    },
    {
        name: 'SCANZOROSCIATE',
        istatCode: '003016194'
    },
    {
        name: 'SCAPOLI',
        istatCode: '014094048'
    },
    {
        name: 'SCARLINO',
        istatCode: '009053024'
    },
    {
        name: 'SCARMAGNO',
        istatCode: '001001261'
    },
    {
        name: 'SCARNAFIGI',
        istatCode: '001004217'
    },
    {
        name: 'SCARNAFIGI-RUFFIA',
        istatCode: '001004819'
    },
    {
        name: 'SCARPERIA',
        istatCode: '009048042'
    },
    {
        name: 'SCARPERIA E SAN PIERO',
        istatCode: '009048053'
    },
    {
        name: 'SCARPIZZOLO',
        istatCode: '003017897'
    },
    {
        name: 'SCAVOLINO',
        istatCode: '011041820'
    },
    {
        name: 'SCENA - SCHENNA',
        istatCode: '004021087'
    },
    {
        name: 'SCERNI',
        istatCode: '013069087'
    },
    {
        name: 'SCHEGGIA',
        istatCode: '010054046'
    },
    {
        name: 'SCHEGGIA E PASCELUPO',
        istatCode: '010054046'
    },
    {
        name: 'SCHEGGINO',
        istatCode: '010054047'
    },
    {
        name: 'SCHIAVI DI ABRUZZO',
        istatCode: '013069088'
    },
    {
        name: 'SCHIAVON',
        istatCode: '005024099'
    },
    {
        name: 'SCHIGNANO',
        istatCode: '003013211'
    },
    {
        name: 'SCHILPARIO',
        istatCode: '003016195'
    },
    {
        name: 'SCHIO',
        istatCode: '005024100'
    },
    {
        name: 'SCHIVENOGLIA',
        istatCode: '003020060'
    },
    {
        name: 'SCIACCA',
        istatCode: '019084041'
    },
    {
        name: 'SCIARA',
        istatCode: '019082068'
    },
    {
        name: 'SCICLI',
        istatCode: '019088011'
    },
    {
        name: 'SCIDO',
        istatCode: '018080084'
    },
    {
        name: 'SCIGLIANO',
        istatCode: '018078139'
    },
    {
        name: 'SCILLA',
        istatCode: '018080085'
    },
    {
        name: 'SCILLATO',
        istatCode: '019082081'
    },
    {
        name: 'SCIOLZE',
        istatCode: '001001262'
    },
    {
        name: 'SCISCIANO',
        istatCode: '015063077'
    },
    {
        name: 'SCLAFANI BAGNI',
        istatCode: '019082069'
    },
    {
        name: 'SCONTRONE',
        istatCode: '013066094'
    },
    {
        name: 'SCOPA',
        istatCode: '001002134'
    },
    {
        name: 'SCOPELLO',
        istatCode: '001002135'
    },
    {
        name: 'SCOPPITO',
        istatCode: '013066095'
    },
    {
        name: 'SCORDIA',
        istatCode: '019087049'
    },
    {
        name: 'SCORRANO',
        istatCode: '016075073'
    },
    {
        name: 'SCORZE\'',
        istatCode: '005027037'
    },
    {
        name: 'SCURCOLA MARSICANA',
        istatCode: '013066096'
    },
    {
        name: 'SCURELLE',
        istatCode: '004022171'
    },
    {
        name: 'SCURZOLENGO',
        istatCode: '001005103'
    },
    {
        name: 'SEBORGA',
        istatCode: '007008057'
    },
    {
        name: 'SECINARO',
        istatCode: '013066097'
    },
    {
        name: 'SECLI\'',
        istatCode: '016075074'
    },
    {
        name: 'SECONDIGLIANO',
        istatCode: '015063810'
    },
    {
        name: 'SECUGNAGO',
        istatCode: '003098052'
    },
    {
        name: 'SEDEGLIANO',
        istatCode: '006030109'
    },
    {
        name: 'SEDICO',
        istatCode: '005025053'
    },
    {
        name: 'SEDILO',
        istatCode: '020095052'
    },
    {
        name: 'SEDINI',
        istatCode: '020090065'
    },
    {
        name: 'SEDRIANO',
        istatCode: '003015204'
    },
    {
        name: 'SEDRINA',
        istatCode: '003016196'
    },
    {
        name: 'SEFRO',
        istatCode: '011043050'
    },
    {
        name: 'SEGARIU',
        istatCode: '020111073'
    },
    {
        name: 'SEGGIANO',
        istatCode: '009053025'
    },
    {
        name: 'SEGNI',
        istatCode: '012058102'
    },
    {
        name: 'SEGONZANO',
        istatCode: '004022172'
    },
    {
        name: 'SEGRATE',
        istatCode: '003015205'
    },
    {
        name: 'SEGUSINO',
        istatCode: '005026079'
    },
    {
        name: 'SELARGIUS',
        istatCode: '020092068'
    },
    {
        name: 'SELCI',
        istatCode: '012057065'
    },
    {
        name: 'SELEGAS',
        istatCode: '020111074'
    },
    {
        name: 'SELLA GIUDICARIE',
        istatCode: '004022246'
    },
    {
        name: 'SELLANO',
        istatCode: '010054048'
    },
    {
        name: 'SELLERO',
        istatCode: '003017176'
    },
    {
        name: 'SELLIA',
        istatCode: '018079126'
    },
    {
        name: 'SELLIA MARINA',
        istatCode: '018079127'
    },
    {
        name: 'SELVA DEI MOLINI - MUEHLWALD',
        istatCode: '004021088'
    },
    {
        name: 'SELVA DI CADORE',
        istatCode: '005025054'
    },
    {
        name: 'SELVA DI PROGNO',
        istatCode: '005023080'
    },
    {
        name: 'SELVA DI VAL GARDENA - WOLKENSTEIN IN GROEDEN',
        istatCode: '004021089'
    },
    {
        name: 'SELVAZZANO DENTRO',
        istatCode: '005028086'
    },
    {
        name: 'SELVE MARCONE',
        istatCode: '001096061'
    },
    {
        name: 'SELVINO',
        istatCode: '003016197'
    },
    {
        name: 'SEMESTENE',
        istatCode: '020090066'
    },
    {
        name: 'SEMIANA',
        istatCode: '003018148'
    },
    {
        name: 'SEMINARA',
        istatCode: '018080086'
    },
    {
        name: 'SEMPRONIANO',
        istatCode: '009053028'
    },
    {
        name: 'SENAGO',
        istatCode: '003015206'
    },
    {
        name: 'SENALES - SCHNALS',
        istatCode: '004021091'
    },
    {
        name: 'SENALE-SAN FELICE - UNSERE LIEBE FRAU IM WALDE-ST. FELIX',
        istatCode: '004021118'
    },
    {
        name: 'SENEGHE',
        istatCode: '020095053'
    },
    {
        name: 'SENERCHIA',
        istatCode: '015064098'
    },
    {
        name: 'SENIGA',
        istatCode: '003017177'
    },
    {
        name: 'SENIGALLIA',
        istatCode: '011042045'
    },
    {
        name: 'SENIS',
        istatCode: '020095054'
    },
    {
        name: 'SENISE',
        istatCode: '017076085'
    },
    {
        name: 'SENNA COMASCO',
        istatCode: '003013212'
    },
    {
        name: 'SENNA LODIGIANA',
        istatCode: '003098053'
    },
    {
        name: 'SENNARIOLO',
        istatCode: '020095055'
    },
    {
        name: 'SENNORI',
        istatCode: '020090067'
    },
    {
        name: 'SENORBI\'',
        istatCode: '020111075'
    },
    {
        name: 'SEPINO',
        istatCode: '014070075'
    },
    {
        name: 'SEPPIANA',
        istatCode: '001103063'
    },
    {
        name: 'SEPRIO',
        istatCode: '003013941'
    },
    {
        name: 'SEQUALS',
        istatCode: '006093042'
    },
    {
        name: 'SERAVEZZA',
        istatCode: '009046028'
    },
    {
        name: 'SERBARIU',
        istatCode: '020092807'
    },
    {
        name: 'SERDIANA',
        istatCode: '020111076'
    },
    {
        name: 'SEREGNO',
        istatCode: '003108039'
    },
    {
        name: 'SEREN DEL GRAPPA',
        istatCode: '005025055'
    },
    {
        name: 'SERGNANO',
        istatCode: '003019094'
    },
    {
        name: 'SERIATE',
        istatCode: '003016198'
    },
    {
        name: 'SERINA',
        istatCode: '003016199'
    },
    {
        name: 'SERINO',
        istatCode: '015064099'
    },
    {
        name: 'SERLE',
        istatCode: '003017178'
    },
    {
        name: 'SERMIDE E FELONICA',
        istatCode: '003020061'
    },
    {
        name: 'SERMONETA',
        istatCode: '012059027'
    },
    {
        name: 'SERNAGLIA DELLA BATTAGLIA',
        istatCode: '005026080'
    },
    {
        name: 'SERNIO',
        istatCode: '003014059'
    },
    {
        name: 'SEROLE',
        istatCode: '001005104'
    },
    {
        name: 'SERRA D\'AIELLO',
        istatCode: '018078140'
    },
    {
        name: 'SERRA DE\' CONTI',
        istatCode: '011042046'
    },
    {
        name: 'SERRA PEDACE',
        istatCode: '018078141'
    },
    {
        name: 'SERRA RICCO\'',
        istatCode: '007010058'
    },
    {
        name: 'SERRA SAN BRUNO',
        istatCode: '018102037'
    },
    {
        name: 'SERRA SAN QUIRICO',
        istatCode: '011042047'
    },
    {
        name: 'SERRA SANT\'ABBONDIO',
        istatCode: '011041061'
    },
    {
        name: 'SERRACAPRIOLA',
        istatCode: '016071053'
    },
    {
        name: 'SERRADIFALCO',
        istatCode: '019085018'
    },
    {
        name: 'SERRALUNGA D\'ALBA',
        istatCode: '001004218'
    },
    {
        name: 'SERRALUNGA DI CREA',
        istatCode: '001006159'
    },
    {
        name: 'SERRAMANNA',
        istatCode: '020111077'
    },
    {
        name: 'SERRAMAZZONI',
        istatCode: '008036042'
    },
    {
        name: 'SERRAMEZZANA',
        istatCode: '015065139'
    },
    {
        name: 'SERRAMONACESCA',
        istatCode: '013068040'
    },
    {
        name: 'SERRAPETRONA',
        istatCode: '011043051'
    },
    {
        name: 'SERRARA FONTANA',
        istatCode: '015063078'
    },
    {
        name: 'SERRASTRETTA',
        istatCode: '018079129'
    },
    {
        name: 'SERRATA',
        istatCode: '018080087'
    },
    {
        name: 'SERRAVALLE A PO',
        istatCode: '003020062'
    },
    {
        name: 'SERRAVALLE DI CHIENTI',
        istatCode: '011043052'
    },
    {
        name: 'SERRAVALLE LANGHE',
        istatCode: '001004219'
    },
    {
        name: 'SERRAVALLE PISTOIESE',
        istatCode: '009047020'
    },
    {
        name: 'SERRAVALLE SCRIVIA',
        istatCode: '001006160'
    },
    {
        name: 'SERRAVALLE SESIA',
        istatCode: '001002137'
    },
    {
        name: 'SERRE',
        istatCode: '015065140'
    },
    {
        name: 'SERRENTI',
        istatCode: '020111078'
    },
    {
        name: 'SERRI',
        istatCode: '020111079'
    },
    {
        name: 'SERRONE',
        istatCode: '012060071'
    },
    {
        name: 'SERRUNGARINA',
        istatCode: '011041062'
    },
    {
        name: 'SERSALE',
        istatCode: '018079130'
    },
    {
        name: 'SERVIGLIANO',
        istatCode: '011109038'
    },
    {
        name: 'SESSA AURUNCA',
        istatCode: '015061088'
    },
    {
        name: 'SESSA CILENTO',
        istatCode: '015065141'
    },
    {
        name: 'SESSAME',
        istatCode: '001005105'
    },
    {
        name: 'SESSANO DEL MOLISE',
        istatCode: '014094049'
    },
    {
        name: 'SESTA GODANO',
        istatCode: '007011028'
    },
    {
        name: 'SESTINO',
        istatCode: '009051035'
    },
    {
        name: 'SESTO - SEXTEN',
        istatCode: '004021092'
    },
    {
        name: 'SESTO AL REGHENA',
        istatCode: '006093043'
    },
    {
        name: 'SESTO CALENDE',
        istatCode: '003012120'
    },
    {
        name: 'SESTO CAMPANO',
        istatCode: '014094050'
    },
    {
        name: 'SESTO ED UNITI',
        istatCode: '003019095'
    },
    {
        name: 'SESTO FIORENTINO',
        istatCode: '009048043'
    },
    {
        name: 'SESTO SAN GIOVANNI',
        istatCode: '003015209'
    },
    {
        name: 'SESTOLA',
        istatCode: '008036043'
    },
    {
        name: 'SESTRI LEVANTE',
        istatCode: '007010059'
    },
    {
        name: 'SESTRI PONENTE',
        istatCode: '007010826'
    },
    {
        name: 'SESTRIERE',
        istatCode: '001001263'
    },
    {
        name: 'SESTU',
        istatCode: '020092074'
    },
    {
        name: 'SETTALA',
        istatCode: '003015210'
    },
    {
        name: 'SETTEFRATI',
        istatCode: '012060072'
    },
    {
        name: 'SETTIME',
        istatCode: '001005106'
    },
    {
        name: 'SETTIMO MILANESE',
        istatCode: '003015211'
    },
    {
        name: 'SETTIMO ROTTARO',
        istatCode: '001001264'
    },
    {
        name: 'SETTIMO SAN PIETRO',
        istatCode: '020092075'
    },
    {
        name: 'SETTIMO TORINESE',
        istatCode: '001001265'
    },
    {
        name: 'SETTIMO VITTONE',
        istatCode: '001001266'
    },
    {
        name: 'SETTINGIANO',
        istatCode: '018079131'
    },
    {
        name: 'SETZU',
        istatCode: '020111080'
    },
    {
        name: 'SEUI',
        istatCode: '020111081'
    },
    {
        name: 'SEULO',
        istatCode: '020111082'
    },
    {
        name: 'SEVESO',
        istatCode: '003108040'
    },
    {
        name: 'SEZZADIO',
        istatCode: '001006161'
    },
    {
        name: 'SEZZE',
        istatCode: '012059028'
    },
    {
        name: 'SFRUZ',
        istatCode: '004022173'
    },
    {
        name: 'SGONICO',
        istatCode: '006032005'
    },
    {
        name: 'SGURGOLA',
        istatCode: '012060073'
    },
    {
        name: 'SIAMAGGIORE',
        istatCode: '020095056'
    },
    {
        name: 'SIAMANNA',
        istatCode: '020095057'
    },
    {
        name: 'SIAMANNA SIAPICCIA',
        istatCode: '020095809'
    },
    {
        name: 'SIANO',
        istatCode: '015065142'
    },
    {
        name: 'SIAPICCIA',
        istatCode: '020095076'
    },
    {
        name: 'SICIGNANO DEGLI ALBURNI',
        istatCode: '015065143'
    },
    {
        name: 'SICULIANA',
        istatCode: '019084042'
    },
    {
        name: 'SIDDI',
        istatCode: '020111083'
    },
    {
        name: 'SIDERNO',
        istatCode: '018080088'
    },
    {
        name: 'SIENA',
        istatCode: '009052032'
    },
    {
        name: 'SIGILLO',
        istatCode: '010054049'
    },
    {
        name: 'SIGNA',
        istatCode: '009048044'
    },
    {
        name: 'SILANDRO - SCHLANDERS',
        istatCode: '004021093'
    },
    {
        name: 'SILANUS',
        istatCode: '020091083'
    },
    {
        name: 'SILEA',
        istatCode: '005026081'
    },
    {
        name: 'SILIGO',
        istatCode: '020090068'
    },
    {
        name: 'SILIQUA',
        istatCode: '020111084'
    },
    {
        name: 'SILIUS',
        istatCode: '020111085'
    },
    {
        name: 'SILLANO',
        istatCode: '009046029'
    },
    {
        name: 'SILLANO GIUNCUGNANO',
        istatCode: '009046037'
    },
    {
        name: 'SILLAVENGO',
        istatCode: '001003138'
    },
    {
        name: 'SILVANO D\'ORBA',
        istatCode: '001006162'
    },
    {
        name: 'SILVANO PIETRA',
        istatCode: '003018149'
    },
    {
        name: 'SILVI',
        istatCode: '013067040'
    },
    {
        name: 'SIMALA',
        istatCode: '020095058'
    },
    {
        name: 'SIMAXIS',
        istatCode: '020095059'
    },
    {
        name: 'SIMBARIO',
        istatCode: '018102038'
    },
    {
        name: 'SIMERI CRICHI',
        istatCode: '018079133'
    },
    {
        name: 'SINAGRA',
        istatCode: '019083095'
    },
    {
        name: 'SINALUNGA',
        istatCode: '009052033'
    },
    {
        name: 'SINDIA',
        istatCode: '020091084'
    },
    {
        name: 'SINI',
        istatCode: '020095060'
    },
    {
        name: 'SINIO',
        istatCode: '001004220'
    },
    {
        name: 'SINISCOLA',
        istatCode: '020091085'
    },
    {
        name: 'SINNAI',
        istatCode: '020092080'
    },
    {
        name: 'SINOPOLI',
        istatCode: '018080089'
    },
    {
        name: 'SIRACUSA',
        istatCode: '019089017'
    },
    {
        name: 'SIRIGNANO',
        istatCode: '015064100'
    },
    {
        name: 'SIRIS',
        istatCode: '020095061'
    },
    {
        name: 'SIRMIONE',
        istatCode: '003017179'
    },
    {
        name: 'SIROLO',
        istatCode: '011042048'
    },
    {
        name: 'SIRONE',
        istatCode: '003097075'
    },
    {
        name: 'SIROR',
        istatCode: '004022174'
    },
    {
        name: 'SIRTORI',
        istatCode: '003097076'
    },
    {
        name: 'SISSA',
        istatCode: '008034034'
    },
    {
        name: 'SISSA TRECASALI',
        istatCode: '008034049'
    },
    {
        name: 'SIURGUS DONIGALA',
        istatCode: '020111086'
    },
    {
        name: 'SIZIANO',
        istatCode: '003018150'
    },
    {
        name: 'SIZZANO',
        istatCode: '001003139'
    },
    {
        name: 'SLUDERNO - SCHLUDERNS',
        istatCode: '004021094'
    },
    {
        name: 'SMARANO',
        istatCode: '004022175'
    },
    {
        name: 'SMERILLO',
        istatCode: '011109039'
    },
    {
        name: 'SOAVE',
        istatCode: '005023081'
    },
    {
        name: 'SOCCHIEVE',
        istatCode: '006030110'
    },
    {
        name: 'SODDI\'',
        istatCode: '020095078'
    },
    {
        name: 'SOGLIANO AL RUBICONE',
        istatCode: '008040046'
    },
    {
        name: 'SOGLIANO CAVOUR',
        istatCode: '016075075'
    },
    {
        name: 'SOGLIO',
        istatCode: '001005107'
    },
    {
        name: 'SOIANO DEL LAGO',
        istatCode: '003017180'
    },
    {
        name: 'SOLAGNA',
        istatCode: '005024101'
    },
    {
        name: 'SOLARINO',
        istatCode: '019089018'
    },
    {
        name: 'SOLARO',
        istatCode: '003015213'
    },
    {
        name: 'SOLAROLO',
        istatCode: '008039018'
    },
    {
        name: 'SOLAROLO RAINERIO',
        istatCode: '003019096'
    },
    {
        name: 'SOLARUSSA',
        istatCode: '020095062'
    },
    {
        name: 'SOLBIATE',
        istatCode: '003013215'
    },
    {
        name: 'SOLBIATE ARNO',
        istatCode: '003012121'
    },
    {
        name: 'SOLBIATE CON CAGNO',
        istatCode: '003013255'
    },
    {
        name: 'SOLBIATE OLONA',
        istatCode: '003012122'
    },
    {
        name: 'SOLDANO',
        istatCode: '007008058'
    },
    {
        name: 'SOLEMINIS',
        istatCode: '020111087'
    },
    {
        name: 'SOLERO',
        istatCode: '001006163'
    },
    {
        name: 'SOLESINO',
        istatCode: '005028087'
    },
    {
        name: 'SOLETO',
        istatCode: '016075076'
    },
    {
        name: 'SOLFERINO',
        istatCode: '003020063'
    },
    {
        name: 'SOLIERA',
        istatCode: '008036044'
    },
    {
        name: 'SOLIGNANO',
        istatCode: '008034035'
    },
    {
        name: 'SOLOFRA',
        istatCode: '015064101'
    },
    {
        name: 'SOLONGHELLO',
        istatCode: '001006164'
    },
    {
        name: 'SOLOPACA',
        istatCode: '015062073'
    },
    {
        name: 'SOLTO COLLINA',
        istatCode: '003016200'
    },
    {
        name: 'SOLZA',
        istatCode: '003016251'
    },
    {
        name: 'SOMAGLIA',
        istatCode: '003098054'
    },
    {
        name: 'SOMANO',
        istatCode: '001004221'
    },
    {
        name: 'SOMMA LOMBARDO',
        istatCode: '003012123'
    },
    {
        name: 'SOMMA VESUVIANA',
        istatCode: '015063079'
    },
    {
        name: 'SOMMACAMPAGNA',
        istatCode: '005023082'
    },
    {
        name: 'SOMMARIVA DEL BOSCO',
        istatCode: '001004222'
    },
    {
        name: 'SOMMARIVA PERNO',
        istatCode: '001004223'
    },
    {
        name: 'SOMMATINO',
        istatCode: '019085019'
    },
    {
        name: 'SOMMO',
        istatCode: '003018151'
    },
    {
        name: 'SONA',
        istatCode: '005023083'
    },
    {
        name: 'SONCINO',
        istatCode: '003019097'
    },
    {
        name: 'SONDALO',
        istatCode: '003014060'
    },
    {
        name: 'SONDRIO',
        istatCode: '003014061'
    },
    {
        name: 'SONGAVAZZO',
        istatCode: '003016201'
    },
    {
        name: 'SONICO',
        istatCode: '003017181'
    },
    {
        name: 'SONNINO',
        istatCode: '012059029'
    },
    {
        name: 'SOPRAMONTE',
        istatCode: '004022919'
    },
    {
        name: 'SOPRANA',
        istatCode: '001096062'
    },
    {
        name: 'SORA',
        istatCode: '012060074'
    },
    {
        name: 'SORAGA',
        istatCode: '004022176'
    },
    {
        name: 'SORAGNA',
        istatCode: '008034036'
    },
    {
        name: 'SORANO',
        istatCode: '009053026'
    },
    {
        name: 'SORBANO',
        istatCode: '008040804'
    },
    {
        name: 'SORBO SAN BASILE',
        istatCode: '018079134'
    },
    {
        name: 'SORBO SERPICO',
        istatCode: '015064102'
    },
    {
        name: 'SORBOLO',
        istatCode: '008034037'
    },
    {
        name: 'SORBOLO MEZZANI',
        istatCode: '008034051'
    },
    {
        name: 'SORDEVOLO',
        istatCode: '001096063'
    },
    {
        name: 'SORDIO',
        istatCode: '003098055'
    },
    {
        name: 'SORESINA',
        istatCode: '003019098'
    },
    {
        name: 'SORGA\'',
        istatCode: '005023084'
    },
    {
        name: 'SORGONO',
        istatCode: '020091086'
    },
    {
        name: 'SORI',
        istatCode: '007010060'
    },
    {
        name: 'SORIANELLO',
        istatCode: '018102039'
    },
    {
        name: 'SORIANO CALABRO',
        istatCode: '018102040'
    },
    {
        name: 'SORIANO NEL CIMINO',
        istatCode: '012056048'
    },
    {
        name: 'SORICO',
        istatCode: '003013216'
    },
    {
        name: 'SORISO',
        istatCode: '001003140'
    },
    {
        name: 'SORISOLE',
        istatCode: '003016202'
    },
    {
        name: 'SORMANO',
        istatCode: '003013217'
    },
    {
        name: 'SORRADILE',
        istatCode: '020095063'
    },
    {
        name: 'SORRENTO',
        istatCode: '015063080'
    },
    {
        name: 'SORSO',
        istatCode: '020090069'
    },
    {
        name: 'SORTINO',
        istatCode: '019089019'
    },
    {
        name: 'SOSPIRO',
        istatCode: '003019099'
    },
    {
        name: 'SOSPIROLO',
        istatCode: '005025056'
    },
    {
        name: 'SOSSANO',
        istatCode: '005024102'
    },
    {
        name: 'SOSTEGNO',
        istatCode: '001096064'
    },
    {
        name: 'SOTTO IL MONTE GIOVANNI XXIII',
        istatCode: '003016203'
    },
    {
        name: 'SOVER',
        istatCode: '004022177'
    },
    {
        name: 'SOVERATO',
        istatCode: '018079137'
    },
    {
        name: 'SOVERE',
        istatCode: '003016204'
    },
    {
        name: 'SOVERIA MANNELLI',
        istatCode: '018079138'
    },
    {
        name: 'SOVERIA SIMERI',
        istatCode: '018079139'
    },
    {
        name: 'SOVERZENE',
        istatCode: '005025057'
    },
    {
        name: 'SOVICILLE',
        istatCode: '009052034'
    },
    {
        name: 'SOVICO',
        istatCode: '003108041'
    },
    {
        name: 'SOVIZZO',
        istatCode: '005024103'
    },
    {
        name: 'SOVRAMONTE',
        istatCode: '005025058'
    },
    {
        name: 'SOZZAGO',
        istatCode: '001003141'
    },
    {
        name: 'SPADAFORA',
        istatCode: '019083096'
    },
    {
        name: 'SPADOLA',
        istatCode: '018102041'
    },
    {
        name: 'SPARANISE',
        istatCode: '015061089'
    },
    {
        name: 'SPARONE',
        istatCode: '001001267'
    },
    {
        name: 'SPECCHIA',
        istatCode: '016075077'
    },
    {
        name: 'SPELLO',
        istatCode: '010054050'
    },
    {
        name: 'SPERA',
        istatCode: '004022178'
    },
    {
        name: 'SPERLINGA',
        istatCode: '019086017'
    },
    {
        name: 'SPERLONGA',
        istatCode: '012059030'
    },
    {
        name: 'SPERONE',
        istatCode: '015064103'
    },
    {
        name: 'SPESSA',
        istatCode: '003018152'
    },
    {
        name: 'SPEZZANO ALBANESE',
        istatCode: '018078142'
    },
    {
        name: 'SPEZZANO DELLA SILA',
        istatCode: '018078143'
    },
    {
        name: 'SPEZZANO PICCOLO',
        istatCode: '018078144'
    },
    {
        name: 'SPIAZZO',
        istatCode: '004022179'
    },
    {
        name: 'SPIGNO MONFERRATO',
        istatCode: '001006165'
    },
    {
        name: 'SPIGNO SATURNIA',
        istatCode: '012059031'
    },
    {
        name: 'SPILAMBERTO',
        istatCode: '008036045'
    },
    {
        name: 'SPILIMBERGO',
        istatCode: '006093044'
    },
    {
        name: 'SPILINGA',
        istatCode: '018102042'
    },
    {
        name: 'SPINADESCO',
        istatCode: '003019100'
    },
    {
        name: 'SPINAZZOLA',
        istatCode: '016110008'
    },
    {
        name: 'SPINEA',
        istatCode: '005027038'
    },
    {
        name: 'SPINEDA',
        istatCode: '003019101'
    },
    {
        name: 'SPINETE',
        istatCode: '014070076'
    },
    {
        name: 'SPINETO SCRIVIA',
        istatCode: '001006166'
    },
    {
        name: 'SPINETOLI',
        istatCode: '011044071'
    },
    {
        name: 'SPINO D\'ADDA',
        istatCode: '003019102'
    },
    {
        name: 'SPINONE AL LAGO',
        istatCode: '003016205'
    },
    {
        name: 'SPINOSO',
        istatCode: '017076086'
    },
    {
        name: 'SPIRANO',
        istatCode: '003016206'
    },
    {
        name: 'SPOLETO',
        istatCode: '010054051'
    },
    {
        name: 'SPOLTORE',
        istatCode: '013068041'
    },
    {
        name: 'SPONGANO',
        istatCode: '016075078'
    },
    {
        name: 'SPORMAGGIORE',
        istatCode: '004022180'
    },
    {
        name: 'SPORMINORE',
        istatCode: '004022181'
    },
    {
        name: 'SPOTORNO',
        istatCode: '007009057'
    },
    {
        name: 'SPRESIANO',
        istatCode: '005026082'
    },
    {
        name: 'SPRIANA',
        istatCode: '003014062'
    },
    {
        name: 'SQUILLACE',
        istatCode: '018079142'
    },
    {
        name: 'SQUINZANO',
        istatCode: '016075079'
    },
    {
        name: 'STAFFOLO',
        istatCode: '011042049'
    },
    {
        name: 'STAGNO LOMBARDO',
        istatCode: '003019103'
    },
    {
        name: 'STAITI',
        istatCode: '018080090'
    },
    {
        name: 'STALETTI',
        istatCode: '018079143'
    },
    {
        name: 'STANGHELLA',
        istatCode: '005028088'
    },
    {
        name: 'STARANZANO',
        istatCode: '006031023'
    },
    {
        name: 'STATTE',
        istatCode: '016073029'
    },
    {
        name: 'STAZZANO',
        istatCode: '001006167'
    },
    {
        name: 'STAZZEMA',
        istatCode: '009046030'
    },
    {
        name: 'STAZZONA',
        istatCode: '003013218'
    },
    {
        name: 'STAZZONA GERMASINO',
        istatCode: '003013944'
    },
    {
        name: 'STEFANACONI',
        istatCode: '018102043'
    },
    {
        name: 'STELLA',
        istatCode: '007009058'
    },
    {
        name: 'STELLA CILENTO',
        istatCode: '015065144'
    },
    {
        name: 'STELLANELLO',
        istatCode: '007009059'
    },
    {
        name: 'STELVIO - STILFS',
        istatCode: '004021095'
    },
    {
        name: 'STENICO',
        istatCode: '004022182'
    },
    {
        name: 'STERNATIA',
        istatCode: '016075080'
    },
    {
        name: 'STEZZANO',
        istatCode: '003016207'
    },
    {
        name: 'STIA',
        istatCode: '009051036'
    },
    {
        name: 'STIENTA',
        istatCode: '005029045'
    },
    {
        name: 'STIGLIANO',
        istatCode: '017077027'
    },
    {
        name: 'STIGNANO',
        istatCode: '018080091'
    },
    {
        name: 'STILO',
        istatCode: '018080092'
    },
    {
        name: 'STIMIGLIANO',
        istatCode: '012057066'
    },
    {
        name: 'STINTINO',
        istatCode: '020090089'
    },
    {
        name: 'STIO',
        istatCode: '015065145'
    },
    {
        name: 'STORNARA',
        istatCode: '016071054'
    },
    {
        name: 'STORNARELLA',
        istatCode: '016071055'
    },
    {
        name: 'STORO',
        istatCode: '004022183'
    },
    {
        name: 'STRA',
        istatCode: '005027039'
    },
    {
        name: 'STRADELLA',
        istatCode: '003018153'
    },
    {
        name: 'STRAMBINELLO',
        istatCode: '001001268'
    },
    {
        name: 'STRAMBINO',
        istatCode: '001001269'
    },
    {
        name: 'STRAMBINO ROMANO',
        istatCode: '002001865'
    },
    {
        name: 'STRANGOLAGALLI',
        istatCode: '012060075'
    },
    {
        name: 'STRAVINO',
        istatCode: '004022544'
    },
    {
        name: 'STREGNA',
        istatCode: '006030111'
    },
    {
        name: 'STREMBO',
        istatCode: '004022184'
    },
    {
        name: 'STRESA',
        istatCode: '001103064'
    },
    {
        name: 'STREVI',
        istatCode: '001006168'
    },
    {
        name: 'STRIANO',
        istatCode: '015063081'
    },
    {
        name: 'STRIGNO',
        istatCode: '004022185'
    },
    {
        name: 'STRONA',
        istatCode: '001096065'
    },
    {
        name: 'STRONCONE',
        istatCode: '010055031'
    },
    {
        name: 'STRONGOLI',
        istatCode: '018101025'
    },
    {
        name: 'STROPPIANA',
        istatCode: '001002142'
    },
    {
        name: 'STROPPO',
        istatCode: '001004224'
    },
    {
        name: 'STROZZA',
        istatCode: '003016208'
    },
    {
        name: 'STURNO',
        istatCode: '015064104'
    },
    {
        name: 'SUARDI',
        istatCode: '003018154'
    },
    {
        name: 'SUBBIANO',
        istatCode: '009051037'
    },
    {
        name: 'SUBIACO',
        istatCode: '012058103'
    },
    {
        name: 'SUCCIVO',
        istatCode: '015061090'
    },
    {
        name: 'SUEGLIO',
        istatCode: '003097077'
    },
    {
        name: 'SUELLI',
        istatCode: '020111088'
    },
    {
        name: 'SUELLO',
        istatCode: '003097078'
    },
    {
        name: 'SUISIO',
        istatCode: '003016209'
    },
    {
        name: 'SULBIATE',
        istatCode: '003108042'
    },
    {
        name: 'SULMONA',
        istatCode: '013066098'
    },
    {
        name: 'SULZANO',
        istatCode: '003017182'
    },
    {
        name: 'SUMIRAGO',
        istatCode: '003012124'
    },
    {
        name: 'SUMMONTE',
        istatCode: '015064105'
    },
    {
        name: 'SUNI',
        istatCode: '020095087'
    },
    {
        name: 'SUNO',
        istatCode: '001003143'
    },
    {
        name: 'SUPERSANO',
        istatCode: '016075081'
    },
    {
        name: 'SUPINO',
        istatCode: '012060076'
    },
    {
        name: 'SURANO',
        istatCode: '016075082'
    },
    {
        name: 'SURBO',
        istatCode: '016075083'
    },
    {
        name: 'SUSA',
        istatCode: '001001270'
    },
    {
        name: 'SUSÀ',
        istatCode: '004022923'
    },
    {
        name: 'SUSEGANA',
        istatCode: '005026083'
    },
    {
        name: 'SUSTINENTE',
        istatCode: '003020064'
    },
    {
        name: 'SUTERA',
        istatCode: '019085020'
    },
    {
        name: 'SUTRI',
        istatCode: '012056049'
    },
    {
        name: 'SUTRIO',
        istatCode: '006030112'
    },
    {
        name: 'SUVERETO',
        istatCode: '009049020'
    },
    {
        name: 'SUZZARA',
        istatCode: '003020065'
    },
    {
        name: 'TACENO',
        istatCode: '003097079'
    },
    {
        name: 'TADASUNI',
        istatCode: '020095064'
    },
    {
        name: 'TAGGIA',
        istatCode: '007008059'
    },
    {
        name: 'TAGLIACOZZO',
        istatCode: '013066099'
    },
    {
        name: 'TAGLIO DI PO',
        istatCode: '005029046'
    },
    {
        name: 'TAGLIOLO BELFORTE',
        istatCode: '001006822'
    },
    {
        name: 'TAGLIOLO MONFERRATO',
        istatCode: '001006169'
    },
    {
        name: 'TAIBON AGORDINO',
        istatCode: '005025059'
    },
    {
        name: 'TAINO',
        istatCode: '003012125'
    },
    {
        name: 'TAIO',
        istatCode: '004022186'
    },
    {
        name: 'TAIPANA',
        istatCode: '006030113'
    },
    {
        name: 'TALAMELLO',
        istatCode: '008099027'
    },
    {
        name: 'TALAMONA',
        istatCode: '003014063'
    },
    {
        name: 'TALANA',
        istatCode: '020091088'
    },
    {
        name: 'TALEGGIO',
        istatCode: '003016210'
    },
    {
        name: 'TALLA',
        istatCode: '009051038'
    },
    {
        name: 'TALMASSONS',
        istatCode: '006030114'
    },
    {
        name: 'TAMBRE',
        istatCode: '005025060'
    },
    {
        name: 'TAORMINA',
        istatCode: '019083097'
    },
    {
        name: 'TAPOGLIANO',
        istatCode: '006030115'
    },
    {
        name: 'TARANO',
        istatCode: '012057067'
    },
    {
        name: 'TARANTA PELIGNA',
        istatCode: '013069089'
    },
    {
        name: 'TARANTASCA',
        istatCode: '001004225'
    },
    {
        name: 'TARANTO',
        istatCode: '016073027'
    },
    {
        name: 'TARCENTO',
        istatCode: '006030116'
    },
    {
        name: 'TARQUINIA',
        istatCode: '012056050'
    },
    {
        name: 'TARSIA',
        istatCode: '018078145'
    },
    {
        name: 'TARTANO',
        istatCode: '003014064'
    },
    {
        name: 'TARVISIO',
        istatCode: '006030117'
    },
    {
        name: 'TARZO',
        istatCode: '005026084'
    },
    {
        name: 'TASSAROLO',
        istatCode: '001006170'
    },
    {
        name: 'TASSULLO',
        istatCode: '004022187'
    },
    {
        name: 'TAURANO',
        istatCode: '015064106'
    },
    {
        name: 'TAURASI',
        istatCode: '015064107'
    },
    {
        name: 'TAURIANOVA',
        istatCode: '018080093'
    },
    {
        name: 'TAURISANO',
        istatCode: '016075084'
    },
    {
        name: 'TAVAGNACCO',
        istatCode: '006030118'
    },
    {
        name: 'TAVAGNASCO',
        istatCode: '001001271'
    },
    {
        name: 'TAVARNELLE VAL DI PESA',
        istatCode: '009048045'
    },
    {
        name: 'TAVAZZANO CON VILLAVESCO',
        istatCode: '003098056'
    },
    {
        name: 'TAVENNA',
        istatCode: '014070077'
    },
    {
        name: 'TAVERNA',
        istatCode: '018079146'
    },
    {
        name: 'TAVERNERIO',
        istatCode: '003013222'
    },
    {
        name: 'TAVERNOLA BERGAMASCA',
        istatCode: '003016211'
    },
    {
        name: 'TAVERNOLE SUL MELLA',
        istatCode: '003017183'
    },
    {
        name: 'TAVIANO',
        istatCode: '016075085'
    },
    {
        name: 'TAVIGLIANO',
        istatCode: '001096066'
    },
    {
        name: 'TAVOLETO',
        istatCode: '011041064'
    },
    {
        name: 'TAVULLIA',
        istatCode: '011041065'
    },
    {
        name: 'TEANA',
        istatCode: '017076087'
    },
    {
        name: 'TEANO',
        istatCode: '015061091'
    },
    {
        name: 'TEGGIANO',
        istatCode: '015065146'
    },
    {
        name: 'TEGLIO',
        istatCode: '003014065'
    },
    {
        name: 'TEGLIO VENETO',
        istatCode: '005027040'
    },
    {
        name: 'TELESE TERME',
        istatCode: '015062074'
    },
    {
        name: 'TELGATE',
        istatCode: '003016212'
    },
    {
        name: 'TELTI',
        istatCode: '020090080'
    },
    {
        name: 'TELVE',
        istatCode: '004022188'
    },
    {
        name: 'TELVE DI SOPRA',
        istatCode: '004022189'
    },
    {
        name: 'TEMPIO PAUSANIA',
        istatCode: '020090070'
    },
    {
        name: 'TEMU\'',
        istatCode: '003017184'
    },
    {
        name: 'TENNA',
        istatCode: '004022190'
    },
    {
        name: 'TENNO',
        istatCode: '004022191'
    },
    {
        name: 'TEOLO',
        istatCode: '005028089'
    },
    {
        name: 'TEOR',
        istatCode: '006030119'
    },
    {
        name: 'TEORA',
        istatCode: '015064108'
    },
    {
        name: 'TERAMO',
        istatCode: '013067041'
    },
    {
        name: 'TERDOBBIATE',
        istatCode: '001003144'
    },
    {
        name: 'TERELLE',
        istatCode: '012060077'
    },
    {
        name: 'TERENTO - TERENTEN',
        istatCode: '004021096'
    },
    {
        name: 'TERENZO',
        istatCode: '008034038'
    },
    {
        name: 'TERGU',
        istatCode: '020090086'
    },
    {
        name: 'TERLAGO',
        istatCode: '004022192'
    },
    {
        name: 'TERLANO - TERLAN',
        istatCode: '004021097'
    },
    {
        name: 'TERLIZZI',
        istatCode: '016072043'
    },
    {
        name: 'TERME VIGLIATORE',
        istatCode: '019083106'
    },
    {
        name: 'TERMENO SULLA STRADA DEL VINO - TRAMIN AN DER WEINSTRASSE',
        istatCode: '004021098'
    },
    {
        name: 'TERMINI IMERESE',
        istatCode: '019082070'
    },
    {
        name: 'TERMOLI',
        istatCode: '014070078'
    },
    {
        name: 'TERNATE',
        istatCode: '003012126'
    },
    {
        name: 'TERNENGO',
        istatCode: '001096067'
    },
    {
        name: 'TERNI',
        istatCode: '010055032'
    },
    {
        name: 'TERNO D\'ISOLA',
        istatCode: '003016213'
    },
    {
        name: 'TERRACINA',
        istatCode: '012059032'
    },
    {
        name: 'TERRAGNOLO',
        istatCode: '004022193'
    },
    {
        name: 'TERRALBA',
        istatCode: '020095065'
    },
    {
        name: 'TERRANOVA DA SIBARI',
        istatCode: '018078146'
    },
    {
        name: 'TERRANOVA DEI PASSERINI',
        istatCode: '003098057'
    },
    {
        name: 'TERRANOVA DI POLLINO',
        istatCode: '017076088'
    },
    {
        name: 'TERRANOVA SAPPO MINULIO',
        istatCode: '018080094'
    },
    {
        name: 'TERRANUOVA BRACCIOLINI',
        istatCode: '009051039'
    },
    {
        name: 'TERRASINI',
        istatCode: '019082071'
    },
    {
        name: 'TERRASSA PADOVANA',
        istatCode: '005028090'
    },
    {
        name: 'TERRAVECCHIA',
        istatCode: '018078147'
    },
    {
        name: 'TERRAZZO',
        istatCode: '005023085'
    },
    {
        name: 'TERRE D\'ADIGE',
        istatCode: '004022251'
    },
    {
        name: 'TERRE DEL RENO',
        istatCode: '008038028'
    },
    {
        name: 'TERRE ROVERESCHE',
        istatCode: '011041070'
    },
    {
        name: 'TERRES',
        istatCode: '004022194'
    },
    {
        name: 'TERRICCIOLA',
        istatCode: '009050036'
    },
    {
        name: 'TERRUGGIA',
        istatCode: '001006171'
    },
    {
        name: 'TERTENIA',
        istatCode: '020091089'
    },
    {
        name: 'TERZIGNO',
        istatCode: '015063082'
    },
    {
        name: 'TERZO',
        istatCode: '001006172'
    },
    {
        name: 'TERZO D\'AQUILEIA',
        istatCode: '006030120'
    },
    {
        name: 'TERZOLAS',
        istatCode: '004022195'
    },
    {
        name: 'TERZORIO',
        istatCode: '007008060'
    },
    {
        name: 'TESERO',
        istatCode: '004022196'
    },
    {
        name: 'TESIMO - TISENS',
        istatCode: '004021099'
    },
    {
        name: 'TESSENNANO',
        istatCode: '012056051'
    },
    {
        name: 'TESTICO',
        istatCode: '007009060'
    },
    {
        name: 'TETI',
        istatCode: '020091090'
    },
    {
        name: 'TEULADA',
        istatCode: '020111089'
    },
    {
        name: 'TEVEROLA',
        istatCode: '015061092'
    },
    {
        name: 'TEZZE SUL BRENTA',
        istatCode: '005024104'
    },
    {
        name: 'THIENE',
        istatCode: '005024105'
    },
    {
        name: 'THIESI',
        istatCode: '020090071'
    },
    {
        name: 'TIANA',
        istatCode: '020091091'
    },
    {
        name: 'TIARNO',
        istatCode: '004022928'
    },
    {
        name: 'TIARNO DI SOPRA',
        istatCode: '004022197'
    },
    {
        name: 'TIARNO DI SOTTO',
        istatCode: '004022198'
    },
    {
        name: 'TICENGO',
        istatCode: '003019104'
    },
    {
        name: 'TICINETO',
        istatCode: '001006173'
    },
    {
        name: 'TIGGIANO',
        istatCode: '016075086'
    },
    {
        name: 'TIGLIETO',
        istatCode: '007010061'
    },
    {
        name: 'TIGLIOLE',
        istatCode: '001005108'
    },
    {
        name: 'TIGNALE',
        istatCode: '003017185'
    },
    {
        name: 'TINNURA',
        istatCode: '020095088'
    },
    {
        name: 'TIONE DEGLI ABRUZZI',
        istatCode: '013066100'
    },
    {
        name: 'TIONE DI TRENTO',
        istatCode: '004022199'
    },
    {
        name: 'TIRANO',
        istatCode: '003014066'
    },
    {
        name: 'TIRES - TIERS',
        istatCode: '004021100'
    },
    {
        name: 'TIRIOLO',
        istatCode: '018079147'
    },
    {
        name: 'TIROLO - TIROL',
        istatCode: '004021101'
    },
    {
        name: 'TISSI',
        istatCode: '020090072'
    },
    {
        name: 'TITO',
        istatCode: '017076089'
    },
    {
        name: 'TIVOLI',
        istatCode: '012058104'
    },
    {
        name: 'TIZZANO VAL PARMA',
        istatCode: '008034039'
    },
    {
        name: 'TOANO',
        istatCode: '008035041'
    },
    {
        name: 'TOCCO CAUDIO',
        istatCode: '015062075'
    },
    {
        name: 'TOCCO DA CASAURIA',
        istatCode: '013068042'
    },
    {
        name: 'TOCENO',
        istatCode: '001103065'
    },
    {
        name: 'TODI',
        istatCode: '010054052'
    },
    {
        name: 'TOFFIA',
        istatCode: '012057068'
    },
    {
        name: 'TOIRANO',
        istatCode: '007009061'
    },
    {
        name: 'TOLENTINO',
        istatCode: '011043053'
    },
    {
        name: 'TOLFA',
        istatCode: '012058105'
    },
    {
        name: 'TOLLEGNO',
        istatCode: '001096068'
    },
    {
        name: 'TOLLO',
        istatCode: '013069090'
    },
    {
        name: 'TOLMEZZO',
        istatCode: '006030121'
    },
    {
        name: 'TOLVE',
        istatCode: '017076090'
    },
    {
        name: 'TOMBOLO',
        istatCode: '005028091'
    },
    {
        name: 'TON',
        istatCode: '004022200'
    },
    {
        name: 'TONADICO',
        istatCode: '004022201'
    },
    {
        name: 'TONARA',
        istatCode: '020091093'
    },
    {
        name: 'TONCO',
        istatCode: '001005109'
    },
    {
        name: 'TONENGO',
        istatCode: '001005110'
    },
    {
        name: 'TONEZZA DEL CIMONE',
        istatCode: '005024106'
    },
    {
        name: 'TORA E PICCILLI',
        istatCode: '015061093'
    },
    {
        name: 'TORANO CASTELLO',
        istatCode: '018078148'
    },
    {
        name: 'TORANO NUOVO',
        istatCode: '013067042'
    },
    {
        name: 'TORBOLE CASAGLIA',
        istatCode: '003017186'
    },
    {
        name: 'TORCEGNO',
        istatCode: '004022202'
    },
    {
        name: 'TORCHIARA',
        istatCode: '015065147'
    },
    {
        name: 'TORCHIAROLO',
        istatCode: '016074018'
    },
    {
        name: 'TORELLA DEI LOMBARDI',
        istatCode: '015064109'
    },
    {
        name: 'TORELLA DEL SANNIO',
        istatCode: '014070079'
    },
    {
        name: 'TORGIANO',
        istatCode: '010054053'
    },
    {
        name: 'TORGNON',
        istatCode: '002007067'
    },
    {
        name: 'TORINO',
        istatCode: '001001272'
    },
    {
        name: 'TORINO DI SANGRO',
        istatCode: '013069091'
    },
    {
        name: 'TORITTO',
        istatCode: '016072044'
    },
    {
        name: 'TORLINO VIMERCATI',
        istatCode: '003019105'
    },
    {
        name: 'TORNACO',
        istatCode: '001003146'
    },
    {
        name: 'TORNARECCIO',
        istatCode: '013069092'
    },
    {
        name: 'TORNATA',
        istatCode: '003019106'
    },
    {
        name: 'TORNIMPARTE',
        istatCode: '013066101'
    },
    {
        name: 'TORNO',
        istatCode: '003013223'
    },
    {
        name: 'TORNOLO',
        istatCode: '008034040'
    },
    {
        name: 'TORO',
        istatCode: '014070080'
    },
    {
        name: 'TORPE\'',
        istatCode: '020091094'
    },
    {
        name: 'TORRACA',
        istatCode: '015065148'
    },
    {
        name: 'TORRALBA',
        istatCode: '020090073'
    },
    {
        name: 'TORRAZZA COSTE',
        istatCode: '003018155'
    },
    {
        name: 'TORRAZZA PIEMONTE',
        istatCode: '001001273'
    },
    {
        name: 'TORRAZZO',
        istatCode: '001096069'
    },
    {
        name: 'TORRE ANNUNZIATA',
        istatCode: '015063083'
    },
    {
        name: 'TORRE BERETTI',
        istatCode: '003018872'
    },
    {
        name: 'TORRE BERETTI E CASTELLARO',
        istatCode: '003018156'
    },
    {
        name: 'TORRE BOLDONE',
        istatCode: '003016214'
    },
    {
        name: 'TORRE BORMIDA',
        istatCode: '001004226'
    },
    {
        name: 'TORRE CAJETANI',
        istatCode: '012060078'
    },
    {
        name: 'TORRE CANAVESE',
        istatCode: '001001274'
    },
    {
        name: 'TORRE D\'ARESE',
        istatCode: '003018157'
    },
    {
        name: 'TORRE DE\' BUSI',
        istatCode: '003016215'
    },
    {
        name: 'TORRE DE\' NEGRI',
        istatCode: '003018158'
    },
    {
        name: 'TORRE DE\' PASSERI',
        istatCode: '013068043'
    },
    {
        name: 'TORRE DE\' PICENARDI',
        istatCode: '003019107'
    },
    {
        name: 'TORRE DE\' ROVERI',
        istatCode: '003016216'
    },
    {
        name: 'TORRE DEL GRECO',
        istatCode: '015063084'
    },
    {
        name: 'TORRE DEL MANGANO',
        istatCode: '003018874'
    },
    {
        name: 'TORRE DI MOSTO',
        istatCode: '005027041'
    },
    {
        name: 'TORRE DI RUGGIERO',
        istatCode: '018079148'
    },
    {
        name: 'TORRE DI SANTA MARIA',
        istatCode: '003014067'
    },
    {
        name: 'TORRE D\'ISOLA',
        istatCode: '003018159'
    },
    {
        name: 'TORRE LE NOCELLE',
        istatCode: '015064110'
    },
    {
        name: 'TORRE MONDOVI\'',
        istatCode: '001004227'
    },
    {
        name: 'TORRE ORSAIA',
        istatCode: '015065149'
    },
    {
        name: 'TORRE PALLAVICINA',
        istatCode: '003016217'
    },
    {
        name: 'TORRE PELLICE',
        istatCode: '001001275'
    },
    {
        name: 'TORRE SAN GIORGIO',
        istatCode: '001004228'
    },
    {
        name: 'TORRE SAN PATRIZIO',
        istatCode: '011109040'
    },
    {
        name: 'TORRE SANTA SUSANNA',
        istatCode: '016074019'
    },
    {
        name: 'TORREANO',
        istatCode: '006030122'
    },
    {
        name: 'TORREBELVICINO',
        istatCode: '005024107'
    },
    {
        name: 'TORREBRUNA',
        istatCode: '013069093'
    },
    {
        name: 'TORRECUSO',
        istatCode: '015062076'
    },
    {
        name: 'TORREGLIA',
        istatCode: '005028092'
    },
    {
        name: 'TORREGROTTA',
        istatCode: '019083098'
    },
    {
        name: 'TORREMAGGIORE',
        istatCode: '016071056'
    },
    {
        name: 'TORRENOVA',
        istatCode: '019083108'
    },
    {
        name: 'TORRESINA',
        istatCode: '001004229'
    },
    {
        name: 'TORRETTA',
        istatCode: '019082072'
    },
    {
        name: 'TORREVECCHIA PIA',
        istatCode: '003018160'
    },
    {
        name: 'TORREVECCHIA TEATINA',
        istatCode: '013069094'
    },
    {
        name: 'TORRI DEL BENACO',
        istatCode: '005023086'
    },
    {
        name: 'TORRI DI QUARTESOLO',
        istatCode: '005024108'
    },
    {
        name: 'TORRI IN SABINA',
        istatCode: '012057070'
    },
    {
        name: 'TORRIANA',
        istatCode: '008099019'
    },
    {
        name: 'TORRICE',
        istatCode: '012060079'
    },
    {
        name: 'TORRICELLA',
        istatCode: '016073028'
    },
    {
        name: 'TORRICELLA DEL PIZZO',
        istatCode: '003019108'
    },
    {
        name: 'TORRICELLA IN SABINA',
        istatCode: '012057069'
    },
    {
        name: 'TORRICELLA PELIGNA',
        istatCode: '013069095'
    },
    {
        name: 'TORRICELLA SICURA',
        istatCode: '013067043'
    },
    {
        name: 'TORRICELLA VERZATE',
        istatCode: '003018161'
    },
    {
        name: 'TORRIGLIA',
        istatCode: '007010062'
    },
    {
        name: 'TORRILE',
        istatCode: '008034041'
    },
    {
        name: 'TORRIONI',
        istatCode: '015064111'
    },
    {
        name: 'TORRITA DI SIENA',
        istatCode: '009052035'
    },
    {
        name: 'TORRITA TIBERINA',
        istatCode: '012058106'
    },
    {
        name: 'TORTOLI\'',
        istatCode: '020091095'
    },
    {
        name: 'TORTONA',
        istatCode: '001006174'
    },
    {
        name: 'TORTORA',
        istatCode: '018078149'
    },
    {
        name: 'TORTORELLA',
        istatCode: '015065150'
    },
    {
        name: 'TORTORETO',
        istatCode: '013067044'
    },
    {
        name: 'TORTORICI',
        istatCode: '019083099'
    },
    {
        name: 'TORVISCOSA',
        istatCode: '006030123'
    },
    {
        name: 'TOSCOLANO-MADERNO',
        istatCode: '003017187'
    },
    {
        name: 'Toss',
        istatCode: '004022930'
    },
    {
        name: 'TOSSICIA',
        istatCode: '013067045'
    },
    {
        name: 'TOVO DI SANT\'AGATA',
        istatCode: '003014068'
    },
    {
        name: 'TOVO SAN GIACOMO',
        istatCode: '007009062'
    },
    {
        name: 'TRABIA',
        istatCode: '019082073'
    },
    {
        name: 'TRADATE',
        istatCode: '003012127'
    },
    {
        name: 'TRAMATZA',
        istatCode: '020095066'
    },
    {
        name: 'TRAMBILENO',
        istatCode: '004022203'
    },
    {
        name: 'TRAMONTI',
        istatCode: '015065151'
    },
    {
        name: 'TRAMONTI DI SOPRA',
        istatCode: '006093045'
    },
    {
        name: 'TRAMONTI DI SOTTO',
        istatCode: '006093046'
    },
    {
        name: 'TRAMUTOLA',
        istatCode: '017076091'
    },
    {
        name: 'TRANA',
        istatCode: '001001276'
    },
    {
        name: 'TRANI',
        istatCode: '016110009'
    },
    {
        name: 'TRANSACQUA',
        istatCode: '004022204'
    },
    {
        name: 'TRAONA',
        istatCode: '003014069'
    },
    {
        name: 'TRAPANI',
        istatCode: '019081021'
    },
    {
        name: 'TRAPPETO',
        istatCode: '019082074'
    },
    {
        name: 'TRAREGO VIGGIONA',
        istatCode: '001103066'
    },
    {
        name: 'TRASACCO',
        istatCode: '013066102'
    },
    {
        name: 'TRASAGHIS',
        istatCode: '006030124'
    },
    {
        name: 'TRASQUERA',
        istatCode: '001103067'
    },
    {
        name: 'TRATALIAS',
        istatCode: '020111090'
    },
    {
        name: 'TRAUSELLA',
        istatCode: '001001277'
    },
    {
        name: 'TRAVACO\' SICCOMARIO',
        istatCode: '003018162'
    },
    {
        name: 'TRAVAGLIATO',
        istatCode: '003017188'
    },
    {
        name: 'TRAVEDONA',
        istatCode: '003012894'
    },
    {
        name: 'TRAVEDONA-MONATE',
        istatCode: '003012128'
    },
    {
        name: 'TRAVERSELLA',
        istatCode: '001001278'
    },
    {
        name: 'TRAVERSETOLO',
        istatCode: '008034042'
    },
    {
        name: 'TRAVES',
        istatCode: '001001279'
    },
    {
        name: 'TRAVESIO',
        istatCode: '006093047'
    },
    {
        name: 'TRAVO',
        istatCode: '008033043'
    },
    {
        name: 'TRE VILLE',
        istatCode: '004022247'
    },
    {
        name: 'TREBASELEGHE',
        istatCode: '005028093'
    },
    {
        name: 'TREBISACCE',
        istatCode: '018078150'
    },
    {
        name: 'TRECASALI',
        istatCode: '008034043'
    },
    {
        name: 'TRECASE',
        istatCode: '015063091'
    },
    {
        name: 'TRECASTAGNI',
        istatCode: '019087050'
    },
    {
        name: 'TRECASTELLI',
        istatCode: '011042050'
    },
    {
        name: 'TRECATE',
        istatCode: '001003149'
    },
    {
        name: 'TRECCHINA',
        istatCode: '017076092'
    },
    {
        name: 'TRECENTA',
        istatCode: '005029047'
    },
    {
        name: 'TREDOSSI',
        istatCode: '003019915'
    },
    {
        name: 'TREDOZIO',
        istatCode: '008040049'
    },
    {
        name: 'TREGLIO',
        istatCode: '013069096'
    },
    {
        name: 'TREGNAGO',
        istatCode: '005023087'
    },
    {
        name: 'TREIA',
        istatCode: '011043054'
    },
    {
        name: 'TREISO',
        istatCode: '001004230'
    },
    {
        name: 'TREMENICO',
        istatCode: '003097081'
    },
    {
        name: 'TREMESTIERI ETNEO',
        istatCode: '019087051'
    },
    {
        name: 'TREMEZZINA (L370)',
        istatCode: '003013948'
    },
    {
        name: 'TREMEZZINA (M341)',
        istatCode: '003013252'
    },
    {
        name: 'TREMEZZO',
        istatCode: '003013225'
    },
    {
        name: 'TREMOSINE',
        istatCode: '003017189'
    },
    {
        name: 'TRENTA',
        istatCode: '018078151'
    },
    {
        name: 'TRENTINARA',
        istatCode: '015065152'
    },
    {
        name: 'TRENTO',
        istatCode: '004022205'
    },
    {
        name: 'TRENTOLA-DUCENTA',
        istatCode: '015061094'
    },
    {
        name: 'TRENZANO',
        istatCode: '003017190'
    },
    {
        name: 'TREPPO CARNICO',
        istatCode: '006030125'
    },
    {
        name: 'TREPPO GRANDE',
        istatCode: '006030126'
    },
    {
        name: 'TREPPO LIGOSULLO',
        istatCode: '006030191'
    },
    {
        name: 'TREPUZZI',
        istatCode: '016075087'
    },
    {
        name: 'TREQUANDA',
        istatCode: '009052036'
    },
    {
        name: 'TRES',
        istatCode: '004022206'
    },
    {
        name: 'TRESANA',
        istatCode: '009045015'
    },
    {
        name: 'TRESCORE BALNEARIO',
        istatCode: '003016218'
    },
    {
        name: 'TRESCORE CREMASCO',
        istatCode: '003019109'
    },
    {
        name: 'TRESIGALLO',
        istatCode: '008038024'
    },
    {
        name: 'TRESIGNANA',
        istatCode: '008038030'
    },
    {
        name: 'TRESIVIO',
        istatCode: '003014070'
    },
    {
        name: 'TRESNURAGHES',
        istatCode: '020095067'
    },
    {
        name: 'TRETTO',
        istatCode: '005024109'
    },
    {
        name: 'TREVENZUOLO',
        istatCode: '005023088'
    },
    {
        name: 'TREVI',
        istatCode: '010054054'
    },
    {
        name: 'TREVI NEL LAZIO',
        istatCode: '012060080'
    },
    {
        name: 'TREVICO',
        istatCode: '015064112'
    },
    {
        name: 'TREVIGLIO',
        istatCode: '003016219'
    },
    {
        name: 'TREVIGNANO',
        istatCode: '005026085'
    },
    {
        name: 'TREVIGNANO ROMANO',
        istatCode: '012058107'
    },
    {
        name: 'TREVILLE',
        istatCode: '001006175'
    },
    {
        name: 'TREVIOLO',
        istatCode: '003016220'
    },
    {
        name: 'TREVISO',
        istatCode: '005026086'
    },
    {
        name: 'TREVISO BRESCIANO',
        istatCode: '003017191'
    },
    {
        name: 'TREZZANO ROSA',
        istatCode: '003015219'
    },
    {
        name: 'TREZZANO SUL NAVIGLIO',
        istatCode: '003015220'
    },
    {
        name: 'TREZZO SULL\'ADDA',
        istatCode: '003015221'
    },
    {
        name: 'TREZZO TINELLA',
        istatCode: '001004231'
    },
    {
        name: 'TREZZONE',
        istatCode: '003013226'
    },
    {
        name: 'TRIBANO',
        istatCode: '005028094'
    },
    {
        name: 'TRIBIANO',
        istatCode: '003015222'
    },
    {
        name: 'TRIBOGNA',
        istatCode: '007010063'
    },
    {
        name: 'TRICARICO',
        istatCode: '017077028'
    },
    {
        name: 'TRICASE',
        istatCode: '016075088'
    },
    {
        name: 'TRICERRO',
        istatCode: '001002147'
    },
    {
        name: 'TRICESIMO',
        istatCode: '006030127'
    },
    {
        name: 'TRICHIANA',
        istatCode: '005025061'
    },
    {
        name: 'TRIEI',
        istatCode: '020091097'
    },
    {
        name: 'TRIESTE',
        istatCode: '006032006'
    },
    {
        name: 'TRIGGIANO',
        istatCode: '016072046'
    },
    {
        name: 'TRIGOLO',
        istatCode: '003019110'
    },
    {
        name: 'TRINITA\'',
        istatCode: '001004232'
    },
    {
        name: 'TRINITA\' D\'AGULTU E VIGNOLA',
        istatCode: '020090074'
    },
    {
        name: 'TRINITAPOLI',
        istatCode: '016110010'
    },
    {
        name: 'TRINO',
        istatCode: '001002148'
    },
    {
        name: 'TRIORA',
        istatCode: '007008061'
    },
    {
        name: 'TRIPI',
        istatCode: '019083100'
    },
    {
        name: 'TRISOBBIO',
        istatCode: '001006176'
    },
    {
        name: 'TRISSINO',
        istatCode: '005024110'
    },
    {
        name: 'TRIUGGIO',
        istatCode: '003108043'
    },
    {
        name: 'TRIVENTO',
        istatCode: '014070081'
    },
    {
        name: 'TRIVERO',
        istatCode: '001096070'
    },
    {
        name: 'TRIVIGLIANO',
        istatCode: '012060081'
    },
    {
        name: 'TRIVIGNANO UDINESE',
        istatCode: '006030128'
    },
    {
        name: 'TRIVIGNO',
        istatCode: '017076093'
    },
    {
        name: 'TRIVOLZIO',
        istatCode: '003018163'
    },
    {
        name: 'TRODENA - TRUDEN',
        istatCode: '004021102'
    },
    {
        name: 'TROFARELLO',
        istatCode: '001001280'
    },
    {
        name: 'TROIA',
        istatCode: '016071058'
    },
    {
        name: 'TROINA',
        istatCode: '019086018'
    },
    {
        name: 'TROMELLO',
        istatCode: '003018164'
    },
    {
        name: 'TRONTANO',
        istatCode: '001103068'
    },
    {
        name: 'TRONZANO LAGO MAGGIORE',
        istatCode: '003012129'
    },
    {
        name: 'TRONZANO VERCELLESE',
        istatCode: '001002150'
    },
    {
        name: 'TROPEA',
        istatCode: '018102044'
    },
    {
        name: 'TROVO',
        istatCode: '003018165'
    },
    {
        name: 'TRUCCAZZANO',
        istatCode: '003015224'
    },
    {
        name: 'TUBRE - TAUFERS IM MUENSTERTAL',
        istatCode: '004021103'
    },
    {
        name: 'TUENNO',
        istatCode: '004022207'
    },
    {
        name: 'TUFARA',
        istatCode: '014070082'
    },
    {
        name: 'TUFILLO',
        istatCode: '013069097'
    },
    {
        name: 'TUFINO',
        istatCode: '015063085'
    },
    {
        name: 'TUFO',
        istatCode: '015064113'
    },
    {
        name: 'TUGLIE',
        istatCode: '016075089'
    },
    {
        name: 'TUILI',
        istatCode: '020111091'
    },
    {
        name: 'TULA',
        istatCode: '020090075'
    },
    {
        name: 'TUORO SUL TRASIMENO',
        istatCode: '010054055'
    },
    {
        name: 'TURANIA',
        istatCode: '012057071'
    },
    {
        name: 'TURANO LODIGIANO',
        istatCode: '003098058'
    },
    {
        name: 'TURATE',
        istatCode: '003013227'
    },
    {
        name: 'TURBIGO',
        istatCode: '003015226'
    },
    {
        name: 'TURI',
        istatCode: '016072047'
    },
    {
        name: 'TURRI',
        istatCode: '020111092'
    },
    {
        name: 'TURRIACO',
        istatCode: '006031024'
    },
    {
        name: 'TURRIVALIGNANI',
        istatCode: '013068044'
    },
    {
        name: 'TURSI',
        istatCode: '017077029'
    },
    {
        name: 'TUSA',
        istatCode: '019083101'
    },
    {
        name: 'TUSCANIA',
        istatCode: '012056052'
    },
    {
        name: 'UBIALE CLANEZZO',
        istatCode: '003016221'
    },
    {
        name: 'UBOLDO',
        istatCode: '003012130'
    },
    {
        name: 'UCRIA',
        istatCode: '019083102'
    },
    {
        name: 'UDINE',
        istatCode: '006030129'
    },
    {
        name: 'UGENTO',
        istatCode: '016075090'
    },
    {
        name: 'UGGIANO LA CHIESA',
        istatCode: '016075091'
    },
    {
        name: 'UGGIATE',
        istatCode: '003013950'
    },
    {
        name: 'UGGIATE-TREVANO',
        istatCode: '003013228'
    },
    {
        name: 'ULA\' TIRSO',
        istatCode: '020095068'
    },
    {
        name: 'ULASSAI',
        istatCode: '020091098'
    },
    {
        name: 'ULTIMO - ULTEN',
        istatCode: '004021104'
    },
    {
        name: 'UMBERTIDE',
        istatCode: '010054056'
    },
    {
        name: 'UMBRIATICO',
        istatCode: '018101026'
    },
    {
        name: 'URAGO D\'OGLIO',
        istatCode: '003017192'
    },
    {
        name: 'URAS',
        istatCode: '020095069'
    },
    {
        name: 'URBANA',
        istatCode: '005028095'
    },
    {
        name: 'URBANIA',
        istatCode: '011041066'
    },
    {
        name: 'URBE',
        istatCode: '007009063'
    },
    {
        name: 'URBINO',
        istatCode: '011041067'
    },
    {
        name: 'URBISAGLIA',
        istatCode: '011043055'
    },
    {
        name: 'URGNANO',
        istatCode: '003016222'
    },
    {
        name: 'URI',
        istatCode: '020090076'
    },
    {
        name: 'URURI',
        istatCode: '014070083'
    },
    {
        name: 'URZULEI',
        istatCode: '020091099'
    },
    {
        name: 'USCIO',
        istatCode: '007010064'
    },
    {
        name: 'USELLUS',
        istatCode: '020095070'
    },
    {
        name: 'USINI',
        istatCode: '020090077'
    },
    {
        name: 'USMATE VELATE',
        istatCode: '003108044'
    },
    {
        name: 'USSANA',
        istatCode: '020111093'
    },
    {
        name: 'USSARAMANNA',
        istatCode: '020111094'
    },
    {
        name: 'USSASSAI',
        istatCode: '020091100'
    },
    {
        name: 'USSEAUX',
        istatCode: '001001281'
    },
    {
        name: 'USSEGLIO',
        istatCode: '001001282'
    },
    {
        name: 'USSITA',
        istatCode: '011043056'
    },
    {
        name: 'USTICA',
        istatCode: '019082075'
    },
    {
        name: 'UTA',
        istatCode: '020092090'
    },
    {
        name: 'UZZANO',
        istatCode: '009047021'
    },
    {
        name: 'VACCARIZZO ALBANESE',
        istatCode: '018078152'
    },
    {
        name: 'VACONE',
        istatCode: '012057072'
    },
    {
        name: 'VACRI',
        istatCode: '013069098'
    },
    {
        name: 'VADENA - PFATTEN',
        istatCode: '004021105'
    },
    {
        name: 'VADO LIGURE',
        istatCode: '007009064'
    },
    {
        name: 'VAGLI SOTTO',
        istatCode: '009046031'
    },
    {
        name: 'VAGLIA',
        istatCode: '009048046'
    },
    {
        name: 'VAGLIO BASILICATA',
        istatCode: '017076094'
    },
    {
        name: 'VAGLIO SERRA',
        istatCode: '001005111'
    },
    {
        name: 'VAIANO',
        istatCode: '009100006'
    },
    {
        name: 'VAIANO CREMASCO',
        istatCode: '003019111'
    },
    {
        name: 'VAIE',
        istatCode: '001001283'
    },
    {
        name: 'VAILATE',
        istatCode: '003019112'
    },
    {
        name: 'VAIRANO PATENORA',
        istatCode: '015061095'
    },
    {
        name: 'VAJONT',
        istatCode: '006093052'
    },
    {
        name: 'VAL BREMBILLA',
        istatCode: '003016253'
    },
    {
        name: 'VAL DELLA TORRE',
        istatCode: '001001284'
    },
    {
        name: 'VAL DI CHY',
        istatCode: '001001317'
    },
    {
        name: 'VAL DI NIZZA',
        istatCode: '003018166'
    },
    {
        name: 'VAL DI VIZZE - PFITSCH',
        istatCode: '004021107'
    },
    {
        name: 'VAL DI ZOLDO',
        istatCode: '005025073'
    },
    {
        name: 'VAL LIONA',
        istatCode: '005024123'
    },
    {
        name: 'VAL MARCHIROLO',
        istatCode: '003012517'
    },
    {
        name: 'VAL MASINO',
        istatCode: '003014074'
    },
    {
        name: 'VAL REZZO',
        istatCode: '003013233'
    },
    {
        name: 'VALBONDIONE',
        istatCode: '003016223'
    },
    {
        name: 'VALBREMBO',
        istatCode: '003016224'
    },
    {
        name: 'VALBRENTA',
        istatCode: '005024125'
    },
    {
        name: 'VALBREVENNA',
        istatCode: '007010065'
    },
    {
        name: 'VALBRONA',
        istatCode: '003013229'
    },
    {
        name: 'VALCHIUSA',
        istatCode: '001001318'
    },
    {
        name: 'VALDA',
        istatCode: '004022208'
    },
    {
        name: 'VALDAGNO',
        istatCode: '005024111'
    },
    {
        name: 'VALDAONE',
        istatCode: '004022232'
    },
    {
        name: 'VALDAORA - OLANG',
        istatCode: '004021106'
    },
    {
        name: 'VALDASTICO',
        istatCode: '005024112'
    },
    {
        name: 'VALDENGO',
        istatCode: '001096071'
    },
    {
        name: 'VALDERICE',
        istatCode: '019081022'
    },
    {
        name: 'VALDIDENTRO',
        istatCode: '003014071'
    },
    {
        name: 'VALDIERI',
        istatCode: '001004233'
    },
    {
        name: 'VALDILANA',
        istatCode: '001096088'
    },
    {
        name: 'VALDINA',
        istatCode: '019083103'
    },
    {
        name: 'VALDISOTTO',
        istatCode: '003014072'
    },
    {
        name: 'VALDOBBIADENE',
        istatCode: '005026087'
    },
    {
        name: 'VALDUGGIA',
        istatCode: '001002152'
    },
    {
        name: 'VALEGGIO',
        istatCode: '003018167'
    },
    {
        name: 'VALEGGIO SUL MINCIO',
        istatCode: '005023089'
    },
    {
        name: 'VALENTANO',
        istatCode: '012056053'
    },
    {
        name: 'VALENZA',
        istatCode: '001006177'
    },
    {
        name: 'VALENZANO',
        istatCode: '016072048'
    },
    {
        name: 'VALERA FRATTA',
        istatCode: '003098059'
    },
    {
        name: 'VALFABBRICA',
        istatCode: '010054057'
    },
    {
        name: 'VALFENERA',
        istatCode: '001005112'
    },
    {
        name: 'VALFLORIANA',
        istatCode: '004022209'
    },
    {
        name: 'VALFORNACE',
        istatCode: '011043058'
    },
    {
        name: 'VALFURVA',
        istatCode: '003014073'
    },
    {
        name: 'VALGANNA',
        istatCode: '003012131'
    },
    {
        name: 'VALGIOIE',
        istatCode: '001001285'
    },
    {
        name: 'VALGOGLIO',
        istatCode: '003016225'
    },
    {
        name: 'VALGRANA',
        istatCode: '001004234'
    },
    {
        name: 'VALGREGHENTINO',
        istatCode: '003097082'
    },
    {
        name: 'VALGRISENCHE',
        istatCode: '002007068'
    },
    {
        name: 'VALGUARNERA CAROPEPE',
        istatCode: '019086019'
    },
    {
        name: 'VALLADA AGORDINA',
        istatCode: '005025062'
    },
    {
        name: 'VALLANZENGO',
        istatCode: '001096072'
    },
    {
        name: 'VALLARSA',
        istatCode: '004022210'
    },
    {
        name: 'VALLATA',
        istatCode: '015064114'
    },
    {
        name: 'VALLE AGRICOLA',
        istatCode: '015061096'
    },
    {
        name: 'VALLE AURINA - AHRNTAL',
        istatCode: '004021108'
    },
    {
        name: 'VALLE CASTELLANA',
        istatCode: '013067046'
    },
    {
        name: 'VALLE CONNOBINA',
        istatCode: '001103079'
    },
    {
        name: 'VALLE DELL\'ANGELO',
        istatCode: '015065153'
    },
    {
        name: 'VALLE DI CADORE',
        istatCode: '005025063'
    },
    {
        name: 'VALLE DI CASIES - GSIES',
        istatCode: '004021109'
    },
    {
        name: 'VALLE DI MADDALONI',
        istatCode: '015061097'
    },
    {
        name: 'VALLE LOMELLINA',
        istatCode: '003018168'
    },
    {
        name: 'VALLE MOSSO',
        istatCode: '001096073'
    },
    {
        name: 'VALLE SALIMBENE',
        istatCode: '003018169'
    },
    {
        name: 'VALLE SAN NICOLAO',
        istatCode: '001096074'
    },
    {
        name: 'VALLEBONA',
        istatCode: '007008062'
    },
    {
        name: 'VALLECORSA',
        istatCode: '012060082'
    },
    {
        name: 'VALLECROSIA',
        istatCode: '007008063'
    },
    {
        name: 'VALLEDOLMO',
        istatCode: '019082076'
    },
    {
        name: 'VALLEDORIA',
        istatCode: '020090079'
    },
    {
        name: 'VALLEFIORITA',
        istatCode: '018079151'
    },
    {
        name: 'VALLEFOGLIA',
        istatCode: '011041068'
    },
    {
        name: 'VALLELAGHI',
        istatCode: '004022248'
    },
    {
        name: 'VALLELONGA',
        istatCode: '018102045'
    },
    {
        name: 'VALLELUNGA PRATAMENO',
        istatCode: '019085021'
    },
    {
        name: 'VALLEMAIO',
        istatCode: '012060083'
    },
    {
        name: 'VALLEPIETRA',
        istatCode: '012058108'
    },
    {
        name: 'VALLERANO',
        istatCode: '012056054'
    },
    {
        name: 'VALLERMOSA',
        istatCode: '020111095'
    },
    {
        name: 'VALLEROTONDA',
        istatCode: '012060084'
    },
    {
        name: 'VALLESACCARDA',
        istatCode: '015064115'
    },
    {
        name: 'VALLEVE',
        istatCode: '003016226'
    },
    {
        name: 'VALLI DEL PASUBIO',
        istatCode: '005024113'
    },
    {
        name: 'VALLINFREDA',
        istatCode: '012058109'
    },
    {
        name: 'VALLIO TERME',
        istatCode: '003017193'
    },
    {
        name: 'VALLO DELLA LUCANIA',
        istatCode: '015065154'
    },
    {
        name: 'VALLO DI NERA',
        istatCode: '010054058'
    },
    {
        name: 'VALLO TORINESE',
        istatCode: '001001286'
    },
    {
        name: 'VALLONARA',
        istatCode: '005024807'
    },
    {
        name: 'VALLORIATE',
        istatCode: '001004235'
    },
    {
        name: 'VALMACCA',
        istatCode: '001006178'
    },
    {
        name: 'VALMADRERA',
        istatCode: '003097083'
    },
    {
        name: 'VALMALA',
        istatCode: '001004236'
    },
    {
        name: 'VALMONTONE',
        istatCode: '012058110'
    },
    {
        name: 'VALMOREA',
        istatCode: '003013232'
    },
    {
        name: 'VALMOZZOLA',
        istatCode: '008034044'
    },
    {
        name: 'VALNEGRA',
        istatCode: '003016227'
    },
    {
        name: 'VALPELLINE',
        istatCode: '002007069'
    },
    {
        name: 'VALPERGA',
        istatCode: '001001287'
    },
    {
        name: 'VALPRATO SOANA',
        istatCode: '001001288'
    },
    {
        name: 'VALROVINA',
        istatCode: '005024808'
    },
    {
        name: 'VALSAMOGGIA',
        istatCode: '008037061'
    },
    {
        name: 'VALSANTAMARINA',
        istatCode: '006701711'
    },
    {
        name: 'VALSAVARENCHE',
        istatCode: '002007070'
    },
    {
        name: 'VALSAVIORE',
        istatCode: '003017906'
    },
    {
        name: 'VALSECCA',
        istatCode: '003016228'
    },
    {
        name: 'VALSINNI',
        istatCode: '017077030'
    },
    {
        name: 'VALSOLDA',
        istatCode: '003013234'
    },
    {
        name: 'VALSTAGNA',
        istatCode: '005024114'
    },
    {
        name: 'VALSTRONA',
        istatCode: '001103069'
    },
    {
        name: 'VALTOPINA',
        istatCode: '010054059'
    },
    {
        name: 'VALTORTA',
        istatCode: '003016229'
    },
    {
        name: 'VALTOURNENCHE',
        istatCode: '002007071'
    },
    {
        name: 'VALVA',
        istatCode: '015065155'
    },
    {
        name: 'VALVARRONE',
        istatCode: '003097093'
    },
    {
        name: 'VALVASONE',
        istatCode: '006093048'
    },
    {
        name: 'VALVASONE ARZENE',
        istatCode: '006093053'
    },
    {
        name: 'VALVERDE (CT)',
        istatCode: '019087052'
    },
    {
        name: 'VALVERDE (PV)',
        istatCode: '003018170'
    },
    {
        name: 'VALVESTINO',
        istatCode: '003017194'
    },
    {
        name: 'VANDOIES - VINTL',
        istatCode: '004021110'
    },
    {
        name: 'VANZAGHELLO',
        istatCode: '003015249'
    },
    {
        name: 'VANZAGO',
        istatCode: '003015229'
    },
    {
        name: 'VANZONE CON SAN CARLO',
        istatCode: '001103070'
    },
    {
        name: 'VAPRIO D\'ADDA',
        istatCode: '003015230'
    },
    {
        name: 'VAPRIO D\'AGOGNA',
        istatCode: '001003153'
    },
    {
        name: 'VARALLO',
        istatCode: '001002156'
    },
    {
        name: 'VARALLO POMBIA',
        istatCode: '001003154'
    },
    {
        name: 'VARANO BORGHI',
        istatCode: '003012132'
    },
    {
        name: 'VARANO DE\' MELEGARI',
        istatCode: '008034045'
    },
    {
        name: 'VARAPODIO',
        istatCode: '018080095'
    },
    {
        name: 'VARAZZE',
        istatCode: '007009065'
    },
    {
        name: 'VARCO SABINO',
        istatCode: '012057073'
    },
    {
        name: 'VAREDO',
        istatCode: '003108045'
    },
    {
        name: 'VARENA',
        istatCode: '004022211'
    },
    {
        name: 'VARENNA',
        istatCode: '003097084'
    },
    {
        name: 'VARESE',
        istatCode: '003012133'
    },
    {
        name: 'VARESE LIGURE',
        istatCode: '007011029'
    },
    {
        name: 'VARISELLA',
        istatCode: '001001289'
    },
    {
        name: 'VARMO',
        istatCode: '006030130'
    },
    {
        name: 'VARNA - VAHRN',
        istatCode: '004021111'
    },
    {
        name: 'VARSI',
        istatCode: '008034046'
    },
    {
        name: 'VARZI',
        istatCode: '003018171'
    },
    {
        name: 'VARZO',
        istatCode: '001103071'
    },
    {
        name: 'VAS',
        istatCode: '005025064'
    },
    {
        name: 'VASANELLO',
        istatCode: '012056055'
    },
    {
        name: 'VASIA',
        istatCode: '007008064'
    },
    {
        name: 'VASTO',
        istatCode: '013069099'
    },
    {
        name: 'VASTOGIRARDI',
        istatCode: '014094051'
    },
    {
        name: 'VATTARO',
        istatCode: '004022212'
    },
    {
        name: 'VAUDA CANAVESE',
        istatCode: '001001290'
    },
    {
        name: 'VAZZANO',
        istatCode: '018102046'
    },
    {
        name: 'VAZZOLA',
        istatCode: '005026088'
    },
    {
        name: 'VECCHIANO',
        istatCode: '009050037'
    },
    {
        name: 'VEDANO AL LAMBRO',
        istatCode: '003108046'
    },
    {
        name: 'VEDANO OLONA',
        istatCode: '003012134'
    },
    {
        name: 'VEDDASCA',
        istatCode: '003012135'
    },
    {
        name: 'VEDELAGO',
        istatCode: '005026089'
    },
    {
        name: 'VEDESETA',
        istatCode: '003016230'
    },
    {
        name: 'VEDUGGIO CON COLZANO',
        istatCode: '003108047'
    },
    {
        name: 'VEGGIANO',
        istatCode: '005028096'
    },
    {
        name: 'VEGLIE',
        istatCode: '016075092'
    },
    {
        name: 'VEGLIO',
        istatCode: '001096075'
    },
    {
        name: 'VEJANO',
        istatCode: '012056056'
    },
    {
        name: 'VELESO',
        istatCode: '003013236'
    },
    {
        name: 'VELEZZO LOMELLINA',
        istatCode: '003018172'
    },
    {
        name: 'VELLETRI',
        istatCode: '012058111'
    },
    {
        name: 'VELLEZZO BELLINI',
        istatCode: '003018173'
    },
    {
        name: 'VELO D\'ASTICO',
        istatCode: '005024115'
    },
    {
        name: 'VELO VERONESE',
        istatCode: '005023090'
    },
    {
        name: 'VELTURNO - FELDTHURNS',
        istatCode: '004021116'
    },
    {
        name: 'VENAFRO',
        istatCode: '014094052'
    },
    {
        name: 'VENARIA REALE',
        istatCode: '001001292'
    },
    {
        name: 'VENAROTTA',
        istatCode: '011044073'
    },
    {
        name: 'VENASCA',
        istatCode: '001004237'
    },
    {
        name: 'VENAUS',
        istatCode: '001001291'
    },
    {
        name: 'VENDONE',
        istatCode: '007009066'
    },
    {
        name: 'VENDROGNO',
        istatCode: '003097085'
    },
    {
        name: 'VENEGONO',
        istatCode: '003012899'
    },
    {
        name: 'VENEGONO INFERIORE',
        istatCode: '003012136'
    },
    {
        name: 'VENEGONO SUPERIORE',
        istatCode: '003012137'
    },
    {
        name: 'VENETICO',
        istatCode: '019083104'
    },
    {
        name: 'VENEZIA',
        istatCode: '005027042'
    },
    {
        name: 'VENIANO',
        istatCode: '003013238'
    },
    {
        name: 'VENOSA',
        istatCode: '017076095'
    },
    {
        name: 'VENTASSO',
        istatCode: '008035046'
    },
    {
        name: 'VENTICANO',
        istatCode: '015064116'
    },
    {
        name: 'VENTIMIGLIA',
        istatCode: '007008065'
    },
    {
        name: 'VENTIMIGLIA DI SICILIA',
        istatCode: '019082077'
    },
    {
        name: 'VENTOTENE',
        istatCode: '012059033'
    },
    {
        name: 'VENZONE',
        istatCode: '006030131'
    },
    {
        name: 'VERANO - VOERAN',
        istatCode: '004021112'
    },
    {
        name: 'VERANO BRIANZA',
        istatCode: '003108048'
    },
    {
        name: 'VERBANIA',
        istatCode: '001103072'
    },
    {
        name: 'VERBICARO',
        istatCode: '018078153'
    },
    {
        name: 'VERCANA',
        istatCode: '003013239'
    },
    {
        name: 'VERCEIA',
        istatCode: '003014075'
    },
    {
        name: 'VERCELLI',
        istatCode: '001002158'
    },
    {
        name: 'VERCURAGO',
        istatCode: '003097086'
    },
    {
        name: 'VERDELLINO',
        istatCode: '003016232'
    },
    {
        name: 'VERDELLO',
        istatCode: '003016233'
    },
    {
        name: 'VERDERIO',
        istatCode: '003097091'
    },
    {
        name: 'VERDERIO INFERIORE',
        istatCode: '003097087'
    },
    {
        name: 'VERDERIO SUPERIORE',
        istatCode: '003097088'
    },
    {
        name: 'VERDUNO',
        istatCode: '001004238'
    },
    {
        name: 'VERGATO',
        istatCode: '008037059'
    },
    {
        name: 'VERGEMOLI',
        istatCode: '009046032'
    },
    {
        name: 'VERGHERETO',
        istatCode: '008040050'
    },
    {
        name: 'VERGIATE',
        istatCode: '003012138'
    },
    {
        name: 'VERMEZZO',
        istatCode: '003015235'
    },
    {
        name: 'VERMEZZO CON ZELO',
        istatCode: '003015251'
    },
    {
        name: 'VERMIGLIO',
        istatCode: '004022213'
    },
    {
        name: 'VERNANTE',
        istatCode: '001004239'
    },
    {
        name: 'VERNASCA',
        istatCode: '008033044'
    },
    {
        name: 'VERNATE',
        istatCode: '003015236'
    },
    {
        name: 'VERNAZZA',
        istatCode: '007011030'
    },
    {
        name: 'VERNIO',
        istatCode: '009100007'
    },
    {
        name: 'VERNOLE',
        istatCode: '016075093'
    },
    {
        name: 'VEROLANUOVA',
        istatCode: '003017195'
    },
    {
        name: 'VEROLAVECCHIA',
        istatCode: '003017196'
    },
    {
        name: 'VEROLENGO',
        istatCode: '001001293'
    },
    {
        name: 'VEROLI',
        istatCode: '012060085'
    },
    {
        name: 'VERONA',
        istatCode: '005023091'
    },
    {
        name: 'VERONELLA',
        istatCode: '005023092'
    },
    {
        name: 'VERRAYES',
        istatCode: '002007072'
    },
    {
        name: 'VERRES',
        istatCode: '002007073'
    },
    {
        name: 'VERRETTO',
        istatCode: '003018174'
    },
    {
        name: 'VERRONE',
        istatCode: '001096076'
    },
    {
        name: 'VERRUA PO',
        istatCode: '003018175'
    },
    {
        name: 'VERRUA SAVOIA',
        istatCode: '001001294'
    },
    {
        name: 'VERTEMATE CON MINOPRIO',
        istatCode: '003013242'
    },
    {
        name: 'VERTOVA',
        istatCode: '003016234'
    },
    {
        name: 'VERUCCHIO',
        istatCode: '008099020'
    },
    {
        name: 'VERUNO',
        istatCode: '001003157'
    },
    {
        name: 'VERVIO',
        istatCode: '003014076'
    },
    {
        name: 'VERVO\'',
        istatCode: '004022214'
    },
    {
        name: 'VERZEGNIS',
        istatCode: '006030132'
    },
    {
        name: 'VERZINO',
        istatCode: '018101027'
    },
    {
        name: 'VERZUOLO',
        istatCode: '001004240'
    },
    {
        name: 'VESCOVANA',
        istatCode: '005028097'
    },
    {
        name: 'VESCOVATO',
        istatCode: '003019113'
    },
    {
        name: 'VESIME',
        istatCode: '001005113'
    },
    {
        name: 'VESPOLATE',
        istatCode: '001003158'
    },
    {
        name: 'VESSALICO',
        istatCode: '007008066'
    },
    {
        name: 'VESTENANOVA',
        istatCode: '005023093'
    },
    {
        name: 'VESTIGNE\'',
        istatCode: '001001295'
    },
    {
        name: 'VESTONE',
        istatCode: '003017197'
    },
    {
        name: 'VESTRENO',
        istatCode: '003097089'
    },
    {
        name: 'VETRALLA',
        istatCode: '012056057'
    },
    {
        name: 'VETTO',
        istatCode: '008035042'
    },
    {
        name: 'VEZZA D\'ALBA',
        istatCode: '001004241'
    },
    {
        name: 'VEZZA D\'OGLIO',
        istatCode: '003017198'
    },
    {
        name: 'VEZZANO',
        istatCode: '004022215'
    },
    {
        name: 'VEZZANO LIGURE',
        istatCode: '007011031'
    },
    {
        name: 'VEZZANO SUL CROSTOLO',
        istatCode: '008035043'
    },
    {
        name: 'VEZZI PORTIO',
        istatCode: '007009067'
    },
    {
        name: 'VIADANA',
        istatCode: '003020066'
    },
    {
        name: 'VIADANICA',
        istatCode: '003016235'
    },
    {
        name: 'VIAGRANDE',
        istatCode: '019087053'
    },
    {
        name: 'VIALE',
        istatCode: '001005114'
    },
    {
        name: 'VIALFRE\'',
        istatCode: '001001296'
    },
    {
        name: 'VIANO',
        istatCode: '008035044'
    },
    {
        name: 'VIAREGGIO',
        istatCode: '009046033'
    },
    {
        name: 'VIARIGI',
        istatCode: '001005115'
    },
    {
        name: 'VIBO VALENTIA',
        istatCode: '018102047'
    },
    {
        name: 'VIBONATI',
        istatCode: '015065156'
    },
    {
        name: 'VICALVI',
        istatCode: '012060086'
    },
    {
        name: 'VICARI',
        istatCode: '019082078'
    },
    {
        name: 'VICCHIO',
        istatCode: '009048049'
    },
    {
        name: 'VICENZA',
        istatCode: '005024116'
    },
    {
        name: 'VICO CANAVESE',
        istatCode: '001001297'
    },
    {
        name: 'VICO DEL GARGANO',
        istatCode: '016071059'
    },
    {
        name: 'VICO EQUENSE',
        istatCode: '015063086'
    },
    {
        name: 'VICO NEL LAZIO',
        istatCode: '012060087'
    },
    {
        name: 'VICOFORTE',
        istatCode: '001004242'
    },
    {
        name: 'VICOLI',
        istatCode: '013068045'
    },
    {
        name: 'VICOLUNGO',
        istatCode: '001003159'
    },
    {
        name: 'VICOPISANO',
        istatCode: '009050038'
    },
    {
        name: 'VICOVARO',
        istatCode: '012058112'
    },
    {
        name: 'VIDDALBA',
        istatCode: '020090082'
    },
    {
        name: 'VIDIGULFO',
        istatCode: '003018176'
    },
    {
        name: 'VIDOR',
        istatCode: '005026090'
    },
    {
        name: 'VIDRACCO',
        istatCode: '001001298'
    },
    {
        name: 'VIESTE',
        istatCode: '016071060'
    },
    {
        name: 'VIETRI DI POTENZA',
        istatCode: '017076096'
    },
    {
        name: 'VIETRI SUL MARE',
        istatCode: '015065157'
    },
    {
        name: 'VIGANELLA',
        istatCode: '001103073'
    },
    {
        name: 'VIGANO\'',
        istatCode: '003097090'
    },
    {
        name: 'VIGANO SAN MARTINO',
        istatCode: '003016236'
    },
    {
        name: 'VIGARANO MAINARDA',
        istatCode: '008038022'
    },
    {
        name: 'VIGASIO',
        istatCode: '005023094'
    },
    {
        name: 'VIGATTO',
        istatCode: '008034810'
    },
    {
        name: 'VIGEVANO',
        istatCode: '003018177'
    },
    {
        name: 'VIGGIANELLO',
        istatCode: '017076097'
    },
    {
        name: 'VIGGIANO',
        istatCode: '017076098'
    },
    {
        name: 'VIGGIU\'',
        istatCode: '003012139'
    },
    {
        name: 'VIGHIZZOLO D\'ESTE',
        istatCode: '005028098'
    },
    {
        name: 'VIGLIANO BIELLESE',
        istatCode: '001096077'
    },
    {
        name: 'VIGLIANO D\'ASTI',
        istatCode: '001005116'
    },
    {
        name: 'VIGNALE MONFERRATO',
        istatCode: '001006179'
    },
    {
        name: 'VIGNANELLO',
        istatCode: '012056058'
    },
    {
        name: 'VIGNATE',
        istatCode: '003015237'
    },
    {
        name: 'VIGNOLA',
        istatCode: '008036046'
    },
    {
        name: 'VIGNOLA-FALESINA',
        istatCode: '004022216'
    },
    {
        name: 'VIGNOLE BORBERA',
        istatCode: '001006180'
    },
    {
        name: 'VIGNOLO',
        istatCode: '001004243'
    },
    {
        name: 'VIGNONE',
        istatCode: '001103074'
    },
    {
        name: 'VIGO DI CADORE',
        istatCode: '005025065'
    },
    {
        name: 'VIGO DI FASSA',
        istatCode: '004022217'
    },
    {
        name: 'VIGO RENDENA',
        istatCode: '004022220'
    },
    {
        name: 'VIGODARZERE',
        istatCode: '005028099'
    },
    {
        name: 'VIGOLO',
        istatCode: '003016237'
    },
    {
        name: 'VIGOLO BASELGA',
        istatCode: '004022218'
    },
    {
        name: 'VIGOLO VATTARO',
        istatCode: '004022219'
    },
    {
        name: 'VIGOLZONE',
        istatCode: '008033045'
    },
    {
        name: 'VIGONE',
        istatCode: '001001299'
    },
    {
        name: 'VIGONOVO',
        istatCode: '005027043'
    },
    {
        name: 'VIGONZA',
        istatCode: '005028100'
    },
    {
        name: 'VIGUZZOLO',
        istatCode: '001006181'
    },
    {
        name: 'VILLA AGNEDO',
        istatCode: '004022221'
    },
    {
        name: 'VILLA BARTOLOMEA',
        istatCode: '005023095'
    },
    {
        name: 'VILLA BASILICA',
        istatCode: '009046034'
    },
    {
        name: 'VILLA BISCOSSI',
        istatCode: '003018178'
    },
    {
        name: 'VILLA CARCINA',
        istatCode: '003017199'
    },
    {
        name: 'VILLA CASTELLI',
        istatCode: '016074020'
    },
    {
        name: 'VILLA CELIERA',
        istatCode: '013068046'
    },
    {
        name: 'VILLA COLLEMANDINA',
        istatCode: '009046035'
    },
    {
        name: 'VILLA CORSIONE',
        istatCode: '001005820'
    },
    {
        name: 'VILLA CORTESE',
        istatCode: '003015248'
    },
    {
        name: 'VILLA D\'ADDA',
        istatCode: '003016238'
    },
    {
        name: 'VILLA D\'ALME\'',
        istatCode: '003016239'
    },
    {
        name: 'VILLA DEL BOSCO',
        istatCode: '001096078'
    },
    {
        name: 'VILLA DEL CONTE',
        istatCode: '005028101'
    },
    {
        name: 'VILLA DI BRIANO',
        istatCode: '015061098'
    },
    {
        name: 'VILLA DI CHIAVENNA',
        istatCode: '003014077'
    },
    {
        name: 'VILLA DI SERIO',
        istatCode: '003016240'
    },
    {
        name: 'VILLA DI TIRANO',
        istatCode: '003014078'
    },
    {
        name: 'VILLA D\'OGNA',
        istatCode: '003016241'
    },
    {
        name: 'VILLA ESTENSE',
        istatCode: '005028102'
    },
    {
        name: 'VILLA FARALDI',
        istatCode: '007008067'
    },
    {
        name: 'VILLA GUARDIA',
        istatCode: '003013245'
    },
    {
        name: 'VILLA LAGARINA',
        istatCode: '004022222'
    },
    {
        name: 'VILLA LATINA',
        istatCode: '012060088'
    },
    {
        name: 'VILLA LITERNO',
        istatCode: '015061099'
    },
    {
        name: 'VILLA MINOZZO',
        istatCode: '008035045'
    },
    {
        name: 'VILLA POMA',
        istatCode: '003020067'
    },
    {
        name: 'VILLA RENDENA',
        istatCode: '004022223'
    },
    {
        name: 'VILLA SAN GIOVANNI',
        istatCode: '018080096'
    },
    {
        name: 'VILLA SAN GIOVANNI IN TUSCIA',
        istatCode: '012056046'
    },
    {
        name: 'VILLA SAN PIETRO',
        istatCode: '020092099'
    },
    {
        name: 'VILLA SAN SECONDO',
        istatCode: '001005119'
    },
    {
        name: 'VILLA SANTA LUCIA',
        istatCode: '012060089'
    },
    {
        name: 'VILLA SANTA LUCIA DEGLI ABRUZZI',
        istatCode: '013066104'
    },
    {
        name: 'VILLA SANTA MARIA',
        istatCode: '013069102'
    },
    {
        name: 'VILLA SANT\'ANGELO',
        istatCode: '013066105'
    },
    {
        name: 'VILLA SANT\'ANTONIO',
        istatCode: '020095048'
    },
    {
        name: 'VILLA SANTINA',
        istatCode: '006030133'
    },
    {
        name: 'VILLA SANTO STEFANO',
        istatCode: '012060090'
    },
    {
        name: 'VILLA VERDE',
        istatCode: '020095073'
    },
    {
        name: 'VILLA VICENTINA',
        istatCode: '006030134'
    },
    {
        name: 'VILLA VOLTURNO',
        istatCode: '015061809'
    },
    {
        name: 'VILLABASSA - NIEDERDORF',
        istatCode: '004021113'
    },
    {
        name: 'VILLABATE',
        istatCode: '019082079'
    },
    {
        name: 'VILLACHIARA',
        istatCode: '003017200'
    },
    {
        name: 'VILLACIDRO',
        istatCode: '020111096'
    },
    {
        name: 'VILLADEATI',
        istatCode: '001006182'
    },
    {
        name: 'VILLADOSE',
        istatCode: '005029048'
    },
    {
        name: 'VILLADOSSOLA',
        istatCode: '001103075'
    },
    {
        name: 'VILLAFALLETTO',
        istatCode: '001004244'
    },
    {
        name: 'VILLAFRANCA D\'ASTI',
        istatCode: '001005117'
    },
    {
        name: 'VILLAFRANCA DI VERONA',
        istatCode: '005023096'
    },
    {
        name: 'VILLAFRANCA IN LUNIGIANA',
        istatCode: '009045016'
    },
    {
        name: 'VILLAFRANCA PADOVANA',
        istatCode: '005028103'
    },
    {
        name: 'VILLAFRANCA PIEMONTE',
        istatCode: '001001300'
    },
    {
        name: 'VILLAFRANCA SICULA',
        istatCode: '019084043'
    },
    {
        name: 'VILLAFRANCA TIRRENA',
        istatCode: '019083105'
    },
    {
        name: 'VILLAFRATI',
        istatCode: '019082080'
    },
    {
        name: 'VILLAGA',
        istatCode: '005024117'
    },
    {
        name: 'VILLAGRANDE STRISAILI',
        istatCode: '020091101'
    },
    {
        name: 'VILLALAGO',
        istatCode: '013066103'
    },
    {
        name: 'VILLALBA',
        istatCode: '019085022'
    },
    {
        name: 'VILLALFONSINA',
        istatCode: '013069100'
    },
    {
        name: 'VILLALVERNIA',
        istatCode: '001006183'
    },
    {
        name: 'VILLAMAGNA',
        istatCode: '013069101'
    },
    {
        name: 'VILLAMAINA',
        istatCode: '015064117'
    },
    {
        name: 'VILLAMAR',
        istatCode: '020111097'
    },
    {
        name: 'VILLAMARZANA',
        istatCode: '005029049'
    },
    {
        name: 'VILLAMASSARGIA',
        istatCode: '020111098'
    },
    {
        name: 'VILLAMIROGLIO',
        istatCode: '001006184'
    },
    {
        name: 'VILLANDRO - VILLANDERS',
        istatCode: '004021114'
    },
    {
        name: 'VILLANOVA BIELLESE',
        istatCode: '001096079'
    },
    {
        name: 'VILLANOVA CANAVESE',
        istatCode: '001001301'
    },
    {
        name: 'VILLANOVA D\'ALBENGA',
        istatCode: '007009068'
    },
    {
        name: 'VILLANOVA D\'ARDENGHI',
        istatCode: '003018179'
    },
    {
        name: 'VILLANOVA D\'ASTI',
        istatCode: '001005118'
    },
    {
        name: 'VILLANOVA DEL BATTISTA',
        istatCode: '015064118'
    },
    {
        name: 'VILLANOVA DEL GHEBBO',
        istatCode: '005029050'
    },
    {
        name: 'VILLANOVA DEL SILLARO',
        istatCode: '003098060'
    },
    {
        name: 'VILLANOVA DI CAMPOSAMPIERO',
        istatCode: '005028104'
    },
    {
        name: 'VILLANOVA MARCHESANA',
        istatCode: '005029051'
    },
    {
        name: 'VILLANOVA MONDOVI\'',
        istatCode: '001004245'
    },
    {
        name: 'VILLANOVA MONFERRATO',
        istatCode: '001006185'
    },
    {
        name: 'VILLANOVA MONTELEONE',
        istatCode: '020090078'
    },
    {
        name: 'VILLANOVA SOLARO',
        istatCode: '001004246'
    },
    {
        name: 'VILLANOVA SULL\'ARDA',
        istatCode: '008033046'
    },
    {
        name: 'VILLANOVA TRUSCHEDU',
        istatCode: '020095071'
    },
    {
        name: 'VILLANOVAFORRU',
        istatCode: '020111100'
    },
    {
        name: 'VILLANOVAFRANCA',
        istatCode: '020111101'
    },
    {
        name: 'VILLANOVATULO',
        istatCode: '020111099'
    },
    {
        name: 'VILLANTERIO',
        istatCode: '003018180'
    },
    {
        name: 'VILLANUOVA SUL CLISI',
        istatCode: '003017201'
    },
    {
        name: 'VILLAPERUCCIO',
        istatCode: '020111102'
    },
    {
        name: 'VILLAPIANA',
        istatCode: '018078154'
    },
    {
        name: 'VILLAPUTZU',
        istatCode: '020111103'
    },
    {
        name: 'VILLAR DORA',
        istatCode: '001001303'
    },
    {
        name: 'VILLAR FOCCHIARDO',
        istatCode: '001001305'
    },
    {
        name: 'VILLAR PELLICE',
        istatCode: '001001306'
    },
    {
        name: 'VILLAR PEROSA',
        istatCode: '001001307'
    },
    {
        name: 'VILLAR SAN COSTANZO',
        istatCode: '001004247'
    },
    {
        name: 'VILLARBASSE',
        istatCode: '001001302'
    },
    {
        name: 'VILLARBOIT',
        istatCode: '001002163'
    },
    {
        name: 'VILLAREGGIA',
        istatCode: '001001304'
    },
    {
        name: 'VILLARICCA',
        istatCode: '015063087'
    },
    {
        name: 'VILLAROMAGNANO',
        istatCode: '001006186'
    },
    {
        name: 'VILLAROSA',
        istatCode: '019086020'
    },
    {
        name: 'VILLASALTO',
        istatCode: '020111104'
    },
    {
        name: 'VILLASANTA',
        istatCode: '003108049'
    },
    {
        name: 'VILLASIMIUS',
        istatCode: '020111105'
    },
    {
        name: 'VILLASOR',
        istatCode: '020111106'
    },
    {
        name: 'VILLASPECIOSA',
        istatCode: '020111107'
    },
    {
        name: 'VILLASTELLONE',
        istatCode: '001001308'
    },
    {
        name: 'VILLATA',
        istatCode: '001002164'
    },
    {
        name: 'VILLAURBANA',
        istatCode: '020095072'
    },
    {
        name: 'VILLAVALLELONGA',
        istatCode: '013066106'
    },
    {
        name: 'VILLAVERLA',
        istatCode: '005024118'
    },
    {
        name: 'VILLAZZANO',
        istatCode: '004022940'
    },
    {
        name: 'VILLE D\'ANAUNIA',
        istatCode: '004022249'
    },
    {
        name: 'VILLE DI FIEMME',
        istatCode: '004022254'
    },
    {
        name: 'VILLENEUVE',
        istatCode: '002007074'
    },
    {
        name: 'VILLESSE',
        istatCode: '006031025'
    },
    {
        name: 'VILLETTA BARREA',
        istatCode: '013066107'
    },
    {
        name: 'VILLETTE',
        istatCode: '001103076'
    },
    {
        name: 'VILLIMPENTA',
        istatCode: '003020068'
    },
    {
        name: 'VILLONGO',
        istatCode: '003016242'
    },
    {
        name: 'VILLORBA',
        istatCode: '005026091'
    },
    {
        name: 'VILMINORE',
        istatCode: '003016884'
    },
    {
        name: 'VILMINORE DI SCALVE',
        istatCode: '003016243'
    },
    {
        name: 'VIMERCATE',
        istatCode: '003108050'
    },
    {
        name: 'VIMODRONE',
        istatCode: '003015242'
    },
    {
        name: 'VINADIO',
        istatCode: '001004248'
    },
    {
        name: 'VINCHIATURO',
        istatCode: '014070084'
    },
    {
        name: 'VINCHIO',
        istatCode: '001005120'
    },
    {
        name: 'VINCI',
        istatCode: '009048050'
    },
    {
        name: 'VINOVO',
        istatCode: '001001309'
    },
    {
        name: 'VINZAGLIO',
        istatCode: '001003164'
    },
    {
        name: 'VIOLA',
        istatCode: '001004249'
    },
    {
        name: 'VIONE',
        istatCode: '003017202'
    },
    {
        name: 'VIPITENO - STERZING',
        istatCode: '004021115'
    },
    {
        name: 'VIRGILIO',
        istatCode: '003020069'
    },
    {
        name: 'VIRLE PIEMONTE',
        istatCode: '001001310'
    },
    {
        name: 'VISANO',
        istatCode: '003017203'
    },
    {
        name: 'VISCHE',
        istatCode: '001001311'
    },
    {
        name: 'VISCIANO',
        istatCode: '015063088'
    },
    {
        name: 'VISCO',
        istatCode: '006030135'
    },
    {
        name: 'VISONE',
        istatCode: '001006187'
    },
    {
        name: 'VISSO',
        istatCode: '011043057'
    },
    {
        name: 'VISTARINO',
        istatCode: '003018181'
    },
    {
        name: 'VISTRORIO',
        istatCode: '001001312'
    },
    {
        name: 'VITA',
        istatCode: '019081023'
    },
    {
        name: 'VITERBO',
        istatCode: '012056059'
    },
    {
        name: 'VITICUSO',
        istatCode: '012060091'
    },
    {
        name: 'VITO D\'ASIO',
        istatCode: '006093049'
    },
    {
        name: 'VITORCHIANO',
        istatCode: '012056060'
    },
    {
        name: 'VITTORIA',
        istatCode: '019088012'
    },
    {
        name: 'VITTORIO VENETO',
        istatCode: '005026092'
    },
    {
        name: 'VITTORITO',
        istatCode: '013066108'
    },
    {
        name: 'VITTUONE',
        istatCode: '003015243'
    },
    {
        name: 'VITULANO',
        istatCode: '015062077'
    },
    {
        name: 'VITULAZIO',
        istatCode: '015061100'
    },
    {
        name: 'VIU\'',
        istatCode: '001001313'
    },
    {
        name: 'VIVARO',
        istatCode: '006093050'
    },
    {
        name: 'VIVARO ROMANO',
        istatCode: '012058113'
    },
    {
        name: 'VIVERONE',
        istatCode: '001096080'
    },
    {
        name: 'VIZZINI',
        istatCode: '019087054'
    },
    {
        name: 'VIZZOLA TICINO',
        istatCode: '003012140'
    },
    {
        name: 'VIZZOLO PREDABISSI',
        istatCode: '003015244'
    },
    {
        name: 'VO',
        istatCode: '005028105'
    },
    {
        name: 'VOBARNO',
        istatCode: '003017204'
    },
    {
        name: 'VOBBIA',
        istatCode: '007010066'
    },
    {
        name: 'VOCCA',
        istatCode: '001002166'
    },
    {
        name: 'VODO CADORE',
        istatCode: '005025066'
    },
    {
        name: 'VOGHERA',
        istatCode: '003018182'
    },
    {
        name: 'VOGHIERA',
        istatCode: '008038023'
    },
    {
        name: 'VOGOGNA',
        istatCode: '001103077'
    },
    {
        name: 'VOLANO',
        istatCode: '004022224'
    },
    {
        name: 'VOLLA',
        istatCode: '015063089'
    },
    {
        name: 'VOLONGO',
        istatCode: '003019114'
    },
    {
        name: 'VOLPAGO DEL MONTELLO',
        istatCode: '005026093'
    },
    {
        name: 'VOLPARA',
        istatCode: '003018183'
    },
    {
        name: 'VOLPEDO',
        istatCode: '001006188'
    },
    {
        name: 'VOLPEGLINO',
        istatCode: '001006189'
    },
    {
        name: 'VOLPIANO',
        istatCode: '001001314'
    },
    {
        name: 'VOLTA MANTOVANA',
        istatCode: '003020070'
    },
    {
        name: 'VOLTAGGIO',
        istatCode: '001006190'
    },
    {
        name: 'VOLTAGO AGORDINO',
        istatCode: '005025067'
    },
    {
        name: 'VOLTERRA',
        istatCode: '009050039'
    },
    {
        name: 'VOLTIDO',
        istatCode: '003019115'
    },
    {
        name: 'VOLTURARA APPULA',
        istatCode: '016071061'
    },
    {
        name: 'VOLTURARA IRPINA',
        istatCode: '015064119'
    },
    {
        name: 'VOLTURINO',
        istatCode: '016071062'
    },
    {
        name: 'VOLVERA',
        istatCode: '001001315'
    },
    {
        name: 'VOTTIGNASCO',
        istatCode: '001004250'
    },
    {
        name: 'ZACCANOPOLI',
        istatCode: '018102048'
    },
    {
        name: 'ZAFFERANA ETNEA',
        istatCode: '019087055'
    },
    {
        name: 'ZAGARISE',
        istatCode: '018079157'
    },
    {
        name: 'ZAGAROLO',
        istatCode: '012058114'
    },
    {
        name: 'ZAMBANA',
        istatCode: '004022225'
    },
    {
        name: 'ZAMBRONE',
        istatCode: '018102049'
    },
    {
        name: 'ZANDOBBIO',
        istatCode: '003016244'
    },
    {
        name: 'ZANE\'',
        istatCode: '005024119'
    },
    {
        name: 'ZANICA',
        istatCode: '003016245'
    },
    {
        name: 'ZAPPONETA',
        istatCode: '016071064'
    },
    {
        name: 'ZAVATTARELLO',
        istatCode: '003018184'
    },
    {
        name: 'ZAVATTARELLO VALVERDE',
        istatCode: '003018890'
    },
    {
        name: 'ZECCONE',
        istatCode: '003018185'
    },
    {
        name: 'ZEDDIANI',
        istatCode: '020095074'
    },
    {
        name: 'ZELBIO',
        istatCode: '003013246'
    },
    {
        name: 'ZELBIO-VELESO',
        istatCode: '003013961'
    },
    {
        name: 'ZELO BUON PERSICO',
        istatCode: '003098061'
    },
    {
        name: 'ZELO SURRIGONE',
        istatCode: '003015246'
    },
    {
        name: 'ZEME',
        istatCode: '003018186'
    },
    {
        name: 'ZENEVREDO',
        istatCode: '003018187'
    },
    {
        name: 'ZENSON DI PIAVE',
        istatCode: '005026094'
    },
    {
        name: 'ZERBA',
        istatCode: '008033047'
    },
    {
        name: 'ZERBO',
        istatCode: '003018188'
    },
    {
        name: 'ZERBOLO\'',
        istatCode: '003018189'
    },
    {
        name: 'ZERFALIU',
        istatCode: '020095075'
    },
    {
        name: 'ZERI',
        istatCode: '009045017'
    },
    {
        name: 'ZERMEGHEDO',
        istatCode: '005024120'
    },
    {
        name: 'ZERO BRANCO',
        istatCode: '005026095'
    },
    {
        name: 'ZEVIO',
        istatCode: '005023097'
    },
    {
        name: 'ZIANO DI FIEMME',
        istatCode: '004022226'
    },
    {
        name: 'ZIANO PIACENTINO',
        istatCode: '008033048'
    },
    {
        name: 'ZIBELLO',
        istatCode: '008034048'
    },
    {
        name: 'ZIBIDO SAN GIACOMO',
        istatCode: '003015247'
    },
    {
        name: 'ZIGNAGO',
        istatCode: '007011032'
    },
    {
        name: 'ZIMELLA',
        istatCode: '005023098'
    },
    {
        name: 'ZIMONE',
        istatCode: '001096081'
    },
    {
        name: 'ZINASCO',
        istatCode: '003018190'
    },
    {
        name: 'ZOAGLI',
        istatCode: '007010067'
    },
    {
        name: 'ZOCCA',
        istatCode: '008036047'
    },
    {
        name: 'ZOGNO',
        istatCode: '003016246'
    },
    {
        name: 'ZOLA PREDOSA',
        istatCode: '008037060'
    },
    {
        name: 'ZOLDO ALTO',
        istatCode: '005025068'
    },
    {
        name: 'ZOLLINO',
        istatCode: '016075094'
    },
    {
        name: 'ZONE',
        istatCode: '003017205'
    },
    {
        name: 'ZOPPE\' DI CADORE',
        istatCode: '005025069'
    },
    {
        name: 'ZOPPOLA',
        istatCode: '006093051'
    },
    {
        name: 'ZOVENCEDO',
        istatCode: '005024121'
    },
    {
        name: 'ZUBIENA',
        istatCode: '001096082'
    },
    {
        name: 'ZUCCARELLO',
        istatCode: '007009069'
    },
    {
        name: 'ZUCLO',
        istatCode: '004022227'
    },
    {
        name: 'ZUGLIANO',
        istatCode: '005024122'
    },
    {
        name: 'ZUGLIO',
        istatCode: '006030136'
    },
    {
        name: 'ZUMAGLIA',
        istatCode: '001096083'
    },
    {
        name: 'ZUMPANO',
        istatCode: '018078155'
    },
    {
        name: 'ZUNGRI',
        istatCode: '018102050'
    },
    {
        name: 'ZUNGOLI',
        istatCode: '015064120'
    }
];
